webpackJsonp([35783957827783],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopDefault(ex) {
	  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
	}
	
	var styled = _interopDefault(__webpack_require__(194));
	
	var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
	'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
	var newStyled = styled.bind();
	tags.forEach(function (tagName) {
	  newStyled[tagName] = newStyled(tagName);
	});
	exports.default = newStyled;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.showOnlyOnDesktop = exports.minDesktop = exports.minTablet = exports.onlyTablet = exports.mediaTablet = exports.mediaPhone = exports.DESKTOP_WIDE = exports.TABLET = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: none;\n  ', ' {\n    display: block;\n  }\n'], ['\n  display: none;\n  ', ' {\n    display: block;\n  }\n']);
	
	var _core = __webpack_require__(26);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var TABLET = exports.TABLET = 768;
	var DESKTOP_WIDE = exports.DESKTOP_WIDE = 1270;
	
	var mediaPhone = exports.mediaPhone = '@media (max-width: ' + (TABLET - 1) + 'px)';
	var mediaTablet = exports.mediaTablet = '@media (max-width: ' + (DESKTOP_WIDE - 1) + 'px)';
	
	var onlyTablet = exports.onlyTablet = '@media (min-width: ' + TABLET + 'px) and (max-width: ' + (DESKTOP_WIDE - 1) + 'px)';
	
	var minTablet = exports.minTablet = '@media (min-width: ' + TABLET + 'px)';
	var minDesktop = exports.minDesktop = '@media (min-width: ' + DESKTOP_WIDE + 'px)';
	
	var showOnlyOnDesktop = exports.showOnlyOnDesktop = (0, _core.css)(_templateObject, minDesktop);

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LI = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin-top: ', ';\n  margin-bottom: ', ';\n'], ['\n  margin-top: ', ';\n  margin-bottom: ', ';\n']);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var LI = exports.LI = _styled2.default.li(_templateObject, function (_ref) {
	  var gapBefore = _ref.gapBefore;
	  return gapBefore ? '1em' : 0;
	}, function (_ref2) {
	  var gapAfter = _ref2.gapAfter;
	  return gapAfter ? '1em' : 0;
	});

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Section = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin-top: ', ';\n  margin-bottom: ', ';\n'], ['\n  margin-top: ', ';\n  margin-bottom: ', ';\n']);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Section = exports.Section = _styled2.default.section(_templateObject, function (_ref) {
	  var gapBefore = _ref.gapBefore;
	  return gapBefore ? '1.5em' : 0;
	}, function (_ref2) {
	  var gapAfter = _ref2.gapAfter;
	  return gapAfter ? '1.5em' : 0;
	});

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.UL = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n\n  list-style-type: ', ';\n\n  padding-left: 20px;\n\n'], ['\n\n  list-style-type: ', ';\n\n  padding-left: 20px;\n\n']);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _P = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; } /* eslint-disable no-nested-ternary */
	
	
	var UL = exports.UL = (0, _styled2.default)(_P.P)(_templateObject, function (_ref) {
	  var disc = _ref.disc,
	      square = _ref.square;
	  return disc ? 'circle' : square ? 'square' : 'disc';
	}).withComponent('ul');

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.P = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  font-size: 18px;\n  line-height: 1.4;\n\n  ', ' {\n    font-size: 20px;\n  }\n\n  margin-top: ', ';\n  margin-bottom: ', ';\n'], ['\n  font-size: 18px;\n  line-height: 1.4;\n\n  ', ' {\n    font-size: 20px;\n  }\n\n  margin-top: ', ';\n  margin-bottom: ', ';\n']);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _breakpoints = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var P = exports.P = _styled2.default.p(_templateObject, _breakpoints.minTablet, function (_ref) {
	  var gapBefore = _ref.gapBefore;
	  return gapBefore ? '1em' : 0;
	}, function (_ref2) {
	  var gapAfter = _ref2.gapAfter;
	  return gapAfter ? '1em' : 0;
	});

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var BackColor = '#fff';
	var SecondaryBackColor = '#fafbed';
	
	var TextColor = '#000';
	var SecondaryTextColor = '#b8c500';
	var ImpressumTextColor = '#AAAAAA';
	
	var ActionColor = '#0f0';
	var ActionShadeColor = '#00f000';
	var ActionTextColor = '#fff';
	
	exports.ActionColor = ActionColor;
	exports.ActionShadeColor = ActionShadeColor;
	exports.ActionTextColor = ActionTextColor;
	exports.BackColor = BackColor;
	exports.ImpressumTextColor = ImpressumTextColor;
	exports.SecondaryBackColor = SecondaryBackColor;
	exports.SecondaryTextColor = SecondaryTextColor;
	exports.TextColor = TextColor;

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isPrefixedValue;
	var regex = /-webkit-|-moz-|-ms-/;
	
	function isPrefixedValue(value) {
	  return typeof value === 'string' && regex.test(value);
	}
	module.exports = exports['default'];

/***/ }),
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(198);


/***/ }),
/* 15 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var HeadlineFont = exports.HeadlineFont = "\n  font-family: 'Caveat Brush', serif;\n  font-weight: normal;\n";
	
	var Headline2ndFont = exports.Headline2ndFont = "\n  font-family: Knewave, sans-serif;\n  font-weight: normal;\n";
	
	var MonospaceFont = exports.MonospaceFont = "\n  font-family: monospace;\n  font-weight: normal;\n";
	
	var ListStyleSymbolFont = exports.ListStyleSymbolFont = "\n  font-family: monospace;\n";
	
	var ActionFont = exports.ActionFont = "\n  font-family: 'Caveat Brush', monospace;\n  font-weight: normal;\n";

/***/ }),
/* 16 */,
/* 17 */
/***/ (function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault;

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(350);
	} else {
	  module.exports = require("./emotion.cjs.dev.js");
	}


/***/ }),
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	// ==============================
	// THEME
	// ==============================
	
	var theme = {};
	
	// container
	theme.container = {
		background: 'rgba(0, 0, 0, 0.8)',
		gutter: {
			horizontal: 10,
			vertical: 10
		},
		zIndex: 2001
	};
	
	// header
	theme.header = {
		height: 40
	};
	theme.close = {
		fill: 'white'
	};
	
	// footer
	theme.footer = {
		color: 'white',
		count: {
			color: 'rgba(255, 255, 255, 0.75)',
			fontSize: '0.85em'
		},
		height: 40,
		gutter: {
			horizontal: 0,
			vertical: 5
		}
	};
	
	// thumbnails
	theme.thumbnail = {
		activeBorderColor: 'white',
		size: 50,
		gutter: 2
	};
	
	// arrow
	theme.arrow = {
		background: 'none',
		fill: 'white',
		height: 120
	};
	
	exports.default = theme;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var createCache = _interopDefault(__webpack_require__(131));
	var utils = __webpack_require__(84);
	var serialize = __webpack_require__(66);
	var sheet = __webpack_require__(133);
	var css = _interopDefault(__webpack_require__(191));
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	var EmotionCacheContext = React.createContext(createCache());
	var ThemeContext = React.createContext({});
	var CacheProvider = EmotionCacheContext.Provider;
	
	exports.withEmotionCache = function withEmotionCache(func) {
	  var render = function render(props, ref) {
	    return React.createElement(EmotionCacheContext.Consumer, null, function ( // $FlowFixMe we know it won't be null
	    cache) {
	      return func(props, cache, ref);
	    });
	  }; // $FlowFixMe
	
	
	  return React.forwardRef(render);
	};
	
	var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
	var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var render = function render(cache, props, theme, ref) {
	  var type = props[typePropName];
	  var registeredStyles = [];
	  var className = '';
	  var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
	  // not passing the registered cache to serializeStyles because it would
	  // make certain babel optimisations not possible
	
	  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
	    cssProp = cache.registered[cssProp];
	  }
	
	  registeredStyles.push(cssProp);
	
	  if (props.className !== undefined) {
	    className = utils.getRegisteredStyles(cache.registered, registeredStyles, props.className);
	  }
	
	  var serialized = serialize.serializeStyles(registeredStyles);
	
	  if (false) {
	    var labelFromStack = props[labelPropName];
	
	    if (labelFromStack) {
	      serialized = serialize.serializeStyles([serialized, 'label:' + labelFromStack + ';']);
	    }
	  }
	
	  var rules = utils.insertStyles(cache, serialized, typeof type === 'string');
	  className += cache.key + "-" + serialized.name;
	  var newProps = {};
	
	  for (var key in props) {
	    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && (("production") === 'production' || key !== labelPropName)) {
	      newProps[key] = props[key];
	    }
	  }
	
	  newProps.ref = ref;
	  newProps.className = className;
	  var ele = React.createElement(type, newProps);
	
	  return ele;
	};
	
	var Emotion = exports.withEmotionCache(function (props, cache, ref) {
	  // use Context.read for the theme when it's stable
	  if (typeof props.css === 'function') {
	    return React.createElement(ThemeContext.Consumer, null, function (theme) {
	      return render(cache, props, theme, ref);
	    });
	  }
	
	  return render(cache, props, null, ref);
	});
	
	if (false) {
	  Emotion.displayName = 'EmotionCssPropInternal';
	} // $FlowFixMe
	
	
	var jsx = function jsx(type, props) {
	  var args = arguments;
	
	  if (props == null || props.css == null) {
	    // $FlowFixMe
	    return React.createElement.apply(undefined, args);
	  }
	
	  if (false) {
	    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/css' like this: css`" + props.css + "`");
	  }
	
	  var argsLength = args.length;
	  var createElementArgArray = new Array(argsLength);
	  createElementArgArray[0] = Emotion;
	  var newProps = {};
	
	  for (var key in props) {
	    if (hasOwnProperty.call(props, key)) {
	      newProps[key] = props[key];
	    }
	  }
	
	  newProps[typePropName] = type;
	
	  if (false) {
	    var error = new Error();
	
	    if (error.stack) {
	      // chrome
	      var match = error.stack.match(/at jsx.*\n\s+at ([A-Z][A-Za-z]+) /);
	
	      if (!match) {
	        // safari and firefox
	        match = error.stack.match(/^.*\n([A-Z][A-Za-z]+)@/);
	      }
	
	      if (match) {
	        newProps[labelPropName] = match[1];
	      }
	    }
	  }
	
	  createElementArgArray[1] = newProps;
	
	  for (var i = 2; i < argsLength; i++) {
	    createElementArgArray[i] = args[i];
	  } // $FlowFixMe
	
	
	  return React.createElement.apply(null, createElementArgArray);
	};
	
	var warnedAboutCssPropForGlobal = false;
	var Global =
	/* #__PURE__ */
	exports.withEmotionCache(function (props, cache) {
	  if (false) {
	    console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
	    warnedAboutCssPropForGlobal = true;
	  }
	
	  var styles = props.styles;
	
	  if (typeof styles === 'function') {
	    return React.createElement(ThemeContext.Consumer, null, function (theme) {
	      var serialized = serialize.serializeStyles([styles(theme)]);
	      return React.createElement(InnerGlobal, {
	        serialized: serialized,
	        cache: cache
	      });
	    });
	  }
	
	  var serialized = serialize.serializeStyles([styles]);
	  return React.createElement(InnerGlobal, {
	    serialized: serialized,
	    cache: cache
	  });
	});
	
	// maintain place over rerenders.
	// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
	// initial client-side render from SSR, use place of hydrating tag
	var InnerGlobal =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(InnerGlobal, _React$Component);
	
	  function InnerGlobal(props, context, updater) {
	    return _React$Component.call(this, props, context, updater) || this;
	  }
	
	  var _proto = InnerGlobal.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.sheet = new sheet.StyleSheet({
	      key: this.props.cache.key + "-global",
	      nonce: this.props.cache.sheet.nonce,
	      container: this.props.cache.sheet.container
	    }); // $FlowFixMe
	
	    var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");
	
	    if (node !== null) {
	      this.sheet.tags.push(node);
	    }
	
	    if (this.props.cache.sheet.tags.length) {
	      this.sheet.before = this.props.cache.sheet.tags[0];
	    }
	
	    this.insertStyles();
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (prevProps.serialized.name !== this.props.serialized.name) {
	      this.insertStyles();
	    }
	  };
	
	  _proto.insertStyles = function insertStyles() {
	    if (this.props.serialized.next !== undefined) {
	      // insert keyframes
	      utils.insertStyles(this.props.cache, this.props.serialized.next, true);
	    }
	
	    if (this.sheet.tags.length) {
	      // if this doesn't exist then it will be null so the style element will be appended
	      var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
	      this.sheet.before = element;
	      this.sheet.flush();
	    }
	
	    this.props.cache.insert("", this.props.serialized, this.sheet, false);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.sheet.flush();
	  };
	
	  _proto.render = function render() {
	
	    return null;
	  };
	
	  return InnerGlobal;
	}(React.Component);
	
	var keyframes = function keyframes() {
	  var insertable = css.apply(void 0, arguments);
	  var name = "animation-" + insertable.name; // $FlowFixMe
	
	  return {
	    name: name,
	    styles: "@keyframes " + name + "{" + insertable.styles + "}",
	    anim: 1,
	    toString: function toString() {
	      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
	    }
	  };
	};
	
	var classnames = function classnames(args) {
	  var len = args.length;
	  var i = 0;
	  var cls = '';
	
	  for (; i < len; i++) {
	    var arg = args[i];
	    if (arg == null) continue;
	    var toAdd = void 0;
	
	    switch (typeof arg) {
	      case 'boolean':
	        break;
	
	      case 'object':
	        {
	          if (Array.isArray(arg)) {
	            toAdd = classnames(arg);
	          } else {
	            toAdd = '';
	
	            for (var k in arg) {
	              if (arg[k] && k) {
	                toAdd && (toAdd += ' ');
	                toAdd += k;
	              }
	            }
	          }
	
	          break;
	        }
	
	      default:
	        {
	          toAdd = arg;
	        }
	    }
	
	    if (toAdd) {
	      cls && (cls += ' ');
	      cls += toAdd;
	    }
	  }
	
	  return cls;
	};
	
	function merge(registered, css$$1, className) {
	  var registeredStyles = [];
	  var rawClassName = utils.getRegisteredStyles(registered, registeredStyles, className);
	
	  if (registeredStyles.length < 2) {
	    return className;
	  }
	
	  return rawClassName + css$$1(registeredStyles);
	}
	
	var ClassNames = exports.withEmotionCache(function (props, context) {
	  return React.createElement(ThemeContext.Consumer, null, function (theme) {
	    var hasRendered = false;
	
	    var css$$1 = function css$$1() {
	      if (hasRendered && ("production") !== 'production') {
	        throw new Error('css can only be used during render');
	      }
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      var serialized = serialize.serializeStyles(args, context.registered);
	
	      {
	        utils.insertStyles(context, serialized, false);
	      }
	
	      return context.key + "-" + serialized.name;
	    };
	
	    var cx = function cx() {
	      if (hasRendered && ("production") !== 'production') {
	        throw new Error('cx can only be used during render');
	      }
	
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return merge(context.registered, css$$1, classnames(args));
	    };
	
	    var content = {
	      css: css$$1,
	      cx: cx,
	      theme: theme
	    };
	    var ele = props.children(content);
	    hasRendered = true;
	
	    return ele;
	  });
	});
	
	exports.css = css;
	exports.CacheProvider = CacheProvider;
	exports.ThemeContext = ThemeContext;
	exports.jsx = jsx;
	exports.Global = Global;
	exports.keyframes = keyframes;
	exports.ClassNames = ClassNames;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	// rawAsap provides everything we need except exception management.
	var rawAsap = __webpack_require__(86);
	// RawTasks are recycled to reduce GC churn.
	var freeTasks = [];
	// We queue errors to ensure they are thrown in right order (FIFO).
	// Array-as-queue is good enough here, since we are just dealing with exceptions.
	var pendingErrors = [];
	var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);
	
	function throwFirstError() {
	    if (pendingErrors.length) {
	        throw pendingErrors.shift();
	    }
	}
	
	/**
	 * Calls a task as soon as possible after returning, in its own event, with priority
	 * over other events like animation, reflow, and repaint. An error thrown from an
	 * event will not interrupt, nor even substantially slow down the processing of
	 * other events, but will be rather postponed to a lower priority event.
	 * @param {{call}} task A callable object, typically a function that takes no
	 * arguments.
	 */
	module.exports = asap;
	function asap(task) {
	    var rawTask;
	    if (freeTasks.length) {
	        rawTask = freeTasks.pop();
	    } else {
	        rawTask = new RawTask();
	    }
	    rawTask.task = task;
	    rawAsap(rawTask);
	}
	
	// We wrap tasks with recyclable task objects.  A task object implements
	// `call`, just like a function.
	function RawTask() {
	    this.task = null;
	}
	
	// The sole purpose of wrapping the task is to catch the exception and recycle
	// the task object after its single use.
	RawTask.prototype.call = function () {
	    try {
	        this.task.call();
	    } catch (error) {
	        if (asap.onerror) {
	            // This hook exists purely for testing purposes.
	            // Its name will be periodically randomized to break any code that
	            // depends on its existence.
	            asap.onerror(error);
	        } else {
	            // In a web browser, exceptions are not fatal. However, to avoid
	            // slowing down the queue of pending tasks, we rethrow the error in a
	            // lower priority turn.
	            pendingErrors.push(error);
	            requestErrorThrow();
	        }
	    } finally {
	        this.task = null;
	        freeTasks[freeTasks.length] = this;
	    }
	};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ExternalLink = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin-right: 0.5em;\n'], ['\n  margin-right: 0.5em;\n']);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _ExternalLink = __webpack_require__(89);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ExternalLink = exports.ExternalLink = (0, _styled2.default)(_ExternalLink.ExternalLink)(_templateObject);

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createPrefixer;
	
	var _prefixProperty = __webpack_require__(124);
	
	var _prefixProperty2 = _interopRequireDefault(_prefixProperty);
	
	var _prefixValue = __webpack_require__(125);
	
	var _prefixValue2 = _interopRequireDefault(_prefixValue);
	
	var _addNewValuesOnly = __webpack_require__(122);
	
	var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);
	
	var _isObject = __webpack_require__(123);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createPrefixer(_ref) {
	  var prefixMap = _ref.prefixMap,
	      plugins = _ref.plugins;
	
	  return function prefix(style) {
	    for (var property in style) {
	      var value = style[property];
	
	      // handle nested objects
	      if ((0, _isObject2.default)(value)) {
	        style[property] = prefix(value);
	        // handle array values
	      } else if (Array.isArray(value)) {
	        var combinedValue = [];
	
	        for (var i = 0, len = value.length; i < len; ++i) {
	          var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, prefixMap);
	          (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
	        }
	
	        // only modify the value if it was touched
	        // by any plugin to prevent unnecessary mutations
	        if (combinedValue.length > 0) {
	          style[property] = combinedValue;
	        }
	      } else {
	        var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);
	
	        // only modify the value if it was touched
	        // by any plugin to prevent unnecessary mutations
	        if (_processedValue) {
	          style[property] = _processedValue;
	        }
	
	        style = (0, _prefixProperty2.default)(prefixMap, property, style);
	      }
	    }
	
	    return style;
	  };
	}

/***/ }),
/* 37 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = backgroundClip;
	
	// https://developer.mozilla.org/en-US/docs/Web/CSS/background-clip#Browser_compatibility
	function backgroundClip(property, value) {
	  if (typeof value === 'string' && value === 'text') {
	    return ['-webkit-text', 'text'];
	  }
	}

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _isPrefixedValue = __webpack_require__(12);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixes = ['-webkit-', '-moz-', ''];
	function calc(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/calc\(/g, prefix + 'calc(');
	    });
	  }
	}

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = crossFade;
	
	var _isPrefixedValue = __webpack_require__(12);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// http://caniuse.com/#search=cross-fade
	var prefixes = ['-webkit-', ''];
	function crossFade(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('cross-fade(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/cross-fade\(/g, prefix + 'cross-fade(');
	    });
	  }
	}

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cursor;
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var values = {
	  'zoom-in': true,
	  'zoom-out': true,
	  grab: true,
	  grabbing: true
	};
	
	function cursor(property, value) {
	  if (property === 'cursor' && values.hasOwnProperty(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = filter;
	
	var _isPrefixedValue = __webpack_require__(12);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// http://caniuse.com/#feat=css-filter-function
	var prefixes = ['-webkit-', ''];
	function filter(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('filter(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/filter\(/g, prefix + 'filter(');
	    });
	  }
	}

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	var values = {
	  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
	  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
	};
	
	function flex(property, value) {
	  if (property === 'display' && values.hasOwnProperty(value)) {
	    return values[value];
	  }
	}

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end'
	};
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msFlexPreferredSize'
	  // Full expanded syntax is flex-grow | flex-shrink | flex-basis.
	};var flexShorthandMappings = {
	  auto: '1 1 auto',
	  inherit: 'inherit',
	  initial: '0 1 auto',
	  none: '0 0 auto',
	  unset: 'unset'
	};
	var isUnitlessNumber = /^\d+(\.\d+)?$/;
	
	function flexboxIE(property, value, style) {
	  if (Object.prototype.hasOwnProperty.call(alternativeProps, property)) {
	    style[alternativeProps[property]] = alternativeValues[value] || value;
	  }
	  if (property === 'flex') {
	    // For certain values we can do straight mappings based on the spec
	    // for the expansions.
	    if (Object.prototype.hasOwnProperty.call(flexShorthandMappings, value)) {
	      style.msFlex = flexShorthandMappings[value];
	      return;
	    }
	    // Here we have no direct mapping, so we favor looking for a
	    // unitless positive number as that will be the most common use-case.
	    if (isUnitlessNumber.test(value)) {
	      style.msFlex = value + ' 1 0%';
	      return;
	    }
	
	    // The next thing we can look for is if there are multiple values.
	    var flexValues = value.split(/\s/);
	    // If we only have a single value that wasn't a positive unitless
	    // or a pre-mapped value, then we can assume it is a unit value.
	    switch (flexValues.length) {
	      case 1:
	        style.msFlex = '1 1 ' + value;
	        return;
	      case 2:
	        // If we have 2 units, then we expect that the first will
	        // always be a unitless number and represents flex-grow.
	        // The second unit will represent flex-shrink for a unitless
	        // value, or flex-basis otherwise.
	        if (isUnitlessNumber.test(flexValues[1])) {
	          style.msFlex = flexValues[0] + ' ' + flexValues[1] + ' 0%';
	        } else {
	          style.msFlex = flexValues[0] + ' 1 ' + flexValues[1];
	        }
	        return;
	      default:
	        style.msFlex = value;
	    }
	  }
	}

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines',
	  flexGrow: 'WebkitBoxFlex'
	};
	
	function flexboxOld(property, value, style) {
	  if (property === 'flexDirection' && typeof value === 'string') {
	    if (value.indexOf('column') > -1) {
	      style.WebkitBoxOrient = 'vertical';
	    } else {
	      style.WebkitBoxOrient = 'horizontal';
	    }
	    if (value.indexOf('reverse') > -1) {
	      style.WebkitBoxDirection = 'reverse';
	    } else {
	      style.WebkitBoxDirection = 'normal';
	    }
	  }
	  if (alternativeProps.hasOwnProperty(property)) {
	    style[alternativeProps[property]] = alternativeValues[value] || value;
	  }
	}

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _isPrefixedValue = __webpack_require__(12);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/gi;
	
	function gradient(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
	    return prefixes.map(function (prefix) {
	      return value.replace(values, function (grad) {
	        return prefix + grad;
	      });
	    });
	  }
	}

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = imageSet;
	
	var _isPrefixedValue = __webpack_require__(12);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// http://caniuse.com/#feat=css-image-set
	var prefixes = ['-webkit-', ''];
	function imageSet(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('image-set(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/image-set\(/g, prefix + 'image-set(');
	    });
	  }
	}

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = logical;
	var alternativeProps = {
	  marginBlockStart: ['WebkitMarginBefore'],
	  marginBlockEnd: ['WebkitMarginAfter'],
	  marginInlineStart: ['WebkitMarginStart', 'MozMarginStart'],
	  marginInlineEnd: ['WebkitMarginEnd', 'MozMarginEnd'],
	  paddingBlockStart: ['WebkitPaddingBefore'],
	  paddingBlockEnd: ['WebkitPaddingAfter'],
	  paddingInlineStart: ['WebkitPaddingStart', 'MozPaddingStart'],
	  paddingInlineEnd: ['WebkitPaddingEnd', 'MozPaddingEnd'],
	  borderBlockStart: ['WebkitBorderBefore'],
	  borderBlockStartColor: ['WebkitBorderBeforeColor'],
	  borderBlockStartStyle: ['WebkitBorderBeforeStyle'],
	  borderBlockStartWidth: ['WebkitBorderBeforeWidth'],
	  borderBlockEnd: ['WebkitBorderAfter'],
	  borderBlockEndColor: ['WebkitBorderAfterColor'],
	  borderBlockEndStyle: ['WebkitBorderAfterStyle'],
	  borderBlockEndWidth: ['WebkitBorderAfterWidth'],
	  borderInlineStart: ['WebkitBorderStart', 'MozBorderStart'],
	  borderInlineStartColor: ['WebkitBorderStartColor', 'MozBorderStartColor'],
	  borderInlineStartStyle: ['WebkitBorderStartStyle', 'MozBorderStartStyle'],
	  borderInlineStartWidth: ['WebkitBorderStartWidth', 'MozBorderStartWidth'],
	  borderInlineEnd: ['WebkitBorderEnd', 'MozBorderEnd'],
	  borderInlineEndColor: ['WebkitBorderEndColor', 'MozBorderEndColor'],
	  borderInlineEndStyle: ['WebkitBorderEndStyle', 'MozBorderEndStyle'],
	  borderInlineEndWidth: ['WebkitBorderEndWidth', 'MozBorderEndWidth']
	};
	
	function logical(property, value, style) {
	  if (Object.prototype.hasOwnProperty.call(alternativeProps, property)) {
	    var alternativePropList = alternativeProps[property];
	    for (var i = 0, len = alternativePropList.length; i < len; ++i) {
	      style[alternativePropList[i]] = value;
	    }
	  }
	}

/***/ }),
/* 48 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = position;
	function position(property, value) {
	  if (property === 'position' && value === 'sticky') {
	    return ['-webkit-sticky', 'sticky'];
	  }
	}

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(property, value) {
	  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = transition;
	
	var _hyphenateProperty = __webpack_require__(118);
	
	var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);
	
	var _isPrefixedValue = __webpack_require__(12);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	var _capitalizeString = __webpack_require__(63);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  transition: true,
	  transitionProperty: true,
	  WebkitTransition: true,
	  WebkitTransitionProperty: true,
	  MozTransition: true,
	  MozTransitionProperty: true
	};
	
	
	var prefixMapping = {
	  Webkit: '-webkit-',
	  Moz: '-moz-',
	  ms: '-ms-'
	};
	
	function prefixValue(value, propertyPrefixMap) {
	  if ((0, _isPrefixedValue2.default)(value)) {
	    return value;
	  }
	
	  // only split multi values, not cubic beziers
	  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	  for (var i = 0, len = multipleValues.length; i < len; ++i) {
	    var singleValue = multipleValues[i];
	    var values = [singleValue];
	    for (var property in propertyPrefixMap) {
	      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);
	
	      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
	        var prefixes = propertyPrefixMap[property];
	        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
	          // join all prefixes and create a new value
	          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
	        }
	      }
	    }
	
	    multipleValues[i] = values.join(',');
	  }
	
	  return multipleValues.join(',');
	}
	
	function transition(property, value, style, propertyPrefixMap) {
	  // also check for already prefixed transitions
	  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
	    var outputValue = prefixValue(value, propertyPrefixMap);
	    // if the property is already prefixed
	    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
	      return !/-moz-|-ms-/.test(val);
	    }).join(',');
	
	    if (property.indexOf('Webkit') > -1) {
	      return webkitOutput;
	    }
	
	    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
	      return !/-webkit-|-ms-/.test(val);
	    }).join(',');
	
	    if (property.indexOf('Moz') > -1) {
	      return mozOutput;
	    }
	
	    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
	    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
	    return outputValue;
	  }
	}

/***/ }),
/* 51 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function deepMerge(target) {
		var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		var extended = _extends({}, target);
	
		Object.keys(source).forEach(function (key) {
			if (_typeof(source[key]) !== 'object' || !source[key]) {
				extended[key] = source[key];
			} else {
				if (!target[key]) {
					extended[key] = source[key];
				} else {
					extended[key] = deepMerge(target[key], source[key]);
				}
			}
		});
	
		return extended;
	}
	
	exports.default = deepMerge;

/***/ }),
/* 52 */,
/* 53 */
/***/ (function(module, exports) {

	"use strict";
	
	function hash(str) {
	  var hash = 5381,
	      i    = str.length;
	
	  while(i) {
	    hash = (hash * 33) ^ str.charCodeAt(--i);
	  }
	
	  /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
	   * integers. Since we want the results to be always positive, convert the
	   * signed int to an unsigned by doing an unsigned bitshift. */
	  return hash >>> 0;
	}
	
	module.exports = hash;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DownloadMaterialButton = __webpack_require__(215);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DownloadMaterialButton).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Stacheldraht = __webpack_require__(264);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Stacheldraht).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = capitalizeString;
	function capitalizeString(str) {
	  return str.charAt(0).toUpperCase() + str.slice(1);
	}

/***/ }),
/* 64 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 65 */,
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopDefault(ex) {
	  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
	}
	
	var hashString = _interopDefault(__webpack_require__(192));
	
	var unitless = _interopDefault(__webpack_require__(196));
	
	var memoize = _interopDefault(__webpack_require__(132));
	
	var hyphenateRegex = /[A-Z]|^ms/g;
	var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
	
	var isCustomProperty = function isCustomProperty(property) {
	  return property.charCodeAt(1) === 45;
	};
	
	var processStyleName = memoize(function (styleName) {
	  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
	});
	
	var processStyleValue = function processStyleValue(key, value) {
	  if (value == null || typeof value === 'boolean') {
	    return '';
	  }
	
	  switch (key) {
	    case 'animation':
	    case 'animationName':
	      {
	        if (typeof value === 'string') {
	          value = value.replace(animationRegex, function (match, p1, p2) {
	            cursor = {
	              name: p1,
	              styles: p2,
	              next: cursor
	            };
	            return p1;
	          });
	        }
	      }
	  }
	
	  if (unitless[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
	    return value + 'px';
	  }
	
	  return value;
	};
	
	if (false) {
	  var contentValuePattern = /(attr|calc|counters?|url)\(/;
	  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
	  var oldProcessStyleValue = processStyleValue;
	  var msPattern = /^-ms-/;
	  var hyphenPattern = /-(.)/g;
	  var hyphenatedCache = {};
	
	  processStyleValue = function processStyleValue(key, value) {
	    if (key === 'content') {
	      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
	        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
	      }
	    }
	
	    var processed = oldProcessStyleValue(key, value);
	
	    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
	      hyphenatedCache[key] = true;
	      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, char) {
	        return char.toUpperCase();
	      }) + "?");
	    }
	
	    return processed;
	  };
	}
	
	var shouldWarnAboutInterpolatingClassNameFromCss = true;
	
	function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
	  if (interpolation == null) {
	    return '';
	  }
	
	  if (interpolation.__emotion_styles !== undefined) {
	    if (false) {
	      throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	    }
	
	    return interpolation;
	  }
	
	  switch (typeof interpolation) {
	    case 'boolean':
	      {
	        return '';
	      }
	
	    case 'object':
	      {
	        if (interpolation.anim === 1) {
	          cursor = {
	            name: interpolation.name,
	            styles: interpolation.styles,
	            next: cursor
	          };
	          return interpolation.name;
	        }
	
	        if (interpolation.styles !== undefined) {
	          var next = interpolation.next;
	
	          if (next !== undefined) {
	            // not the most efficient thing ever but this is a pretty rare case
	            // and there will be very few iterations of this generally
	            while (next !== undefined) {
	              cursor = {
	                name: next.name,
	                styles: next.styles,
	                next: cursor
	              };
	              next = next.next;
	            }
	          }
	
	          var styles = interpolation.styles;
	
	          if (false) {
	            styles += interpolation.map;
	          }
	
	          return styles;
	        }
	
	        return createStringFromObject(mergedProps, registered, interpolation);
	      }
	
	    case 'function':
	      {
	        if (mergedProps !== undefined) {
	          var previousCursor = cursor;
	          var result = interpolation(mergedProps);
	          cursor = previousCursor;
	          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
	        } else if (false) {
	          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
	        }
	      }
	    // eslint-disable-next-line no-fallthrough
	
	    default:
	      {
	        if (registered == null) {
	          return interpolation;
	        }
	
	        var cached = registered[interpolation];
	
	        if (false) {
	          console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
	          shouldWarnAboutInterpolatingClassNameFromCss = false;
	        }
	
	        return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
	      }
	  }
	}
	
	function createStringFromObject(mergedProps, registered, obj) {
	  var string = '';
	
	  if (Array.isArray(obj)) {
	    for (var i = 0; i < obj.length; i++) {
	      string += handleInterpolation(mergedProps, registered, obj[i], false);
	    }
	  } else {
	    for (var _key in obj) {
	      var value = obj[_key];
	
	      if (typeof value !== 'object') {
	        if (registered != null && registered[value] !== undefined) {
	          string += _key + "{" + registered[value] + "}";
	        } else {
	          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
	        }
	      } else {
	        if (_key === 'NO_COMPONENT_SELECTOR' && ("production") !== 'production') {
	          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	        }
	
	        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
	          for (var _i = 0; _i < value.length; _i++) {
	            string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
	          }
	        } else {
	          string += _key + "{" + handleInterpolation(mergedProps, registered, value, false) + "}";
	        }
	      }
	    }
	  }
	
	  return string;
	}
	
	var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
	var sourceMapPattern;
	
	if (false) {
	  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
	} // this is the cursor for keyframes
	// keyframes are stored on the SerializedStyles object as a linked list
	
	
	var cursor;
	
	var serializeStyles = function serializeStyles(args, registered, mergedProps) {
	  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
	    return args[0];
	  }
	
	  var stringMode = true;
	  var styles = '';
	  cursor = undefined;
	  var strings = args[0];
	
	  if (strings == null || strings.raw === undefined) {
	    stringMode = false;
	    styles += handleInterpolation(mergedProps, registered, strings, false);
	  } else {
	    styles += strings[0];
	  } // we start at 1 since we've already handled the first arg
	
	
	  for (var i = 1; i < args.length; i++) {
	    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
	
	    if (stringMode) {
	      styles += strings[i];
	    }
	  }
	
	  var sourceMap;
	
	  if (false) {
	    styles = styles.replace(sourceMapPattern, function (match) {
	      sourceMap = match;
	      return '';
	    });
	  } // using a global regex with .exec is stateful so lastIndex has to be reset each time
	
	
	  labelPattern.lastIndex = 0;
	  var identifierName = '';
	  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
	
	  while ((match = labelPattern.exec(styles)) !== null) {
	    identifierName += '-' + // $FlowFixMe we know it's not null
	    match[1];
	  }
	
	  var name = hashString(styles) + identifierName;
	
	  if (false) {
	    return {
	      name: name,
	      styles: styles,
	      map: sourceMap,
	      next: cursor
	    };
	  }
	
	  return {
	    name: name,
	    styles: styles,
	    next: cursor
	  };
	};
	
	exports.serializeStyles = serializeStyles;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var stringHash = _interopDefault(__webpack_require__(53));
	var asap = _interopDefault(__webpack_require__(27));
	var createPrefixer = _interopDefault(__webpack_require__(36));
	var backgroundClip = _interopDefault(__webpack_require__(37));
	var calc = _interopDefault(__webpack_require__(38));
	var crossFade = _interopDefault(__webpack_require__(39));
	var cursor = _interopDefault(__webpack_require__(40));
	var filter = _interopDefault(__webpack_require__(41));
	var flex = _interopDefault(__webpack_require__(42));
	var flexboxIE = _interopDefault(__webpack_require__(43));
	var flexboxOld = _interopDefault(__webpack_require__(44));
	var gradient = _interopDefault(__webpack_require__(45));
	var imageSet = _interopDefault(__webpack_require__(46));
	var logical = _interopDefault(__webpack_require__(47));
	var position = _interopDefault(__webpack_require__(48));
	var sizing = _interopDefault(__webpack_require__(49));
	var transition = _interopDefault(__webpack_require__(50));
	
	function _typeof(obj) {
	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    _typeof = function (obj) {
	      return typeof obj;
	    };
	  } else {
	    _typeof = function (obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	  }
	
	  return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    var ownKeys = Object.keys(source);
	
	    if (typeof Object.getOwnPropertySymbols === 'function') {
	      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
	      }));
	    }
	
	    ownKeys.forEach(function (key) {
	      _defineProperty(target, key, source[key]);
	    });
	  }
	
	  return target;
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  }
	}
	
	function _iterableToArray(iter) {
	  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance");
	}
	
	/* @flow */
	/* ::
	type ObjectMap = { [id:string]: any };
	*/
	
	var UPPERCASE_RE = /([A-Z])/g;
	
	var UPPERCASE_RE_TO_KEBAB = function UPPERCASE_RE_TO_KEBAB(match
	/* : string */
	) {
	  return (
	    /* : string */
	    "-".concat(match.toLowerCase())
	  );
	};
	
	var kebabifyStyleName = function kebabifyStyleName(string
	/* : string */
	)
	/* : string */
	{
	  var result = string.replace(UPPERCASE_RE, UPPERCASE_RE_TO_KEBAB);
	
	  if (result[0] === 'm' && result[1] === 's' && result[2] === '-') {
	    return "-".concat(result);
	  }
	
	  return result;
	};
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 * Taken from React's CSSProperty.js
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	/**
	 * Taken from React's CSSProperty.js
	 *
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 * Taken from React's CSSProperty.js
	 */
	
	
	var prefixes = ['Webkit', 'ms', 'Moz', 'O']; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	// Taken from React's CSSProperty.js
	
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	var stringifyValue = function stringifyValue(key
	/* : string */
	, prop
	/* : any */
	)
	/* : string */
	{
	  if (typeof prop === "number") {
	    if (isUnitlessNumber[key]) {
	      return "" + prop;
	    } else {
	      return prop + "px";
	    }
	  } else {
	    return '' + prop;
	  }
	};
	var stringifyAndImportantifyValue = function stringifyAndImportantifyValue(key
	/* : string */
	, prop
	/* : any */
	) {
	  return (
	    /* : string */
	    importantify(stringifyValue(key, prop))
	  );
	}; // Turn a string into a hash string of base-36 values (using letters and numbers)
	// eslint-disable-next-line no-unused-vars
	
	var hashString = function hashString(string
	/* : string */
	, key
	/* : ?string */
	) {
	  return (
	    /* string */
	    stringHash(string).toString(36)
	  );
	}; // Hash a javascript object using JSON.stringify. This is very fast, about 3
	// microseconds on my computer for a sample object:
	// http://jsperf.com/test-hashfnv32a-hash/5
	//
	// Note that this uses JSON.stringify to stringify the objects so in order for
	// this to produce consistent hashes browsers need to have a consistent
	// ordering of objects. Ben Alpert says that Facebook depends on this, so we
	// can probably depend on this too.
	
	var hashObject = function hashObject(object
	/* : ObjectMap */
	) {
	  return (
	    /* : string */
	    hashString(JSON.stringify(object))
	  );
	}; // Given a single style value string like the "b" from "a: b;", adds !important
	// to generate "b !important".
	
	var importantify = function importantify(string
	/* : string */
	) {
	  return (
	    /* : string */
	    // Bracket string character access is very fast, and in the default case we
	    // normally don't expect there to be "!important" at the end of the string
	    // so we can use this simple check to take an optimized path. If there
	    // happens to be a "!" in this position, we follow up with a more thorough
	    // check.
	    string[string.length - 10] === '!' && string.slice(-11) === ' !important' ? string : "".concat(string, " !important")
	  );
	};
	
	/* @flow */
	var MAP_EXISTS = typeof Map !== 'undefined';
	
	var OrderedElements =
	/*#__PURE__*/
	function () {
	  /* ::
	  elements: {[string]: any};
	  keyOrder: string[];
	  */
	  function OrderedElements() {
	    this.elements = {};
	    this.keyOrder = [];
	  }
	
	  var _proto = OrderedElements.prototype;
	
	  _proto.forEach = function forEach(callback
	  /* : (string, any) => void */
	  ) {
	    for (var i = 0; i < this.keyOrder.length; i++) {
	      // (value, key) to match Map's API
	      callback(this.elements[this.keyOrder[i]], this.keyOrder[i]);
	    }
	  };
	
	  _proto.set = function set(key
	  /* : string */
	  , value
	  /* : any */
	  , shouldReorder
	  /* : ?boolean */
	  ) {
	    if (!this.elements.hasOwnProperty(key)) {
	      this.keyOrder.push(key);
	    } else if (shouldReorder) {
	      var index = this.keyOrder.indexOf(key);
	      this.keyOrder.splice(index, 1);
	      this.keyOrder.push(key);
	    }
	
	    if (value == null) {
	      this.elements[key] = value;
	      return;
	    }
	
	    if (MAP_EXISTS && value instanceof Map || value instanceof OrderedElements) {
	      // We have found a nested Map, so we need to recurse so that all
	      // of the nested objects and Maps are merged properly.
	      var nested = this.elements.hasOwnProperty(key) ? this.elements[key] : new OrderedElements();
	      value.forEach(function (value, key) {
	        nested.set(key, value, shouldReorder);
	      });
	      this.elements[key] = nested;
	      return;
	    }
	
	    if (!Array.isArray(value) && _typeof(value) === 'object') {
	      // We have found a nested object, so we need to recurse so that all
	      // of the nested objects and Maps are merged properly.
	      var _nested = this.elements.hasOwnProperty(key) ? this.elements[key] : new OrderedElements();
	
	      var keys = Object.keys(value);
	
	      for (var i = 0; i < keys.length; i += 1) {
	        _nested.set(keys[i], value[keys[i]], shouldReorder);
	      }
	
	      this.elements[key] = _nested;
	      return;
	    }
	
	    this.elements[key] = value;
	  };
	
	  _proto.get = function get(key
	  /* : string */
	  )
	  /* : any */
	  {
	    return this.elements[key];
	  };
	
	  _proto.has = function has(key
	  /* : string */
	  )
	  /* : boolean */
	  {
	    return this.elements.hasOwnProperty(key);
	  };
	
	  _proto.addStyleType = function addStyleType(styleType
	  /* : any */
	  )
	  /* : void */
	  {
	    var _this = this;
	
	    if (MAP_EXISTS && styleType instanceof Map || styleType instanceof OrderedElements) {
	      styleType.forEach(function (value, key) {
	        _this.set(key, value, true);
	      });
	    } else {
	      var keys = Object.keys(styleType);
	
	      for (var i = 0; i < keys.length; i++) {
	        this.set(keys[i], styleType[keys[i]], true);
	      }
	    }
	  };
	
	  return OrderedElements;
	}();
	
	var w = ["Webkit"];
	var m = ["Moz"];
	var ms = ["ms"];
	var wm = ["Webkit", "Moz"];
	var wms = ["Webkit", "ms"];
	var wmms = ["Webkit", "Moz", "ms"];
	var staticData = {
	  plugins: [backgroundClip, calc, crossFade, cursor, filter, flex, flexboxIE, flexboxOld, gradient, imageSet, logical, position, sizing, transition],
	  prefixMap: {
	    "transform": wms,
	    "transformOrigin": wms,
	    "transformOriginX": wms,
	    "transformOriginY": wms,
	    "backfaceVisibility": w,
	    "perspective": w,
	    "perspectiveOrigin": w,
	    "transformStyle": w,
	    "transformOriginZ": w,
	    "animation": w,
	    "animationDelay": w,
	    "animationDirection": w,
	    "animationFillMode": w,
	    "animationDuration": w,
	    "animationIterationCount": w,
	    "animationName": w,
	    "animationPlayState": w,
	    "animationTimingFunction": w,
	    "appearance": wm,
	    "userSelect": wmms,
	    "fontKerning": w,
	    "textEmphasisPosition": w,
	    "textEmphasis": w,
	    "textEmphasisStyle": w,
	    "textEmphasisColor": w,
	    "boxDecorationBreak": w,
	    "clipPath": w,
	    "maskImage": w,
	    "maskMode": w,
	    "maskRepeat": w,
	    "maskPosition": w,
	    "maskClip": w,
	    "maskOrigin": w,
	    "maskSize": w,
	    "maskComposite": w,
	    "mask": w,
	    "maskBorderSource": w,
	    "maskBorderMode": w,
	    "maskBorderSlice": w,
	    "maskBorderWidth": w,
	    "maskBorderOutset": w,
	    "maskBorderRepeat": w,
	    "maskBorder": w,
	    "maskType": w,
	    "textDecorationStyle": wm,
	    "textDecorationSkip": wm,
	    "textDecorationLine": wm,
	    "textDecorationColor": wm,
	    "filter": w,
	    "fontFeatureSettings": wm,
	    "breakAfter": wmms,
	    "breakBefore": wmms,
	    "breakInside": wmms,
	    "columnCount": wm,
	    "columnFill": wm,
	    "columnGap": wm,
	    "columnRule": wm,
	    "columnRuleColor": wm,
	    "columnRuleStyle": wm,
	    "columnRuleWidth": wm,
	    "columns": wm,
	    "columnSpan": wm,
	    "columnWidth": wm,
	    "writingMode": wms,
	    "flex": wms,
	    "flexBasis": w,
	    "flexDirection": wms,
	    "flexGrow": w,
	    "flexFlow": wms,
	    "flexShrink": w,
	    "flexWrap": wms,
	    "alignContent": w,
	    "alignItems": w,
	    "alignSelf": w,
	    "justifyContent": w,
	    "order": w,
	    "transitionDelay": w,
	    "transitionDuration": w,
	    "transitionProperty": w,
	    "transitionTimingFunction": w,
	    "backdropFilter": w,
	    "scrollSnapType": wms,
	    "scrollSnapPointsX": wms,
	    "scrollSnapPointsY": wms,
	    "scrollSnapDestination": wms,
	    "scrollSnapCoordinate": wms,
	    "shapeImageThreshold": w,
	    "shapeImageMargin": w,
	    "shapeImageOutside": w,
	    "hyphens": wmms,
	    "flowInto": wms,
	    "flowFrom": wms,
	    "regionFragment": wms,
	    "textOrientation": w,
	    "boxSizing": m,
	    "textAlignLast": m,
	    "tabSize": m,
	    "wrapFlow": ms,
	    "wrapThrough": ms,
	    "wrapMargin": ms,
	    "touchAction": ms,
	    "gridTemplateColumns": ms,
	    "gridTemplateRows": ms,
	    "gridTemplateAreas": ms,
	    "gridTemplate": ms,
	    "gridAutoColumns": ms,
	    "gridAutoRows": ms,
	    "gridAutoFlow": ms,
	    "grid": ms,
	    "gridRowStart": ms,
	    "gridColumnStart": ms,
	    "gridRowEnd": ms,
	    "gridRow": ms,
	    "gridColumn": ms,
	    "gridColumnEnd": ms,
	    "gridColumnGap": ms,
	    "gridRowGap": ms,
	    "gridArea": ms,
	    "gridGap": ms,
	    "textSizeAdjust": wms,
	    "borderImage": w,
	    "borderImageOutset": w,
	    "borderImageRepeat": w,
	    "borderImageSlice": w,
	    "borderImageSource": w,
	    "borderImageWidth": w
	  }
	};
	
	var prefixAll = createPrefixer(staticData);
	/* ::
	import type { SheetDefinition } from './index.js';
	type StringHandlers = { [id:string]: Function };
	type SelectorCallback = (selector: string) => string[];
	export type SelectorHandler = (
	    selector: string,
	    baseSelector: string,
	    callback: SelectorCallback
	) => string[] | string | null;
	*/
	
	/**
	 * `selectorHandlers` are functions which handle special selectors which act
	 * differently than normal style definitions. These functions look at the
	 * current selector and can generate CSS for the styles in their subtree by
	 * calling the callback with a new selector.
	 *
	 * For example, when generating styles with a base selector of '.foo' and the
	 * following styles object:
	 *
	 *   {
	 *     ':nth-child(2n)': {
	 *       ':hover': {
	 *         color: 'red'
	 *       }
	 *     }
	 *   }
	 *
	 * when we reach the ':hover' style, we would call our selector handlers like
	 *
	 *   handler(':hover', '.foo:nth-child(2n)', callback)
	 *
	 * Since our `pseudoSelectors` handles ':hover' styles, that handler would call
	 * the callback like
	 *
	 *   callback('.foo:nth-child(2n):hover')
	 *
	 * to generate its subtree `{ color: 'red' }` styles with a
	 * '.foo:nth-child(2n):hover' selector. The callback would return an array of CSS
	 * rules like
	 *
	 *   ['.foo:nth-child(2n):hover{color:red !important;}']
	 *
	 * and the handler would then return that resulting CSS.
	 *
	 * `defaultSelectorHandlers` is the list of default handlers used in a call to
	 * `generateCSS`.
	 *
	 * @name SelectorHandler
	 * @function
	 * @param {string} selector: The currently inspected selector. ':hover' in the
	 *     example above.
	 * @param {string} baseSelector: The selector of the parent styles.
	 *     '.foo:nth-child(2n)' in the example above.
	 * @param {function} generateSubtreeStyles: A function which can be called to
	 *     generate CSS for the subtree of styles corresponding to the selector.
	 *     Accepts a new baseSelector to use for generating those styles.
	 * @returns {string[] | string | null} The generated CSS for this selector, or
	 *     null if we don't handle this selector.
	 */
	
	var defaultSelectorHandlers
	/* : SelectorHandler[] */
	= [// Handle pseudo-selectors, like :hover and :nth-child(3n)
	function pseudoSelectors(selector, baseSelector, generateSubtreeStyles) {
	  if (selector[0] !== ":") {
	    return null;
	  }
	
	  return generateSubtreeStyles(baseSelector + selector);
	}, // Handle media queries (or font-faces)
	function mediaQueries(selector, baseSelector, generateSubtreeStyles) {
	  if (selector[0] !== "@") {
	    return null;
	  } // Generate the styles normally, and then wrap them in the media query.
	
	
	  var generated = generateSubtreeStyles(baseSelector);
	  return ["".concat(selector, "{").concat(generated.join(''), "}")];
	}];
	/**
	 * Generate CSS for a selector and some styles.
	 *
	 * This function handles the media queries and pseudo selectors that can be used
	 * in aphrodite styles.
	 *
	 * @param {string} selector: A base CSS selector for the styles to be generated
	 *     with.
	 * @param {Object} styleTypes: A list of properties of the return type of
	 *     StyleSheet.create, e.g. [styles.red, styles.blue].
	 * @param {Array.<SelectorHandler>} selectorHandlers: A list of selector
	 *     handlers to use for handling special selectors. See
	 *     `defaultSelectorHandlers`.
	 * @param stringHandlers: See `generateCSSRuleset`
	 * @param useImportant: See `generateCSSRuleset`
	 *
	 * To actually generate the CSS special-construct-less styles are passed to
	 * `generateCSSRuleset`.
	 *
	 * For instance, a call to
	 *
	 *     generateCSS(".foo", [{
	 *       color: "red",
	 *       "@media screen": {
	 *         height: 20,
	 *         ":hover": {
	 *           backgroundColor: "black"
	 *         }
	 *       },
	 *       ":active": {
	 *         fontWeight: "bold"
	 *       }
	 *     }], defaultSelectorHandlers);
	 *
	 * with the default `selectorHandlers` will make 5 calls to
	 * `generateCSSRuleset`:
	 *
	 *     generateCSSRuleset(".foo", { color: "red" }, ...)
	 *     generateCSSRuleset(".foo:active", { fontWeight: "bold" }, ...)
	 *     // These 2 will be wrapped in @media screen {}
	 *     generateCSSRuleset(".foo", { height: 20 }, ...)
	 *     generateCSSRuleset(".foo:hover", { backgroundColor: "black" }, ...)
	 */
	
	var generateCSS = function generateCSS(selector
	/* : string */
	, styleTypes
	/* : SheetDefinition[] */
	, selectorHandlers
	/* : SelectorHandler[] */
	, stringHandlers
	/* : StringHandlers */
	, useImportant
	/* : boolean */
	)
	/* : string[] */
	{
	  var merged = new OrderedElements();
	
	  for (var i = 0; i < styleTypes.length; i++) {
	    merged.addStyleType(styleTypes[i]);
	  }
	
	  var plainDeclarations = new OrderedElements();
	  var generatedStyles = []; // TODO(emily): benchmark this to see if a plain for loop would be faster.
	
	  merged.forEach(function (val, key) {
	    // For each key, see if one of the selector handlers will handle these
	    // styles.
	    var foundHandler = selectorHandlers.some(function (handler) {
	      var result = handler(key, selector, function (newSelector) {
	        return generateCSS(newSelector, [val], selectorHandlers, stringHandlers, useImportant);
	      });
	
	      if (result != null) {
	        // If the handler returned something, add it to the generated
	        // CSS and stop looking for another handler.
	        if (Array.isArray(result)) {
	          generatedStyles.push.apply(generatedStyles, _toConsumableArray(result));
	        } else {
	          // eslint-disable-next-line
	          console.warn('WARNING: Selector handlers should return an array of rules.' + 'Returning a string containing multiple rules is deprecated.', handler);
	          generatedStyles.push("@media all {".concat(result, "}"));
	        }
	
	        return true;
	      }
	    }); // If none of the handlers handled it, add it to the list of plain
	    // style declarations.
	
	    if (!foundHandler) {
	      plainDeclarations.set(key, val, true);
	    }
	  });
	  var generatedRuleset = generateCSSRuleset(selector, plainDeclarations, stringHandlers, useImportant, selectorHandlers);
	
	  if (generatedRuleset) {
	    generatedStyles.unshift(generatedRuleset);
	  }
	
	  return generatedStyles;
	};
	/**
	 * Helper method of generateCSSRuleset to facilitate custom handling of certain
	 * CSS properties. Used for e.g. font families.
	 *
	 * See generateCSSRuleset for usage and documentation of paramater types.
	 */
	
	var runStringHandlers = function runStringHandlers(declarations
	/* : OrderedElements */
	, stringHandlers
	/* : StringHandlers */
	, selectorHandlers
	/* : SelectorHandler[] */
	)
	/* : void */
	{
	  if (!stringHandlers) {
	    return;
	  }
	
	  var stringHandlerKeys = Object.keys(stringHandlers);
	
	  for (var i = 0; i < stringHandlerKeys.length; i++) {
	    var key = stringHandlerKeys[i];
	
	    if (declarations.has(key)) {
	      // A declaration exists for this particular string handler, so we
	      // need to let the string handler interpret the declaration first
	      // before proceeding.
	      //
	      // TODO(emily): Pass in a callback which generates CSS, similar to
	      // how our selector handlers work, instead of passing in
	      // `selectorHandlers` and have them make calls to `generateCSS`
	      // themselves. Right now, this is impractical because our string
	      // handlers are very specialized and do complex things.
	      declarations.set(key, stringHandlers[key](declarations.get(key), selectorHandlers), // Preserve order here, since we are really replacing an
	      // unprocessed style with a processed style, not overriding an
	      // earlier style
	      false);
	    }
	  }
	};
	
	var transformRule = function transformRule(key
	/* : string */
	, value
	/* : string */
	, transformValue
	/* : function */
	) {
	  return (
	    /* : string */
	    "".concat(kebabifyStyleName(key), ":").concat(transformValue(key, value), ";")
	  );
	};
	
	var arrayToObjectKeysReducer = function arrayToObjectKeysReducer(acc, val) {
	  acc[val] = true;
	  return acc;
	};
	/**
	 * Generate a CSS ruleset with the selector and containing the declarations.
	 *
	 * This function assumes that the given declarations don't contain any special
	 * children (such as media queries, pseudo-selectors, or descendant styles).
	 *
	 * Note that this method does not deal with nesting used for e.g.
	 * psuedo-selectors or media queries. That responsibility is left to  the
	 * `generateCSS` function.
	 *
	 * @param {string} selector: the selector associated with the ruleset
	 * @param {Object} declarations: a map from camelCased CSS property name to CSS
	 *     property value.
	 * @param {Object.<string, function>} stringHandlers: a map from camelCased CSS
	 *     property name to a function which will map the given value to the value
	 *     that is output.
	 * @param {bool} useImportant: A boolean saying whether to append "!important"
	 *     to each of the CSS declarations.
	 * @returns {string} A string of raw CSS.
	 *
	 * Examples:
	 *
	 *    generateCSSRuleset(".blah", { color: "red" })
	 *    -> ".blah{color: red !important;}"
	 *    generateCSSRuleset(".blah", { color: "red" }, {}, false)
	 *    -> ".blah{color: red}"
	 *    generateCSSRuleset(".blah", { color: "red" }, {color: c => c.toUpperCase})
	 *    -> ".blah{color: RED}"
	 *    generateCSSRuleset(".blah:hover", { color: "red" })
	 *    -> ".blah:hover{color: red}"
	 */
	
	
	var generateCSSRuleset = function generateCSSRuleset(selector
	/* : string */
	, declarations
	/* : OrderedElements */
	, stringHandlers
	/* : StringHandlers */
	, useImportant
	/* : boolean */
	, selectorHandlers
	/* : SelectorHandler[] */
	)
	/* : string */
	{
	  // Mutates declarations
	  runStringHandlers(declarations, stringHandlers, selectorHandlers);
	  var originalElements = Object.keys(declarations.elements).reduce(arrayToObjectKeysReducer, Object.create(null)); // NOTE(emily): This mutates handledDeclarations.elements.
	
	  var prefixedElements = prefixAll(declarations.elements);
	  var elementNames = Object.keys(prefixedElements);
	
	  if (elementNames.length !== declarations.keyOrder.length) {
	    // There are some prefixed values, so we need to figure out how to sort
	    // them.
	    //
	    // Loop through prefixedElements, looking for anything that is not in
	    // sortOrder, which means it was added by prefixAll. This means that we
	    // need to figure out where it should appear in the sortOrder.
	    for (var i = 0; i < elementNames.length; i++) {
	      if (!originalElements[elementNames[i]]) {
	        // This element is not in the sortOrder, which means it is a prefixed
	        // value that was added by prefixAll. Let's try to figure out where it
	        // goes.
	        var originalStyle = void 0;
	
	        if (elementNames[i][0] === 'W') {
	          // This is a Webkit-prefixed style, like "WebkitTransition". Let's
	          // find its original style's sort order.
	          originalStyle = elementNames[i][6].toLowerCase() + elementNames[i].slice(7);
	        } else if (elementNames[i][1] === 'o') {
	          // This is a Moz-prefixed style, like "MozTransition". We check
	          // the second character to avoid colliding with Ms-prefixed
	          // styles. Let's find its original style's sort order.
	          originalStyle = elementNames[i][3].toLowerCase() + elementNames[i].slice(4);
	        } else {
	          // if (elementNames[i][1] === 's') {
	          // This is a Ms-prefixed style, like "MsTransition".
	          originalStyle = elementNames[i][2].toLowerCase() + elementNames[i].slice(3);
	        }
	
	        if (originalStyle && originalElements[originalStyle]) {
	          var originalIndex = declarations.keyOrder.indexOf(originalStyle);
	          declarations.keyOrder.splice(originalIndex, 0, elementNames[i]);
	        } else {
	          // We don't know what the original style was, so sort it to
	          // top. This can happen for styles that are added that don't
	          // have the same base name as the original style.
	          declarations.keyOrder.unshift(elementNames[i]);
	        }
	      }
	    }
	  }
	
	  var transformValue = useImportant === false ? stringifyValue : stringifyAndImportantifyValue;
	  var rules = [];
	
	  for (var _i = 0; _i < declarations.keyOrder.length; _i++) {
	    var key = declarations.keyOrder[_i];
	    var value = prefixedElements[key];
	
	    if (Array.isArray(value)) {
	      // inline-style-prefixer returns an array when there should be
	      // multiple rules for the same key. Here we flatten to multiple
	      // pairs with the same key.
	      for (var j = 0; j < value.length; j++) {
	        rules.push(transformRule(key, value[j], transformValue));
	      }
	    } else {
	      rules.push(transformRule(key, value, transformValue));
	    }
	  }
	
	  if (rules.length) {
	    return "".concat(selector, "{").concat(rules.join(""), "}");
	  } else {
	    return "";
	  }
	};
	
	/* ::
	import type { SheetDefinition, SheetDefinitions } from './index.js';
	import type { MaybeSheetDefinition } from './exports.js';
	import type { SelectorHandler } from './generate.js';
	*/
	// The current <style> tag we are inserting into, or null if we haven't
	// inserted anything yet. We could find this each time using
	// `document.querySelector("style[data-aphrodite"])`, but holding onto it is
	// faster.
	
	var styleTag
	/* : ?HTMLStyleElement */
	= null; // Inject a set of rules into a <style> tag in the head of the document. This
	// will automatically create a style tag and then continue to use it for
	// multiple injections. It will also use a style tag with the `data-aphrodite`
	// tag on it if that exists in the DOM. This could be used for e.g. reusing the
	// same style tag that server-side rendering inserts.
	
	var injectStyleTag = function injectStyleTag(cssRules
	/* : string[] */
	) {
	  if (styleTag == null) {
	    // Try to find a style tag with the `data-aphrodite` attribute first.
	    styleTag = document.querySelector("style[data-aphrodite]")
	    /* : any */
	    ; // If that doesn't work, generate a new style tag.
	
	    if (styleTag == null) {
	      // Taken from
	      // http://stackoverflow.com/questions/524696/how-to-create-a-style-tag-with-javascript
	      var head = document.head || document.getElementsByTagName('head')[0];
	      styleTag = document.createElement('style');
	      styleTag.type = 'text/css';
	      styleTag.setAttribute("data-aphrodite", "");
	      head.appendChild(styleTag);
	    }
	  } // $FlowFixMe
	
	
	  var sheet = styleTag.styleSheet || styleTag.sheet
	  /* : any */
	  ;
	
	  if (sheet.insertRule) {
	    var numRules = sheet.cssRules.length;
	    cssRules.forEach(function (rule) {
	      try {
	        sheet.insertRule(rule, numRules);
	        numRules += 1;
	      } catch (e) {// The selector for this rule wasn't compatible with the browser
	      }
	    });
	  } else {
	    styleTag.innerText = (styleTag.innerText || '') + cssRules.join('');
	  }
	}; // Custom handlers for stringifying CSS values that have side effects
	// (such as fontFamily, which can cause @font-face rules to be injected)
	
	
	var stringHandlers = {
	  // With fontFamily we look for objects that are passed in and interpret
	  // them as @font-face rules that we need to inject. The value of fontFamily
	  // can either be a string (as normal), an object (a single font face), or
	  // an array of objects and strings.
	  fontFamily: function fontFamily(val) {
	    if (Array.isArray(val)) {
	      var nameMap = {};
	      val.forEach(function (v) {
	        nameMap[fontFamily(v)] = true;
	      });
	      return Object.keys(nameMap).join(",");
	    } else if (_typeof(val) === "object") {
	      injectStyleOnce(val.src, "@font-face", [val], false);
	      return "\"".concat(val.fontFamily, "\"");
	    } else {
	      return val;
	    }
	  },
	  // With animationName we look for an object that contains keyframes and
	  // inject them as an `@keyframes` block, returning a uniquely generated
	  // name. The keyframes object should look like
	  //  animationName: {
	  //    from: {
	  //      left: 0,
	  //      top: 0,
	  //    },
	  //    '50%': {
	  //      left: 15,
	  //      top: 5,
	  //    },
	  //    to: {
	  //      left: 20,
	  //      top: 20,
	  //    }
	  //  }
	  // TODO(emily): `stringHandlers` doesn't let us rename the key, so I have
	  // to use `animationName` here. Improve that so we can call this
	  // `animation` instead of `animationName`.
	  animationName: function animationName(val, selectorHandlers) {
	    if (Array.isArray(val)) {
	      return val.map(function (v) {
	        return animationName(v, selectorHandlers);
	      }).join(",");
	    } else if (_typeof(val) === "object") {
	      // Generate a unique name based on the hash of the object. We can't
	      // just use the hash because the name can't start with a number.
	      // TODO(emily): this probably makes debugging hard, allow a custom
	      // name?
	      var name = "keyframe_".concat(hashObject(val)); // Since keyframes need 3 layers of nesting, we use `generateCSS` to
	      // build the inner layers and wrap it in `@keyframes` ourselves.
	
	      var finalVal = "@keyframes ".concat(name, "{"); // TODO see if we can find a way where checking for OrderedElements
	      // here is not necessary. Alternatively, perhaps we should have a
	      // utility method that can iterate over either a plain object, an
	      // instance of OrderedElements, or a Map, and then use that here and
	      // elsewhere.
	
	      if (val instanceof OrderedElements) {
	        val.forEach(function (valVal, valKey) {
	          finalVal += generateCSS(valKey, [valVal], selectorHandlers, stringHandlers, false).join('');
	        });
	      } else {
	        Object.keys(val).forEach(function (key) {
	          finalVal += generateCSS(key, [val[key]], selectorHandlers, stringHandlers, false).join('');
	        });
	      }
	
	      finalVal += '}';
	      injectGeneratedCSSOnce(name, [finalVal]);
	      return name;
	    } else {
	      return val;
	    }
	  }
	}; // This is a map from Aphrodite's generated class names to `true` (acting as a
	// set of class names)
	
	var alreadyInjected = {}; // This is the buffer of styles which have not yet been flushed.
	
	var injectionBuffer
	/* : string[] */
	= []; // A flag to tell if we are already buffering styles. This could happen either
	// because we scheduled a flush call already, so newly added styles will
	// already be flushed, or because we are statically buffering on the server.
	
	var isBuffering = false;
	
	var injectGeneratedCSSOnce = function injectGeneratedCSSOnce(key, generatedCSS) {
	  var _injectionBuffer;
	
	  if (alreadyInjected[key]) {
	    return;
	  }
	
	  if (!isBuffering) {
	    // We should never be automatically buffering on the server (or any
	    // place without a document), so guard against that.
	    if (typeof document === "undefined") {
	      throw new Error("Cannot automatically buffer without a document");
	    } // If we're not already buffering, schedule a call to flush the
	    // current styles.
	
	
	    isBuffering = true;
	    asap(flushToStyleTag);
	  }
	
	  (_injectionBuffer = injectionBuffer).push.apply(_injectionBuffer, _toConsumableArray(generatedCSS));
	
	  alreadyInjected[key] = true;
	};
	
	var injectStyleOnce = function injectStyleOnce(key
	/* : string */
	, selector
	/* : string */
	, definitions
	/* : SheetDefinition[] */
	, useImportant
	/* : boolean */
	) {
	  var selectorHandlers
	  /* : SelectorHandler[] */
	  = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	
	  if (alreadyInjected[key]) {
	    return;
	  }
	
	  var generated = generateCSS(selector, definitions, selectorHandlers, stringHandlers, useImportant);
	  injectGeneratedCSSOnce(key, generated);
	};
	var reset = function reset() {
	  injectionBuffer = [];
	  alreadyInjected = {};
	  isBuffering = false;
	  styleTag = null;
	};
	var getBufferedStyles = function getBufferedStyles() {
	  return injectionBuffer;
	};
	var startBuffering = function startBuffering() {
	  if (isBuffering) {
	    throw new Error("Cannot buffer while already buffering");
	  }
	
	  isBuffering = true;
	};
	
	var flushToArray = function flushToArray() {
	  isBuffering = false;
	  var ret = injectionBuffer;
	  injectionBuffer = [];
	  return ret;
	};
	
	var flushToString = function flushToString() {
	  return flushToArray().join('');
	};
	var flushToStyleTag = function flushToStyleTag() {
	  var cssRules = flushToArray();
	
	  if (cssRules.length > 0) {
	    injectStyleTag(cssRules);
	  }
	};
	var getRenderedClassNames = function getRenderedClassNames()
	/* : string[] */
	{
	  return Object.keys(alreadyInjected);
	};
	var addRenderedClassNames = function addRenderedClassNames(classNames
	/* : string[] */
	) {
	  classNames.forEach(function (className) {
	    alreadyInjected[className] = true;
	  });
	};
	
	var processStyleDefinitions = function processStyleDefinitions(styleDefinitions
	/* : any[] */
	, classNameBits
	/* : string[] */
	, definitionBits
	/* : Object[] */
	, length
	/* : number */
	)
	/* : number */
	{
	  for (var i = 0; i < styleDefinitions.length; i += 1) {
	    // Filter out falsy values from the input, to allow for
	    // `css(a, test && c)`
	    if (styleDefinitions[i]) {
	      if (Array.isArray(styleDefinitions[i])) {
	        // We've encountered an array, so let's recurse
	        length += processStyleDefinitions(styleDefinitions[i], classNameBits, definitionBits, length);
	      } else {
	        classNameBits.push(styleDefinitions[i]._name);
	        definitionBits.push(styleDefinitions[i]._definition);
	        length += styleDefinitions[i]._len;
	      }
	    }
	  }
	
	  return length;
	};
	/**
	 * Inject styles associated with the passed style definition objects, and return
	 * an associated CSS class name.
	 *
	 * @param {boolean} useImportant If true, will append !important to generated
	 *     CSS output. e.g. {color: red} -> "color: red !important".
	 * @param {(Object|Object[])[]} styleDefinitions style definition objects, or
	 *     arbitrarily nested arrays of them, as returned as properties of the
	 *     return value of StyleSheet.create().
	 */
	
	
	var injectAndGetClassName = function injectAndGetClassName(useImportant
	/* : boolean */
	, styleDefinitions
	/* : MaybeSheetDefinition[] */
	, selectorHandlers
	/* : SelectorHandler[] */
	)
	/* : string */
	{
	  var classNameBits = [];
	  var definitionBits = []; // Mutates classNameBits and definitionBits and returns a length which we
	  // will append to the hash to decrease the chance of hash collisions.
	
	  var length = processStyleDefinitions(styleDefinitions, classNameBits, definitionBits, 0); // Break if there aren't any valid styles.
	
	  if (classNameBits.length === 0) {
	    return "";
	  }
	
	  var className;
	
	  if (true) {
	    className = classNameBits.length === 1 ? "_".concat(classNameBits[0]) : "_".concat(hashString(classNameBits.join())).concat((length % 36).toString(36));
	  } else {
	    className = classNameBits.join("-o_O-");
	  }
	
	  injectStyleOnce(className, ".".concat(className), definitionBits, useImportant, selectorHandlers);
	  return className;
	};
	
	/* ::
	import type { SelectorHandler } from './generate.js';
	export type SheetDefinition = { [id:string]: any };
	export type SheetDefinitions = SheetDefinition | SheetDefinition[];
	type RenderFunction = () => string;
	type Extension = {
	    selectorHandler: SelectorHandler
	};
	export type MaybeSheetDefinition = SheetDefinition | false | null | void
	*/
	
	var unminifiedHashFn = function unminifiedHashFn(str
	/* : string */
	, key
	/* : string */
	) {
	  return "".concat(key, "_").concat(hashString(str));
	}; // StyleSheet.create is in a hot path so we want to keep as much logic out of it
	// as possible. So, we figure out which hash function to use once, and only
	// switch it out via minify() as necessary.
	//
	// This is in an exported function to make it easier to test.
	
	
	var initialHashFn = function initialHashFn() {
	  return  true ? hashString : unminifiedHashFn;
	};
	var hashFn = initialHashFn();
	var StyleSheet = {
	  create: function create(sheetDefinition
	  /* : SheetDefinition */
	  )
	  /* : Object */
	  {
	    var mappedSheetDefinition = {};
	    var keys = Object.keys(sheetDefinition);
	
	    for (var i = 0; i < keys.length; i += 1) {
	      var key = keys[i];
	      var val = sheetDefinition[key];
	      var stringVal = JSON.stringify(val);
	      mappedSheetDefinition[key] = {
	        _len: stringVal.length,
	        _name: hashFn(stringVal, key),
	        _definition: val
	      };
	    }
	
	    return mappedSheetDefinition;
	  },
	  rehydrate: function rehydrate() {
	    var renderedClassNames
	    /* : string[] */
	    = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    addRenderedClassNames(renderedClassNames);
	  }
	};
	/**
	 * Utilities for using Aphrodite server-side.
	 *
	 * This can be minified out in client-only bundles by replacing `typeof window`
	 * with `"object"`, e.g. via Webpack's DefinePlugin:
	 *
	 *   new webpack.DefinePlugin({
	 *     "typeof window": JSON.stringify("object")
	 *   })
	 */
	
	var StyleSheetServer = typeof window !== 'undefined' ? null : {
	  renderStatic: function renderStatic(renderFunc
	  /* : RenderFunction */
	  ) {
	    reset();
	    startBuffering();
	    var html = renderFunc();
	    var cssContent = flushToString();
	    return {
	      html: html,
	      css: {
	        content: cssContent,
	        renderedClassNames: getRenderedClassNames()
	      }
	    };
	  }
	};
	/**
	 * Utilities for using Aphrodite in tests.
	 *
	 * Not meant to be used in production.
	 */
	
	var StyleSheetTestUtils =  true ? null : {
	  /**
	  * Prevent styles from being injected into the DOM.
	  *
	  * This is useful in situations where you'd like to test rendering UI
	  * components which use Aphrodite without any of the side-effects of
	  * Aphrodite happening. Particularly useful for testing the output of
	  * components when you have no DOM, e.g. testing in Node without a fake DOM.
	  *
	  * Should be paired with a subsequent call to
	  * clearBufferAndResumeStyleInjection.
	  */
	  suppressStyleInjection: function suppressStyleInjection() {
	    reset();
	    startBuffering();
	  },
	
	  /**
	  * Opposite method of preventStyleInject.
	  */
	  clearBufferAndResumeStyleInjection: function clearBufferAndResumeStyleInjection() {
	    reset();
	  },
	
	  /**
	  * Returns a string of buffered styles which have not been flushed
	  *
	  * @returns {string}  Buffer of styles which have not yet been flushed.
	  */
	  getBufferedStyles: function getBufferedStyles$1() {
	    return getBufferedStyles();
	  }
	};
	/**
	 * Generate the Aphrodite API exports, with given `selectorHandlers` and
	 * `useImportant` state.
	 */
	
	function makeExports(useImportant
	/* : boolean */
	) {
	  var selectorHandlers
	  /* : SelectorHandler[] */
	  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultSelectorHandlers;
	  return {
	    StyleSheet: _objectSpread({}, StyleSheet, {
	      /**
	       * Returns a version of the exports of Aphrodite (i.e. an object
	       * with `css` and `StyleSheet` properties) which have some
	       * extensions included.
	       *
	       * @param {Array.<Object>} extensions: An array of extensions to
	       *     add to this instance of Aphrodite. Each object should have a
	       *     single property on it, defining which kind of extension to
	       *     add.
	       * @param {SelectorHandler} [extensions[].selectorHandler]: A
	       *     selector handler extension. See `defaultSelectorHandlers` in
	       *     generate.js.
	       *
	       * @returns {Object} An object containing the exports of the new
	       *     instance of Aphrodite.
	       */
	      extend: function extend(extensions
	      /* : Extension[] */
	      ) {
	        var extensionSelectorHandlers = extensions // Pull out extensions with a selectorHandler property
	        .map(function (extension) {
	          return extension.selectorHandler;
	        }) // Remove nulls (i.e. extensions without a selectorHandler property).
	        .filter(function (handler) {
	          return handler;
	        });
	        return makeExports(useImportant, selectorHandlers.concat(extensionSelectorHandlers));
	      }
	    }),
	    StyleSheetServer: StyleSheetServer,
	    StyleSheetTestUtils: StyleSheetTestUtils,
	    minify: function minify(shouldMinify
	    /* : boolean */
	    ) {
	      hashFn = shouldMinify ? hashString : unminifiedHashFn;
	    },
	    css: function css()
	    /* : MaybeSheetDefinition[] */
	    {
	      for (var _len = arguments.length, styleDefinitions = new Array(_len), _key = 0; _key < _len; _key++) {
	        styleDefinitions[_key] = arguments[_key];
	      }
	
	      return injectAndGetClassName(useImportant, styleDefinitions, selectorHandlers);
	    },
	    flushToStyleTag: flushToStyleTag,
	    injectAndGetClassName: injectAndGetClassName,
	    defaultSelectorHandlers: defaultSelectorHandlers
	  };
	}
	
	exports.makeExports = makeExports;


/***/ }),
/* 68 */,
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _H = __webpack_require__(222);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_H).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),
/* 82 */,
/* 83 */,
/* 84 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var isBrowser = "object" !== 'undefined';
	function getRegisteredStyles(registered, registeredStyles, classNames) {
	  var rawClassName = '';
	  classNames.split(' ').forEach(function (className) {
	    if (registered[className] !== undefined) {
	      registeredStyles.push(registered[className]);
	    } else {
	      rawClassName += className + " ";
	    }
	  });
	  return rawClassName;
	}
	var insertStyles = function insertStyles(cache, serialized, isStringTag) {
	  var className = cache.key + "-" + serialized.name;
	
	  if ( // we only need to add the styles to the registered cache if the
	  // class name could be used further down
	  // the tree but if it's a string tag, we know it won't
	  // so we don't have to add it to registered cache.
	  // this improves memory usage since we can avoid storing the whole style string
	  (isStringTag === false || // we need to always store it if we're in compat mode and
	  // in node since emotion-server relies on whether a style is in
	  // the registered cache to know whether a style is global or not
	  // also, note that this check will be dead code eliminated in the browser
	  isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
	    cache.registered[className] = serialized.styles;
	  }
	
	  if (cache.inserted[serialized.name] === undefined) {
	    var current = serialized;
	
	    do {
	      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);
	
	      current = current.next;
	    } while (current !== undefined);
	  }
	};
	
	exports.getRegisteredStyles = getRegisteredStyles;
	exports.insertStyles = insertStyles;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var __chunk_1 = __webpack_require__(67);
	__webpack_require__(53);
	__webpack_require__(27);
	__webpack_require__(36);
	__webpack_require__(37);
	__webpack_require__(38);
	__webpack_require__(39);
	__webpack_require__(40);
	__webpack_require__(41);
	__webpack_require__(42);
	__webpack_require__(43);
	__webpack_require__(44);
	__webpack_require__(45);
	__webpack_require__(46);
	__webpack_require__(47);
	__webpack_require__(48);
	__webpack_require__(49);
	__webpack_require__(50);
	
	var useImportant = true; // Add !important to all style definitions
	
	var Aphrodite = __chunk_1.makeExports(useImportant);
	var StyleSheet = Aphrodite.StyleSheet,
	    StyleSheetServer = Aphrodite.StyleSheetServer,
	    StyleSheetTestUtils = Aphrodite.StyleSheetTestUtils,
	    css = Aphrodite.css,
	    minify = Aphrodite.minify,
	    flushToStyleTag = Aphrodite.flushToStyleTag,
	    injectAndGetClassName = Aphrodite.injectAndGetClassName,
	    defaultSelectorHandlers = Aphrodite.defaultSelectorHandlers;
	
	exports.StyleSheet = StyleSheet;
	exports.StyleSheetServer = StyleSheetServer;
	exports.StyleSheetTestUtils = StyleSheetTestUtils;
	exports.css = css;
	exports.minify = minify;
	exports.flushToStyleTag = flushToStyleTag;
	exports.injectAndGetClassName = injectAndGetClassName;
	exports.defaultSelectorHandlers = defaultSelectorHandlers;


/***/ }),
/* 86 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 87 */,
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DownloadPdf = __webpack_require__(216);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DownloadPdf).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ExternalLink = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  padding-right: 1.2em;\n\n  background-size: 1em 1em;\n  background-repeat: no-repeat;\n  background-position: right;\n  background-image: url(', ');\n'], ['\n  padding-right: 1.2em;\n\n  background-size: 1em 1em;\n  background-repeat: no-repeat;\n  background-position: right;\n  background-image: url(', ');\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _outlineLaunch24px = __webpack_require__(440);
	
	var _outlineLaunch24px2 = _interopRequireDefault(_outlineLaunch24px);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var A = _styled2.default.a(_templateObject, _outlineLaunch24px2.default);
	
	var ExternalLink = exports.ExternalLink = function ExternalLink(_ref) {
	  var target = _ref.target,
	      href = _ref.href,
	      className = _ref.className,
	      rel = _ref.rel,
	      children = _ref.children;
	  return _react2.default.createElement(
	    A,
	    { href: href, target: target, rel: rel, className: className },
	    children || href
	  );
	};
	
	ExternalLink.propTypes = {
	  href: _propTypes2.default.string.isRequired,
	  target: _propTypes2.default.string,
	  rel: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.node
	};
	
	ExternalLink.defaultProps = {
	  target: '_blank',
	  rel: 'noopener nofollow external',
	  className: undefined,
	  children: undefined
	};

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ExternalSourcePropTypes = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExternalSourcePropTypes = exports.ExternalSourcePropTypes = {
	  type: _propTypes2.default.oneOf(['link', 'pdf', 'image', 'video', 'component', 'notype']),
	  body: _propTypes2.default.string.isRequired,
	  url: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
	  indent: _propTypes2.default.number
	};
	
	exports.default = _propTypes2.default.shape(ExternalSourcePropTypes);

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.H2 = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin-top: 2em;\n  color: ', ';\n  text-transform: uppercase;\n'], ['\n  margin-top: 2em;\n  color: ', ';\n  text-transform: uppercase;\n']);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _H = __webpack_require__(141);
	
	var _colors = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var H2 = exports.H2 = (0, _styled2.default)(_H.H3)(_templateObject, _colors.SecondaryTextColor);

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.HideLogoLabelOnPhoneStyles = exports.LogoLabelStyles = exports.LogoLabelFontSize = exports.LogoLabelColor = exports.px = exports.LOGO_PHONE_SCALE = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  font-size: ', ';\n  font-weight: normal;\n\n  color: ', ';\n\n  padding-bottom: 4px;\n'], ['\n  font-size: ', ';\n  font-weight: normal;\n\n  color: ', ';\n\n  padding-bottom: 4px;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  ', ' {\n    display: none;\n  }\n'], ['\n  ', ' {\n    display: none;\n  }\n']);
	
	var _emotion = __webpack_require__(22);
	
	var _breakpoints = __webpack_require__(4);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var LOGO_PHONE_SCALE = exports.LOGO_PHONE_SCALE = 0.73333;
	
	var px = exports.px = function px(px_) {
	  return Math.round(px_) + 'px';
	};
	
	var LogoLabelColor = exports.LogoLabelColor = '#A7A7A7';
	var LogoLabelFontSize = exports.LogoLabelFontSize = '13px';
	
	var LogoLabelStyles = exports.LogoLabelStyles = (0, _emotion.css)(_templateObject, LogoLabelFontSize, LogoLabelColor);
	
	var HideLogoLabelOnPhoneStyles = exports.HideLogoLabelOnPhoneStyles = (0, _emotion.css)(_templateObject2, _breakpoints.mediaPhone);

/***/ }),
/* 93 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var sharpImageRendering = "\n   image-rendering: -moz-crisp-edges;\n   image-rendering:   -o-crisp-edges;\n   image-rendering: -webkit-optimize-contrast;\n   image-rendering: crisp-edges;\n   -ms-interpolation-mode: nearest-neighbor;\n";
	
	exports.sharpImageRendering = sharpImageRendering;

/***/ }),
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hyphenateProperty;
	
	var _hyphenateStyleName = __webpack_require__(121);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hyphenateProperty(property) {
	  return (0, _hyphenateStyleName2.default)(property);
	}
	module.exports = exports['default'];

/***/ }),
/* 119 */,
/* 120 */,
/* 121 */
/***/ (function(module, exports) {

	'use strict';
	
	var uppercasePattern = /[A-Z]/g;
	var msPattern = /^ms-/;
	var cache = {};
	
	function hyphenateStyleName(string) {
	    return string in cache
	    ? cache[string]
	    : cache[string] = string
	      .replace(uppercasePattern, '-$&')
	      .toLowerCase()
	      .replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;


/***/ }),
/* 122 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addNewValuesOnly;
	function addIfNew(list, value) {
	  if (list.indexOf(value) === -1) {
	    list.push(value);
	  }
	}
	
	function addNewValuesOnly(list, values) {
	  if (Array.isArray(values)) {
	    for (var i = 0, len = values.length; i < len; ++i) {
	      addIfNew(list, values[i]);
	    }
	  } else {
	    addIfNew(list, values);
	  }
	}

/***/ }),
/* 123 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isObject;
	function isObject(value) {
	  return value instanceof Object && !Array.isArray(value);
	}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixProperty;
	
	var _capitalizeString = __webpack_require__(63);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function prefixProperty(prefixProperties, property, style) {
	  if (prefixProperties.hasOwnProperty(property)) {
	    var newStyle = {};
	    var requiredPrefixes = prefixProperties[property];
	    var capitalizedProperty = (0, _capitalizeString2.default)(property);
	    var keys = Object.keys(style);
	    for (var i = 0; i < keys.length; i++) {
	      var styleProperty = keys[i];
	      if (styleProperty === property) {
	        for (var j = 0; j < requiredPrefixes.length; j++) {
	          newStyle[requiredPrefixes[j] + capitalizedProperty] = style[property];
	        }
	      }
	      newStyle[styleProperty] = style[styleProperty];
	    }
	    return newStyle;
	  }
	  return style;
	}

/***/ }),
/* 125 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixValue;
	function prefixValue(plugins, property, value, style, metaData) {
	  for (var i = 0, len = plugins.length; i < len; ++i) {
	    var processedValue = plugins[i](property, value, style, metaData);
	
	    // we can stop processing if a value is returned
	    // as all plugin criteria are unique
	    if (processedValue) {
	      return processedValue;
	    }
	  }
	}

/***/ }),
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var sheet = __webpack_require__(133);
	var Stylis = _interopDefault(__webpack_require__(195));
	__webpack_require__(197);
	
	// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
	// inlined to avoid umd wrapper and peerDep warnings/installing stylis
	// since we use stylis after closure compiler
	var delimiter = '/*|*/';
	var needle = delimiter + '}';
	
	function toSheet(block) {
	  if (block) {
	    Sheet.current.insert(block + '}');
	  }
	}
	
	var Sheet = {
	  current: null
	};
	var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
	  switch (context) {
	    // property
	    case 1:
	      {
	        switch (content.charCodeAt(0)) {
	          case 64:
	            {
	              // @import
	              Sheet.current.insert(content + ';');
	              return '';
	            }
	          // charcode for l
	
	          case 108:
	            {
	              // charcode for b
	              // this ignores label
	              if (content.charCodeAt(2) === 98) {
	                return '';
	              }
	            }
	        }
	
	        break;
	      }
	    // selector
	
	    case 2:
	      {
	        if (ns === 0) return content + delimiter;
	        break;
	      }
	    // at-rule
	
	    case 3:
	      {
	        switch (ns) {
	          // @font-face, @page
	          case 102:
	          case 112:
	            {
	              Sheet.current.insert(selectors[0] + content);
	              return '';
	            }
	
	          default:
	            {
	              return content + (at === 0 ? delimiter : '');
	            }
	        }
	      }
	
	    case -2:
	      {
	        content.split(needle).forEach(toSheet);
	      }
	  }
	};
	
	var createCache = function createCache(options) {
	  if (options === undefined) options = {};
	  var key = options.key || 'css';
	  var stylisOptions;
	
	  if (options.prefix !== undefined) {
	    stylisOptions = {
	      prefix: options.prefix
	    };
	  }
	
	  var stylis = new Stylis(stylisOptions);
	
	  if (false) {
	    // $FlowFixMe
	    if (/[^a-z-]/.test(key)) {
	      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
	    }
	  }
	
	  var inserted = {}; // $FlowFixMe
	
	  var container;
	
	  {
	    container = options.container || document.head;
	    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
	    Array.prototype.forEach.call(nodes, function (node) {
	      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
	
	      attrib.split(' ').forEach(function (id) {
	        inserted[id] = true;
	      });
	
	      if (node.parentNode !== container) {
	        container.appendChild(node);
	      }
	    });
	  }
	
	  var _insert;
	
	  {
	    stylis.use(options.stylisPlugins)(ruleSheet);
	
	    _insert = function insert(selector, serialized, sheet$$1, shouldCache) {
	      var name = serialized.name;
	      Sheet.current = sheet$$1;
	
	      if (false) {
	        var map = serialized.map;
	        Sheet.current = {
	          insert: function insert(rule) {
	            sheet$$1.insert(rule + map);
	          }
	        };
	      }
	
	      stylis(selector, serialized.styles);
	
	      if (shouldCache) {
	        cache.inserted[name] = true;
	      }
	    };
	  }
	
	  if (false) {
	    // https://esbench.com/bench/5bf7371a4cd7e6009ef61d0a
	    var commentStart = /\/\*/g;
	    var commentEnd = /\*\//g;
	    stylis.use(function (context, content) {
	      switch (context) {
	        case -1:
	          {
	            while (commentStart.test(content)) {
	              commentEnd.lastIndex = commentStart.lastIndex;
	
	              if (commentEnd.test(content)) {
	                commentStart.lastIndex = commentEnd.lastIndex;
	                continue;
	              }
	
	              throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
	            }
	
	            commentStart.lastIndex = 0;
	            break;
	          }
	      }
	    });
	    stylis.use(function (context, content, selectors) {
	      switch (context) {
	        case -1:
	          {
	            var flag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
	            var unsafePseudoClasses = content.match(/(:first|:nth|:nth-last)-child/g);
	
	            if (unsafePseudoClasses) {
	              unsafePseudoClasses.forEach(function (unsafePseudoClass) {
	                var ignoreRegExp = new RegExp(unsafePseudoClass + ".*\\/\\* " + flag + " \\*\\/");
	                var ignore = ignoreRegExp.test(content);
	
	                if (unsafePseudoClass && !ignore) {
	                  console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
	                }
	              });
	            }
	
	            break;
	          }
	      }
	    });
	  }
	
	  var cache = {
	    key: key,
	    sheet: new sheet.StyleSheet({
	      key: key,
	      container: container,
	      nonce: options.nonce,
	      speedy: options.speedy
	    }),
	    nonce: options.nonce,
	    inserted: inserted,
	    registered: {},
	    insert: _insert
	  };
	  return cache;
	};
	
	exports.default = createCache;


/***/ }),
/* 132 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function memoize(fn) {
	  var cache = {};
	  return function (arg) {
	    if (cache[arg] === undefined) cache[arg] = fn(arg);
	    return cache[arg];
	  };
	}
	
	exports.default = memoize;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/*
	
	Based off glamor's StyleSheet, thanks Sunil ❤️
	
	high performance StyleSheet for css-in-js systems
	
	- uses multiple style tags behind the scenes for millions of rules
	- uses `insertRule` for appending in production for *much* faster performance
	
	// usage
	
	import { StyleSheet } from '@emotion/sheet'
	
	let styleSheet = new StyleSheet({ key: '', container: document.head })
	
	styleSheet.insert('#box { border: 1px solid red; }')
	- appends a css rule into the stylesheet
	
	styleSheet.flush()
	- empties the stylesheet of all its contents
	
	*/
	// $FlowFixMe
	function sheetForTag(tag) {
	  if (tag.sheet) {
	    // $FlowFixMe
	    return tag.sheet;
	  } // this weirdness brought to you by firefox
	
	  /* istanbul ignore next */
	
	
	  for (var i = 0; i < document.styleSheets.length; i++) {
	    if (document.styleSheets[i].ownerNode === tag) {
	      // $FlowFixMe
	      return document.styleSheets[i];
	    }
	  }
	}
	
	function createStyleElement(options) {
	  var tag = document.createElement('style');
	  tag.setAttribute('data-emotion', options.key);
	
	  if (options.nonce !== undefined) {
	    tag.setAttribute('nonce', options.nonce);
	  }
	
	  tag.appendChild(document.createTextNode(''));
	  return tag;
	}
	
	var StyleSheet =
	/*#__PURE__*/
	function () {
	  function StyleSheet(options) {
	    this.isSpeedy = options.speedy === undefined ? ("production") === 'production' : options.speedy;
	    this.tags = [];
	    this.ctr = 0;
	    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
	
	    this.key = options.key;
	    this.container = options.container;
	    this.before = null;
	  }
	
	  var _proto = StyleSheet.prototype;
	
	  _proto.insert = function insert(rule) {
	    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
	    // it's 1 in dev because we insert source maps that map a single rule to a location
	    // and you can only have one source map per style tag
	    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
	      var _tag = createStyleElement(this);
	
	      var before;
	
	      if (this.tags.length === 0) {
	        before = this.before;
	      } else {
	        before = this.tags[this.tags.length - 1].nextSibling;
	      }
	
	      this.container.insertBefore(_tag, before);
	      this.tags.push(_tag);
	    }
	
	    var tag = this.tags[this.tags.length - 1];
	
	    if (this.isSpeedy) {
	      var sheet = sheetForTag(tag);
	
	      try {
	        // this is a really hot path
	        // we check the second character first because having "i"
	        // as the second character will happen less often than
	        // having "@" as the first character
	        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
	        // the big drawback is that the css won't be editable in devtools
	
	        sheet.insertRule(rule, // we need to insert @import rules before anything else
	        // otherwise there will be an error
	        // technically this means that the @import rules will
	        // _usually_(not always since there could be multiple style tags)
	        // be the first ones in prod and generally later in dev
	        // this shouldn't really matter in the real world though
	        // @import is generally only used for font faces from google fonts and etc.
	        // so while this could be technically correct then it would be slower and larger
	        // for a tiny bit of correctness that won't matter in the real world
	        isImportRule ? 0 : sheet.cssRules.length);
	      } catch (e) {
	        if (false) {
	          console.warn("There was a problem inserting the following rule: \"" + rule + "\"", e);
	        }
	      }
	    } else {
	      tag.appendChild(document.createTextNode(rule));
	    }
	
	    this.ctr++;
	  };
	
	  _proto.flush = function flush() {
	    // $FlowFixMe
	    this.tags.forEach(function (tag) {
	      return tag.parentNode.removeChild(tag);
	    });
	    this.tags = [];
	    this.ctr = 0;
	  };
	
	  return StyleSheet;
	}();
	
	exports.StyleSheet = StyleSheet;


/***/ }),
/* 134 */,
/* 135 */,
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ExternalDownloadPropTypes = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExternalDownloadPropTypes = exports.ExternalDownloadPropTypes = {
	  label: _propTypes2.default.string.isRequired,
	  url: _propTypes2.default.string.isRequired,
	  file: _propTypes2.default.string.isRequired
	};
	
	exports.default = _propTypes2.default.shape(ExternalDownloadPropTypes);

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ExternalSourceShape = __webpack_require__(90);
	
	var _ExternalSourceShape2 = _interopRequireDefault(_ExternalSourceShape);
	
	var _ExternalDownloadShape = __webpack_require__(136);
	
	var _ExternalDownloadShape2 = _interopRequireDefault(_ExternalDownloadShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _propTypes2.default.arrayOf(_propTypes2.default.shape({
	  id: _propTypes2.default.string,
	  title: _propTypes2.default.string.isRequired,
	  items: _propTypes2.default.arrayOf(_ExternalSourceShape2.default).isRequired,
	  download: _ExternalDownloadShape2.default
	}));
	module.exports = exports['default'];

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ExternalLinksCollection = __webpack_require__(218);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ExternalLinksCollection).default;
	  }
	});
	
	var _ExternalLinksShape = __webpack_require__(137);
	
	Object.defineProperty(exports, 'ExternalLinksShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ExternalLinksShape).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.TextFontStyles = exports.SectionIdFontStyles = exports.SectionHeadline2ndFontStyles = exports.SectionHeadlineFontStyles = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  color: ', ';\n\n  font-size: 18px;\n  ', ' {\n    font-size: 20px;\n  }\n  ', ' {\n    font-size: 22px;\n  }\n'], ['\n  color: ', ';\n\n  font-size: 18px;\n  ', ' {\n    font-size: 20px;\n  }\n  ', ' {\n    font-size: 22px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  ', ';\n\n  color: ', ';\n\n  font-size: 24px;\n  ', ' {\n    font-size: 28px;\n  }\n  ', ' {\n    font-size: 32px;\n  }\n'], ['\n  ', ';\n\n  color: ', ';\n\n  font-size: 24px;\n  ', ' {\n    font-size: 28px;\n  }\n  ', ' {\n    font-size: 32px;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  ', ';\n\n  color: ', ';\n\n  font-size: 24px;\n  ', ' {\n    font-size: 32px;\n  }\n  ', ' {\n    font-size: 44px;\n    margin-top: -.2em;\n  }\n'], ['\n  ', ';\n\n  color: ', ';\n\n  font-size: 24px;\n  ', ' {\n    font-size: 32px;\n  }\n  ', ' {\n    font-size: 44px;\n    margin-top: -.2em;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  font-size: 18px;\n'], ['\n  color: ', ';\n  font-size: 18px;\n']);
	
	var _core = __webpack_require__(26);
	
	var _breakpoints = __webpack_require__(4);
	
	var _colors = __webpack_require__(9);
	
	var _fonts = __webpack_require__(15);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var SectionHeadlineFontStyles = exports.SectionHeadlineFontStyles = (0, _core.css)(_templateObject, _colors.TextColor, _breakpoints.minTablet, _breakpoints.minDesktop);
	
	var SectionHeadline2ndFontStyles = exports.SectionHeadline2ndFontStyles = (0, _core.css)(_templateObject2, _fonts.HeadlineFont, _colors.TextColor, _breakpoints.minTablet, _breakpoints.minDesktop);
	
	var SectionIdFontStyles = exports.SectionIdFontStyles = (0, _core.css)(_templateObject3, _fonts.HeadlineFont, _colors.SecondaryTextColor, _breakpoints.minTablet, _breakpoints.minDesktop);
	
	var TextFontStyles = exports.TextFontStyles = (0, _core.css)(_templateObject4, _colors.TextColor);

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _GrafikPDFDownload = __webpack_require__(221);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GrafikPDFDownload).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.H3 = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  font-weight: bold;\n  font-size: 20px;\n\n  line-height: 1.4;\n\n  margin-top: 1.5em;\n'], ['\n  font-weight: bold;\n  font-size: 20px;\n\n  line-height: 1.4;\n\n  margin-top: 1.5em;\n']);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var H3 = exports.H3 = _styled2.default.h3(_templateObject);

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PageLayout = __webpack_require__(254);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PageLayout).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),
/* 143 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var DESKTOP_WIDTH = exports.DESKTOP_WIDTH = 1180;
	var DESKTOP_MARGIN = exports.DESKTOP_MARGIN = 35;
	
	var TABLET_WIDTH = exports.TABLET_WIDTH = 732;
	var TABLET_MARGIN = exports.TABLET_MARGIN = 15;
	
	var PHONE_MARGIN = exports.PHONE_MARGIN = 25;

/***/ }),
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _noImportant = __webpack_require__(14);
	
	var _theme = __webpack_require__(25);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _deepMerge = __webpack_require__(51);
	
	var _deepMerge2 = _interopRequireDefault(_deepMerge);
	
	var _Icon = __webpack_require__(177);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function Arrow(_ref, _ref2) {
		var theme = _ref2.theme;
	
		var direction = _ref.direction,
		    icon = _ref.icon,
		    onClick = _ref.onClick,
		    size = _ref.size,
		    props = _objectWithoutProperties(_ref, ['direction', 'icon', 'onClick', 'size']);
	
		var classes = _noImportant.StyleSheet.create((0, _deepMerge2.default)(defaultStyles, theme));
	
		return _react2.default.createElement(
			'button',
			_extends({
				type: 'button',
				className: (0, _noImportant.css)(classes.arrow, classes['arrow__direction__' + direction], size && classes['arrow__size__' + size]),
				onClick: onClick,
				onTouchEnd: onClick
			}, props),
			_react2.default.createElement(_Icon2.default, { fill: !!theme.arrow && theme.arrow.fill || _theme2.default.arrow.fill, type: icon })
		);
	}
	
	Arrow.propTypes = {
		direction: _propTypes2.default.oneOf(['left', 'right']),
		icon: _propTypes2.default.string,
		onClick: _propTypes2.default.func.isRequired,
		size: _propTypes2.default.oneOf(['medium', 'small']).isRequired
	};
	Arrow.defaultProps = {
		size: 'medium'
	};
	Arrow.contextTypes = {
		theme: _propTypes2.default.object.isRequired
	};
	
	var defaultStyles = {
		arrow: {
			background: 'none',
			border: 'none',
			borderRadius: 4,
			cursor: 'pointer',
			outline: 'none',
			padding: 10, // increase hit area
			position: 'absolute',
			top: '50%',
	
			// disable user select
			WebkitTouchCallout: 'none',
			userSelect: 'none'
		},
	
		// sizes
		arrow__size__medium: {
			height: _theme2.default.arrow.height,
			marginTop: _theme2.default.arrow.height / -2,
			width: 40,
	
			'@media (min-width: 768px)': {
				width: 70
			}
		},
		arrow__size__small: {
			height: _theme2.default.thumbnail.size,
			marginTop: _theme2.default.thumbnail.size / -2,
			width: 30,
	
			'@media (min-width: 500px)': {
				width: 40
			}
		},
	
		// direction
		arrow__direction__right: {
			right: _theme2.default.container.gutter.horizontal
		},
		arrow__direction__left: {
			left: _theme2.default.container.gutter.horizontal
		}
	};
	
	exports.default = Arrow;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _arrowLeft = __webpack_require__(398);
	
	var _arrowLeft2 = _interopRequireDefault(_arrowLeft);
	
	var _arrowRight = __webpack_require__(399);
	
	var _arrowRight2 = _interopRequireDefault(_arrowRight);
	
	var _close = __webpack_require__(400);
	
	var _close2 = _interopRequireDefault(_close);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var icons = { arrowLeft: _arrowLeft2.default, arrowRight: _arrowRight2.default, close: _close2.default };
	
	var Icon = function Icon(_ref) {
		var fill = _ref.fill,
		    type = _ref.type,
		    props = _objectWithoutProperties(_ref, ['fill', 'type']);
	
		var icon = icons[type];
	
		return _react2.default.createElement('span', _extends({
			dangerouslySetInnerHTML: { __html: icon(fill) }
		}, props));
	};
	
	Icon.propTypes = {
		fill: _propTypes2.default.string,
		type: _propTypes2.default.oneOf(Object.keys(icons))
	};
	Icon.defaultProps = {
		fill: 'white'
	};
	
	exports.default = Icon;

/***/ }),
/* 178 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultProps = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// create defaults
	var defaultProps = exports.defaultProps = {
	  attributes: {},
	  styles: {}
	};
	
	var PropToggle = function (_PureComponent) {
	  _inherits(PropToggle, _PureComponent);
	
	  function PropToggle() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PropToggle);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PropToggle.__proto__ || Object.getPrototypeOf(PropToggle)).call.apply(_ref, [this].concat(args))), _this), _this.originalAttributes = {}, _this.originalStyles = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PropToggle, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          attributes = _props.attributes,
	          styles = _props.styles,
	          _props$target = _props.target,
	          target = _props$target === undefined ? document.body : _props$target;
	
	      if (!target) return;
	
	      this.attributeKeys = Object.keys(attributes);
	      this.styleKeys = Object.keys(styles);
	
	      // styles
	      if (this.styleKeys.length) {
	        this.styleKeys.forEach(function (k) {
	          _this2.originalStyles[k] = target.style.getPropertyValue(k);
	          target.style.setProperty(k, styles[k]);
	        });
	      }
	
	      // attributes
	      if (this.attributeKeys.length) {
	        this.attributeKeys.forEach(function (k) {
	          _this2.originalAttributes[k] = target.getAttribute(k) || '';
	          target.setAttribute(k, attributes[k]);
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _this3 = this;
	
	      var _props$target2 = this.props.target,
	          target = _props$target2 === undefined ? document.body : _props$target2;
	
	      if (!target) return;
	
	      // styles
	      if (this.styleKeys.length) {
	        this.styleKeys.forEach(function (k) {
	          target.style.setProperty(k, _this3.originalStyles[k]);
	        });
	      }
	
	      // attributes
	      if (this.attributeKeys.length) {
	        this.attributeKeys.forEach(function (k) {
	          if (_this3.originalAttributes[k]) {
	            target.setAttribute(k, _this3.originalAttributes[k]);
	          } else {
	            target.removeAttribute(k);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return PropToggle;
	}(_react.PureComponent);
	
	PropToggle.defaultProps = defaultProps;
	exports.default = PropToggle;

/***/ }),
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preventTouchMove = preventTouchMove;
	exports.allowTouchMove = allowTouchMove;
	exports.preventInertiaScroll = preventInertiaScroll;
	exports.isTouchDevice = isTouchDevice;
	exports.getPadding = getPadding;
	exports.camelToKebab = camelToKebab;
	exports.getWindowHeight = getWindowHeight;
	exports.getDocumentHeight = getDocumentHeight;
	exports.parse = parse;
	function preventTouchMove(e) {
	  e.preventDefault();
	}
	
	function allowTouchMove(e) {
	  e.stopPropagation();
	}
	
	function preventInertiaScroll() {
	  var top = this.scrollTop;
	  var totalScroll = this.scrollHeight;
	  var currentScroll = top + this.offsetHeight;
	
	  if (top === 0) {
	    this.scrollTop = 1;
	  } else if (currentScroll === totalScroll) {
	    this.scrollTop = top - 1;
	  }
	}
	
	// `ontouchstart` check works on most browsers
	// `maxTouchPoints` works on IE10/11 and Surface
	function isTouchDevice() {
	  if (!window) return false;
	  return 'ontouchstart' in window || navigator.maxTouchPoints;
	}
	
	function getPadding() {
	  if (!document || !window) return 0;
	
	  var currentPadding = parseInt(document.body.paddingRight, 10) || 0;
	  var clientWidth = document.body ? document.body.clientWidth : 0;
	  var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
	
	  return adjustedPadding;
	}
	
	function camelToKebab(str) {
	  return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
	}
	
	function getWindowHeight() {
	  var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
	  if (window && window.innerHeight) {
	    return window.innerHeight * multiplier;
	  }
	}
	
	function getDocumentHeight() {
	  if (document && document.body) {
	    return document.body.clientHeight;
	  }
	}
	
	function parse(val) {
	  return isNaN(val) ? val : val + 'px';
	}

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(83));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(61));
	
	var _reactLifecyclesCompat = __webpack_require__(178);
	
	var _PropTypes = __webpack_require__(189);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var UNMOUNTED = 'unmounted';
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 'exited';
	exports.EXITED = EXITED;
	var ENTERING = 'entering';
	exports.ENTERING = ENTERING;
	var ENTERED = 'entered';
	exports.ENTERED = ENTERED;
	var EXITING = 'exiting';
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the components.
	 * It's up to you to give meaning and effect to those states. For example we can
	 * add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import Transition from 'react-transition-group/Transition';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {(state) => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
	 * What it does do is track transition states over time so you can update the
	 * component (such as by adding styles or classes) when it changes states.
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component begins the
	 * "Enter" stage. During this stage, the component will shift from its current transition state,
	 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
	 * it's complete. Let's take the following example:
	 *
	 * ```jsx
	 * state = { in: false };
	 *
	 * toggleEnterState = () => {
	 *   this.setState({ in: true });
	 * }
	 *
	 * render() {
	 *   return (
	 *     <div>
	 *       <Transition in={this.state.in} timeout={500} />
	 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state and
	 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
	 *
	 * ## Timing
	 *
	 * Timing is often the trickiest part of animation, mistakes can result in slight delays
	 * that are hard to pin down. A common example is when you want to add an exit transition,
	 * you should set the desired final styles when the state is `'exiting'`. That's when the
	 * transition to those styles will start and, if you matched the `timeout` prop with the
	 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
	 *
	 * > **Note**: For simpler transitions the `Transition` component might be enough, but
	 * > take into account that it's platform-agnostic, while the `CSSTransition` component
	 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * > in order to make more complex transitions more predictable. For example, even though
	 * > classes `example-enter` and `example-enter-active` are applied immediately one after
	 * > another, you can still transition from one to the other because of the forced reflow
	 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
	 * > for more info). Take this into account when choosing between `Transition` and
	 * > `CSSTransition`.
	 */
	
	exports.EXITING = EXITING;
	
	var Transition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(Transition, _React$Component);
	
	  function Transition(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
	
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	    var initialStatus;
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = {
	      status: initialStatus
	    };
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  var _proto = Transition.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: null // allows for nested Transitions
	
	    };
	  };
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return {
	        status: EXITED
	      };
	    }
	
	    return null;
	  }; // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	  //   return { nextStatus }
	  // }
	
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	
	    this.updateStatus(false, nextStatus);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  _proto.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	    var exit, enter, appear;
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter;
	      appear = timeout.appear;
	    }
	
	    return {
	      exit: exit,
	      enter: enter,
	      appear: appear
	    };
	  };
	
	  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
	    if (mounting === void 0) {
	      mounting = false;
	    }
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	
	      var node = _reactDom.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({
	        status: UNMOUNTED
	      });
	    }
	  };
	
	  _proto.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	    var timeouts = this.getTimeouts(); // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	
	    if (!mounting && !enter) {
	      this.safeSetState({
	        status: ENTERED
	      }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	    this.safeSetState({
	      status: ENTERING
	    }, function () {
	      _this2.props.onEntering(node, appearing); // FIXME: appear timeout?
	
	
	      _this2.onTransitionEnd(node, timeouts.enter, function () {
	        _this2.safeSetState({
	          status: ENTERED
	        }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  _proto.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
	
	    if (!exit) {
	      this.safeSetState({
	        status: EXITED
	      }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	
	    this.props.onExit(node);
	    this.safeSetState({
	      status: EXITING
	    }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({
	          status: EXITED
	        }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  _proto.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  _proto.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  _proto.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	
	    if (node) {
	      if (this.props.addEndListener) {
	        this.props.addEndListener(node, this.nextCallback);
	      }
	
	      if (timeout != null) {
	        setTimeout(this.nextCallback, timeout);
	      }
	    } else {
	      setTimeout(this.nextCallback, 0);
	    }
	  };
	
	  _proto.render = function render() {
	    var status = this.state.status;
	
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react.default.Children.only(children);
	
	    return _react.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element.
	   * This function is called with the current transition status
	   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
	   * to apply context specific props to a component.
	   *
	   * ```jsx
	   * <Transition timeout={150}>
	   *   {(status) => (
	   *     <MyComponent className={`fade fade-${status}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided
	   *
	   * You may specify a single timeout for all transitions like: `timeout={500}`,
	   * or individually like:
	   *
	   * ```jsx
	   * timeout={{
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * @type {number | { enter?: number, exit?: number }}
	   */
	  timeout: function timeout(props) {
	    var pt = process.env.NODE_ENV !== "production" ? _PropTypes.timeoutsShape : {};;
	    if (!props.addEndListener) pt = pt.isRequired;
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return pt.apply(void 0, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func // Name the function so it is clearer in the documentation
	
	} : {};
	
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);
	
	exports.default = _default;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(83));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(178);
	
	var _ChildMapping = __webpack_require__(431);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var propTypes =  false ? {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   * If you use React v16+ and would like to avoid a wrapping `<div>` element
	   * you can pass in `component={null}`. This is useful if the wrapping div
	   * borks your css styles.
	   */
	  component: _propTypes.default.any,
	
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * A convenience prop that enables or disables appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables exit animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes.default.func
	} : {};;
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	  /**
	   * The `<TransitionGroup>` component manages a set of transition components
	   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
	   * components, `<TransitionGroup>` is a state machine for managing the mounting
	   * and unmounting of components over time.
	   *
	   * Consider the example below. As items are removed or added to the TodoList the
	   * `in` prop is toggled automatically by the `<TransitionGroup>`.
	   *
	   * Note that `<TransitionGroup>`  does not define any animation behavior!
	   * Exactly _how_ a list item animates is up to the individual transition
	   * component. This means you can mix and match animations across different list
	   * items.
	   */
	
	};
	
	var TransitionGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	
	    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
	
	
	    _this.state = {
	      handleExited: handleExited,
	      firstRender: true
	    };
	    return _this;
	  }
	
	  var _proto = TransitionGroup.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: {
	        isMounting: !this.appeared
	      }
	    };
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	    this.mounted = true;
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.mounted = false;
	  };
	
	  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
	    var prevChildMapping = _ref.children,
	        handleExited = _ref.handleExited,
	        firstRender = _ref.firstRender;
	    return {
	      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
	      firstRender: false
	    };
	  };
	
	  _proto.handleExited = function handleExited(child, node) {
	    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
	    if (child.key in currentChildMapping) return;
	
	    if (child.props.onExited) {
	      child.props.onExited(node);
	    }
	
	    if (this.mounted) {
	      this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[child.key];
	        return {
	          children: children
	        };
	      });
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.component,
	        childFactory = _this$props.childFactory,
	        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
	
	    var children = values(this.state.children).map(childFactory);
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    if (Component === null) {
	      return children;
	    }
	
	    return _react.default.createElement(Component, props, children);
	  };
	
	  return TransitionGroup;
	}(_react.default.Component);
	
	TransitionGroup.childContextTypes = {
	  transitionGroup: _propTypes.default.object.isRequired
	};
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.transitionTimeout = transitionTimeout;
	exports.classNamesShape = exports.timeoutsShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.'); // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var timeoutsShape = _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	  enter: _propTypes.default.number,
	  exit: _propTypes.default.number
	}).isRequired]);
	
	exports.timeoutsShape = timeoutsShape;
	
	var classNamesShape = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  active: _propTypes.default.string
	}), _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  enterDone: _propTypes.default.string,
	  enterActive: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  exitDone: _propTypes.default.string,
	  exitActive: _propTypes.default.string
	})]);
	
	exports.classNamesShape = classNamesShape;

/***/ }),
/* 190 */
/***/ (function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var serialize = __webpack_require__(66);
	
	function css() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return serialize.serializeStyles(args);
	}
	
	exports.default = css;


/***/ }),
/* 192 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/* eslint-disable */
	// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
	function murmurhash2_32_gc(str) {
	  var l = str.length,
	      h = l ^ l,
	      i = 0,
	      k;
	
	  while (l >= 4) {
	    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    k ^= k >>> 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
	    l -= 4;
	    ++i;
	  }
	
	  switch (l) {
	    case 3:
	      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
	
	    case 2:
	      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
	
	    case 1:
	      h ^= str.charCodeAt(i) & 0xff;
	      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  }
	
	  h ^= h >>> 13;
	  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  h ^= h >>> 15;
	  return (h >>> 0).toString(36);
	}
	
	exports.default = murmurhash2_32_gc;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopDefault(ex) {
	  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
	}
	
	var memoize = _interopDefault(__webpack_require__(132));
	
	var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
	
	var index = memoize(function (prop) {
	  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
	  /* o */
	  && prop.charCodeAt(1) === 110
	  /* n */
	  && prop.charCodeAt(2) < 91;
	}
	/* Z+1 */
	);
	exports.default = index;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopDefault(ex) {
	  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
	}
	
	var _extends = _interopDefault(__webpack_require__(190));
	
	var React = __webpack_require__(1);
	
	var isPropValid = _interopDefault(__webpack_require__(193));
	
	var core = __webpack_require__(26);
	
	var utils = __webpack_require__(84);
	
	var serialize = __webpack_require__(66);
	
	var testOmitPropsOnStringTag = isPropValid;
	
	var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
	  return key !== 'theme' && key !== 'innerRef';
	};
	
	var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
	  return typeof tag === 'string' && // 96 is one less than the char code
	  // for "a" so this is checking that
	  // it's a lowercase character
	  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
	};
	
	var createStyled = function createStyled(tag, options) {
	  if (false) {
	    if (tag === undefined) {
	      throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
	    }
	  }
	
	  var identifierName;
	  var shouldForwardProp;
	  var targetClassName;
	
	  if (options !== undefined) {
	    identifierName = options.label;
	    targetClassName = options.target;
	    shouldForwardProp = tag.__emotion_forwardProp && options.shouldForwardProp ? function (propName) {
	      return tag.__emotion_forwardProp(propName) && // $FlowFixMe
	      options.shouldForwardProp(propName);
	    } : options.shouldForwardProp;
	  }
	
	  var isReal = tag.__emotion_real === tag;
	  var baseTag = isReal && tag.__emotion_base || tag;
	
	  if (typeof shouldForwardProp !== 'function' && isReal) {
	    shouldForwardProp = tag.__emotion_forwardProp;
	  }
	
	  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
	  var shouldUseAs = !defaultShouldForwardProp('as');
	  return function () {
	    var args = arguments;
	    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
	
	    if (identifierName !== undefined) {
	      styles.push("label:" + identifierName + ";");
	    }
	
	    if (args[0] == null || args[0].raw === undefined) {
	      styles.push.apply(styles, args);
	    } else {
	      styles.push(args[0][0]);
	      var len = args.length;
	      var i = 1;
	
	      for (; i < len; i++) {
	        styles.push(args[i], args[0][i]);
	      }
	    }
	
	    var Styled = core.withEmotionCache(function (props, context, ref) {
	      return React.createElement(core.ThemeContext.Consumer, null, function (theme) {
	        var finalTag = shouldUseAs && props.as || baseTag;
	        var className = '';
	        var classInterpolations = [];
	        var mergedProps = props;
	
	        if (props.theme == null) {
	          mergedProps = {};
	
	          for (var key in props) {
	            mergedProps[key] = props[key];
	          }
	
	          mergedProps.theme = theme;
	        }
	
	        if (typeof props.className === 'string') {
	          className += utils.getRegisteredStyles(context.registered, classInterpolations, props.className);
	        }
	
	        var serialized = serialize.serializeStyles(styles.concat(classInterpolations), context.registered, mergedProps);
	        var rules = utils.insertStyles(context, serialized, typeof finalTag === 'string');
	        className += context.key + "-" + serialized.name;
	
	        if (targetClassName !== undefined) {
	          className += " " + targetClassName;
	        }
	
	        var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(finalTag) : defaultShouldForwardProp;
	        var newProps = {};
	
	        for (var _key in props) {
	          if (shouldUseAs && _key === 'as') continue;
	
	          if ( // $FlowFixMe
	          finalShouldForwardProp(_key)) {
	            newProps[_key] = props[_key];
	          }
	        }
	
	        newProps.className = className;
	        newProps.ref = ref || props.innerRef;
	
	        if (false) {
	          console.error('`innerRef` is deprecated and will be removed in a future major version of Emotion, please use the `ref` prop instead' + (identifierName === undefined ? '' : " in the usage of `" + identifierName + "`"));
	        }
	
	        var ele = React.createElement(finalTag, newProps);
	        return ele;
	      });
	    });
	    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
	    Styled.defaultProps = tag.defaultProps;
	    Styled.__emotion_real = Styled;
	    Styled.__emotion_base = baseTag;
	    Styled.__emotion_styles = styles;
	    Styled.__emotion_forwardProp = shouldForwardProp;
	    Object.defineProperty(Styled, 'toString', {
	      value: function value() {
	        if (targetClassName === undefined && ("production") !== 'production') {
	          return 'NO_COMPONENT_SELECTOR';
	        } // $FlowFixMe
	
	
	        return "." + targetClassName;
	      }
	    });
	
	    Styled.withComponent = function (nextTag, nextOptions) {
	      return createStyled(nextTag, nextOptions !== undefined ? _extends({}, options || {}, nextOptions) : options).apply(void 0, styles);
	    };
	
	    return Styled;
	  };
	};
	
	exports.default = createStyled;


/***/ }),
/* 195 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function stylis_min (W) {
	  function M(d, c, e, h, a) {
	    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
	      g = e.charCodeAt(l);
	      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
	
	      if (0 === b + n + v + m) {
	        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
	          switch (g) {
	            case 32:
	            case 9:
	            case 59:
	            case 13:
	            case 10:
	              break;
	
	            default:
	              f += e.charAt(l);
	          }
	
	          g = 59;
	        }
	
	        switch (g) {
	          case 123:
	            f = f.trim();
	            q = f.charCodeAt(0);
	            k = 1;
	
	            for (t = ++l; l < B;) {
	              switch (g = e.charCodeAt(l)) {
	                case 123:
	                  k++;
	                  break;
	
	                case 125:
	                  k--;
	                  break;
	
	                case 47:
	                  switch (g = e.charCodeAt(l + 1)) {
	                    case 42:
	                    case 47:
	                      a: {
	                        for (u = l + 1; u < J; ++u) {
	                          switch (e.charCodeAt(u)) {
	                            case 47:
	                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
	                                l = u + 1;
	                                break a;
	                              }
	
	                              break;
	
	                            case 10:
	                              if (47 === g) {
	                                l = u + 1;
	                                break a;
	                              }
	
	                          }
	                        }
	
	                        l = u;
	                      }
	
	                  }
	
	                  break;
	
	                case 91:
	                  g++;
	
	                case 40:
	                  g++;
	
	                case 34:
	                case 39:
	                  for (; l++ < J && e.charCodeAt(l) !== g;) {
	                  }
	
	              }
	
	              if (0 === k) break;
	              l++;
	            }
	
	            k = e.substring(t, l);
	            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
	
	            switch (q) {
	              case 64:
	                0 < r && (f = f.replace(N, ''));
	                g = f.charCodeAt(1);
	
	                switch (g) {
	                  case 100:
	                  case 109:
	                  case 115:
	                  case 45:
	                    r = c;
	                    break;
	
	                  default:
	                    r = O;
	                }
	
	                k = M(c, r, k, g, a + 1);
	                t = k.length;
	                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
	                if (0 < t) switch (g) {
	                  case 115:
	                    f = f.replace(da, ea);
	
	                  case 100:
	                  case 109:
	                  case 45:
	                    k = f + '{' + k + '}';
	                    break;
	
	                  case 107:
	                    f = f.replace(fa, '$1 $2');
	                    k = f + '{' + k + '}';
	                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
	                    break;
	
	                  default:
	                    k = f + k, 112 === h && (k = (p += k, ''));
	                } else k = '';
	                break;
	
	              default:
	                k = M(c, X(c, f, I), k, h, a + 1);
	            }
	
	            F += k;
	            k = I = r = u = q = 0;
	            f = '';
	            g = e.charCodeAt(++l);
	            break;
	
	          case 125:
	          case 59:
	            f = (0 < r ? f.replace(N, '') : f).trim();
	            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
	              case 0:
	                break;
	
	              case 64:
	                if (105 === g || 99 === g) {
	                  G += f + e.charAt(l);
	                  break;
	                }
	
	              default:
	                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
	            }
	            I = r = u = q = 0;
	            f = '';
	            g = e.charCodeAt(++l);
	        }
	      }
	
	      switch (g) {
	        case 13:
	        case 10:
	          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
	          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
	          z = 1;
	          D++;
	          break;
	
	        case 59:
	        case 125:
	          if (0 === b + n + v + m) {
	            z++;
	            break;
	          }
	
	        default:
	          z++;
	          y = e.charAt(l);
	
	          switch (g) {
	            case 9:
	            case 32:
	              if (0 === n + m + b) switch (x) {
	                case 44:
	                case 58:
	                case 9:
	                case 32:
	                  y = '';
	                  break;
	
	                default:
	                  32 !== g && (y = ' ');
	              }
	              break;
	
	            case 0:
	              y = '\\0';
	              break;
	
	            case 12:
	              y = '\\f';
	              break;
	
	            case 11:
	              y = '\\v';
	              break;
	
	            case 38:
	              0 === n + b + m && (r = I = 1, y = '\f' + y);
	              break;
	
	            case 108:
	              if (0 === n + b + m + E && 0 < u) switch (l - u) {
	                case 2:
	                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
	
	                case 8:
	                  111 === K && (E = K);
	              }
	              break;
	
	            case 58:
	              0 === n + b + m && (u = l);
	              break;
	
	            case 44:
	              0 === b + v + n + m && (r = 1, y += '\r');
	              break;
	
	            case 34:
	            case 39:
	              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
	              break;
	
	            case 91:
	              0 === n + b + v && m++;
	              break;
	
	            case 93:
	              0 === n + b + v && m--;
	              break;
	
	            case 41:
	              0 === n + b + m && v--;
	              break;
	
	            case 40:
	              if (0 === n + b + m) {
	                if (0 === q) switch (2 * x + 3 * K) {
	                  case 533:
	                    break;
	
	                  default:
	                    q = 1;
	                }
	                v++;
	              }
	
	              break;
	
	            case 64:
	              0 === b + v + n + m + u + k && (k = 1);
	              break;
	
	            case 42:
	            case 47:
	              if (!(0 < n + m + v)) switch (b) {
	                case 0:
	                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
	                    case 235:
	                      b = 47;
	                      break;
	
	                    case 220:
	                      t = l, b = 42;
	                  }
	
	                  break;
	
	                case 42:
	                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
	              }
	          }
	
	          0 === b && (f += y);
	      }
	
	      K = x;
	      x = g;
	      l++;
	    }
	
	    t = p.length;
	
	    if (0 < t) {
	      r = c;
	      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
	      p = r.join(',') + '{' + p + '}';
	
	      if (0 !== w * E) {
	        2 !== w || L(p, 2) || (E = 0);
	
	        switch (E) {
	          case 111:
	            p = p.replace(ha, ':-moz-$1') + p;
	            break;
	
	          case 112:
	            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
	        }
	
	        E = 0;
	      }
	    }
	
	    return G + p + F;
	  }
	
	  function X(d, c, e) {
	    var h = c.trim().split(ia);
	    c = h;
	    var a = h.length,
	        m = d.length;
	
	    switch (m) {
	      case 0:
	      case 1:
	        var b = 0;
	
	        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
	          c[b] = Z(d, c[b], e, m).trim();
	        }
	
	        break;
	
	      default:
	        var v = b = 0;
	
	        for (c = []; b < a; ++b) {
	          for (var n = 0; n < m; ++n) {
	            c[v++] = Z(d[n] + ' ', h[b], e, m).trim();
	          }
	        }
	
	    }
	
	    return c;
	  }
	
	  function Z(d, c, e) {
	    var h = c.charCodeAt(0);
	    33 > h && (h = (c = c.trim()).charCodeAt(0));
	
	    switch (h) {
	      case 38:
	        return c.replace(F, '$1' + d.trim());
	
	      case 58:
	        return d.trim() + c.replace(F, '$1' + d.trim());
	
	      default:
	        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
	    }
	
	    return d + c;
	  }
	
	  function P(d, c, e, h) {
	    var a = d + ';',
	        m = 2 * c + 3 * e + 4 * h;
	
	    if (944 === m) {
	      d = a.indexOf(':', 9) + 1;
	      var b = a.substring(d, a.length - 1).trim();
	      b = a.substring(0, d).trim() + b + ';';
	      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
	    }
	
	    if (0 === w || 2 === w && !L(a, 1)) return a;
	
	    switch (m) {
	      case 1015:
	        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
	
	      case 951:
	        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
	
	      case 963:
	        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
	
	      case 1009:
	        if (100 !== a.charCodeAt(4)) break;
	
	      case 969:
	      case 942:
	        return '-webkit-' + a + a;
	
	      case 978:
	        return '-webkit-' + a + '-moz-' + a + a;
	
	      case 1019:
	      case 983:
	        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
	
	      case 883:
	        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
	        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
	        break;
	
	      case 932:
	        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
	          case 103:
	            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
	
	          case 115:
	            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
	
	          case 98:
	            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
	        }
	        return '-webkit-' + a + '-ms-' + a + a;
	
	      case 964:
	        return '-webkit-' + a + '-ms-flex-' + a + a;
	
	      case 1023:
	        if (99 !== a.charCodeAt(8)) break;
	        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
	        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
	
	      case 1005:
	        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
	
	      case 1e3:
	        b = a.substring(13).trim();
	        c = b.indexOf('-') + 1;
	
	        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
	          case 226:
	            b = a.replace(G, 'tb');
	            break;
	
	          case 232:
	            b = a.replace(G, 'tb-rl');
	            break;
	
	          case 220:
	            b = a.replace(G, 'lr');
	            break;
	
	          default:
	            return a;
	        }
	
	        return '-webkit-' + a + '-ms-' + b + a;
	
	      case 1017:
	        if (-1 === a.indexOf('sticky', 9)) break;
	
	      case 975:
	        c = (a = d).length - 10;
	        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
	
	        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
	          case 203:
	            if (111 > b.charCodeAt(8)) break;
	
	          case 115:
	            a = a.replace(b, '-webkit-' + b) + ';' + a;
	            break;
	
	          case 207:
	          case 102:
	            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
	        }
	
	        return a + ';';
	
	      case 938:
	        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
	          case 105:
	            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
	
	          case 115:
	            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
	
	          default:
	            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
	        }
	        break;
	
	      case 973:
	      case 989:
	        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
	
	      case 931:
	      case 953:
	        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
	        break;
	
	      case 962:
	        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
	    }
	
	    return a;
	  }
	
	  function L(d, c) {
	    var e = d.indexOf(1 === c ? ':' : '{'),
	        h = d.substring(0, 3 !== c ? e : 10);
	    e = d.substring(e + 1, d.length - 1);
	    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
	  }
	
	  function ea(d, c) {
	    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
	    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
	  }
	
	  function H(d, c, e, h, a, m, b, v, n, q) {
	    for (var g = 0, x = c, w; g < A; ++g) {
	      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
	        case void 0:
	        case !1:
	        case !0:
	        case null:
	          break;
	
	        default:
	          x = w;
	      }
	    }
	
	    if (x !== c) return x;
	  }
	
	  function T(d) {
	    switch (d) {
	      case void 0:
	      case null:
	        A = S.length = 0;
	        break;
	
	      default:
	        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
	          T(d[c]);
	        } else Y = !!d | 0;
	    }
	
	    return T;
	  }
	
	  function U(d) {
	    d = d.prefix;
	    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
	    return U;
	  }
	
	  function B(d, c) {
	    var e = d;
	    33 > e.charCodeAt(0) && (e = e.trim());
	    V = e;
	    e = [V];
	
	    if (0 < A) {
	      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
	      void 0 !== h && 'string' === typeof h && (c = h);
	    }
	
	    var a = M(O, e, c, 0, 0);
	    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
	    V = '';
	    E = 0;
	    z = D = 1;
	    return a;
	  }
	
	  var ca = /^\0+/g,
	      N = /[\0\r\f]/g,
	      aa = /: */g,
	      ka = /zoo|gra/,
	      ma = /([,: ])(transform)/g,
	      ia = /,\r+?/g,
	      F = /([\t\r\n ])*\f?&/g,
	      fa = /@(k\w+)\s*(\S*)\s*/,
	      Q = /::(place)/g,
	      ha = /:(read-only)/g,
	      G = /[svh]\w+-[tblr]{2}/,
	      da = /\(\s*(.*)\s*\)/g,
	      oa = /([\s\S]*?);/g,
	      ba = /-self|flex-/g,
	      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
	      la = /stretch|:\s*\w+\-(?:conte|avail)/,
	      ja = /([^-])(image-set\()/,
	      z = 1,
	      D = 1,
	      E = 0,
	      w = 1,
	      O = [],
	      S = [],
	      A = 0,
	      R = null,
	      Y = 0,
	      V = '';
	  B.use = T;
	  B.set = U;
	  void 0 !== W && U(W);
	  return B;
	}
	
	exports.default = stylis_min;


/***/ }),
/* 196 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var unitlessKeys = {
	  animationIterationCount: 1,
	  borderImageOutset: 1,
	  borderImageSlice: 1,
	  borderImageWidth: 1,
	  boxFlex: 1,
	  boxFlexGroup: 1,
	  boxOrdinalGroup: 1,
	  columnCount: 1,
	  columns: 1,
	  flex: 1,
	  flexGrow: 1,
	  flexPositive: 1,
	  flexShrink: 1,
	  flexNegative: 1,
	  flexOrder: 1,
	  gridRow: 1,
	  gridRowEnd: 1,
	  gridRowSpan: 1,
	  gridRowStart: 1,
	  gridColumn: 1,
	  gridColumnEnd: 1,
	  gridColumnSpan: 1,
	  gridColumnStart: 1,
	  msGridRow: 1,
	  msGridRowSpan: 1,
	  msGridColumn: 1,
	  msGridColumnSpan: 1,
	  fontWeight: 1,
	  lineHeight: 1,
	  opacity: 1,
	  order: 1,
	  orphans: 1,
	  tabSize: 1,
	  widows: 1,
	  zIndex: 1,
	  zoom: 1,
	  WebkitLineClamp: 1,
	  // SVG-related properties
	  fillOpacity: 1,
	  floodOpacity: 1,
	  stopOpacity: 1,
	  strokeDasharray: 1,
	  strokeDashoffset: 1,
	  strokeMiterlimit: 1,
	  strokeOpacity: 1,
	  strokeWidth: 1
	};
	
	exports.default = unitlessKeys;


/***/ }),
/* 197 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var weakMemoize = function weakMemoize(func) {
	  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
	  var cache = new WeakMap();
	  return function (arg) {
	    if (cache.has(arg)) {
	      // $FlowFixMe
	      return cache.get(arg);
	    }
	
	    var ret = func(arg);
	    cache.set(arg, ret);
	    return ret;
	  };
	};
	
	exports.default = weakMemoize;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var __chunk_1 = __webpack_require__(67);
	__webpack_require__(53);
	__webpack_require__(27);
	__webpack_require__(36);
	__webpack_require__(37);
	__webpack_require__(38);
	__webpack_require__(39);
	__webpack_require__(40);
	__webpack_require__(41);
	__webpack_require__(42);
	__webpack_require__(43);
	__webpack_require__(44);
	__webpack_require__(45);
	__webpack_require__(46);
	__webpack_require__(47);
	__webpack_require__(48);
	__webpack_require__(49);
	__webpack_require__(50);
	
	/* @flow */
	var useImportant = false; // Don't add !important to style definitions
	
	var Aphrodite = __chunk_1.makeExports(useImportant);
	var StyleSheet = Aphrodite.StyleSheet,
	    StyleSheetServer = Aphrodite.StyleSheetServer,
	    StyleSheetTestUtils = Aphrodite.StyleSheetTestUtils,
	    css = Aphrodite.css,
	    minify = Aphrodite.minify,
	    flushToStyleTag = Aphrodite.flushToStyleTag,
	    injectAndGetClassName = Aphrodite.injectAndGetClassName,
	    defaultSelectorHandlers = Aphrodite.defaultSelectorHandlers;
	
	exports.StyleSheet = StyleSheet;
	exports.StyleSheetServer = StyleSheetServer;
	exports.StyleSheetTestUtils = StyleSheetTestUtils;
	exports.css = css;
	exports.minify = minify;
	exports.flushToStyleTag = flushToStyleTag;
	exports.injectAndGetClassName = injectAndGetClassName;
	exports.defaultSelectorHandlers = defaultSelectorHandlers;


/***/ }),
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n\n  ', ' {\n    flex-direction: row;\n    justify-content: space-around;\n  }\n\n  ', ' {\n    display: block;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n\n  ', ' {\n    flex-direction: row;\n    justify-content: space-around;\n  }\n\n  ', ' {\n    display: block;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  flex: 0 1 auto;\n\n  ', ' {\n    margin-bottom: 40px;\n    max-width: 270px; \n  }\n\n  ', ' {\n    flex: 0 1 306px;\n    margin-left: 0;\n    margin-right: 0;\n  }\n\n  ', ' {\n    margin-bottom: 50px;\n  }\n'], ['\n  flex: 0 1 auto;\n\n  ', ' {\n    margin-bottom: 40px;\n    max-width: 270px; \n  }\n\n  ', ' {\n    flex: 0 1 306px;\n    margin-left: 0;\n    margin-right: 0;\n  }\n\n  ', ' {\n    margin-bottom: 50px;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  max-width: 340px;\n\n  ', ' {\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  flex: 0 1 auto;\n\n  ', ' {\n    flex: 0 1 300px;\n  }\n'], ['\n  max-width: 340px;\n\n  ', ' {\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  flex: 0 1 auto;\n\n  ', ' {\n    flex: 0 1 300px;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  ', ' {\n    display: flex;\n    justify-content: space-between;\n    max-width: 1020px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n'], ['\n  ', ' {\n    display: flex;\n    justify-content: space-between;\n    max-width: 1020px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  ', ' {\n    flex: 0 1 600px;\n    padding-bottom: 150px;\n  }\n'], ['\n  ', ' {\n    flex: 0 1 600px;\n    padding-bottom: 150px;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _breakpoints = __webpack_require__(4);
	
	var _Introduction = __webpack_require__(208);
	
	var _Introduction2 = _interopRequireDefault(_Introduction);
	
	var _DownloadMaterial = __webpack_require__(207);
	
	var _DownloadMaterial2 = _interopRequireDefault(_DownloadMaterial);
	
	var _MaterialDescription = __webpack_require__(209);
	
	var _MaterialDescription2 = _interopRequireDefault(_MaterialDescription);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var DownloadMaterialWithDescription = _styled2.default.div(_templateObject, _breakpoints.minTablet, _breakpoints.minDesktop);
	
	var DownloadMaterialStyled = (0, _styled2.default)(_DownloadMaterial2.default)(_templateObject2, _breakpoints.mediaPhone, _breakpoints.minTablet, _breakpoints.minDesktop);
	
	var MaterialDescriptionStyled = (0, _styled2.default)(_MaterialDescription2.default)(_templateObject3, _breakpoints.mediaPhone, _breakpoints.minTablet);
	
	var Section = _styled2.default.section(_templateObject4, _breakpoints.minDesktop);
	
	var IntroductionStyled = (0, _styled2.default)(_Introduction2.default)(_templateObject5, _breakpoints.minDesktop);
	
	var AboutMaterialDownload = function AboutMaterialDownload() {
	  return _react2.default.createElement(
	    Section,
	    null,
	    _react2.default.createElement(IntroductionStyled, null),
	    _react2.default.createElement(
	      DownloadMaterialWithDescription,
	      null,
	      _react2.default.createElement(DownloadMaterialStyled, null),
	      _react2.default.createElement(MaterialDescriptionStyled, null)
	    )
	  );
	};
	
	exports.default = AboutMaterialDownload;
	module.exports = exports['default'];

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  position: relative;\n  width: 306px;\n  margin-left: auto;\n  margin-right: auto;\n'], ['\n  position: relative;\n  width: 306px;\n  margin-left: auto;\n  margin-right: auto;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  top: 215px;\n  ', ' {\n    top: 180px;\n  }\n  left: 0;\n  right: 0;\n  padding: 15px 0;\n  border-radius: 3px;\n  text-align: center;\n'], ['\n  position: absolute;\n  top: 215px;\n  ', ' {\n    top: 180px;\n  }\n  left: 0;\n  right: 0;\n  padding: 15px 0;\n  border-radius: 3px;\n  text-align: center;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _breakpoints = __webpack_require__(4);
	
	var _GrafikPDFDownload = __webpack_require__(140);
	
	var _GrafikPDFDownload2 = _interopRequireDefault(_GrafikPDFDownload);
	
	var _DownloadMaterialButton = __webpack_require__(54);
	
	var _DownloadMaterialButton2 = _interopRequireDefault(_DownloadMaterialButton);
	
	var _DownloadPdf = __webpack_require__(88);
	
	var _DownloadPdf2 = _interopRequireDefault(_DownloadPdf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Article = _styled2.default.article(_templateObject);
	
	var DownloadMaterialButtonStyled = (0, _styled2.default)(_DownloadMaterialButton2.default)(_templateObject2, _breakpoints.mediaPhone);
	
	var DownloadMaterial = function DownloadMaterial(_ref) {
	  var className = _ref.className;
	  return _react2.default.createElement(
	    Article,
	    { className: className },
	    _react2.default.createElement(
	      _DownloadPdf2.default,
	      null,
	      _react2.default.createElement(_GrafikPDFDownload2.default, null),
	      _react2.default.createElement(DownloadMaterialButtonStyled, { nolink: true })
	    )
	  );
	};
	
	DownloadMaterial.propTypes = {
	  className: _propTypes2.default.string
	};
	
	DownloadMaterial.defaultProps = {
	  className: undefined
	};
	
	exports.default = DownloadMaterial;
	module.exports = exports['default'];

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin-left: 1em;\n'], ['\n  margin-left: 1em;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  margin-top: 40px;\n\n  ', ' {\n    display: none;\n  }\n'], ['\n  margin-top: 40px;\n\n  ', ' {\n    display: none;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  @media (min-width: 540px) {\n    margin-top: 35px;\n  }\n  ', ' {\n    margin-bottom: 30px;\n  }\n  @media (min-width: 950px) {\n    margin-top: 35px;\n  }\n  ', ' {\n    margin-top: 55px;\n  }\n'], ['\n  @media (min-width: 540px) {\n    margin-top: 35px;\n  }\n  ', ' {\n    margin-bottom: 30px;\n  }\n  @media (min-width: 950px) {\n    margin-top: 35px;\n  }\n  ', ' {\n    margin-top: 55px;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  display: ', ';\n  margin-top: 10px;\n'], ['\n  display: ', ';\n  margin-top: 10px;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  -webkit-appearance: none;\n  border: none;\n  background-color: transparent;\n\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  &:focus {\n    outline: none;\n  }\n'], ['\n  -webkit-appearance: none;\n  border: none;\n  background-color: transparent;\n\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  &:focus {\n    outline: none;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  ', ';\n  margin-top: 30px;\n  margin-bottom: 10px;\n'], ['\n  ', ';\n  margin-top: 30px;\n  margin-bottom: 10px;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _core = __webpack_require__(26);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _H = __webpack_require__(69);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _H3 = __webpack_require__(141);
	
	var _P = __webpack_require__(8);
	
	var _Stacheldraht = __webpack_require__(55);
	
	var _Stacheldraht2 = _interopRequireDefault(_Stacheldraht);
	
	var _ExternalLink = __webpack_require__(89);
	
	var _breakpoints = __webpack_require__(4);
	
	var _fonts = __webpack_require__(15);
	
	var _colors = __webpack_require__(9);
	
	var _showMorePlus = __webpack_require__(437);
	
	var _showMorePlus2 = _interopRequireDefault(_showMorePlus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var UL = (0, _styled2.default)(_P.P)(_templateObject);
	
	var StacheldrahtStyled = (0, _styled2.default)(_Stacheldraht2.default)(_templateObject2, _breakpoints.minDesktop);
	
	var Article = _styled2.default.article(_templateObject3, _breakpoints.minTablet, _breakpoints.minDesktop);
	
	var ExtendedSection = _styled2.default.section(_templateObject4, function (_ref) {
	  var show = _ref.show;
	  return show ? 'block' : 'none';
	});
	
	var ResetButtonStyles = (0, _core.css)(_templateObject5);
	
	var ShowMoreButton = _styled2.default.button([ResetButtonStyles, _fonts.HeadlineFont, '\n  font-size: 22px;\n  ' + _breakpoints.mediaPhone + ' {\n    font-size: 18px;\n  }\n\n  color: ' + _colors.TextColor + ';\n\n  display: block;\n  margin: 50px auto 20px;\n  padding-left: 36px;\n  line-height: 24px;\n\n  background-size: 24px 24px;\n  background-repeat: no-repeat;\n  background-position: left;\n  background-image: url(' + _showMorePlus2.default + ');\n\n  text-transform: uppercase;\n']);
	
	var H2Styled = (0, _styled2.default)(_H2.default)(_templateObject6, _fonts.Headline2ndFont);
	
	var Introduction = function (_React$Component) {
	  _inherits(Introduction, _React$Component);
	
	  function Introduction(props) {
	    _classCallCheck(this, Introduction);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      showLongContent: false
	    };
	    return _this;
	  }
	
	  Introduction.prototype.showLongContent = function showLongContent() {
	    this.setState({ showLongContent: true });
	  };
	
	  Introduction.prototype.render = function render() {
	    var _this2 = this;
	
	    var className = this.props.className;
	    var showLongContent = this.state.showLongContent;
	
	
	    return _react2.default.createElement(
	      Article,
	      { className: className },
	      _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(
	          _P.P,
	          { gapAfter: true },
	          'Liebe Lehrerinnen und Lehrer,'
	        ),
	        _react2.default.createElement(
	          _P.P,
	          { gapAfter: true },
	          'modebewusst sein bedeutet laut Duden: \u201E',
	          _react2.default.createElement(
	            'b',
	            null,
	            'sich bewusst nach der Mode richtend'
	          ),
	          '\u201D. Fr\xFChjahr, Sommer, Herbst und Winter \u2013 f\xFCr jede Saison locken Hersteller und Modezeitungen mit neuer trendiger Kleidung \u2013 Jahr f\xFCr Jahr. Gro\xDFe Modeketten bringen sogar bis zu acht Kollektionen jedes Jahr auf den Markt. Wer modisch up to date bleiben will, kauft sich also kontinuierlich neue Kleidung \u2013 jeder Deutsche im Durchschnitt 60 Teile im Jahr.',
	          _react2.default.createElement('br', null),
	          'Zwar ',
	          _react2.default.createElement(
	            _ExternalLink.ExternalLink,
	            { href: 'https://www.zukunftsinstitut.de/artikel/das-ende-der-fast-fashion-aera/' },
	            'sieht das Zukunftsinstitut langfristig den Trend zu nachhaltiger und fairer Mode'
	          ),
	          ' und auch gro\xDFe Modeh\xE4user wie H&M bieten mittlerweile nachhaltige Mode an. Aber noch konsumieren viele Fast Fashion und die entsprechenden Retailer verzeichnen hohe Ums\xE4tze.',
	          _react2.default.createElement('br', null),
	          'In den letzten Jahren gab es zahlreiche kritische Medienberichte und viele Aktionen von gemeinn\xFCtzigen Organisationen, die auf die Problematik der schnellen Wegwerf-Mode aufmerksam gemacht haben. Auch gibt es mittlerweile viele alternative Handlungsm\xF6glichkeiten \u2013 gerade \xFCber neue Medien, wie z. B. Apps zum Tauschen, Verkaufen und Leihen sowie YouTube-Tutorials zum Selbermachen und Upcycling.',
	          _react2.default.createElement('br', null),
	          'Dennoch scheinen die vermeintlichen Vorteile von Fast Fashion aus pers\xF6nlicher Sicht bei vielen Verbrauchern noch zu \xFCberwiegen, die negativen Wirkungen werden verdr\xE4ngt oder aber die Alternativen sind zu wenig bekannt oder zu undurchsichtig, wie z. B. faire Siegel: Was ist da wirklich fair und was nicht mehr als eine Goodwill-Kampagne oder sogar Greenwashing?',
	          _react2.default.createElement('br', null),
	          'Daher m\xF6chten wir auf dieser Website Lehrkr\xE4ften der Sekundarstufe 1 Impulse geben, wie sie das Thema im Unterricht bearbeiten k\xF6nnen \u2013 und zwar ohne den erhobenen Zeigefinger, denn die Jugendlichen sollen selbst ihr Verhalten reflektieren. Ziel ist, dass die Jugendlichen ',
	          _react2.default.createElement(
	            'b',
	            null,
	            'bewusst mit Mode umgehen'
	          ),
	          '.',
	          _react2.default.createElement('br', null),
	          'Wir verweisen an passender Stelle auf die Materialien anderer Herausgeber, die sich gut einbinden lassen, und bieten eine kommentierte Link-Liste, sodass sich ohne aufwendige Eigenrecherche die richtigen Materialien f\xFCr den Unterricht finden lassen.',
	          _react2.default.createElement('br', null),
	          'In der Smartboard-Galerie auf dieser Seite finden Sie \u2013 neben den Arbeitsbl\xE4ttern und Grafiken \u2013 Stimmungsbilder, um das Unterrichtsthema visuell zu untermalen. Wir m\xF6chten an dieser Stelle der Postcode-Lotterie danken, mit deren F\xF6rderung wir dieses Projekt an den Start bringen konnten.',
	          _react2.default.createElement('br', null),
	          'Ihnen w\xFCnschen wir einen erlebnisreichen Unterricht zum Thema Mode',
	          _react2.default.createElement(
	            'em',
	            null,
	            'bewusst'
	          ),
	          '.'
	        ),
	        _react2.default.createElement(
	          _P.P,
	          null,
	          'Ihr Bund f\xFCr Bildung e. V.'
	        ),
	        showLongContent || _react2.default.createElement(
	          ShowMoreButton,
	          { onClick: function onClick() {
	              return _this2.showLongContent();
	            } },
	          'Mehr anzeigen'
	        )
	      ),
	      _react2.default.createElement(
	        ExtendedSection,
	        { show: showLongContent },
	        _react2.default.createElement(
	          H2Styled,
	          null,
	          'Lernziele:'
	        ),
	        _react2.default.createElement(
	          UL,
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'Wissen vermitteln \xFCber Warenstr\xF6me der Modeindustrie und deren wirtschaftliche, soziale und \xF6konomische Auswirkungen'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Reflexion \xFCber (auf Mode bezogene) Werte'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Reflexion \xFCber Handlungen als Mode-Konsument'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Kritischer Umgang mit pers\xF6nlichen Einstellungen und \xE4u\xDFeren Einfl\xFCssen'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Kennenlernen von Handlungsoptionen'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'F\xE4higkeit zum Handeln als m\xFCndiger, reflektierter und verantwortungsvoller Konsument und Weltb\xFCrger'
	          )
	        ),
	        _react2.default.createElement(
	          H2Styled,
	          null,
	          'ACHTUNG:'
	        ),
	        _react2.default.createElement(
	          _P.P,
	          null,
	          'Bitte beachten Sie, dass Mode auch ein sensibles und heikles Thema sein kann. Es gibt zum einen Sch\xFClerinnen und Sch\xFCler (SuS), die sich Mode nicht leisten k\xF6nnen und daher vielleicht ausgegrenzt werden, und zum anderen SuS, die sich stark \xFCber Mode identifizieren. Hier sollte man keine individuellen Auswertungen in den Mittelpunkt des Unterrichts stellen, sondern Auswertungen (wie z. B. die Kleiderschrank-Analyse) im Klassenverband verallgemeinern, indem man auf konkrete Zahlen verzichtet. Generell ist es sehr wichtig, keine Wertung vorzunehmen, sondern zur Reflexion anzuregen.'
	        ),
	        _react2.default.createElement(
	          H2Styled,
	          null,
	          'Hintergrund:'
	        ),
	        _react2.default.createElement(
	          _P.P,
	          null,
	          'Jugendliche w\xE4hlen nach einer Greenpeace-Studie von 2015 ihre Kleidung haupts\xE4chlich nach dem Aussehen und dem Preis aus, das Herstellungsland oder Zertifizierungen (z. B. bio, Fair Trade) spielen hingegen kaum eine Rolle. Nur 10 bis 20 Prozent der Jugendlichen und jungen Erwachsenen zwischen 16 und 25 Jahren zeigten sich in einer weiteren Studie zum Thema (\u201EJugendliche und nachhaltiger Konsum\u201D, 2017) dazu bereit, auf Produkte zu verzichten, wenn sie nicht umweltfreundlich oder unter fairen Arbeitsbedingungen produziert w\xFCrden. Dabei interessieren sich weit mehr als die H\xE4lfte der befragten Jugendlichen f\xFCr Themen wie Umwelt- oder Klimaschutz. Haltung und Konsumverhalten stehen demnach deutlich im Gegensatz zueinander: Dies zeigt den Bedarf an Information \xFCber die Auswirkungen ihres aktuellen Modekonsums und \xFCber erschwingliche, attraktive und nachhaltige Mode.'
	        ),
	        _react2.default.createElement(
	          H2Styled,
	          null,
	          'Didaktische Grundlagen unserer Unterrichtsimpulse:'
	        ),
	        _react2.default.createElement(
	          _H3.H3,
	          null,
	          'Bildung f\xFCr nachhaltige Entwicklung (BNE)'
	        ),
	        _react2.default.createElement(
	          _P.P,
	          null,
	          '\u201EGemeint ist eine Bildung, die Menschen zu zukunftsf\xE4higem Denken und Handeln bef\xE4higt: Wie beeinflussen meine Entscheidungen Menschen nachfolgender Generationen oder in anderen Erdteilen? Welche Auswirkungen hat es beispielsweise, wie ich konsumiere \u2026? (...) Bildung f\xFCr nachhaltige Entwicklung erm\xF6glicht es jedem Einzelnen, die Auswirkungen des eigenen Handelns auf die Welt zu verstehen und verantwortungsvolle Entscheidungen zu treffen.\u201D',
	          _react2.default.createElement('br', null),
	          '(',
	          _react2.default.createElement(_ExternalLink.ExternalLink, { href: 'https://www.bne-portal.de' }),
	          ')'
	        ),
	        _react2.default.createElement(
	          _H3.H3,
	          null,
	          'Global Citizenship Education'
	        ),
	        _react2.default.createElement(
	          _P.P,
	          null,
	          'Unsere Impulse sind problem- und sch\xFClerorientiert gestaltet. Es geht uns darum, dass die SuS das Wissen selbst erwerben, kritisch reflektieren und die nachhaltige Entwicklung im eigenen Umfeld mitgestalten. Im Sinne der Global Citizenship Education erfahren die SuS Verantwortung und Selbstwirksamkeit.'
	        ),
	        _react2.default.createElement(
	          H2Styled,
	          null,
	          'Lehrplananbindung:'
	        ),
	        _react2.default.createElement(
	          _P.P,
	          null,
	          'Mode an sich ist nicht Gegenstand der Lehrpl\xE4ne f\xFCr die Sekundarstufe 1. Allerdings lassen sich daran verschiedene Themenkomplexe einzeln oder aufeinander bezogen f\xE4cherspezifisch, fach\xFCbergreifend und f\xE4cherverbindend behandeln: Identit\xE4t, Vorbilder, Abgrenzung und Zugeh\xF6rigkeit; digitale Welt und Medienbildung; \xF6kologische, soziale, kulturelle und \xF6konomische Nachhaltigkeit, Konsum und Verzicht; Produktionskreisl\xE4ufe, Wirtschaft und Industrie, Globalisierung. Alle diese Themenkomplexe sind Gegenstand von Lehr- und Kompetenzpl\xE4nen. F\xFCr die SuS werden sie \xFCber Mode als Teil ihrer Lebenswelt verstehbar.'
	        )
	      ),
	      _react2.default.createElement(StacheldrahtStyled, { small: true })
	    );
	  };
	
	  return Introduction;
	}(_react2.default.Component);
	
	Introduction.propTypes = {
	  className: _propTypes2.default.string
	};
	
	Introduction.defaultProps = {
	  className: undefined
	};
	
	exports.default = Introduction;
	module.exports = exports['default'];

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  padding: 0;\n  padding-bottom: 5px;\n'], ['\n  padding: 0;\n  padding-bottom: 5px;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  font-size: 20px;\n  line-height: 1.2;\n  list-style-type: none;\n\n  &:before {\n    ', ';\n    content: \'\u2192\';\n    margin-right: 0.5em;\n    margin-left: 0.1em;\n\n    font-size: 24px;\n    ', ' {\n      font-size: 32px;\n    }\n  }\n\n  ', ' {\n    font-size: 22px;\n  }\n'], ['\n  font-size: 20px;\n  line-height: 1.2;\n  list-style-type: none;\n\n  &:before {\n    ', ';\n    content: \'\\u2192\';\n    margin-right: 0.5em;\n    margin-left: 0.1em;\n\n    font-size: 24px;\n    ', ' {\n      font-size: 32px;\n    }\n  }\n\n  ', ' {\n    font-size: 22px;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  margin-top: 20px;\n  padding-bottom: 50px;\n'], ['\n  margin-top: 20px;\n  padding-bottom: 50px;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose([''], ['']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  padding: 10px .5em 10px 0;\n  border-radius: 3px;\n'], ['\n  padding: 10px .5em 10px 0;\n  border-radius: 3px;\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  ', ';\n'], ['\n  ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DownloadMaterialButton = __webpack_require__(54);
	
	var _DownloadMaterialButton2 = _interopRequireDefault(_DownloadMaterialButton);
	
	var _breakpoints = __webpack_require__(4);
	
	var _fonts = __webpack_require__(15);
	
	var _H = __webpack_require__(69);
	
	var _H2 = _interopRequireDefault(_H);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var DESCRIPTIONS = ['Einf&uuml;hrung in das Thema', 'Lernziele', 'Hintergrundinformationen', 'Didaktische Grundlagen', 'Lehrplananbindung'];
	
	var UL = _styled2.default.ul(_templateObject);
	
	var LI = _styled2.default.li(_templateObject2, _fonts.ListStyleSymbolFont, _breakpoints.minDesktop, _breakpoints.minDesktop);
	
	var Article = _styled2.default.article(_templateObject3);
	
	var DownloadContainer = _styled2.default.div(_templateObject4);
	
	var DownloadMaterialButtonStyled = (0, _styled2.default)(_DownloadMaterialButton2.default)(_templateObject5);
	
	var H2Styled = (0, _styled2.default)(_H2.default)(_templateObject6, _fonts.HeadlineFont);
	
	var MaterialDescription = function MaterialDescription(_ref) {
	  var className = _ref.className;
	  return _react2.default.createElement(
	    Article,
	    { className: className },
	    _react2.default.createElement(
	      H2Styled,
	      null,
	      'Einleitung (PDF)'
	    ),
	    _react2.default.createElement(
	      UL,
	      null,
	      DESCRIPTIONS.map(function (text) {
	        return _react2.default.createElement(LI, { key: text, dangerouslySetInnerHTML: { __html: text } });
	      })
	    ),
	    _react2.default.createElement(
	      DownloadContainer,
	      null,
	      _react2.default.createElement(DownloadMaterialButtonStyled, { label: 'Einleitung herunterladen', download: 'ModeBewusst_Einleitung.pdf', href: '/downloads/ModeBewusst_Einleitung.pdf' })
	    )
	  );
	};
	
	MaterialDescription.propTypes = {
	  className: _propTypes2.default.string
	};
	
	MaterialDescription.defaultProps = {
	  className: undefined
	};
	
	exports.default = MaterialDescription;
	module.exports = exports['default'];

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AboutMaterialDownload = __webpack_require__(206);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AboutMaterialDownload).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.BFBLogoSmallOnPhone = undefined;
	
	var _css; /* eslint-disable react/jsx-no-target-blank */
	/* eslint-disable object-curly-newline */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _emotion = __webpack_require__(22);
	
	var _breakpoints = __webpack_require__(4);
	
	var _Logo = __webpack_require__(92);
	
	var _images = __webpack_require__(93);
	
	var _BfBLogo = __webpack_require__(438);
	
	var _BfBLogo2 = _interopRequireDefault(_BfBLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LOGO_WIDTH = 120;
	var LOGO_HEIGHT = 40;
	var LOGO_SCALE = 1.28;
	
	var BFBLogoSmallOnPhone = exports.BFBLogoSmallOnPhone = (0, _emotion.css)((_css = {}, _css[_breakpoints.mediaPhone] = {
	  width: (0, _Logo.px)(LOGO_WIDTH * LOGO_SCALE * _Logo.LOGO_PHONE_SCALE),
	  height: (0, _Logo.px)(LOGO_HEIGHT * LOGO_SCALE * _Logo.LOGO_PHONE_SCALE),
	  marginTop: '7px'
	}, _css));
	
	var BFBLogo = function (_React$Component) {
	  _inherits(BFBLogo, _React$Component);
	
	  function BFBLogo(props) {
	    _classCallCheck(this, BFBLogo);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      loaded: false
	    };
	    return _this;
	  }
	
	  BFBLogo.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        className = _props.className,
	        labelStyles = _props.labelStyles,
	        imageContainerStyles = _props.imageContainerStyles,
	        imageStyles = _props.imageStyles;
	    var loaded = this.state.loaded;
	
	    return _react2.default.createElement(
	      'article',
	      { className: className },
	      _react2.default.createElement(
	        'div',
	        { className: (0, _emotion.css)(_Logo.LogoLabelStyles, labelStyles) },
	        'Initiiert und durchgef\xFChrt von'
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          className: (0, _emotion.css)('\n            text-align: right;\n          ', imageContainerStyles)
	        },
	        _react2.default.createElement(
	          'a',
	          { href: 'http://www.bundfuerbildung.de', target: '_blank', rel: 'noopener nofollow external' },
	          _react2.default.createElement('img', {
	            src: _BfBLogo2.default,
	            alt: 'Bund f\xFCr Bildung',
	            className: (0, _emotion.css)(_images.sharpImageRendering, {
	              width: (0, _Logo.px)(LOGO_WIDTH * LOGO_SCALE),
	              height: (0, _Logo.px)(LOGO_HEIGHT * LOGO_SCALE),
	              marginTop: '2px'
	            }, imageStyles),
	            style: { opacity: loaded ? 1 : 0 },
	            onLoad: function onLoad() {
	              return _this2.setState({ loaded: true });
	            }
	          })
	        )
	      )
	    );
	  };
	
	  return BFBLogo;
	}(_react2.default.Component);
	
	BFBLogo.propTypes = {
	  className: _propTypes2.default.string,
	  labelStyles: _propTypes2.default.any,
	  imageContainerStyles: _propTypes2.default.any,
	  imageStyles: _propTypes2.default.any
	};
	
	BFBLogo.defaultProps = {
	  className: undefined,
	  labelStyles: undefined,
	  imageContainerStyles: undefined,
	  imageStyles: undefined
	};
	
	exports.default = BFBLogo;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _BFBLogo = __webpack_require__(211);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BFBLogo).default;
	  }
	});
	Object.defineProperty(exports, 'BFBLogoSmallOnPhone', {
	  enumerable: true,
	  get: function get() {
	    return _BFBLogo.BFBLogoSmallOnPhone;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.DPLLogoSmallOnPhone = undefined;
	
	var _css; /* eslint-disable react/no-unused-prop-types */
	/* eslint-disable object-curly-newline */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _emotion = __webpack_require__(22);
	
	var _breakpoints = __webpack_require__(4);
	
	var _Logo = __webpack_require__(92);
	
	var _images = __webpack_require__(93);
	
	var _DPLLogo248x = __webpack_require__(439);
	
	var _DPLLogo248x2 = _interopRequireDefault(_DPLLogo248x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LOGO_WIDTH = 83;
	var LOGO_HEIGHT = 55;
	
	var DPLLogoSmallOnPhone = exports.DPLLogoSmallOnPhone = (0, _emotion.css)((_css = {}, _css[_breakpoints.mediaPhone] = {
	  width: (0, _Logo.px)(LOGO_WIDTH * _Logo.LOGO_PHONE_SCALE),
	  height: (0, _Logo.px)(LOGO_HEIGHT * _Logo.LOGO_PHONE_SCALE),
	  marginTop: '6px'
	}, _css));
	
	var DPLLogo = function (_React$Component) {
	  _inherits(DPLLogo, _React$Component);
	
	  function DPLLogo(props) {
	    _classCallCheck(this, DPLLogo);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      loaded: false
	    };
	    return _this;
	  }
	
	  DPLLogo.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        className = _props.className,
	        labelStyles = _props.labelStyles,
	        imageContainerStyles = _props.imageContainerStyles,
	        imageStyles = _props.imageStyles;
	    var loaded = this.state.loaded;
	
	    return _react2.default.createElement(
	      'article',
	      { className: className },
	      _react2.default.createElement(
	        'div',
	        { className: (0, _emotion.css)(_Logo.LogoLabelStyles, labelStyles) },
	        'Gef\xF6rdert von'
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          className: (0, _emotion.css)({
	            textAlign: 'right'
	          }, imageContainerStyles)
	        },
	        _react2.default.createElement(
	          'a',
	          { href: 'https://www.postcode-lotterie.de', target: '_blank', rel: 'noopener nofollow external' },
	          _react2.default.createElement('img', {
	            src: _DPLLogo248x2.default,
	            alt: 'Deutsche Postcode Lotterie',
	            className: (0, _emotion.css)(_images.sharpImageRendering, {
	              width: (0, _Logo.px)(LOGO_WIDTH),
	              height: (0, _Logo.px)(LOGO_HEIGHT),
	              marginTop: '2px',
	              transition: 'opacity 0.25 ease-in-out'
	            }, imageStyles),
	            style: { opacity: loaded ? 1 : 0 },
	            onLoad: function onLoad() {
	              return _this2.setState({ loaded: true });
	            }
	          })
	        )
	      )
	    );
	  };
	
	  return DPLLogo;
	}(_react2.default.Component);
	
	DPLLogo.propTypes = {
	  className: _propTypes2.default.string,
	  labelStyles: _propTypes2.default.any,
	  imageContainerStyles: _propTypes2.default.any,
	  imageStyles: _propTypes2.default.any
	};
	
	DPLLogo.defaultProps = {
	  className: undefined,
	  labelStyles: undefined,
	  imageContainerStyles: undefined,
	  imageStyles: undefined
	};
	
	exports.default = DPLLogo;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DPLLogo = __webpack_require__(213);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DPLLogo).default;
	  }
	});
	Object.defineProperty(exports, 'DPLLogoSmallOnPhone', {
	  enumerable: true,
	  get: function get() {
	    return _DPLLogo.DPLLogoSmallOnPhone;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  ', ';\n  font-size: 22px;\n\n  text-decoration: none;\n  text-transform: uppercase;\n  cursor: pointer;\n\n  line-height: 1.2;\n\n  background-color: ', ';\n  color: ', ';\n\n  &:hover, &:visited {\n    color: ', ';\n    text-decoration: none;\n    background-color: ', ';\n  }\n'], ['\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  ', ';\n  font-size: 22px;\n\n  text-decoration: none;\n  text-transform: uppercase;\n  cursor: pointer;\n\n  line-height: 1.2;\n\n  background-color: ', ';\n  color: ', ';\n\n  &:hover, &:visited {\n    color: ', ';\n    text-decoration: none;\n    background-color: ', ';\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  margin: 0 .5em;\n'], ['\n  margin: 0 .5em;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  text-align: center;\n  display: inline-block;\n'], ['\n  text-align: center;\n  display: inline-block;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _DownloadPdf = __webpack_require__(88);
	
	var _DownloadPdf2 = _interopRequireDefault(_DownloadPdf);
	
	var _colors = __webpack_require__(9);
	
	var _fonts = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var DEFAULT_LABEL = 'Gesamtes Material herunterladen';
	
	var A = (0, _styled2.default)(_DownloadPdf2.default)(_templateObject, _fonts.ActionFont, _colors.ActionColor, _colors.ActionTextColor, _colors.ActionTextColor, _colors.ActionShadeColor);
	
	var IconImg = _styled2.default.div(_templateObject2);
	
	var Label = _styled2.default.span(_templateObject3);
	
	var DownloadIcon = function DownloadIcon() {
	  return _react2.default.createElement(
	    IconImg,
	    null,
	    _react2.default.createElement(
	      'svg',
	      { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 33 33', width: '33', height: '33' },
	      _react2.default.createElement('path', { fill: 'currentColor', d: 'M12.26,0h8.35a.73.73,0,0,1,.78.69V14.37h3.49a.68.68,0,0,1,.61,1.11L17,24.68a.84.84,0,0,1-1.22,0l-8.44-9.2A.68.68,0,0,1,8,14.37h3.48V.69A.74.74,0,0,1,12.26,0', transform: 'translate(0 0)' }),
	      _react2.default.createElement('path', { fill: 'currentColor', d: 'M2.05,28.76H30.81a2.06,2.06,0,1,1,0,4.11H2.05a2.06,2.06,0,0,1,0-4.11', transform: 'translate(0 0)' })
	    )
	  );
	};
	
	var renderIcon = function renderIcon(noicon) {
	  return noicon ? null : _react2.default.createElement(DownloadIcon, null);
	};
	
	var renderLabel = function renderLabel(nolabel, label) {
	  return nolabel ? null : _react2.default.createElement(
	    Label,
	    null,
	    label
	  );
	};
	
	var DownloadMaterialButton = function DownloadMaterialButton(_ref) {
	  var className = _ref.className,
	      download = _ref.download,
	      href = _ref.href,
	      label = _ref.label,
	      noicon = _ref.noicon,
	      nolabel = _ref.nolabel,
	      nolink = _ref.nolink;
	  return _react2.default.createElement(
	    A,
	    { href: href, download: download, className: className, nolink: nolink },
	    renderIcon(noicon, label),
	    renderLabel(nolabel, label)
	  );
	};
	
	DownloadMaterialButton.propTypes = {
	  nolabel: _propTypes2.default.bool,
	  noicon: _propTypes2.default.bool,
	  nolink: _propTypes2.default.bool,
	  label: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  href: _propTypes2.default.string,
	  download: _propTypes2.default.string
	};
	
	DownloadMaterialButton.defaultProps = {
	  nolabel: false,
	  noicon: false,
	  nolink: false,
	  label: DEFAULT_LABEL,
	  className: undefined,
	  href: undefined,
	  download: undefined
	};
	
	exports.default = DownloadMaterialButton;
	module.exports = exports['default'];

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  cursor: pointer;\n  text-decoration: none !important;\n'], ['\n  cursor: pointer;\n  text-decoration: none !important;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; } /* eslint-disable object-curly-newline */
	
	
	var Link = _styled2.default.a(_templateObject);
	
	var DownloadPdf = function DownloadPdf(_ref) {
	  var className = _ref.className,
	      href = _ref.href,
	      download = _ref.download,
	      nolink = _ref.nolink,
	      children = _ref.children;
	
	  var A = nolink ? Link.withComponent('span') : Link;
	  return _react2.default.createElement(
	    A,
	    { className: className, href: href, download: download },
	    children
	  );
	};
	
	DownloadPdf.propTypes = {
	  href: _propTypes2.default.string,
	  download: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  nolink: _propTypes2.default.bool,
	  children: _propTypes2.default.any.isRequired
	};
	
	DownloadPdf.defaultProps = {
	  href: '/downloads/Unterrichtsmaterialien_Modebewusst_komplett.pdf',
	  download: 'Unterrichtsmaterialien_Modebewusst_komplett.pdf',
	  className: undefined,
	  nolink: false
	};
	
	exports.default = DownloadPdf;
	module.exports = exports['default'];

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  position: relative;\n\n  width: ', 'px;\n  height: ', 'px;\n\n  cursor: pointer;\n'], ['\n  position: relative;\n\n  width: ', 'px;\n  height: ', 'px;\n\n  cursor: pointer;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n\n  transition: all .25s;\n\n  height: ', 'px;\n\n  background-color: ', ';\n'], ['\n  position: absolute;\n\n  transition: all .25s;\n\n  height: ', 'px;\n\n  background-color: ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  width: ', ';\n  top: 7px;\n  left: -2px;\n  transform: rotate(45deg);\n'], ['\n  width: ', ';\n  top: 7px;\n  left: -2px;\n  transform: rotate(45deg);\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  width: ', ';\n  top: 13px;\n  left: -5px;\n  transform: rotate(225deg); // -135deg); // 225deg);\n'], ['\n  width: ', ';\n  top: 13px;\n  left: -5px;\n  transform: rotate(225deg); // -135deg); // 225deg);\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  width: ', ';\n  top: 7px;\n  right: -2px;\n  transform: rotate(-45deg);\n'], ['\n  width: ', ';\n  top: 7px;\n  right: -2px;\n  transform: rotate(-45deg);\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  width: ', ';\n  top: 13px;\n  right: -5px;\n  transform: rotate(135deg); // -225deg);\n'], ['\n  width: ', ';\n  top: 13px;\n  right: -5px;\n  transform: rotate(135deg); // -225deg);\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _emotion = __webpack_require__(22);
	
	var _colors = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var SIZE = 32;
	var LINE_SIZE = 3;
	
	var px = function px(pixels) {
	  return Math.round(pixels) + 'px';
	};
	
	var Container = _styled2.default.div(_templateObject, SIZE, SIZE);
	
	var LineStyles = (0, _emotion.css)(_templateObject2, LINE_SIZE, _colors.SecondaryTextColor);
	
	var AStyles = (0, _emotion.css)(_templateObject3, px(SIZE * 0.7));
	
	var ACloseStyles = (0, _emotion.css)(_templateObject4, px(SIZE * 1.3125));
	
	var BStyles = (0, _emotion.css)(_templateObject5, px(SIZE * 0.7));
	
	var BCloseStyles = (0, _emotion.css)(_templateObject6, px(SIZE * 1.3125));
	
	var Collapsor = function Collapsor(_ref) {
	  var open = _ref.open,
	      className = _ref.className,
	      onClick = _ref.onClick;
	  return _react2.default.createElement(
	    Container,
	    { className: className, onClick: onClick },
	    _react2.default.createElement('div', { className: LineStyles + ' ' + AStyles + ' ' + (open ? ACloseStyles : '') }),
	    _react2.default.createElement('div', { className: LineStyles + ' ' + BStyles + ' ' + (open ? BCloseStyles : '') })
	  );
	};
	
	Collapsor.propTypes = {
	  open: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  onClick: _propTypes2.default.func
	};
	
	Collapsor.defaultProps = {
	  open: false,
	  className: undefined,
	  onClick: undefined
	};
	
	exports.default = Collapsor;
	module.exports = exports['default'];

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin-left: ', 'px;\n  margin-right: ', 'px;\n\n  ', ' {\n    margin-left: ', 'px;\n    margin-right: ', 'px;\n  }\n  ', ' {\n    margin-left: 80px;\n    margin-right: 80px;\n  }\n'], ['\n  margin-left: ', 'px;\n  margin-right: ', 'px;\n\n  ', ' {\n    margin-left: ', 'px;\n    margin-right: ', 'px;\n  }\n  ', ' {\n    margin-left: 80px;\n    margin-right: 80px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  margin-top: 13px;\n  padding: 0;\n'], ['\n  margin-top: 13px;\n  padding: 0;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  border-bottom: ', ';\n\n  &:last-child {\n    ', ' {\n      border-bottom: 0;\n    }\n  }\n'], ['\n  border-bottom: ', ';\n\n  &:last-child {\n    ', ' {\n      border-bottom: 0;\n    }\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  ', ' {\n    margin-left: 25px;\n    margin-right: 25px;\n    margin-bottom: 20px;\n  }\n  ', ' {\n    margin-bottom: 40px;\n  }\n  ', ' {\n    margin-bottom: 50px;\n  }\n'], ['\n  ', ' {\n    margin-left: 25px;\n    margin-right: 25px;\n    margin-bottom: 20px;\n  }\n  ', ' {\n    margin-bottom: 40px;\n  }\n  ', ' {\n    margin-bottom: 50px;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _breakpoints = __webpack_require__(4);
	
	var _colors = __webpack_require__(9);
	
	var _pageLayout = __webpack_require__(143);
	
	var _H = __webpack_require__(69);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _ExternalLinksSection = __webpack_require__(219);
	
	var _ExternalLinksSection2 = _interopRequireDefault(_ExternalLinksSection);
	
	var _ExternalLinksShape = __webpack_require__(137);
	
	var _ExternalLinksShape2 = _interopRequireDefault(_ExternalLinksShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styled2.default.div(_templateObject, -_pageLayout.PHONE_MARGIN, -_pageLayout.PHONE_MARGIN, _breakpoints.minTablet, -_pageLayout.TABLET_MARGIN + 40, -_pageLayout.TABLET_MARGIN + 40, _breakpoints.minDesktop);
	
	var SectionsList = _styled2.default.ul(_templateObject2);
	
	var ExternalLinksSectionStyled = (0, _styled2.default)(_ExternalLinksSection2.default)(_templateObject3, function (_ref) {
	  var collapsable = _ref.collapsable,
	      sources = _ref.sources;
	  return collapsable && sources.length > 1 ? '1px solid ' + _colors.SecondaryTextColor : 0;
	}, _breakpoints.minDesktop);
	
	var Headline = (0, _styled2.default)(_H2.default)(_templateObject4, _breakpoints.mediaPhone, _breakpoints.minTablet, _breakpoints.minDesktop);
	
	var ExternalLinksCollection = function ExternalLinksCollection(_ref2) {
	  var headline = _ref2.headline,
	      sources = _ref2.sources,
	      showIds = _ref2.showIds,
	      collapsable = _ref2.collapsable;
	  return _react2.default.createElement(
	    Container,
	    null,
	    _react2.default.createElement(
	      Headline,
	      null,
	      headline
	    ),
	    _react2.default.createElement(
	      SectionsList,
	      null,
	      sources.map(function (_ref3) {
	        var id = _ref3.id,
	            title = _ref3.title,
	            items = _ref3.items,
	            download = _ref3.download;
	        return _react2.default.createElement(ExternalLinksSectionStyled, {
	          key: id || title,
	          id: id,
	          headline: title,
	          showId: showIds,
	          sources: items,
	          collapsable: collapsable,
	          download: download
	        });
	      })
	    )
	  );
	};
	
	ExternalLinksCollection.propTypes = {
	  headline: _propTypes2.default.string,
	  sources: _ExternalLinksShape2.default.isRequired,
	  showIds: _propTypes2.default.bool,
	  collapsable: _propTypes2.default.bool
	};
	
	ExternalLinksCollection.defaultProps = {
	  headline: '',
	  showIds: false,
	  collapsable: false
	};
	
	exports.default = ExternalLinksCollection;
	module.exports = exports['default'];

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  list-style-type: none;\n  min-height: ', ';\n\n  ', ' {\n    padding-left: 25px;\n    padding-right: 25px;\n  }\n  ', ' {\n    padding-left: 20px;\n  }\n'], ['\n  list-style-type: none;\n  min-height: ', ';\n\n  ', ' {\n    padding-left: 25px;\n    padding-right: 25px;\n  }\n  ', ' {\n    padding-left: 20px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  padding-bottom: 25px;\n\n  ', ' {\n    padding-bottom: 35px;\n  }\n'], ['\n  padding-bottom: 25px;\n\n  ', ' {\n    padding-bottom: 35px;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  position: relative;\n\n  margin-top: 10px;\n\n  ', ' {\n    margin-top: 20px;\n  }\n\n  ', ' {\n    margin-top: 25px;\n  }\n\n  ', '\n'], ['\n  position: relative;\n\n  margin-top: 10px;\n\n  ', ' {\n    margin-top: 20px;\n  }\n\n  ', ' {\n    margin-top: 25px;\n  }\n\n  ', '\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n'], ['\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  ', ';\n\n  ', ' {\n    margin-bottom: 2px;\n  }\n'], ['\n  ', ';\n\n  ', ' {\n    margin-bottom: 2px;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  ', ';\n\n  padding-left: 80px;\n\n  ', ' {\n    padding-left: 65px;\n  }\n'], ['\n  ', ';\n\n  padding-left: 80px;\n\n  ', ' {\n    padding-left: 65px;\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  ', ';\n\n  padding-left: 0;\n\n  ', ' {\n    padding-left: 55px;\n  }\n'], ['\n  ', ';\n\n  padding-left: 0;\n\n  ', ' {\n    padding-left: 55px;\n  }\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n  line-height: 1.3;\n\n  padding-top: 6px;\n\n  color: ', ';\n\n  &:hover {\n    color: ', ';\n  }\n\n  cursor: pointer;\n\n  ', ' {\n    padding-top: 7px;\n    padding-right: 60px;\n  }\n\n  ', '\n'], ['\n  line-height: 1.3;\n\n  padding-top: 6px;\n\n  color: ', ';\n\n  &:hover {\n    color: ', ';\n  }\n\n  cursor: pointer;\n\n  ', ' {\n    padding-top: 7px;\n    padding-right: 60px;\n  }\n\n  ', '\n']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n  padding: 60px 0 40px 0; // 65px;\n  ', ' {\n    padding: 40px 20px 40px 80px;\n  }\n  ', ' {\n    padding: 40px 40px 40px 80px;\n  }\n'], ['\n  padding: 60px 0 40px 0; // 65px;\n  ', ' {\n    padding: 40px 20px 40px 80px;\n  }\n  ', ' {\n    padding: 40px 40px 40px 80px;\n  }\n']),
	    _templateObject10 = _taggedTemplateLiteralLoose(['\n  padding: 40px 0 40px 0;\n  ', ' {\n    padding: 40px 20px 40px 0;\n  }\n  ', ' {\n    padding: 40px 40px 40px 0;\n  }\n'], ['\n  padding: 40px 0 40px 0;\n  ', ' {\n    padding: 40px 20px 40px 0;\n  }\n  ', ' {\n    padding: 40px 40px 40px 0;\n  }\n']),
	    _templateObject11 = _taggedTemplateLiteralLoose(['\n  display: none;\n'], ['\n  display: none;\n']),
	    _templateObject12 = _taggedTemplateLiteralLoose(['\n'], ['\n']),
	    _templateObject13 = _taggedTemplateLiteralLoose(['\n  ', '\n  ', '\n  ', '\n'], ['\n  ', '\n  ', '\n  ', '\n']),
	    _templateObject14 = _taggedTemplateLiteralLoose(['\n  from {\n    transform: translate3d(0,10px,0);\n  }\n\n  to {\n    transform: translate3d(0,0,0);\n  }\n'], ['\n  from {\n    transform: translate3d(0,10px,0);\n  }\n\n  to {\n    transform: translate3d(0,0,0);\n  }\n']),
	    _templateObject15 = _taggedTemplateLiteralLoose(['\n  from {\n    transform: scale(1);\n  }\n\n  to {\n    transform: scale(1.1);\n  }\n'], ['\n  from {\n    transform: scale(1);\n  }\n\n  to {\n    transform: scale(1.1);\n  }\n']),
	    _templateObject16 = _taggedTemplateLiteralLoose(['\n  *:hover > & {\n    animation: ', ' .4s alternate infinite;\n    @media (hover: none) {\n      animation: none;\n    }\n  }\n'], ['\n  *:hover > & {\n    animation: ', ' .4s alternate infinite;\n    @media (hover: none) {\n      animation: none;\n    }\n  }\n']),
	    _templateObject17 = _taggedTemplateLiteralLoose(['\n  ', ';\n\n  display: none;\n  ', ' {\n    display: block;\n  }\n  margin-top: ', '; \n'], ['\n  ', ';\n\n  display: none;\n  ', ' {\n    display: block;\n  }\n  margin-top: ', '; \n']),
	    _templateObject18 = _taggedTemplateLiteralLoose(['\n  ', ';\n\n  position: absolute;\n  top: 10px;\n  right: 25px;\n  ', ' {\n    right: 35px;\n  }\n  ', ' {\n    display: none;\n  }\n'], ['\n  ', ';\n\n  position: absolute;\n  top: 10px;\n  right: 25px;\n  ', ' {\n    right: 35px;\n  }\n  ', ' {\n    display: none;\n  }\n']),
	    _templateObject19 = _taggedTemplateLiteralLoose(['\n  list-style-type: none;\n  text-align: center;\n  padding-top: 3em;\n  padding-bottom: 1.5em;\n'], ['\n  list-style-type: none;\n  text-align: center;\n  padding-top: 3em;\n  padding-bottom: 1.5em;\n']),
	    _templateObject20 = _taggedTemplateLiteralLoose(['\n  padding: 15px;\n  border-radius: 3px;\n  text-align: center;\n'], ['\n  padding: 15px;\n  border-radius: 3px;\n  text-align: center;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _core = __webpack_require__(26);
	
	var _DownloadMaterialButton = __webpack_require__(54);
	
	var _DownloadMaterialButton2 = _interopRequireDefault(_DownloadMaterialButton);
	
	var _breakpoints = __webpack_require__(4);
	
	var _colors = __webpack_require__(9);
	
	var _ExternalDownloadShape = __webpack_require__(136);
	
	var _ExternalDownloadShape2 = _interopRequireDefault(_ExternalDownloadShape);
	
	var _ExternalSourceShape = __webpack_require__(90);
	
	var _ExternalSourceShape2 = _interopRequireDefault(_ExternalSourceShape);
	
	var _ExternalSource = __webpack_require__(220);
	
	var _ExternalSource2 = _interopRequireDefault(_ExternalSource);
	
	var _Collapsor = __webpack_require__(217);
	
	var _Collapsor2 = _interopRequireDefault(_Collapsor);
	
	var _styles = __webpack_require__(139);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; } /* eslint-disable object-curly-newline */
	
	
	var Container = _styled2.default.li(_templateObject, function (_ref) {
	  var showId = _ref.showId;
	  return showId ? '68px' : '55px';
	}, _breakpoints.mediaPhone, _breakpoints.minTablet);
	
	var HeaderWithCollapsedSection = (0, _core.css)(_templateObject2, _breakpoints.minDesktop);
	
	var Header = _styled2.default.div(_templateObject3, _breakpoints.minTablet, _breakpoints.minDesktop, function (_ref2) {
	  var open = _ref2.open;
	  return !open && HeaderWithCollapsedSection;
	});
	
	var HeaderStart = _styled2.default.div(_templateObject4);
	
	var SectionId = _styled2.default.div(_templateObject5, _styles.SectionIdFontStyles, _breakpoints.mediaPhone);
	
	var HeadlineWithIdStyles = (0, _core.css)(_templateObject6, _styles.SectionHeadlineFontStyles, _breakpoints.mediaPhone);
	
	var HeadlineWithoutIdStyles = (0, _core.css)(_templateObject7, _styles.SectionHeadline2ndFontStyles, _breakpoints.mediaPhone);
	
	var Headline = _styled2.default.div(_templateObject8, function (_ref3) {
	  var open = _ref3.open;
	  return open ? _colors.SecondaryTextColor : _colors.TextColor;
	}, _colors.SecondaryTextColor, _breakpoints.minTablet, function (_ref4) {
	  var showId = _ref4.showId;
	  return showId ? HeadlineWithIdStyles : HeadlineWithoutIdStyles;
	});
	
	var SourcesWithIdStyles = (0, _core.css)(_templateObject9, _breakpoints.minTablet, _breakpoints.minDesktop);
	
	var SourcesWithoutIdStyles = (0, _core.css)(_templateObject10, _breakpoints.minTablet, _breakpoints.minDesktop);
	
	var SourcesCollapsed = (0, _core.css)(_templateObject11);
	
	var SourcesOpened = (0, _core.css)(_templateObject12);
	
	var Sources = _styled2.default.ul(_templateObject13, function (_ref5) {
	  var showId = _ref5.showId;
	  return showId ? SourcesWithIdStyles : SourcesWithoutIdStyles;
	}, function (_ref6) {
	  var open = _ref6.open;
	  return open ? SourcesOpened : SourcesCollapsed;
	}, function (_ref7) {
	  var collapsable = _ref7.collapsable;
	  return collapsable ? '' : 'padding-top: 0 !important;';
	});
	
	var BounceAnimation = (0, _core.keyframes)(_templateObject14);
	
	var ZoomAnimation = (0, _core.keyframes)(_templateObject15);
	
	var BounceStyles = (0, _core.css)(_templateObject16, BounceAnimation);
	
	var ZoomStyles = (0, _core.css)(_templateObject16, ZoomAnimation);
	
	var CollapsorPhone = (0, _styled2.default)(_Collapsor2.default)(_templateObject17, function (_ref8) {
	  var open = _ref8.open;
	  return open ? ZoomStyles : BounceStyles;
	}, _breakpoints.mediaPhone, function (_ref9) {
	  var showId = _ref9.showId;
	  return showId ? '0' : '10px';
	});
	
	var CollapsorRight = (0, _styled2.default)(_Collapsor2.default)(_templateObject18, function (_ref10) {
	  var open = _ref10.open;
	  return open ? ZoomStyles : BounceStyles;
	}, _breakpoints.minDesktop, _breakpoints.mediaPhone);
	
	var DownloadButtonContainer = _styled2.default.li(_templateObject19);
	
	var DownloadButton = (0, _styled2.default)(_DownloadMaterialButton2.default)(_templateObject20);
	
	var ExternalLinksSection = function (_React$Component) {
	  _inherits(ExternalLinksSection, _React$Component);
	
	  function ExternalLinksSection() {
	    _classCallCheck(this, ExternalLinksSection);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = {
	      isOpen: false
	    };
	    return _this;
	  }
	
	  ExternalLinksSection.prototype.toggleCollapse = function toggleCollapse() {
	    this.setState(function (state) {
	      return { isOpen: !state.isOpen };
	    });
	  };
	
	  ExternalLinksSection.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        id = _props.id,
	        headline = _props.headline,
	        sources = _props.sources,
	        showId = _props.showId,
	        className = _props.className,
	        collapsable = _props.collapsable,
	        extDownload = _props.download;
	    var isOpen = this.state.isOpen;
	
	    return _react2.default.createElement(
	      Container,
	      { className: className, showId: showId },
	      collapsable && _react2.default.createElement(
	        Header,
	        { open: isOpen },
	        _react2.default.createElement(
	          HeaderStart,
	          null,
	          showId && _react2.default.createElement(
	            SectionId,
	            null,
	            id
	          ),
	          _react2.default.createElement(CollapsorPhone, { onClick: function onClick() {
	              return _this2.toggleCollapse();
	            }, showId: showId, open: isOpen })
	        ),
	        _react2.default.createElement(Headline, { showId: showId, open: isOpen, onClick: function onClick() {
	            return _this2.toggleCollapse();
	          }, dangerouslySetInnerHTML: { __html: headline } }),
	        _react2.default.createElement(CollapsorRight, { onClick: function onClick() {
	            return _this2.toggleCollapse();
	          }, open: isOpen })
	      ),
	      _react2.default.createElement(
	        Sources,
	        { showId: showId, open: !collapsable || isOpen, collapsable: collapsable },
	        sources.map(function (_ref11) {
	          var type = _ref11.type,
	              body = _ref11.body,
	              url = _ref11.url,
	              download = _ref11.download,
	              indent = _ref11.indent;
	          return _react2.default.createElement(_ExternalSource2.default, { key: body, type: type, body: body, url: url, download: download, indent: indent });
	        }),
	        extDownload && _react2.default.createElement(
	          DownloadButtonContainer,
	          null,
	          _react2.default.createElement(DownloadButton, {
	            label: extDownload.label,
	            href: extDownload.url,
	            download: extDownload.file
	          })
	        )
	      )
	    );
	  };
	
	  return ExternalLinksSection;
	}(_react2.default.Component);
	
	ExternalLinksSection.propTypes = {
	  id: _propTypes2.default.string,
	  headline: _propTypes2.default.string.isRequired,
	  sources: _propTypes2.default.arrayOf(_ExternalSourceShape2.default).isRequired,
	  download: _ExternalDownloadShape2.default,
	  showId: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  collapsable: _propTypes2.default.bool
	};
	
	ExternalLinksSection.defaultProps = {
	  id: undefined,
	  showId: false,
	  className: undefined,
	  collapsable: false,
	  download: undefined
	};
	
	exports.default = ExternalLinksSection;
	module.exports = exports['default'];

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    background-image: url(', ');\n  '], ['\n    background-image: url(', ');\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    display: none;\n  '], ['\n    display: none;\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  margin-left: ', ';\n  margin-bottom: 15px;\n  list-style-type: none;\n'], ['\n  position: relative;\n  margin-left: ', ';\n  margin-bottom: 15px;\n  list-style-type: none;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 32px;\n  height: 32px;\n\n  background-size: 100% 100%;\n  background-repeat: no-repeat;\n'], ['\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 32px;\n  height: 32px;\n\n  background-size: 100% 100%;\n  background-repeat: no-repeat;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  ', ';\n\n  padding-left: ', ';\n'], ['\n  ', ';\n\n  padding-left: ', ';\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  padding: 0;\n'], ['\n  padding: 0;\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  list-style-type: none;\n  padding-left: 55px;\n\n  text-overflow: ellipsis;\n  overflow: hidden;\n'], ['\n  list-style-type: none;\n  padding-left: 55px;\n\n  text-overflow: ellipsis;\n  overflow: hidden;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _emotion = __webpack_require__(22);
	
	var _colors = __webpack_require__(9);
	
	var _ExternalSourceShape = __webpack_require__(90);
	
	var _styles = __webpack_require__(139);
	
	var _outlineLaunch24px = __webpack_require__(442);
	
	var _outlineLaunch24px2 = _interopRequireDefault(_outlineLaunch24px);
	
	var _outlineImage24px = __webpack_require__(441);
	
	var _outlineImage24px2 = _interopRequireDefault(_outlineImage24px);
	
	var _outlineMovie24px = __webpack_require__(443);
	
	var _outlineMovie24px2 = _interopRequireDefault(_outlineMovie24px);
	
	var _outlinePicture_as_pdf24px = __webpack_require__(444);
	
	var _outlinePicture_as_pdf24px2 = _interopRequireDefault(_outlinePicture_as_pdf24px);
	
	var _LE = __webpack_require__(225);
	
	var _LE1_ = __webpack_require__(226);
	
	var _LE1_2 = __webpack_require__(227);
	
	var _LE1_3 = __webpack_require__(228);
	
	var _LE2 = __webpack_require__(229);
	
	var _LE2_ = __webpack_require__(230);
	
	var _LE2_2 = __webpack_require__(231);
	
	var _LE2_3 = __webpack_require__(232);
	
	var _LE3 = __webpack_require__(233);
	
	var _LE3_ = __webpack_require__(234);
	
	var _LE3_2 = __webpack_require__(235);
	
	var _LE3_3 = __webpack_require__(236);
	
	var _LE3_4 = __webpack_require__(237);
	
	var _LE3_5 = __webpack_require__(238);
	
	var _LE3_6 = __webpack_require__(239);
	
	var _LE4 = __webpack_require__(240);
	
	var _LE4_ = __webpack_require__(241);
	
	var _LE4_2b = __webpack_require__(242);
	
	var _LE4_2 = __webpack_require__(243);
	
	var _LE4_3 = __webpack_require__(244);
	
	var _MORE_MATERIAL_AND_TIPS = __webpack_require__(245);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; } /* eslint-disable camelcase */
	/* eslint-disable react/prop-types */
	/* eslint-disable object-curly-newline */
	
	
	var COMPONENTS = {
	  LE1: _LE.LE1,
	  LE1_2: _LE1_.LE1_2,
	  LE1_3: _LE1_2.LE1_3,
	  LE1_4: _LE1_3.LE1_4,
	  LE2: _LE2.LE2,
	  LE2_2: _LE2_.LE2_2,
	  LE2_3: _LE2_2.LE2_3,
	  LE2_4: _LE2_3.LE2_4,
	  LE3: _LE3.LE3,
	  LE3_2: _LE3_.LE3_2,
	  LE3_3: _LE3_2.LE3_3,
	  LE3_4: _LE3_3.LE3_4,
	  LE3_5: _LE3_4.LE3_5,
	  LE3_6: _LE3_5.LE3_6,
	  LE3_7: _LE3_6.LE3_7,
	  LE4: _LE4.LE4,
	  LE4_2: _LE4_.LE4_2,
	  LE4_2b: _LE4_2b.LE4_2b,
	  LE4_3: _LE4_2.LE4_3,
	  LE4_4: _LE4_3.LE4_4,
	  MORE_MATERIAL_AND_TIPS: _MORE_MATERIAL_AND_TIPS.MORE_MATERIAL_AND_TIPS
	};
	
	var TypeExtStyles = {
	  pdf: (0, _emotion.css)(_templateObject, _outlinePicture_as_pdf24px2.default),
	  image: (0, _emotion.css)(_templateObject, _outlineImage24px2.default),
	  video: (0, _emotion.css)(_templateObject, _outlineMovie24px2.default),
	  link: (0, _emotion.css)(_templateObject, _outlineLaunch24px2.default),
	  component: (0, _emotion.css)(_templateObject2),
	  notype: (0, _emotion.css)(_templateObject2)
	};
	
	var Container = _styled2.default.li(_templateObject3, function (_ref) {
	  var indent = _ref.indent;
	  return indent * 20 + 'px';
	});
	
	var TypeStyles = (0, _emotion.css)(_templateObject4);
	
	var Body = _styled2.default.div(_templateObject5, _styles.TextFontStyles, function (_ref2) {
	  var type = _ref2.type;
	  return type === 'notype' ? '0' : '55px';
	});
	
	var LinkList = _styled2.default.ul(_templateObject6);
	
	var LinkItem = _styled2.default.li(_templateObject7);
	
	var LINK_TARGET = '_blank';
	var LINK_REL = 'noopener noreferrer';
	
	var Link = function Link(_ref3) {
	  var href = _ref3.href,
	      download = _ref3.download;
	  return _react2.default.createElement(
	    LinkItem,
	    null,
	    download ? _react2.default.createElement(
	      'a',
	      { href: href, download: download },
	      download
	    ) : _react2.default.createElement(
	      'a',
	      { href: href, target: LINK_TARGET, rel: href && href[0] === '/' ? undefined : LINK_REL },
	      href && href.replace(/^(\/[^/]+)*\//g, '')
	    )
	  );
	};
	
	var parseAutoLinks = function parseAutoLinks(text) {
	  return text.replace(/(https?:\/\/[^ ]*[^ ,.])/g, '<a href="$1" style="color:' + _colors.TextColor + '" target="' + LINK_TARGET + '" rel="' + LINK_REL + '">$1</a>');
	};
	
	var Urls = function Urls(_ref4) {
	  var url = _ref4.url,
	      download = _ref4.download;
	  return Array.isArray(url) ? _react2.default.createElement(
	    LinkList,
	    null,
	    url.map(function (href) {
	      return _react2.default.createElement(Link, { key: href, href: href });
	    })
	  ) : _react2.default.createElement(
	    LinkList,
	    null,
	    _react2.default.createElement(Link, { href: url, download: download })
	  );
	};
	
	var ExternalSource = function ExternalSource(_ref5) {
	  var type = _ref5.type,
	      body = _ref5.body,
	      url = _ref5.url,
	      download = _ref5.download,
	      indent = _ref5.indent;
	
	  var BodyComponent = type === 'component' ? COMPONENTS[body] : undefined;
	
	  return _react2.default.createElement(
	    Container,
	    { indent: indent },
	    _react2.default.createElement('div', { className: (0, _emotion.css)([TypeStyles, TypeExtStyles[type]]) }),
	    BodyComponent && _react2.default.createElement(BodyComponent, null) || _react2.default.createElement(Body, { type: type, dangerouslySetInnerHTML: { __html: parseAutoLinks(body) } }),
	    _react2.default.createElement(Urls, { url: url, download: download })
	  );
	};
	
	ExternalSource.propTypes = _ExternalSourceShape.ExternalSourcePropTypes;
	
	ExternalSource.defaultProps = {
	  type: 'notype',
	  url: undefined,
	  download: undefined,
	  indent: 0
	};
	
	exports.default = ExternalSource;
	module.exports = exports['default'];

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  text-align: center;\n  padding: 30px;\n'], ['\n  text-align: center;\n  padding: 30px;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  overflow: hidden;\n  text-align: center;\n  padding: 0 !important;\n\n  height: 200px;\n\n  ', ' {\n    height: 190px;\n  }\n'], ['\n  overflow: hidden;\n  text-align: center;\n  padding: 0 !important;\n\n  height: 200px;\n\n  ', ' {\n    height: 190px;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  ', '\n  max-width: 100%;\n'], ['\n  ', '\n  max-width: 100%;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _emotion = __webpack_require__(22);
	
	var _breakpoints = __webpack_require__(4);
	
	var _images = __webpack_require__(93);
	
	var _Grafik_Download = __webpack_require__(445);
	
	var _Grafik_Download2 = _interopRequireDefault(_Grafik_Download);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styled2.default.div(_templateObject);
	
	var ContainerInsideCTA = (0, _emotion.css)(_templateObject2, _breakpoints.mediaTablet);
	
	var Img = _styled2.default.img(_templateObject3, _images.sharpImageRendering);
	
	var GrafikPDFDownload = function GrafikPDFDownload(_ref) {
	  var insideCTA = _ref.insideCTA;
	  return _react2.default.createElement(
	    Container,
	    { className: insideCTA ? ContainerInsideCTA : '' },
	    _react2.default.createElement(Img, {
	      src: _Grafik_Download2.default,
	      alt: 'Grafik PDF Download'
	    })
	  );
	};
	
	GrafikPDFDownload.propTypes = {
	  insideCTA: _propTypes2.default.bool
	};
	
	GrafikPDFDownload.defaultProps = {
	  insideCTA: false
	};
	
	exports.default = GrafikPDFDownload;
	module.exports = exports['default'];

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  ', ';\n  font-size: 26px;\n\n  line-height: 1;\n\n  ', ' {\n    font-size: 32px;\n  }\n'], ['\n  ', ';\n  font-size: 26px;\n\n  line-height: 1;\n\n  ', ' {\n    font-size: 32px;\n  }\n']);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _breakpoints = __webpack_require__(4);
	
	var _fonts = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	exports.default = _styled2.default.h2(_templateObject, _fonts.Headline2ndFont, _breakpoints.minDesktop);
	module.exports = exports['default'];

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  color: ', ';\n'], ['\n  color: ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: ', ';\n\n  margin-left: 20px;\n  margin-right: 20px;\n\n  ', ' {\n    width: 645px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n'], ['\n  display: ', ';\n\n  margin-left: 20px;\n  margin-right: 20px;\n\n  ', ' {\n    width: 645px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  font-size: inherit;\n  font-weight: bold;\n  color: ', ';\n'], ['\n  font-size: inherit;\n  font-weight: bold;\n  color: ', ';\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  border: none;\n  height: 1px;\n  color: ', ';\n  background-color: ', ';\n  margin: 2.5em 0;\n'], ['\n  border: none;\n  height: 1px;\n  color: ', ';\n  background-color: ', ';\n  margin: 2.5em 0;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  line-height: 3;\n\n  text-align: right;\n\n  ', ' {\n    font-size: 12px;\n  }\n'], ['\n  line-height: 3;\n\n  text-align: right;\n\n  ', ' {\n    font-size: 12px;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  font-size: 15px;\n  ', ' {\n    font-size: 12px;\n  }\n  margin-bottom: 30px;\n'], ['\n  font-size: 15px;\n  ', ' {\n    font-size: 12px;\n  }\n  margin-bottom: 30px;\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  font-size: 13px;\n  ', ' {\n    font-size: 12px;\n  }\n'], ['\n  font-size: 13px;\n  ', ' {\n    font-size: 12px;\n  }\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n  -webkit-appearance: none;\n  border: none;\n  background-color: transparent;\n\n  cursor: pointer;\n\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  &:focus {\n    outline: none;\n  }\n'], ['\n  -webkit-appearance: none;\n  border: none;\n  background-color: transparent;\n\n  cursor: pointer;\n\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  &:focus {\n    outline: none;\n  }\n']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n  margin-bottom: 0;\n'], ['\n  margin-bottom: 0;\n']),
	    _templateObject10 = _taggedTemplateLiteralLoose(['\n  color: ', ' !important;\n  text-decoration: none;\n'], ['\n  color: ', ' !important;\n  text-decoration: none;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _core = __webpack_require__(26);
	
	var _PageLayout = __webpack_require__(142);
	
	var _PageLayout2 = _interopRequireDefault(_PageLayout);
	
	var _ExternalLink = __webpack_require__(89);
	
	var _breakpoints = __webpack_require__(4);
	
	var _colors = __webpack_require__(9);
	
	var _fonts = __webpack_require__(15);
	
	var _outlineHighlight_off24px = __webpack_require__(446);
	
	var _outlineHighlight_off24px2 = _interopRequireDefault(_outlineHighlight_off24px);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; } /* eslint-env browser */
	
	
	var Section = _styled2.default.section(_templateObject, _colors.ImpressumTextColor);
	
	var InnerContent = _styled2.default.div(_templateObject2, function (_ref) {
	  var isOpen = _ref.isOpen;
	  return isOpen ? 'block' : 'none';
	}, _breakpoints.minTablet);
	
	var H4 = _styled2.default.h4(_templateObject3, _colors.ImpressumTextColor);
	
	var Hr = _styled2.default.hr(_templateObject4, _colors.ImpressumTextColor, _colors.ImpressumTextColor);
	
	var ImpressumHeader = _styled2.default.div(_templateObject5, _breakpoints.mediaPhone);
	
	var ArticleImpressum = _styled2.default.article(_templateObject6, _breakpoints.mediaPhone);
	
	var Haftungsausschluss = _styled2.default.div(_templateObject7, _breakpoints.mediaPhone);
	
	var ResetButtonStyles = (0, _core.css)(_templateObject8);
	
	var Button = _styled2.default.button([ResetButtonStyles, '\n\n  font-size: 15px;\n  ' + _breakpoints.mediaPhone + ' {\n    font-size: 12px;\n  }\n\n  color: ' + _colors.ImpressumTextColor + ';\n']);
	
	var CloseImpressumButton = _styled2.default.button([ResetButtonStyles, _fonts.MonospaceFont, '\n  font-size: 15px;\n  ' + _breakpoints.mediaPhone + ' {\n    font-size: 12px;\n  }\n\n  color: #000;\n\n  opacity: .5;\n  &:hover {\n    opacity: .9;\n  }\n\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 30px;\n  line-height: 24px;\n\n  background-size: 24px 24px;\n  background-repeat: no-repeat;\n  background-position: left;\n  background-image: url(' + _outlineHighlight_off24px2.default + ');\n']);
	
	var H4Styled = (0, _styled2.default)(H4)(_templateObject9);
	
	var ExternalLink = (0, _styled2.default)(_ExternalLink.ExternalLink)(_templateObject10, _colors.ImpressumTextColor);
	
	var Impressum = function (_React$Component) {
	  _inherits(Impressum, _React$Component);
	
	  function Impressum() {
	    _classCallCheck(this, Impressum);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = {
	      isOpen: false
	    };
	    return _this;
	  }
	
	  Impressum.prototype.showImpressum = function showImpressum() {
	    this.setState({ isOpen: true });
	    setTimeout(function () {
	      document.getElementById('impressum').scrollIntoView();
	    }, 50);
	  };
	
	  Impressum.prototype.closeImpressum = function closeImpressum() {
	    this.setState({ isOpen: false });
	  };
	
	  Impressum.prototype.render = function render() {
	    var _this2 = this;
	
	    var isOpen = this.state.isOpen;
	
	
	    return _react2.default.createElement(
	      Section,
	      null,
	      _react2.default.createElement(
	        _PageLayout2.default,
	        null,
	        _react2.default.createElement(
	          ImpressumHeader,
	          null,
	          _react2.default.createElement(
	            Button,
	            { onClick: function onClick() {
	                return _this2.showImpressum();
	              } },
	            'Impressum, Kontakt und Haftungsausschluss'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              ExternalLink,
	              { href: 'http://www.bundfuerbildung.de' },
	              '\xA9 Bund f\xFCr Bildung e. V.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        InnerContent,
	        { isOpen: isOpen },
	        _react2.default.createElement(
	          ArticleImpressum,
	          { id: 'impressum' },
	          _react2.default.createElement(
	            'p',
	            null,
	            'Inhaltlich Verantwortlicher gem\xE4\xDF \xA7 10 Absatz 3 MDStV',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              ExternalLink,
	              { href: 'http://www.bundfuerbildung.de' },
	              'Bund f\xFCr Bildung e. V.'
	            ),
	            _react2.default.createElement('br', null),
	            'Alle Rechte vorbehalten'
	          ),
	          _react2.default.createElement(
	            H4Styled,
	            null,
	            'Verantwortlich f\xFCr die Erstellung der Unterrichtsmaterialien und der Website:'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Konzept und Redaktion: Claudia Wegener, Dr. Ulrike Wunderle',
	            _react2.default.createElement('br', null),
	            'Fachberater: Falko Stolp',
	            _react2.default.createElement('br', null),
	            'Grafische Umsetzung: Stefan Hoch, Kira Freese (Unterrichtsmaterialien und Website)',
	            _react2.default.createElement('br', null),
	            'Lektorat: Sabine Hatzfeld',
	            _react2.default.createElement('br', null),
	            'Programmierung und Hosting: ',
	            _react2.default.createElement(
	              ExternalLink,
	              { href: 'https://www.spearwolf.de' },
	              'Wolfger Schramm (spearwolf)'
	            )
	          ),
	          _react2.default.createElement(Hr, null),
	          _react2.default.createElement(
	            Haftungsausschluss,
	            null,
	            _react2.default.createElement(
	              H4,
	              null,
	              'Haftungsausschluss'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              '1. Inhalt des Onlineangebotes: Der Autor \xFCbernimmt keinerlei Gew\xE4hr f\xFCr die Aktualit\xE4t, Korrektheit, Vollst\xE4ndigkeit oder Qualit\xE4t der bereitgestellten Informationen. Haftungsanspr\xFCche gegen den Autor, welche sich auf Sch\xE4den materieller oder ideeller Art beziehen, die durch die Nutzung oder Nichtnutzung der dargebotenen Informationen bzw. durch die Nutzung fehlerhafter und unvollst\xE4ndiger Informationen verursacht wurden, sind grunds\xE4tzlich ausgeschlossen, sofern seitens des Autors kein nachweislich vors\xE4tzliches oder grob fahrl\xE4ssiges Verschulden vorliegt. Alle Angebote sind freibleibend und unverbindlich. Der Autor beh\xE4lt es sich ausdr\xFCcklich vor, Teile der Seiten oder das gesamte Angebot ohne gesonderte Ank\xFCndigung zu ver\xE4ndern, zu erg\xE4nzen, zu l\xF6schen oder die Ver\xF6ffentlichung zeitweise oder endg\xFCltig einzustellen.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              '2. Verweise und Links: Bei direkten oder indirekten Verweisen auf fremde Webseiten (\u201EHyperlinks\u201C), die au\xDFerhalb des Verantwortungsbereiches des Autors liegen, w\xFCrde eine Haftungsverpflichtung ausschlie\xDFlich in dem Fall in Kraft treten, in dem der Autor von den Inhalten Kenntnis hat und es ihm technisch m\xF6glich und zumutbar w\xE4re, die Nutzung im Falle rechtswidriger Inhalte zu verhindern. Der Autor erkl\xE4rt hiermit ausdr\xFCcklich, dass zum Zeitpunkt der Linksetzung keine illegalen Inhalte auf den zu verlinkenden Seiten erkennbar waren. Auf die aktuelle und zuk\xFCnftige Gestaltung, die Inhalte oder die Urheberschaft der verlinkten/verkn\xFCpften Seiten hat der Autor keinerlei Einfluss. Deshalb distanziert er sich hiermit ausdr\xFCcklich von allen Inhalten aller verlinkten/verkn\xFCpften Seiten, die nach der Linksetzung ver\xE4ndert wurden. Diese Feststellung gilt f\xFCr alle innerhalb des eigenen Internetangebotes gesetzten Links und Verweise sowie f\xFCr Fremdeintr\xE4ge in vom Autor eingerichteten G\xE4steb\xFCchern, Diskussionsforen, Linkverzeichnissen, Mailinglisten und in allen anderen Formen von Datenbanken, auf deren Inhalt externe Schreibzugriffe m\xF6glich sind. F\xFCr illegale, fehlerhafte oder unvollst\xE4ndige Inhalte und insbesondere f\xFCr Sch\xE4den, die aus der Nutzung oder Nichtnutzung solcherart dargebotener Informationen entstehen, haftet allein der Anbieter der Seite, auf welche verwiesen wurde, nicht derjenige, der \xFCber Links auf die jeweilige Ver\xF6ffentlichung lediglich verweist.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              '3. Urheber und Kennzeichenrecht: Der Autor ist bestrebt, in allen Publikationen die Urheberrechte der verwendeten Grafiken, Tondokumente, Videosequenzen und Texte zu beachten, von ihm selbst erstellte Grafiken, Tondokumente, Videosequenzen und Texte zu nutzen oder auf lizenzfreie Grafiken, Tondokumente, Videosequenzen und Texte zur\xFCckzugreifen. Alle innerhalb des Internetangebotes genannten und ggf. durch Dritte gesch\xFCtzten Marken- und Warenzeichen unterliegen uneingeschr\xE4nkt den Bestimmungen des jeweils g\xFCltigen Kennzeichenrechts und den Besitzrechten der jeweiligen eingetragenen Eigent\xFCmer. Allein aufgrund der blo\xDFen Nennung ist nicht der Schluss zu ziehen, dass Markenzeichen nicht durch Rechte Dritter gesch\xFCtzt sind! Das Copyright f\xFCr ver\xF6ffentlichte, vom Autor selbst erstellte Objekte bleibt allein beim Autor der Seiten. Eine Vervielf\xE4ltigung oder Verwendung solcher Grafiken, Tondokumente, Videosequenzen und Texte in anderen elektronischen oder gedruckten Publikationen ist ohne ausdr\xFCckliche Zustimmung des Autors nicht gestattet.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              '4. Datenschutz: Sofern innerhalb des Internetangebotes die M\xF6glichkeit zur Eingabe pers\xF6nlicher oder gesch\xE4ftlicher Daten (E-Mail-Adressen, Namen, Anschriften) besteht, so erfolgt die Preisgabe dieser Daten seitens des Nutzers auf ausdr\xFCcklich freiwilliger Basis. Die Inanspruchnahme und Bezahlung aller angebotenen Dienste ist \u2013 soweit technisch m\xF6glich und zumutbar \u2013 auch ohne Angabe solcher Daten bzw. unter Angabe anonymisierter Daten oder eines Pseudonyms gestattet. Die Nutzung der im Rahmen des Impressums oder vergleichbarer Angaben ver\xF6ffentlichten Kontaktdaten wie Postanschriften, Telefon- und Faxnummern sowie Emailadressen durch Dritte zur \xDCbersendung von nicht ausdr\xFCcklich angeforderten Informationen ist nicht gestattet. Rechtliche Schritte gegen die Versender von sogenannten Spam-Mails bei Verst\xF6ssen gegen dieses Verbot sind ausdr\xFCcklich vorbehalten.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              '5. Rechtswirksamkeit dieses Haftungsausschlusses: Dieser Haftungsausschluss ist als Teil des Internetangebotes zu betrachten, von dem aus auf diese Seite verwiesen wurde. Sofern Teile oder einzelne Formulierungen dieses Textes der geltenden Rechtslage nicht, nicht mehr oder nicht vollst\xE4ndig entsprechen sollten, bleiben die \xFCbrigen Teile des Dokumentes in ihrem Inhalt und ihrer G\xFCltigkeit davon unber\xFChrt.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          CloseImpressumButton,
	          { onClick: function onClick() {
	              return _this2.closeImpressum();
	            } },
	          'Verbergen'
	        )
	      )
	    );
	  };
	
	  return Impressum;
	}(_react2.default.Component);
	
	exports.default = Impressum;
	module.exports = exports['default'];

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Impressum = __webpack_require__(223);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Impressum).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LE1 = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _P = __webpack_require__(8);
	
	var _Section = __webpack_require__(6);
	
	var _H = __webpack_require__(91);
	
	var _UL = __webpack_require__(7);
	
	var _OL = __webpack_require__(246);
	
	var _LI = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LE1 = exports.LE1 = function LE1() {
	  return _react2.default.createElement(
	    _Section.Section,
	    null,
	    _react2.default.createElement(
	      _P.P,
	      { gapAfter: true },
	      'Zum Einstieg in das Thema besch\xE4ftigen sich die SuS mit ihren eigenen Einstellungen zum Thema Mode und reflektieren diese.'
	    ),
	    _react2.default.createElement(
	      _P.P,
	      null,
	      'Kleidung hat schon lange nicht nur einen praktischen Nutzen, sondern als Mode auch einen Symbolwert. Mit ausgesuchter Kleidung kann man darstellen, wer man ist und was einen ausmacht. Mode tr\xE4gt zum Image bei. Marken z. B. r\xFCcken immer weiter in den Vordergrund \u2013 vom kleinen Hinweisschild am R\xFCcken haben es die Labels inzwischen mitten auf die Brust des Shirts geschafft. Gerade Jugendliche in der Orientierungsphase finden hierin Identifikation und Gruppenzugeh\xF6rigkeit. Aber eben auch Ausgrenzung: Wer es sich nicht leisten kann mitzuhalten, zieht sich zur\xFCck oder geht auf Gegenwehr.'
	    ),
	    _react2.default.createElement(
	      _P.P,
	      null,
	      'Das ist kein neues Ph\xE4nomen, aber der Trend verst\xE4rkte sich in den 2000ern.'
	    ),
	    _react2.default.createElement(
	      _H.H2,
	      null,
	      'Unterrichtsimpulse:'
	    ),
	    _react2.default.createElement(
	      _UL.UL,
	      null,
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        _react2.default.createElement(
	          _P.P,
	          null,
	          _react2.default.createElement(
	            'b',
	            null,
	            'Meinungsbilder'
	          ),
	          ' abfragen:'
	        ),
	        _react2.default.createElement(
	          _P.P,
	          null,
	          'Stellen Sie verschiedene Aussagen vor. Die SuS positionieren sich im Klassenraum dazu, ob sie voll zustimmen, teils zustimmen oder gar nicht zustimmen. Halten Sie das Ergebnis in einer Statistik an der Tafel/am Whiteboard fest:'
	        ),
	        _react2.default.createElement(
	          _OL.OL,
	          null,
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Ich trage gerne Markenklamotten.'
	          ),
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Es ist mir wichtig, Modetrends nicht zu verpassen.'
	          ),
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Ich m\xF6chte mich von der Masse absetzen.'
	          ),
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Leute, die sich keine neuen Sachen leisten k\xF6nnen, tun mir leid.'
	          ),
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Meine Freunde haben einen \xE4hnlichen Style wie ich.'
	          ),
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Secondhand kommt f\xFCr mich nicht in Frage.'
	          )
	        )
	      )
	    )
	  );
	};

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LE1_2 = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ExternalLink = __webpack_require__(28);
	
	var _Section = __webpack_require__(6);
	
	var _UL = __webpack_require__(7);
	
	var _LI = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LE1_2 = exports.LE1_2 = function LE1_2() {
	  return _react2.default.createElement(
	    _Section.Section,
	    { gapBefore: true },
	    _react2.default.createElement(
	      _UL.UL,
	      null,
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Diskutieren Sie anschlie\xDFend die Ergebnisse im Klassenverband: Warum sind Marken wichtig? Wie oft im Jahr muss ein neuer Trend mitgemacht werden? Warum wird Secondhand abgelehnt?'
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        { gapBefore: true },
	        'Alternative Analyse der Meinungsbilder: Lassen Sie Ihre SuS den folgenden Typen-Test machen:',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(_ExternalLink.ExternalLink, { href: 'https://www.bpb.de/lernen/formate/275636/test-wie-bist-du-drauf' }),
	        _react2.default.createElement('br', null),
	        'und besprechen Sie im Klassenverband die Ergebnisse (auf verallgemeinerter Ebene): Wie wichtig ist den SuS Mode und welche Ziele verfolgen sie mit ihrem Style? Sie k\xF6nnen diese Themen auch anhand vorhandener Aussagen von verschiedenen Jugendlichen besprechen:',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(_ExternalLink.ExternalLink, { href: 'https://www.bpb.de/lernen/formate/142180/modekonsum' })
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        { gapBefore: true },
	        'Kleider machen Leute? Lassen Sie die verschiedenen Personen auf den Fotos von den SuS beschreiben und reflektieren Sie anschlie\xDFend, wie viel von der ',
	        _react2.default.createElement(
	          'b',
	          null,
	          'Personen-Beschreibung'
	        ),
	        ' auf die Kleidung bezogen ist und ob das zutreffend sein muss.'
	      )
	    )
	  );
	};

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LE1_3 = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _P = __webpack_require__(8);
	
	var _Section = __webpack_require__(6);
	
	var _UL = __webpack_require__(7);
	
	var _LI = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LE1_3 = exports.LE1_3 = function LE1_3() {
	  return _react2.default.createElement(
	    _Section.Section,
	    { gapBefore: true },
	    _react2.default.createElement(
	      _UL.UL,
	      null,
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        _react2.default.createElement(
	          _P.P,
	          null,
	          'Lassen Sie in Partnerarbeit eine ',
	          _react2.default.createElement(
	            'b',
	            null,
	            'Mind-Map'
	          ),
	          ' mit dem Begriff Kleidung im Zentrum erstellen (f\xFCr fortgeschrittenere SuS). Anschlie\xDFend (oder um die Aufgabe zu vereinfachen) wird eine gemeinsame Mind-Map im Klassenverband zusammengetragen.'
	        ),
	        _react2.default.createElement(
	          _P.P,
	          null,
	          'Vermerken Sie hierauf auch, wie h\xE4ufig bestimmte Begriffe jeweils in Partnerarbeit gefunden wurden, z. B. Mode/Style/bestimmte Marken etc. Er\xF6rtern Sie die Begriffe im Klassenverband. Lassen Sie die Mind-Map sichtbar stehen und erweitern Sie diese im Laufe der folgenden Lerneinheiten.'
	        )
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        { gapBefore: true },
	        'Hausaufgabe und \xDCbergang zum Thema Fast Fashion:'
	      )
	    )
	  );
	};

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LE1_4 = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _P = __webpack_require__(8);
	
	var _Section = __webpack_require__(6);
	
	var _UL = __webpack_require__(7);
	
	var _LI = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LE1_4 = exports.LE1_4 = function LE1_4() {
	  return _react2.default.createElement(
	    _Section.Section,
	    null,
	    _react2.default.createElement(
	      _UL.UL,
	      { disc: true, gapAfter: true },
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Menge der Teile (nur Oberbekleidung, also keine Unterw\xE4sche und Str\xFCmpfe)'
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Wie viele davon werden regelm\xE4\xDFig (mindestens zweimal monatlich) angezogen?'
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Auswahl von 10 (Lieblings-)Kleidungsst\xFCcken: Welche Produktionsl\xE4nder sind auf dem Herstellerschild zu finden? Und aus welchem Material ist das Kleidungsst\xFCck?'
	      )
	    ),
	    _react2.default.createElement(
	      _P.P,
	      null,
	      'F\xFCr fortgeschrittenere SuS: Lassen Sie eine eigene Statistik des jeweiligen Kleiderschrank-Inhaltes zusammenstellen:'
	    ),
	    _react2.default.createElement(
	      _UL.UL,
	      { disc: true, gapAfter: true },
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Herkunftsl\xE4nder'
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Material'
	      )
	    ),
	    _react2.default.createElement(
	      _P.P,
	      null,
	      'Die Auswertung der Analyse erfolgt zu Beginn der Lerneinheit 3.'
	    )
	  );
	};

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LE2 = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _P = __webpack_require__(8);
	
	var _Section = __webpack_require__(6);
	
	var _UL = __webpack_require__(7);
	
	var _LI = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LE2 = exports.LE2 = function LE2() {
	  return _react2.default.createElement(
	    _Section.Section,
	    null,
	    _react2.default.createElement(
	      _P.P,
	      { gapAfter: true },
	      'In dieser Lerneinheit setzen sich SuS mit Einfl\xFCssen auf ihre Kaufentscheidung auseinander. Diese haben viel mit Vertrauen zu tun. Eltern sind oft eine wichtige Finanzquelle, aber mit zunehmendem Alter treffen die Jugendlichen ihre Stilentscheidungen lieber mit Freundinnen und Freunden oder richten sich nach ihren Vorbildern: Schlie\xDFlich wollen Jugendliche im eigenen Freundeskreis bzw. in ihrer Bezugsgruppe ankommen.'
	    ),
	    _react2.default.createElement(
	      _P.P,
	      { gapAfter: true },
	      'Mit der intensiven Nutzung sozialer Netzwerke haben Influencer an Einfluss auf die Kaufentscheidungen von Jugendlichen gewonnen. Influencer sind Personen, \u201Edie aufgrund ihrer starken Pr\xE4senz und ihres hohen Ansehens in einem oder mehreren sozialen Netzwerken als Tr\xE4ger f\xFCr Werbung und Vermarktung in Frage kommen\u201D (Wikipedia). Allerdings treten die Grauzonen zwischen Kunden und Vermarktern, Bewertung und Werbung immer deutlicher zutage.'
	    ),
	    _react2.default.createElement(
	      _UL.UL,
	      null,
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        _react2.default.createElement(
	          _P.P,
	          null,
	          _react2.default.createElement(
	            'b',
	            null,
	            'Orientierungshilfen'
	          ),
	          ' abfragen:'
	        ),
	        _react2.default.createElement(
	          _P.P,
	          null,
	          'Fragen Sie Ihre SuS, wer oder welche Quelle ihnen bei der Kaufentscheidung behilflich ist.'
	        )
	      )
	    )
	  );
	};

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LE2_2 = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _P = __webpack_require__(8);
	
	var _Section = __webpack_require__(6);
	
	var _UL = __webpack_require__(7);
	
	var _LI = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LE2_2 = exports.LE2_2 = function LE2_2() {
	  return _react2.default.createElement(
	    _Section.Section,
	    null,
	    _react2.default.createElement(
	      _P.P,
	      null,
	      'Mehrfachantworten sind m\xF6glich:'
	    ),
	    _react2.default.createElement(
	      _UL.UL,
	      { disc: true, gapAfter: true },
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Eltern'
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Freunde und Bekannte'
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Internetseiten von Online-Shops (Amazon, Zalando)'
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Internetseiten von Modemarken und Bekleidungsgesch\xE4ften'
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Zeitschriften/Magazine'
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Soziale Netzwerke (Instagram, Facebook etc.)'
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Fernsehen (Werbung, Promis?)'
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Mode- oder Fashion-Blogs'
	      )
	    ),
	    _react2.default.createElement(
	      _P.P,
	      { gapAfter: true },
	      'Erstellen Sie mit den Sch\xFClern eine ',
	      _react2.default.createElement(
	        'b',
	        null,
	        'Statistik'
	      ),
	      ', ggf. ein Balkendiagramm, um die Ergebnisse zu visualisieren.'
	    ),
	    _react2.default.createElement(
	      _P.P,
	      null,
	      'Welche Gruppe hat am meisten Einfluss? Werten Sie die Ergebnisse gemeinsam aus.'
	    )
	  );
	};

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LE2_3 = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Section = __webpack_require__(6);
	
	var _UL = __webpack_require__(7);
	
	var _LI = __webpack_require__(5);
	
	var _ExternalLink = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LE2_3 = exports.LE2_3 = function LE2_3() {
	  return _react2.default.createElement(
	    _Section.Section,
	    null,
	    _react2.default.createElement(
	      _UL.UL,
	      null,
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Erweiterung: Falls bisher nicht angesprochen, diskutieren Sie das Thema Finanzen mit den SuS: Wer zahlt, hat Einfluss auf die Kaufentscheidung?'
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        { gapBefore: true },
	        'Abschlie\xDFend bietet sich ein Vergleich der Ergebnisse in der Klasse mit jenen der Greenpeace-Studie an (\u201EUsage & Attitude: Mode unter Jugendlichen\u201D von 2015). Ist das Ergebnis \xE4hnlich?',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(_ExternalLink.ExternalLink, { href: 'https://www.greenpeace.de/sites/www.greenpeace.de/files/publications/mode-unter-jugendlichen-greenpeace-umfrage.pdf' }),
	        '(v. a. Schaubild S. 8: Finanzen; Schaubild S. 13: Informationsquellen f\xFCr Modetrends)'
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        { gapBefore: true },
	        'Einfluss von Freunden bei der Kaufentscheidung',
	        _react2.default.createElement('br', null),
	        'Gestalten Sie ein ',
	        _react2.default.createElement(
	          'b',
	          null,
	          'Rollenspiel'
	        ),
	        ', das den SuS den Einfluss ihrer Freundinnen und Freunde auf die eigene Kaufentscheidung verdeutlicht. Alle SuS sollen ein T-Shirt mit in den Unterricht bringen. Stellen Sie 3 bis 4 Einkaufssituationen nach: Eine Sch\xFClerin bzw. ein Sch\xFCler kann ein T-Shirt \u201Ckaufen\u201D und sich hierbei von einer Freundin bzw. einem Freund beraten lassen. Dieser erh\xE4lt eine Handlungsanweisung, z. B.:',
	        _react2.default.createElement(
	          _UL.UL,
	          { disc: true, gapAfter: true },
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Ich argumentiere gegen alle Artikel.'
	          ),
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Ich unterst\xFCtze den Kauf aller Artikel.'
	          ),
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Ich unterst\xFCtze den Kauf des 3. Artikels.'
	          )
	        ),
	        'Halten Sie die SuS an, m\xF6glichst authentisch ihre Rolle auszuf\xFCllen. Nach jedem Spiel k\xF6nnen sich die \u201ETestpersonen\u201D Notizen machen: Wie haben sie sich mit der Beratung (als Unterst\xFCtzung, Korrektiv?) gef\xFChlt? Werten Sie gemeinsam aus: Wie wichtig ist Best\xE4tigung/Ablehnung eines Artikels durch Freunde f\xFCr die eigene Kaufentscheidung?'
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        { gapBefore: true },
	        'Orientierungshilfen aus den Medien',
	        _react2.default.createElement('br', null),
	        'Gestalten Sie mit den SuS eine ',
	        _react2.default.createElement(
	          'b',
	          null,
	          'Wandzeitung'
	        ),
	        ', auf der das Wo, Wer und Wie der Orientierungshilfe erarbeitet und verdeutlicht wird. Die SuS sollen jeweils ein bis zwei Beitr\xE4ge aus Zeitschriften oder anderen Medien (als Screenshots) mitbringen, die sie hilfreich finden. Auf jedem Beitrag wird die Quelle vermerkt, eine Verbindung zu einzelnen SuS sollte nicht erkennbar sein (Anonymisierung!). Nach gemeinsamer Sichtung wird zugeordnet:',
	        _react2.default.createElement(
	          _UL.UL,
	          { disc: true, gapAfter: true },
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Gruppieren Sie gemeinsam die Beitr\xE4ge nach dem Ort der Ver\xF6ffentlichung (Zeitschriften, soziale Netzwerke, Fernsehen u. a.),'
	          ),
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'dann sollen die Verfasser der Beitr\xE4ge (Journalist, Influencer, Promi) in verschiedenen Farben dazugeschrieben werden.'
	          ),
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Schlie\xDFlich beschriften die SuS die Formen der Orientierungshilfe (Bewertung, Beschreibung eines Looks, Darstellung auf Foto).'
	          )
	        ),
	        'Dann k\xF6nnen die SuS die Beitr\xE4ge der Wandzeitung \u201Eliken\u201D, z. B. mit jeweils drei roten und drei gr\xFCnen Punkten: Welcher Beitrag ist besonders hilfreich? Welcher nicht? Vorlieben werden deutlich.'
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        { gapBefore: true },
	        'Die Bedeutung der Influencer',
	        _react2.default.createElement('br', null),
	        'Beim Influencer-Screening hilft die Wandzeitung zur Unterscheidung zwischen Influencern (nur soziale Netzwerke) und Prominenten (nutzen auch diese Kan\xE4le, erhalten aber ihre Prominenz durch andere Berufe und Leistungen). Oder Sie f\xFChren ein Statement des Fu\xDFballers Jerome Boateng an\xA0',
	        _react2.default.createElement(_ExternalLink.ExternalLink, { href: 'https://www.bpb.de/lernen/formate/142180/modekonsum' }),
	        ', um dann auf das Leben und die Arbeit von Influencern zu blicken:',
	        _react2.default.createElement(
	          _UL.UL,
	          { disc: true, gapAfter: true },
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Caro Daur\xA0',
	            _react2.default.createElement(_ExternalLink.ExternalLink, { href: 'https://www.instagram.com/carodaur/' })
	          ),
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Lisa und Lena\xA0',
	            _react2.default.createElement(_ExternalLink.ExternalLink, { href: 'https://www.instagram.com/Lisaandlena/' })
	          ),
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Riccardo Simonetti\xA0',
	            _react2.default.createElement(_ExternalLink.ExternalLink, { href: 'https://www.instagram.com/riccardosimonetti/' })
	          )
	        ),
	        'Welcher Arbeit gehen die Influencer nach? Welchen Eindruck vermitteln die Bilder? Antworten k\xF6nnten sein: ein unbeschwertes, schillerndes Leben (Urlaub, Luxus, Partys in immer tollen Outfits), an dem durch t\xE4gliche Posts alle teilhaben k\xF6nnen. Tags auf Modelabels oder Empfehlungen bilden die Verbindung zwischen diesem unbeschwerten Leben und der eigenen (weniger glamour\xF6sen) Lebenswelt.'
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        { gapBefore: true },
	        'Eine Frage der Glaubw\xFCrdigkeit:',
	        _react2.default.createElement('br', null),
	        'Folgend k\xF6nnen ',
	        _react2.default.createElement(
	          'b',
	          null,
	          'Alltag und Praktiken'
	        ),
	        ' der Influencer in Gruppen untersucht werden:',
	        _react2.default.createElement(
	          _UL.UL,
	          { disc: true, gapAfter: true },
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'zu Caro Daur (Welche Fragen beantwortet sie nicht?)\xA0',
	            _react2.default.createElement(_ExternalLink.ExternalLink, { href: 'https://www.manager-magazin.de/unternehmen/karriere/caro-daur-die-instagram-influencerin-im-interview-a-1155194-2.html' })
	          ),
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Journalistin versucht sich als Influencerin\xA0',
	            _react2.default.createElement(_ExternalLink.ExternalLink, { href: 'https://www.wiwo.de/erfolg/trends/nicht-nackig-genug-der-schwere-weg-zum-social-media-star/19819542-all.html' })
	          ),
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Kategorisierung von Influencern nach \u201ELovers\u201D, \u201ECritics\u201D und \u201EMavens\u201D:\xA0',
	            _react2.default.createElement(_ExternalLink.ExternalLink, { href: 'https://www.internetworld.de/onlinemarketing/influencer/elfte-deutsche-influencer-944588.html' })
	          ),
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Kritik an der unklaren Grenze zwischen Kunden und Vermarktern\xA0',
	            _react2.default.createElement(_ExternalLink.ExternalLink, { href: 'https://www.spiegel.de/wissenschaft/mensch/influencer-der-markt-frisst-seine-kinder-kolumne-a-1206170.html' })
	          )
	        ),
	        'Diskutieren Sie mit den SuS: Welche Zusammenh\xE4nge sind neu? Vertrauen sie Influencern und wie bewerten sie deren Empfehlungen?'
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        { gapBefore: true },
	        'Vertiefung: ',
	        _react2.default.createElement(
	          'b',
	          null,
	          'Vergleichen'
	        ),
	        ' Sie unterschiedliche Studien zum Thema Influencer:',
	        _react2.default.createElement(
	          _UL.UL,
	          { disc: true, gapAfter: true },
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Wer sind die Auftraggeber?'
	          ),
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Welche Gruppe von Jugendlichen wird untersucht?'
	          ),
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Wie viele werden befragt?'
	          ),
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Mit welchem Ergebnis?'
	          )
	        ),
	        'Usage & Attitude-Studie von Greenpeace aus dem Jahr 2015:',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(_ExternalLink.ExternalLink, { href: 'https://www.greenpeace.de/sites/www.greenpeace.de/files/publications/mode-unter-jugendlichen-greenpeace-umfrage.pdf' }),
	        '(v. a. S. 13) und Influry-Studie von 2017:',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(_ExternalLink.ExternalLink, { href: 'https://www.horizont.net/marketing/nachrichten/Produktempfehlungen-Influencer-sind-nach-Freunden-und-Kundenbewertungen-glaubwuerdigste-Quelle-159867' })
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        { gapBefore: true },
	        'Erweiterung: Einen ganz anderen Zugang zum Thema Influencer bietet der ',
	        _react2.default.createElement(
	          'b',
	          null,
	          'fachwissenschaftliche Beitrag'
	        ),
	        ' von Sebastian L\xF6we (22.10.2018), der beispielhaft an einzelnen InfluencerInnen Bildsprache, Wirkung, Schaffung von Authentizit\xE4t und aktuelle Trends analysiert.',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(_ExternalLink.ExternalLink, { href: 'http://www.pop-zeitschrift.de/2018/10/22/social-media-oktober-von-sebastian-loewe' }),
	        'Dieser Artikel kann in einem (oder mehreren) Einzelreferat(en) oder in Gruppen erarbeitet werden.'
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        { gapBefore: true },
	        _react2.default.createElement(
	          'b',
	          null,
	          'Streitfragen'
	        ),
	        ': Werbung in sozialen Netzwerken',
	        _react2.default.createElement('br', null),
	        'Zur Vorbereitung bietet es sich an, dass die SuS folgenden Text lesen:',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(_ExternalLink.ExternalLink, { href: 'http://faktenfinder.tagesschau.de/kurzerklaert/kurzerklaert-werbung-social-media-103~_origin-9e3a5e5a-e0a5-4bef-8705-9f9636ecf64a.html' }),
	        _react2.default.createElement('br', null),
	        'Im Unterricht k\xF6nnen sich die SuS das Urteil im Fall der Influencerin Pamela Reif anhand eines Audiobeitrag (2 \xBD Minuten) erarbeiten:',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(_ExternalLink.ExternalLink, { href: 'https://www.tagesschau.de/inland/urteil-influencerin-pamela-reif-101.html' })
	      )
	    )
	  );
	};

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LE2_4 = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Section = __webpack_require__(6);
	
	var _UL = __webpack_require__(7);
	
	var _LI = __webpack_require__(5);
	
	var _ExternalLink = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LE2_4 = exports.LE2_4 = function LE2_4() {
	  return _react2.default.createElement(
	    _Section.Section,
	    null,
	    _react2.default.createElement(
	      _UL.UL,
	      null,
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Vorformulierte Fragen unterst\xFCtzen die SuS, sich den einzelnen Facetten des Themas zu n\xE4hern. Spielen Sie den Beitrag ggf. mehrmals vor:',
	        _react2.default.createElement(
	          _UL.UL,
	          { disc: true },
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Warum gelten Instagram-Auftritte der Influencerin als Schleichwerbung?'
	          ),
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Wie begr\xFCndet der Verband Sozialer Wettbewerb seine Klage?'
	          ),
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Wie rechtfertigt Pamela Reif ihr Handeln?'
	          ),
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Woraus ergibt sich der unlautere Wettbewerb?'
	          ),
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Warum k\xF6nnen Influencer nicht einfach strittige Posts als Werbung markieren?'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        { gapBefore: true },
	        _react2.default.createElement(
	          'b',
	          null,
	          'Recherche'
	        ),
	        ': Wie unterscheiden sich die Urteile in den F\xE4llen Pamela Reif und Cathy Hummels? Warum?',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(_ExternalLink.ExternalLink, { href: 'https://www.sueddeutsche.de/muenchen/cathy-hummels-prozess-schleichwerbung-1.4426365' })
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        { gapBefore: true },
	        'Erweitern Sie die Mind-Map mit neuen Begriffen, die den SuS jetzt einfallen.'
	      )
	    )
	  );
	};

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LE3 = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _P = __webpack_require__(8);
	
	var _Section = __webpack_require__(6);
	
	var _H = __webpack_require__(91);
	
	var _UL = __webpack_require__(7);
	
	var _LI = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LE3 = exports.LE3 = function LE3() {
	  return _react2.default.createElement(
	    _Section.Section,
	    null,
	    _react2.default.createElement(
	      _P.P,
	      { gapAfter: true },
	      'In der Lerneinheit 3 besch\xE4ftigen sich die SuS mit dem kritischen Trend der Fast Fashion. Sie lernen die Zusammenh\xE4nge und Auswirkungen von Herstellung und Entsorgung kennen und bewerten diese.'
	    ),
	    _react2.default.createElement(
	      _P.P,
	      { gapAfter: true },
	      'Definition:',
	      _react2.default.createElement('br', null),
	      '\u201E',
	      _react2.default.createElement(
	        'b',
	        null,
	        'Fast Fashion'
	      ),
	      ' bezeichnet ein Gesch\xE4ftsmodell des Textilhandels, bei dem die Kollektion laufend ge\xE4ndert und die Zeit von den neuesten Designs der Modesch\xF6pfer zur Massenware in den Filialen stark verk\xFCrzt wird.\u201D',
	      _react2.default.createElement('br', null),
	      '(Quelle: Wikipedia)'
	    ),
	    _react2.default.createElement(
	      _H.H2,
	      null,
	      'Unterrichtsimpulse:'
	    ),
	    _react2.default.createElement(
	      _UL.UL,
	      null,
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        _react2.default.createElement(
	          _P.P,
	          { gapAfter: true },
	          'Werten Sie den Kleiderschrank-Check der SuS gemeinsam aus:'
	        ),
	        _react2.default.createElement(
	          _UL.UL,
	          { disc: true },
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Auf wie viele Teile Oberbekleidung kommt die ganze Klasse? Was ist der Durchschnitt pro Person? Falls individuelle Aussagen hier vermieden werden sollen, geben Sie Angaben wie mehr/weniger als 50/100 Teile vor etc.'
	          ),
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Aus welchen L\xE4ndern kommt die meiste Kleidung? Erstellen Sie gemeinsam eine Statistik.'
	          ),
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Aus welchen Material besteht die Kleidung? Auch hierf\xFCr k\xF6nnen Sie eine Statistik erstellen.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        { gapBefore: true },
	        'Bearbeiten Sie folgende Einsch\xE4tzungsfragen entweder in Einzelarbeit auf dem'
	      )
	    )
	  );
	};

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LE3_2 = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _P = __webpack_require__(8);
	
	var _Section = __webpack_require__(6);
	
	var _UL = __webpack_require__(7);
	
	var _LI = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LE3_2 = exports.LE3_2 = function LE3_2() {
	  return _react2.default.createElement(
	    _Section.Section,
	    null,
	    _react2.default.createElement(
	      _P.P,
	      { gapAfter: true },
	      'oder gemeinsam auf dem Whiteboard und halten Sie die Durchschnittswerte der Sch\xE4tzungen an der Tafel/am Whiteboard fest:'
	    ),
	    _react2.default.createElement(
	      _UL.UL,
	      { disc: true },
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Kleidungskauf: Wie viele Kleidungsst\xFCcke werden von 1 Person in Deutschland durchschnittlich im Jahr gekauft?\xA0',
	        _react2.default.createElement(
	          'em',
	          null,
	          '(L\xF6sung: 60)'
	        )
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Wie viele unserer Klamotten sind aus Plastik hergestellt?\xA0',
	        _react2.default.createElement(
	          'em',
	          null,
	          '(L\xF6sung: 70 Prozent)'
	        )
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Wie viele Liter Wasser werden verbraucht, um ein Baumwoll-Shirt herzustellen?\xA0',
	        _react2.default.createElement(
	          'em',
	          null,
	          '(L\xF6sung: 15.000 Liter)'
	        )
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Wie viele Kilometer reisen die Shirts nach Deutschland?\xA0',
	        _react2.default.createElement(
	          'em',
	          null,
	          '(L\xF6sung: 20.000 km)'
	        )
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Was glaubt ihr, wie viel Geld eines verkauften Shirts (25 Euro) bei einer N\xE4herin landet?\xA0',
	        _react2.default.createElement(
	          'em',
	          null,
	          '(L\xF6sung: 18 Cent)'
	        )
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Was ist Fast Fashion?\xA0',
	        _react2.default.createElement(
	          'em',
	          null,
	          '(L\xF6sung: siehe Definition)'
	        )
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Wer bietet Fast Fashion an?\xA0',
	        _react2.default.createElement(
	          'em',
	          null,
	          '(L\xF6sung: u. a.: H&M, Zara, Primark)'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _P.P,
	      { gapBefore: true },
	      'Zur Aufl\xF6sung der Fragen k\xF6nnen Sie den folgenden Film im Klassenverband zeigen:'
	    )
	  );
	};

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LE3_3 = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _P = __webpack_require__(8);
	
	var _Section = __webpack_require__(6);
	
	var _UL = __webpack_require__(7);
	
	var _LI = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LE3_3 = exports.LE3_3 = function LE3_3() {
	  return _react2.default.createElement(
	    _Section.Section,
	    null,
	    _react2.default.createElement(
	      _UL.UL,
	      null,
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        _react2.default.createElement(
	          _P.P,
	          { gapAfter: true },
	          'Erstellen Sie eine ',
	          _react2.default.createElement(
	            'b',
	            null,
	            'Lebenszyklusanalyse'
	          ),
	          ' eines Kleidungsst\xFCcks aus einer Fast-Fashion-Kollektion. W\xE4hlen Sie hierzu z. B. Kleidungsst\xFCcke aus der Kleiderschrank-Analyse aus oder bringen Sie selbst ein Shirt mit in den Unterricht. In Gruppenarbeit (',
	          _react2.default.createElement(
	            'b',
	            null,
	            'Expertengruppen'
	          ),
	          ') besch\xE4ftigen sich die SuS mit verschiedenen Aspekten:'
	        ),
	        _react2.default.createElement(
	          _UL.UL,
	          { disc: true },
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Soziale Aspekte in der Herstellung: Lassen Sie die Rahmenbedingungen in den L\xE4ndern recherchieren, aus denen die meisten Kleidungsst\xFCcke aus der Kleiderschrank-Analyse stammen. Stichworte: Mindestlohn, Arbeitszeiten, Arbeitsbedingungen etc.'
	          ),
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            '\xD6kologische Aspekte in der Herstellung/im Gebrauch; Stichworte: Zusammensetzung der Kleidung, Giftstoffe, Baumwolle, Synthetikfasern, \xD6kobilanz, Wasserverbrauch, W\xE4sche waschen etc.'
	          ),
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Gebrauch/Entsorgung; Stichworte: Tragedauer, Reparatur, Entsorgung, (was passiert mit den Altkleidern?), Retouren'
	          )
	        ),
	        _react2.default.createElement(
	          _P.P,
	          { gapBefore: true },
	          'Je nachdem wie fortgeschritten Ihre SuS sind, k\xF6nnen Sie ohne oder mit Angabe der o. g. Stichpunkte die Aufgabe erarbeiten lassen bzw. k\xF6nnen Sie zus\xE4tzlich noch folgende Recherchetipps geben:'
	        )
	      )
	    )
	  );
	};

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LE3_4 = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Section = __webpack_require__(6);
	
	var _UL = __webpack_require__(7);
	
	var _LI = __webpack_require__(5);
	
	var _ExternalLink = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LE3_4 = exports.LE3_4 = function LE3_4() {
	  return _react2.default.createElement(
	    _Section.Section,
	    null,
	    _react2.default.createElement(
	      _UL.UL,
	      { disc: true },
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Repr\xE4sentative Umfrage von Greenpeace zum Modekonsum, Tragedauer und Entsorgung in Deutschland:',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _ExternalLink.ExternalLink,
	          { href: 'https://www.greenpeace.de/sites/www.greenpeace.de/files/publications/20151123_greenpeace_modekonsum_flyer.pdf' },
	          'https://www.greenpeace.de/\u2026modekonsum_flyer.pdf'
	        )
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Erkl\xE4rfilm \xFCber den Lebenszyklus eines Baumwoll-Shirts (Englisch mit deutschen Untertiteln):',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _ExternalLink.ExternalLink,
	          { href: 'https://www.kraftfuttermischwerk.de/blogg/der-lebenszyklus-eines-t-shirts/' },
	          'https://www.kraftfuttermischwerk.de\u2026lebenszyklus-eines-t-shirts/'
	        )
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Bericht \xFCber die N\xE4herin Shila:',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(_ExternalLink.ExternalLink, { href: 'https://www.zeit.de/2014/17/bangladesch-naeherin-shila-begum' }),
	        '(Die Zeit; 2014)'
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Film: Interview mit einer Textil-Arbeiterin in Bangladesch:',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _ExternalLink.ExternalLink,
	          { href: 'https://www.youtube.com/watch?v=2IMGwuXgZTY&list=PLrJ57fSkPxcc0rgcldUISKysEpmAjtQs2&index=3&t=0s' },
	          'https://www.youtube.com/watch\u2026tQs2&index=3&t=0s'
	        ),
	        '(BMZ; 2015)'
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Film: Fast Fashion: Schnelle Mode ist im Trend',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(_ExternalLink.ExternalLink, { href: 'https://www.youtube.com/watch?v=0H2WcFiAyrU' }),
	        '(ARD-Mittagsmagazin; 2018)',
	        _react2.default.createElement('br', null),
	        'Erkl\xE4rung Fast Fashion, Produktion und Recycling'
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        '2012 f\xFCr die berufliche Bildung entwickelt, sehr umfangreich zum Thema Arbeitsbedingungen etc.:',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _ExternalLink.ExternalLink,
	          { href: 'http://www.globaleslernen.de/sites/default/files/files/education-material/epiz_berufe_global_g_mode_und_textil.pdf' },
	          'http://www.globaleslernen.de\u2026mode_und_textil.pdf'
	        )
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Hintergrundinformationen zu Produktionsst\xE4tten von Textilien sowie Interviews mit N\xE4herinnen und N\xE4hern, Informationen zum bestehenden internationalen Rechtsrahmen:',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _ExternalLink.ExternalLink,
	          { href: 'https://saubere-kleidung.de/wp-content/uploads/2018/10/menschenrechte_textilindustrie_2018.pdf' },
	          'https://saubere-kleidung.de\u2026textilindustrie_2018.pdf'
	        )
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Arbeitsbedingungen in der Textilbranche inkl. Verbrauchertipps',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _ExternalLink.ExternalLink,
	          { href: 'http://www.bmz.de/de/themen/textilwirtschaft/hintergrund/index.html' },
	          'http://www.bmz.de/de/themen/textilwirtschaft/hintergrund/'
	        )
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Thema Giftstoffe in Kleidung:',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _ExternalLink.ExternalLink,
	          { href: 'https://www.greenpeace.de/sites/www.greenpeace.de/files/gpbm_gefaehrliche_chemie_in_textilien_saubere_mode_ist_moeglich.pdf' },
	          'https://www.greenpeace.de\u2026saubere_mode_ist_moeglich.pdf'
	        )
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Bericht \xFCber das Unternehmen Zara (S\xFCddeutsche Zeitung vom 31. August 2018)',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _ExternalLink.ExternalLink,
	          { href: 'https://www.sueddeutsche.de/wirtschaft/fast-fashion-zara-hat-die-wegwerfmode-perfektioniert-1.4109496' },
	          'https://www.sueddeutsche.de\u2026perfektioniert-1.4109496'
	        )
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Artikel \xFCber H&M (u. a. auch \xFCber Ziele der Nachhaltigkeit vs. Greenwashing):',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _ExternalLink.ExternalLink,
	          { href: 'https://www.sueddeutsche.de/wirtschaft/mode-hm-scheitert-an-sich-selbst-1.3972267' },
	          'https://www.sueddeutsche.de\u2026an-sich-selbst-1.3972267'
	        ),
	        _react2.default.createElement('br', null),
	        '(S\xFCddeutsche Zeitung; 9. Mai 2018)'
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Bericht \xFCber Secondhand-Aufbereitung in Bulgarien, u. a. auch zum Thema Retouren:',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _ExternalLink.ExternalLink,
	          { href: 'https://www.zeit.de/wirtschaft/2018-11/bulgarien-second-hand-geschaeft-fast-fashion' },
	          'https://www.zeit.de\u2026second-hand-geschaeft-fast-fashion'
	        )
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Bericht \xFCber Fast Fashion im Altkleidercontainer:',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _ExternalLink.ExternalLink,
	          { href: 'https://www.rundschau-online.de/wirtschaft/volle-altkleidercontainer-getragene-kleidung-taugt-selbst-als-putzlappen-nicht-31767118' },
	          'https://www.rundschau-online.de\u2026selbst-als-putzlappen-nicht-31767118'
	        )
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Umfrage von Greenpeace zum Thema Online-Bestellungen und Retouren:',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _ExternalLink.ExternalLink,
	          { href: 'https://www.greenpeace.de/sites/www.greenpeace.de/files/publications/umfrage_zum_online-kaufverhalten_2018-se.pdf' },
	          'https://www.greenpeace.de\u2026online-kaufverhalten_2018-se.pdf'
	        )
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Bericht \xFCber das Import-Verbot von Secondhand-Kleidung in Ruanda:',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _ExternalLink.ExternalLink,
	          { href: 'https://www.zeit.de/2019/02/ruanda-import-altkleidung-textilindustrie-globalisierung' },
	          'https://www.zeit.de\u2026textilindustrie-globalisierung'
	        )
	      )
	    )
	  );
	};

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LE3_5 = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _P = __webpack_require__(8);
	
	var _Section = __webpack_require__(6);
	
	var _UL = __webpack_require__(7);
	
	var _LI = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LE3_5 = exports.LE3_5 = function LE3_5() {
	  return _react2.default.createElement(
	    _Section.Section,
	    null,
	    _react2.default.createElement(
	      _UL.UL,
	      null,
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        _react2.default.createElement(
	          _P.P,
	          { gapAfter: true },
	          'F\xFCr fortgeschrittene SuS: Anschlie\xDFend k\xF6nnen sich die SuS gegenseitig in einem ',
	          _react2.default.createElement(
	            'b',
	            null,
	            'Expertenpuzzle'
	          ),
	          ' informieren, d. h. die Gruppen mischen sich so, dass mindestens je ein Experte (Soziale Aspekte/\xD6kologische Aspekte/Aspekte der Entsorgung) dabei ist und sich \xFCber die Recherche-Ergebnisse informieren kann.'
	        )
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        _react2.default.createElement(
	          _P.P,
	          { gapBefore: true },
	          'Fassen Sie die Ergebnisse im Klassenverband in einem Tafelbild zusammen. Dazu k\xF6nnen Sie folgendes Arbeitsblatt verwenden:'
	        )
	      )
	    )
	  );
	};

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LE3_6 = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _P = __webpack_require__(8);
	
	var _Section = __webpack_require__(6);
	
	var _UL = __webpack_require__(7);
	
	var _LI = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LE3_6 = exports.LE3_6 = function LE3_6() {
	  return _react2.default.createElement(
	    _Section.Section,
	    null,
	    _react2.default.createElement(
	      _P.P,
	      null,
	      'Fortgeschrittene SuS k\xF6nnen in Partnerarbeit auch eine eigene Grafik erstellen:'
	    ),
	    _react2.default.createElement(
	      _UL.UL,
	      { disc: true },
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        _react2.default.createElement(
	          _P.P,
	          { gapBefore: true },
	          'Einfl\xFCsse auf Umwelt und Mensch'
	        ),
	        _react2.default.createElement(
	          _UL.UL,
	          { square: true },
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'in der Produktion'
	          ),
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'im Gebrauch und'
	          ),
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'in der Entsorgung'
	          )
	        )
	      )
	    )
	  );
	};

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LE3_7 = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Section = __webpack_require__(6);
	
	var _UL = __webpack_require__(7);
	
	var _LI = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LE3_7 = exports.LE3_7 = function LE3_7() {
	  return _react2.default.createElement(
	    _Section.Section,
	    null,
	    _react2.default.createElement(
	      _UL.UL,
	      null,
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Erweitern Sie die ',
	        _react2.default.createElement(
	          'b',
	          null,
	          'Mind-Map'
	        ),
	        ' aus der Lerneinheit 1 um neue Begriffe, die den SuS nun noch zus\xE4tzlich einfallen.'
	      )
	    )
	  );
	};

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LE4 = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _P = __webpack_require__(8);
	
	var _Section = __webpack_require__(6);
	
	var _H = __webpack_require__(91);
	
	var _UL = __webpack_require__(7);
	
	var _LI = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LE4 = exports.LE4 = function LE4() {
	  return _react2.default.createElement(
	    _Section.Section,
	    null,
	    _react2.default.createElement(
	      _P.P,
	      { gapAfter: true },
	      'In dieser Lerneinheit besch\xE4ftigen sich die SuS mit verschiedenen M\xF6glichkeiten, wie sie als Verbraucher mit Mode vertr\xE4glicher umgehen k\xF6nnen, sei es in der Anschaffung als auch in der weiteren Verwertung. Ziel ist, die SuS handlungsf\xE4hig zu machen, als Konsument verantwortungsvoll und nachhaltig zu handeln.'
	    ),
	    _react2.default.createElement(
	      _P.P,
	      { gapAfter: true },
	      'Definition:',
	      _react2.default.createElement('br', null),
	      'Von Fair Fashion oder auch von Green Fashion, Eco Fashion, Ethical Fashion oder Sustainable Fashion spricht man, wenn die Kleidung aus umweltfreundlichen Materialien sowie unter Ber\xFCcksichtigung sozialer Aspekte produziert wird.',
	      _react2.default.createElement('br', null),
	      '(Quelle: Wikipedia)'
	    ),
	    _react2.default.createElement(
	      _H.H2,
	      null,
	      'Unterrichtsimpulse:'
	    ),
	    _react2.default.createElement(
	      _UL.UL,
	      null,
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Lassen Sie Ihre SuS Vorschl\xE4ge zu alternativem Handeln in Bezug auf Beschaffung und Verwertung sammeln. In Interessengruppen (alternativ: Erarbeitung im Klassenverband) arbeiten die SuS dann Hintergrundinformationen zu einzelnen Aspekten heraus und bereiten konkrete Handlungsvorschl\xE4ge als ',
	        _react2.default.createElement(
	          'b',
	          null,
	          'Aufkl\xE4rungskampagne'
	        ),
	        ' auf: als kurzer Text, als Plakat, Wandzeitung, Comic, YouTube-Film, Foto-Tutorial etc. Hierzu k\xF6nnen die SuS das Arbeitsblatt nutzen. Die konkreten Vorschl\xE4ge k\xF6nnen von den SuS dann \xFCber eigene oder schulbezogene Social-Media-Kan\xE4le verbreitet werden.'
	      )
	    )
	  );
	};

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LE4_2 = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _P = __webpack_require__(8);
	
	var _Section = __webpack_require__(6);
	
	var _UL = __webpack_require__(7);
	
	var _LI = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LE4_2 = exports.LE4_2 = function LE4_2() {
	  return _react2.default.createElement(
	    _Section.Section,
	    null,
	    _react2.default.createElement(
	      _P.P,
	      { gapAfter: true },
	      'M\xF6gliche Interessengruppen z. B.:'
	    ),
	    _react2.default.createElement(
	      _UL.UL,
	      { disc: true },
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Altkleider-Industrie'
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Altkleider selbst verwerten'
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Faire Shops'
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Faire Siegel'
	      )
	    )
	  );
	};

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LE4_2b = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _P = __webpack_require__(8);
	
	var _Section = __webpack_require__(6);
	
	var _UL = __webpack_require__(7);
	
	var _LI = __webpack_require__(5);
	
	var _ExternalLink = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line camelcase
	var LE4_2b = exports.LE4_2b = function LE4_2b() {
	  return _react2.default.createElement(
	    _Section.Section,
	    null,
	    _react2.default.createElement(
	      _UL.UL,
	      { disc: true },
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        _react2.default.createElement(
	          _P.P,
	          { gapAfter: true },
	          'Verwertung: Recycling, Upcycling, Secondhand, Tausch, Selfmade (reparieren, selbst n\xE4hen/\xE4ndern), Kleidersammlung, illegale Kleidersammlung, illegale Altkleider-Container, FairWertung'
	        ),
	        _react2.default.createElement(
	          _UL.UL,
	          { square: true },
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Instagram-Mode-Blog der Berlinerinnen Karina Papp & Anna Vladi: found_on_the_ street (mit Kleidung, die auf Berliner Stra\xDFen gefunden wurde), Kleidersammlung, illegale Kleidersammlung, illegale Altkleider-Container, FairWertung'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        _react2.default.createElement(
	          _P.P,
	          { gapBefore: true, gapAfter: true },
	          'Beschaffung: Fair Fashion (u. a.: Shops/Siegel)'
	        ),
	        _react2.default.createElement(
	          _UL.UL,
	          { square: true },
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Blogger Riccardo versucht fair zu kaufen:\xA0',
	            _react2.default.createElement(_ExternalLink.ExternalLink, { href: 'https://www.br.de/puls/tv/puls/faire-mode-pro-und-contra-100.html' })
	          ),
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Artikel: Interview mit Mimi Sewalski \u201EGro\xDFe Konzerne erfinden oft eigene faire Siegel\u201D:',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(_ExternalLink.ExternalLink, { href: 'https://www.br.de/puls/themen/leben/mimi-sewalski-interview-avocado-store-fast-fashion-100.html' }),
	            '(BR, 2016)'
	          ),
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'BMZ/GIZ: Siegelklarheit. Informationen zu den verschiedenen Siegeln und Standards der Textilindustrie:\xA0',
	            _react2.default.createElement(_ExternalLink.ExternalLink, { href: 'https://www.siegelklarheit.de' })
	          ),
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Label-Portr\xE4ts ab Seite 26:\xA0',
	            _react2.default.createElement(_ExternalLink.ExternalLink, { href: 'https://saubere-kleidung.de/wp-content/uploads/2018/10/menschenrechte_textilindustrie_2018.pdf' }),
	            _react2.default.createElement('br', null),
	            'Was machen die Labels anders als herk\xF6mmliche Mode-Labels? Was sind die Herausforderungen (wirtschaftliche Aspekte, Marketing etc.)?'
	          ),
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Fair-Shopping-Tipps: APPs, Labels und Siegel',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(_ExternalLink.ExternalLink, { href: 'https://www.br.de/puls/themen/leben/fair-shoppen-tipps-100.html' })
	          ),
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Einkaufsratgeber von Greenpeace f\xFCr giftfreie Mode:',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(_ExternalLink.ExternalLink, { href: 'https://www.greenpeace.de/sites/www.greenpeace.de/files/greenpeace_textil-label-juni_2016.pdf' })
	          ),
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Tipps, wie und wo K\xE4ufer und VerbraucherInnen sich engagieren k\xF6nnen: Ratgeber Textilsiegel',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(_ExternalLink.ExternalLink, { href: 'https://saubere-kleidung.de/wp-content/uploads/2018/10/menschenrechte_textilindustrie_2018.pdf' })
	          ),
	          _react2.default.createElement(
	            _LI.LI,
	            null,
	            'Wie ich seit zwei Jahren ohne Fast Fashion lebe (Berliner Zeitung vom 07.02.2019):',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(_ExternalLink.ExternalLink, { href: 'https://www.berliner-zeitung.de/ratgeber/nachhaltigkeit/so-lebe-ich-seit-zwei-jahren-ohne-fast-fashion-31948096' })
	          )
	        )
	      )
	    )
	  );
	};

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LE4_3 = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _P = __webpack_require__(8);
	
	var _Section = __webpack_require__(6);
	
	var _UL = __webpack_require__(7);
	
	var _LI = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LE4_3 = exports.LE4_3 = function LE4_3() {
	  return _react2.default.createElement(
	    _Section.Section,
	    null,
	    _react2.default.createElement(
	      _UL.UL,
	      null,
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        _react2.default.createElement(
	          _P.P,
	          { gapBefore: true },
	          'Jede Arbeitsgruppe stellt ihre Ergebnisse als ',
	          _react2.default.createElement(
	            'b',
	            null,
	            'Lernstation'
	          ),
	          ' f\xFCr alle vor. ',
	          _react2.default.createElement(
	            'b',
	            null,
	            'Diskutieren'
	          ),
	          ' Sie anschlie\xDFend im Klassenverband, was davon leicht umzusetzen ist bzw. was ggf. gegen eine Umsetzung spricht: z. B. Zeit oder Kosten f\xFCr Fair Trade. In diesem Zusammenhang k\xF6nnen Sie auch das Prinzip \u201ECost per Wear\u201C einf\xFChren, d. h. die Kosten f\xFCr jedes einzelne Mal, wenn man ein Kleidungsst\xFCck tr\xE4gt, ausrechnen lassen, wodurch Fair Fashion, die l\xE4nger haltbar ist als Fast Fashion, im Endeffekt nicht teurer ist. (Stichworte: Qualit\xE4t, Reduktion, Wertsch\xE4tzung etc.). Nach dem Prinzip des folgenden Films k\xF6nnen Sie Thesen und Antithesen aufstellen lassen:'
	        )
	      )
	    )
	  );
	};

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LE4_4 = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Section = __webpack_require__(6);
	
	var _UL = __webpack_require__(7);
	
	var _LI = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import { ExternalLink } from './ExternalLink';
	
	var LE4_4 = exports.LE4_4 = function LE4_4() {
	  return _react2.default.createElement(
	    _Section.Section,
	    null,
	    _react2.default.createElement(
	      _UL.UL,
	      null,
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        'Erweitern Sie abschlie\xDFend die ',
	        _react2.default.createElement(
	          'b',
	          null,
	          'Mind-Map'
	        ),
	        ' aus der Lerneinheit 1 um neue Begriffe, die den SuS nun noch zus\xE4tzlich einfallen.'
	      )
	    )
	  );
	};
	
	// import { P } from '../P/P';

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.MORE_MATERIAL_AND_TIPS = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _P = __webpack_require__(8);
	
	var _Section = __webpack_require__(6);
	
	var _UL = __webpack_require__(7);
	
	var _LI = __webpack_require__(5);
	
	var _ExternalLink = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MORE_MATERIAL_AND_TIPS = exports.MORE_MATERIAL_AND_TIPS = function MORE_MATERIAL_AND_TIPS() {
	  return _react2.default.createElement(
	    _Section.Section,
	    null,
	    _react2.default.createElement(
	      _UL.UL,
	      null,
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        _react2.default.createElement(
	          _P.P,
	          { gapAfter: true },
	          'Bayerischer Rundfunk: Erkl\xE4rfilm Fast Fashion/Fakten und Zahlen im \xDCberblick. Geeignet als Einf\xFChrung/zur Relevanz des Themas.',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(_ExternalLink.ExternalLink, { href: 'http://www.br.de/puls/themen/leben/fast-fashion-in-zahlen-102.html' })
	        )
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        _react2.default.createElement(
	          _P.P,
	          { gapAfter: true },
	          'Wanderausstellung Fast Fashion, Schattenseite der Mode:',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(_ExternalLink.ExternalLink, { href: 'http://www.fastfashion-dieausstellung.de' }),
	          '(Bei Redaktionsschluss standen keine Termine in Deutschland fest)'
	        )
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        _react2.default.createElement(
	          _P.P,
	          { gapAfter: true },
	          'Ausstellung (Berlin): Fast Fashion \u2013 Slow Fashion 27.09.2019 bis 02.08.2020 im Museum Europ\xE4ischer Kulturen:',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            _ExternalLink.ExternalLink,
	            { href: 'https://www.smb.museum/ausstellungen/detail/fast-fashion-slow-fashion.html' },
	            'https://www.smb.museum\u2026fast-fashion-slow-fashion.html'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        _react2.default.createElement(
	          _P.P,
	          { gapAfter: true },
	          'Bundeszentrale f\xFCr politische Bildung 2018: Was geht? Modekonsum. Sch\xFClermagazin und Begleitheft f\xFCr P\xE4dagogen.',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            _ExternalLink.ExternalLink,
	            { href: 'https://www.bpb.de/shop/lernen/was-geht/275495/wie-sieht-s-aus-das-heft-ueber-fashion-und-style' },
	            'https://www.bpb.de\u2026heft-ueber-fashion-und-style'
	          ),
	          ', Bestellnummer: 9617'
	        )
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        _react2.default.createElement(
	          _P.P,
	          { gapAfter: true },
	          'AKTIV werden: Mit der Initiative MAKE SMTHNG m\xF6chte Greenpeace die Maker-Community unterst\xFCtzen und bietet daf\xFCr auch Unterrichtsimpulse mit Hintergrundinformationen zu Fast Fashion:',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            _ExternalLink.ExternalLink,
	            { href: 'https://www.greenpeace.de/sites/www.greenpeace.de/files/gpbm_konsum_shoppen_oder_selbermachen_0.pdf' },
	            'https://www.greenpeace.de\u2026oder_selbermachen_0.pdf'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        _react2.default.createElement(
	          _P.P,
	          { gapAfter: true },
	          'Dokumentationsserie \xFCber eine Fashion-Bloggerin aus Norwegen, die in die Textilproduktion eintaucht:',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(_ExternalLink.ExternalLink, { href: 'https://www.aftenposten.no/norge/i/4d1nl9/Video-fra-Aftenposten?category=10514' }),
	          '(OV mit englischen Untertiteln), Bericht in deutscher Sprache hier\xFCber:',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(_ExternalLink.ExternalLink, { href: 'https://www.br.de/puls/themen/leben/deadly-fashion-interview-frida-ottesen-100.html' }),
	          _react2.default.createElement('br', null),
	          'Bemerkung: Die Serie ist gut geeignet, da sich junge Menschen mit der Bloggerin gut identifizieren k\xF6nnen. Sie kann aber auch eine sehr aufw\xFChlende Wirkung haben. Suchen Sie sich daher vorher genau aus, welche Folge Sie im Klassenraum zeigen m\xF6chten.'
	        )
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        _react2.default.createElement(
	          _P.P,
	          { gapAfter: true },
	          'Film \u201EThe true Cost\u201D.\xA0',
	          _react2.default.createElement(_ExternalLink.ExternalLink, { href: 'https://truecostmovie.com/' }),
	          _react2.default.createElement('br', null),
	          'Wenn es Ihnen nicht m\xF6glich ist, den Film zu bestellen/zu zeigen, k\xF6nnen Sie viele Informationen aus den begleitenden Materialien ziehen, z. B. Rollenspiel zur Wertsch\xF6pfungskette ab Seite 26:',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            _ExternalLink.ExternalLink,
	            { href: 'http://grandfilm.de/wp-content/uploads/2016/03/Schulmaterial_TheTrueCost_DerPreisDerMode.pdf' },
	            'http://grandfilm.de\u2026TheTrueCost_DerPreisDerMode.pdf'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        _react2.default.createElement(
	          _P.P,
	          { gapAfter: true },
	          'Podcast \u201EWardrobe Crisis\u201D von Clare Press (Englisch), ggf. zum f\xE4cherverbindenden Einsatz:',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(_ExternalLink.ExternalLink, { href: 'https://www.clarepress.com/podcast' })
	        )
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        _react2.default.createElement(
	          _P.P,
	          { gapAfter: true },
	          '\u201EDas B\xFCndnis f\xFCr nachhaltige Textilien ist eine Multistakeholder-Initiative mit rund 130 Mitgliedern aus Wirtschaft, Politik und Zivilgesellschaft. Sie wollen gemeinsam die Bedingungen in der weltweiten Textilproduktion verbessern \u2013 von der Rohstoffproduktion bis zur Entsorgung. Das Textilb\xFCndnis wurde im Oktober 2014 als Antwort auf t\xF6dliche Unf\xE4lle in Textilfabriken in Bangladesch und Pakistan gegr\xFCndet. Initiator war Bundesentwicklungsminister Dr. Gerd M\xFCller. Die Mitglieder des Textilb\xFCndnisses decken heute rund die H\xE4lfte des deutschen Textilmarktes ab. Eine Marktabdeckung von 75 Prozent soll realisiert werden.\u201D:\xA0',
	          _react2.default.createElement(_ExternalLink.ExternalLink, { href: 'https://www.textilbuendnis.com/' })
	        )
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        _react2.default.createElement(
	          _P.P,
	          { gapAfter: true },
	          'Greenpeace: Konsumkollaps durch Fast Fashion:',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            _ExternalLink.ExternalLink,
	            { href: 'https://www.greenpeace.de/sites/www.greenpeace.de/files/publications/s01951_greenpeace_report_konsumkollaps_fast_fashion.pdf' },
	            'https://www.greenpeace.de\u2026konsumkollaps_fast_fashion.pdf'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _LI.LI,
	        null,
	        _react2.default.createElement(
	          _P.P,
	          { gapAfter: true },
	          'Utopia.de berichtet immer wieder \xFCber erschwingliche, attraktive und nachhaltige Mode (und \xFCber weitere Themen zu Nachhaltigkeit)',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(_ExternalLink.ExternalLink, { href: 'https://utopia.de/ratgeber/fair-fashion-marken-shops/' })
	        )
	      )
	    )
	  );
	};

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.OL = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n\n  list-style-type: lower-roman;\n\n  padding-left: 20px;\n\n'], ['\n\n  list-style-type: lower-roman;\n\n  padding-left: 20px;\n\n']);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _P = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var OL = exports.OL = (0, _styled2.default)(_P.P)(_templateObject).withComponent('ol');

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  width: ', 'px;\n  height: ', 'px;\n\n  transform: rotate(-6deg);\n\n  ', ' {\n    width: ', 'px;\n    height: ', 'px;\n  }\n\n  text-align: center;\n'], ['\n  width: ', 'px;\n  height: ', 'px;\n\n  transform: rotate(-6deg);\n\n  ', ' {\n    width: ', 'px;\n    height: ', 'px;\n  }\n\n  text-align: center;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  color: ', ' !important;\n  background-color: transparent !important;\n\n  margin-top: 15px;\n  ', ' {\n    margin-top: 10px;\n  }\n'], ['\n  color: ', ' !important;\n  background-color: transparent !important;\n\n  margin-top: 15px;\n  ', ' {\n    margin-top: 10px;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  color: ', ' !important;\n  background-color: transparent !important;\n\n  margin-top: 0;\n\n  transform: rotate(6deg);\n'], ['\n  color: ', ' !important;\n  background-color: transparent !important;\n\n  margin-top: 0;\n\n  transform: rotate(6deg);\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _GrafikPDFDownload = __webpack_require__(140);
	
	var _GrafikPDFDownload2 = _interopRequireDefault(_GrafikPDFDownload);
	
	var _DownloadMaterialButton = __webpack_require__(54);
	
	var _DownloadMaterialButton2 = _interopRequireDefault(_DownloadMaterialButton);
	
	var _DownloadPdf = __webpack_require__(88);
	
	var _DownloadPdf2 = _interopRequireDefault(_DownloadPdf);
	
	var _colors = __webpack_require__(9);
	
	var _breakpoints = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var CTA_DESKTOP_SIZE = 270;
	var CTA_SIZE = 250;
	
	var Container = _styled2.default.article(_templateObject, CTA_DESKTOP_SIZE, CTA_DESKTOP_SIZE, _breakpoints.mediaTablet, CTA_SIZE, CTA_SIZE);
	
	var DownloadMaterialButton1st = (0, _styled2.default)(_DownloadMaterialButton2.default)(_templateObject2, _colors.TextColor, _breakpoints.mediaTablet);
	
	var DownloadMaterialButton2nd = (0, _styled2.default)(_DownloadMaterialButton2.default)(_templateObject3, _colors.TextColor);
	
	var CTA = function CTA(_ref) {
	  var className = _ref.className;
	  return _react2.default.createElement(
	    _DownloadPdf2.default,
	    { className: className },
	    _react2.default.createElement(
	      Container,
	      null,
	      _react2.default.createElement(_GrafikPDFDownload2.default, { insideCTA: true }),
	      _react2.default.createElement(DownloadMaterialButton1st, { noicon: true, nolink: true }),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(DownloadMaterialButton2nd, { nolabel: true, nolink: true })
	    )
	  );
	};
	
	CTA.propTypes = {
	  className: _propTypes2.default.string
	};
	
	CTA.defaultProps = {
	  className: undefined
	};
	
	exports.default = CTA;
	module.exports = exports['default'];

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n\n  padding: 0;\n  height: 310px;\n  width: 310px;\n\n  color: ', ';\n  background-color: none;\n  border-radius: 50%;\n\n  @media (min-width: 980px) {\n    padding: 15px;\n    height: 340px;\n    width: 340px;\n\n    color: ', ';\n    background-color: ', ';\n  }\n'], ['\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n\n  padding: 0;\n  height: 310px;\n  width: 310px;\n\n  color: ', ';\n  background-color: none;\n  border-radius: 50%;\n\n  @media (min-width: 980px) {\n    padding: 15px;\n    height: 340px;\n    width: 340px;\n\n    color: ', ';\n    background-color: ', ';\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: block;\n  width: 30px;\n  height: 30px;\n  background-color: ', ';\n  border-radius: 50%;\n  margin-bottom: 25px;\n\n  @media (max-width: 979px) {\n    display: none;\n  }\n'], ['\n  display: block;\n  width: 30px;\n  height: 30px;\n  background-color: ', ';\n  border-radius: 50%;\n  margin-bottom: 25px;\n\n  @media (max-width: 979px) {\n    display: none;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _colors = __webpack_require__(9);
	
	var _ModebewusstSVG = __webpack_require__(249);
	
	var _ModebewusstSVG2 = _interopRequireDefault(_ModebewusstSVG);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styled2.default.div(_templateObject, _colors.TextColor, _colors.ActionTextColor, _colors.ActionColor);
	
	var HoleApplique = _styled2.default.div(_templateObject2, _colors.ActionTextColor);
	
	exports.default = function () {
	  return _react2.default.createElement(
	    Container,
	    null,
	    _react2.default.createElement(HoleApplique, null),
	    _react2.default.createElement(_ModebewusstSVG2.default, null)
	  );
	};
	
	module.exports = exports['default'];

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "svg",
	    { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 286 255", style: { width: '286px', height: '255px' } },
	    _react2.default.createElement("path", { fill: "currentColor", d: "M165.45,233c-1.91.23-5.14,1.6-9.63,4.14-.37,0-.73,3-1.13,8.78a5.93,5.93,0,0,0,.69,2.19c.29,2.52,2.58,3.71,6.88,3.7l1.48-.18c5.59-1.43,8.23-3.23,8-5.3a5.2,5.2,0,0,0,1.3-3.57c0-.17-.14-.73-.42-1.77a16,16,0,0,1,.51-3c-.1-.9-.21-1.34-.37-1.32-.28-2.41-2.73-3.64-7.3-3.65M151,160.9c-1.3.79-1.92,1.49-1.91,2.06a34.72,34.72,0,0,1,.63,3.56l.13,1.12c.16,1.4.23,3.38.25,5.88.08.67.34,2.4.82,5.13.05.5.05,2.78-.07,6.83a12.12,12.12,0,0,0,.74,2.64,8.79,8.79,0,0,0-.19,2.06l.42,3.59c.2,5.49.45,9.44.74,12l1.21,4.86c.14,2.54.57,7.14,1.17,13.72l.37,1.32c1.37,3,3.14,4.39,5.21,4.14a29.28,29.28,0,0,0,7.9-2.34c1.11-.14,1.62-2.24,1.41-6.31l-.15-1.35q-3.32-13.23-4.11-13.13c1.05-.65,1.45-2.34,1.12-5.15a9.56,9.56,0,0,0,.91-5.11l-.49-4.26,0-1.59c-.16,0-.36-.24-.53-.85a34.73,34.73,0,0,0-.13-4.76l-.26-2.24a30.11,30.11,0,0,0-.92-4.21,40.93,40.93,0,0,1-.09-4.53l-.88-1.94a37.87,37.87,0,0,0,.09-4.79l0-.22a8.79,8.79,0,0,0-1.22-3c-.87-2.9-3.54-4.11-7.94-3.57Zm-15.81,78c-.83.27-1.23.55-1.2.83-3.89,2.13-5.73,4.34-5.47,6.58l0,.23c2,5.83,4.81,8.5,8.25,8.08l1.88-.46c4.7-2.57,6.85-5.84,6.38-9.88a14.66,14.66,0,0,0-1.29-3.7q-.23-1.94-8.58-1.68m-6.52-74.46a9.74,9.74,0,0,0-3.89,1.62c-2.6.31-5.39,2.7-8.42,7.17a16.9,16.9,0,0,0-1.71,9.3,10.8,10.8,0,0,0,.45,2,24.79,24.79,0,0,0-.3,4.82,10.69,10.69,0,0,1,.71,2.41c.16,1.4,2.18,2.12,6.06,2.21,0-.17.34-.32,1-.58,1.64-.2,2.75-1.76,3.32-4.72-.12-1.07-.38-2.8-.81-5.13a22.78,22.78,0,0,1,.35-4.37,14.11,14.11,0,0,1,2.13-7.54,2.53,2.53,0,0,1,1.12.32,9.7,9.7,0,0,1,3.59,6.84l.31,2.69a10,10,0,0,1-.83,4c-2.45,6.16-3.61,9.6-3.54,10.22l-2.19,10.73a25.27,25.27,0,0,1-.63,9.39,10.87,10.87,0,0,1,.45,2l0,.22a8.91,8.91,0,0,1-.19,2.07l1.37,6.2c2.13,4.91,4.7,7.15,7.67,6.79,3.59-1.07,5.29-2.59,5.07-4.49a7.27,7.27,0,0,0,1.57-3.15l-.34-1.09a26.21,26.21,0,0,1-.21-3.62,12.89,12.89,0,0,1-.5-2.44,31.09,31.09,0,0,0,.91-5.11,10.05,10.05,0,0,0-.84-1.72c0-.28,0-.45.16-.47-.4-3.42-.16-5.55.75-6.46a21.27,21.27,0,0,1,.68-7.13c2.17-4,3.34-6.38,3.45-7.25a17.81,17.81,0,0,1,.89-7.16,21.48,21.48,0,0,0-2.5-6.74c-.34-2.91-2.16-5.59-5.45-8a10.39,10.39,0,0,0-9.69-3.81" }),
	    _react2.default.createElement("path", { fill: "currentColor", d: "M270.87,53l-2.12.26a21.64,21.64,0,0,0-2.94.59,1.56,1.56,0,0,0-.88-.12c-.42,0-.63.14-.61.3a115,115,0,0,0-15.25,3.87c-3.11.49-4.58,2.61-4.43,6.28a2.85,2.85,0,0,0,1.54,2.09c4.57.06,7.54.15,8.85.27,2.29,16,4.13,26.73,5.45,32.08l0,3.86a38.47,38.47,0,0,1,1.5,7.32l.49,4.26.47,2.22c-.16,0-.21.93-.11,2.74.14,1.17.26,1.78.42,1.76,1.44,12.39,3.24,20,5.45,22.76.82,1.09,2.48,1.51,5.08,1.19,6.54-1.54,9.72-3.3,9.49-5.26a52.42,52.42,0,0,0-2.1-7c-.09-.72-.11-2.77-.07-6.13l-.05-.45a23.76,23.76,0,0,0-1.82-6.37l0-2c-.05-.39-.57-3.51-1.52-9.36l-.1-.9a43.44,43.44,0,0,1-.15-5,43.37,43.37,0,0,0-1.19-4.63,25.48,25.48,0,0,1,.09-3l-2-10,0-3.42A12.68,12.68,0,0,0,272.7,78,11,11,0,0,0,273,75.2a61.93,61.93,0,0,0-2.43-7.89,10.93,10.93,0,0,1,0-1.82l5.93-.73a16.71,16.71,0,0,0,5.2-1.55c3.09-1.63,4.49-3.9,4.14-6.87-.09-.79-.93-2-2.56-3.55-2.84.06-6.56,0-11.21-.22Zm-42.81,6.28a17.4,17.4,0,0,0-10.75,5.64c-2,1.67-3.31,4.33-3.8,8a20.75,20.75,0,0,0,.82,3.31,1.72,1.72,0,0,0-.11.93l.29,2.46c.06.56.77,3,2.13,7.24,1.09,4.3,4,9.57,8.71,15.76a29.52,29.52,0,0,0,4.36,7.88c1.18,3.72,2.23,5.8,3.09,6.21l.31,2.69a51.25,51.25,0,0,1,3.61,12.52c.06,1.92.06,4.2-.07,6.83l-.21,0c-1-.61-2.15-2.74-3.54-6.38-2.41-5.45-5.23-8-8.41-7.61-1,.18-1.46.35-1.43.63-2.81.35-4.08,1.92-3.75,4.78l.19,1.57a8.79,8.79,0,0,0,2.05,4.75,17.65,17.65,0,0,0,4.28,7.21c2.15,4.11,5.85,5.87,11.15,5.22.14-.19.66-.31,1.46-.41,3.07-.37,4.93-1.51,5.62-3.42a32.71,32.71,0,0,0,4.76-10.81,34.31,34.31,0,0,1,0-7.06c-.63-3.1-1.08-5.6-1.31-7.56l-.18-1.57c0-.17-.64-2.26-1.79-6.15a87.46,87.46,0,0,1-3.72-9.78,142.54,142.54,0,0,0-12.2-19.87c-2.06-4.24-3.24-7.45-3.48-9.58L226,71.08c1.22-.15,3.45,1.45,6.59,4.88a31.44,31.44,0,0,0,2.9,6.46c1,1.08,3,1.74,5.83,2,4.24-.52,6.26-1.63,6.07-3.25q-1.32-7.93-2.52-10.6c-5.11-8.3-10.71-12.11-16.8-11.36m-35.67,4.38a17.4,17.4,0,0,0-10.75,5.64c-2,1.67-3.31,4.33-3.8,8a20.75,20.75,0,0,0,.82,3.31,1.72,1.72,0,0,0-.11.93l.29,2.46c.06.56.77,3,2.13,7.24,1.09,4.3,4,9.57,8.71,15.76A29.52,29.52,0,0,0,194,114.8c1.19,3.72,2.23,5.8,3.09,6.21l.31,2.69a51.25,51.25,0,0,1,3.61,12.52c.06,1.92.06,4.2-.07,6.83l-.21,0c-1-.61-2.15-2.74-3.54-6.38-2.41-5.45-5.23-8-8.41-7.61-1,.18-1.46.35-1.43.63-2.81.35-4.08,1.92-3.75,4.78l.19,1.57a8.79,8.79,0,0,0,2,4.75,17.55,17.55,0,0,0,4.28,7.2c2.15,4.12,5.85,5.88,11.15,5.23.14-.19.66-.31,1.46-.41,3.07-.37,4.93-1.51,5.62-3.42a32.71,32.71,0,0,0,4.76-10.81,34.31,34.31,0,0,1,0-7.06c-.63-3.1-1.08-5.6-1.31-7.57l-.18-1.56c0-.17-.64-2.26-1.79-6.15a87.46,87.46,0,0,1-3.72-9.78A142.54,142.54,0,0,0,194,86.61c-2.06-4.24-3.24-7.45-3.48-9.58l-.19-1.57c1.22-.15,3.45,1.45,6.59,4.88a31.44,31.44,0,0,0,2.9,6.46c1,1.08,2.95,1.74,5.83,2,4.24-.52,6.26-1.63,6.07-3.25q-1.32-7.93-2.52-10.61c-5.11-8.29-10.71-12.1-16.8-11.35m-31.07,5.64c-2.87,1.14-4.2,2.73-3.95,4.8l.65,5.61a20.17,20.17,0,0,0,1,5.1l-.21,0a17.4,17.4,0,0,1,.79,3.08c0,1.82,0,2.72-.11,2.74,1,10.17,1.47,16.82,1.23,19.86-.48,6.94-.66,10.94-.55,11.89-.55,8.2-1.15,12.76-1.85,13.65a39.76,39.76,0,0,1-1.63-4.81l.21,0a71.51,71.51,0,0,1-2-9.54l-.39-3.36c-.14-1.18-.27-2.75-.34-4.73a1.77,1.77,0,0,1-.32-.87l.16-.48L153,106.65c0-2.11-.1-5-.36-8.6a86,86,0,0,1-2.26-8.36c-.12-1-.22-3.27-.36-6.78a20,20,0,0,0-1.42-4.82c-2-2.66-4.31-3.8-7.07-3.46,0,.17,0,.23-.18.25l0-.22-.4.28-1.27.15a11.93,11.93,0,0,0-4.75,1.72c-2,.24-2.81,1.71-2.49,4.4l.41,3.59Q135,116.42,135.4,120a71.46,71.46,0,0,0,5.21,20.73,57,57,0,0,0,7.79,11.55c2.94,2.65,5.45,3.88,7.52,3.63l.4-.28,0,.22.4-.27.21,0c3.13-.38,6.82-1.91,11.09-4.54a24.29,24.29,0,0,0,9.51-14.36c.63-.08.64-5.08,0-15a54.37,54.37,0,0,0,.58-13.49c-.17-1.45-.53-4.14-1.15-8l-.15-3.17-2.24-8.13c-2.44-7.6-4.7-13.18-6.67-16.69-1-2.33-2.86-3.29-5.72-2.94ZM76.84,81c-2.24,1.59-3.34,2.74-3.27,3.36,2.63,19.35,4.75,33,6.47,40.82Q84.14,149.3,87,156.82c1.62,4.18,4.1,6.09,7.54,5.67a40.46,40.46,0,0,0,7.05-2.23c1.54-.19,3-1.73,4.2-4.61a35.44,35.44,0,0,1,2.19-8.91q-.15-6.12.56-6.21c1.27,4.91,2.25,8.25,2.9,10.11,1.71,5,4.07,7.23,7,6.87q2.85,3.74,4.92,3.48l.42-.05c3.71-.45,6-2.62,7-6.54a131.56,131.56,0,0,1,1.7-15c-.71-12.59-.91-20.24-.52-22.9-.06-.5-.36-1.77-.86-3.76l.16-4.11c-.18-1.57-.42-3.19-.78-4.91-.15-2.65-.36-4.9-.57-6.75-1.22-6.27-2.15-10.14-2.84-11.47,0-.17-.06-1-.05-2.27-.5-1.93-1.3-2.8-2.46-2.65L122,80.9a11.89,11.89,0,0,0-2.51.53c-1.33.17-2.27,1.36-2.82,3.53l.18,1.57a15.26,15.26,0,0,1-.17,5.93c.18,1.52.42,7.74.66,18.57a8.15,8.15,0,0,0,.47,2.21c.44,5.18.72,9.86.77,14l.31,2.69-.21,0a27.41,27.41,0,0,0-2.08-5c-3.3-9.43-5.89-14.06-7.63-13.84l-1.7.21c-4.77,2-7.1,3.65-6.92,5.17-.18,7.24-.57,14.11-1.26,20.61l-.21,0c-.88-3.81-1.37-5.74-1.53-5.72-1.28-8.66-2.15-12.93-2.57-12.88.16,0,.19-1.1.06-3.19a7.32,7.32,0,0,0-1.22-3,1.69,1.69,0,0,0,.11-.92l-.21-1.8c-.6-2.82-1-5.32-1.31-7.57Q88.26,86.34,85.6,82.41c-1-1.53-3.68-2-8.13-1.5ZM46.69,84.8c0,.17-.71.31-2.25.5-2.88,1.55-4.23,3-4.09,4.14l.52,4.43a23.24,23.24,0,0,1,.13,3,8.22,8.22,0,0,1,.65,1.85,9.15,9.15,0,0,0,0,2.1l.09.84a8,8,0,0,0,.59,1.86l.6,13.85a61.3,61.3,0,0,0,1.25,7.13l.15,4.92A48.56,48.56,0,0,0,46,136.27c.12,3.28.28,6,.54,8.29a109.65,109.65,0,0,0,4.89,21.74c2.81,1.47,7.28,1.55,13.48.28,7.91-.81,12.35-3.34,13.29-7.72q-.3-2.52-5.22-1.91a75.81,75.81,0,0,1-7.58,1.38c-1,.12-1.49-.27-1.58-1.11l0-.4a31.49,31.49,0,0,1-.18-3.44c-.78-2-1.46-5.62-2.08-10.89l-.24-2.07-.08-2.55A9.69,9.69,0,0,1,60,135c-.14-3.46-.23-5.66-.34-6.61l-.37-3.2c-.09-.73-.28-1.9-.63-3.56.15,0,.18-.25.14-.64l-.26-.37.79-.1a49,49,0,0,1,6-2.89,5.13,5.13,0,0,0,4.75-4,3.45,3.45,0,0,0-1.58-2.42c0-.51-2.81-1.13-8.32-1.77-1.73.39-2.73.57-3,.61s-.7-1-1.16-3l.67-3.09c-.38-1.83-.6-3.28-.73-4.4l-.05-.45a8.91,8.91,0,0,1,.27-3.21,1.42,1.42,0,0,1,.82.12l.4-.27,0,.22,1-.35,2.49-.3c5.52-.68,9-3.1,10.39-7.3-.21-1.8-1.38-3.13-3.59-4-3.25.22-6.68.36-10.38.42a6.43,6.43,0,0,0-2.6.77,37.8,37.8,0,0,0-7.94-.33M25.05,141.85l0,.23c3.21,3.07,5,6,5.31,8.67s-.47,5.68-2.35,9.38l-.21,0,0-.23a138.29,138.29,0,0,0-3-16.68,8.3,8.3,0,0,1,.05-1.37ZM15.44,96.2c2.1.93,3.43,3.61,4,8.15l0,.22a56.72,56.72,0,0,1,0,9.1l-.21,0L15.49,96.64ZM7.19,86.29a21,21,0,0,1-2.73.57q-4.36.54-4.46,6l.63,3.56c.12,4.71.22,7.48.33,8.38.4,2,.84,4,1.31,5.75.66,7,1,11.87,1.06,14.65a44,44,0,0,0,1.92,9.08,186.78,186.78,0,0,0,3.83,20c1.25,10.7,2.84,17,4.79,19,.17,1.46,2,2.09,5.37,1.84a38,38,0,0,0,7.48-2.28,12.47,12.47,0,0,0,3.1.76c2.21-.9,3.25-1.65,3.18-2.21l4.14-1.42q6.28-6.92,5.77-11.4c1.25-1.68,1.63-4.4,1.2-8.1l0-.45c-.49-4.26-1.5-7.38-3-9.41a15.43,15.43,0,0,0-6.11-4.47c-2-2.44-5.13-3.92-9.56-4.51a7.5,7.5,0,0,0,.62-4l1.83-2.72Q30.18,112,29.2,103.6A28.5,28.5,0,0,0,25,91.39c-4.43-3.38-7.94-4.94-10.43-4.64l-.64.08-1.24.38Z" }),
	    _react2.default.createElement("path", { fill: "currentColor", d: "M161.11.62c0,.12-.52.23-1.63.37-2.08,1.12-3,2.14-2.95,3l.37,3.19a15,15,0,0,1,.1,2.17,5.78,5.78,0,0,1,.47,1.34,6.31,6.31,0,0,0,0,1.51l.07.61a5.09,5.09,0,0,0,.43,1.34l.42,10a43.81,43.81,0,0,0,.91,5.15l.1,3.55a34.14,34.14,0,0,0,1.2,4.95c.08,2.37.2,4.36.39,6a78.26,78.26,0,0,0,3.53,15.7c2,1.06,5.25,1.12,9.73.2,5.71-.58,8.92-2.41,9.6-5.57-.14-1.21-1.4-1.68-3.77-1.39a50.32,50.32,0,0,1-5.48,1c-.69.09-1.07-.19-1.14-.8l0-.28a23.75,23.75,0,0,1-.14-2.49,37.4,37.4,0,0,1-1.49-7.86l-.18-1.5-.06-1.84a7.12,7.12,0,0,1-.86-2.07c-.09-2.49-.16-4.08-.24-4.77l-.27-2.3c-.06-.53-.2-1.38-.45-2.58.11,0,.13-.18.1-.46l-.19-.26.57-.07a35.9,35.9,0,0,1,4.3-2.09A3.71,3.71,0,0,0,178,21.45a2.47,2.47,0,0,0-1.13-1.74c0-.37-2-.82-6-1.28-1.25.28-2,.41-2.2.44s-.51-.72-.84-2.2l.48-2.23c-.27-1.32-.43-2.37-.53-3.18l0-.32a6.65,6.65,0,0,1,.2-2.33,1,1,0,0,1,.59.1l.29-.2,0,.16.71-.25,1.8-.22c4-.49,6.49-2.24,7.5-5.28A3.69,3.69,0,0,0,176.21,0c-2.34.17-4.82.26-7.49.3a4.88,4.88,0,0,0-1.88.56,27.16,27.16,0,0,0-5.73-.24M145.77,50.9l-.16,0,0-.33.15,0Zm.29-1.52-.16,0,0-.32.15,0Zm-6.18-41.1q6,7.88,7.66,21.88l.14,1.13a35.69,35.69,0,0,1,.11,9c.26,2.22-.3,5.08-1.64,8.57l-.15,0,0-.16a3.06,3.06,0,0,0,.16-1.34L145,37.21a26.86,26.86,0,0,0-.7-3.37s-.05-.77-.09-2.12l-.29-1.11a10.28,10.28,0,0,0-.07-2l0-.33c-.29-1.48-.57-2.22-.88-2.19A7.37,7.37,0,0,0,143,24.8c-.29-2.47-1-4-2.1-4.67l-.37-3.24-3.73-10.7ZM134.46.41c-5.49.88-8.14,2.15-8,3.76a12,12,0,0,0,.9,2.36l.24,2.1c.37,3.2.81,6.59,1.34,10.18l.34,5.54.55,2.07a38,38,0,0,0,.24,4.73,38.48,38.48,0,0,0,1,5c-.11.71-.18,1.09-.18,1.17.24,2.06.71,4.72,1.39,7.87l.22,2a40.72,40.72,0,0,0,1,5.95,41.47,41.47,0,0,0,2.75,10.33c.88,1.21,2.33,1.68,4.36,1.44a3.2,3.2,0,0,0,3.12,1.42c2.64-.33,5.08-3.29,7.34-8.95l2-1.72a7.94,7.94,0,0,1,2.15-4.2,52.23,52.23,0,0,1,1.64-7.26,37.2,37.2,0,0,1,.45-6.79,16.57,16.57,0,0,0-.39-2.08,43.74,43.74,0,0,0-.15-5.24,38.4,38.4,0,0,0-1-4.31,19.76,19.76,0,0,0-.12-2.29,33.28,33.28,0,0,0-2.6-7.72,47,47,0,0,0-7.35-11.09c-2.45-3.43-6.15-4.82-11.05-4.22ZM113.7,16.79c.87,2.15,1.93,4.93,3.14,8.31a12,12,0,0,0,0,1.8l.09.81c.87,3.79,1.38,6.52,1.58,8.18a76.76,76.76,0,0,1,.52,9.79c-.18,4.16-.63,7-1.36,8.37l-.15,0a90.33,90.33,0,0,1-3.44-14.84l-.19-1.62a11.2,11.2,0,0,0-.36-1.76,27.74,27.74,0,0,0-.31-5.38l-.08-.65a1.93,1.93,0,0,0,.33-1.19l-.32-2.75a73.38,73.38,0,0,1,.34-9.07Zm.57-8.44a20.22,20.22,0,0,0-7.34,2.37,5.44,5.44,0,0,0-2.51,2.45c-1.31,6.39-1.9,10.29-1.74,11.7a41.72,41.72,0,0,0-.57,7.13,1.08,1.08,0,0,0,.21.47c-.48.22-.45,2.8.12,7.7l.08.65c.16,1.37.38,3,.7,4.67l0,3.11c.13.11.21.51.3,1.28a38.82,38.82,0,0,0,4.06,9.52c1.6,3.74,3.7,5.45,6.34,5.13l.61-.08a20.86,20.86,0,0,0,3.76-1.11,20.47,20.47,0,0,0,3.9.17,3.1,3.1,0,0,0,3-2.5c1.18-.14,1.85-1.41,2-3.86A15.32,15.32,0,0,0,129,49.23a59.8,59.8,0,0,0-.14-9.18l0-.32a48.19,48.19,0,0,0-1.82-9,34.11,34.11,0,0,0,.22-3.48c-.06-.53-.13-.8-.25-.79a32.14,32.14,0,0,0-3.49-11.39q-3-7.51-9.17-6.75m-25,.28a15.6,15.6,0,0,0-2.12.42c-2.24.44-3.26,1.39-3.09,2.85l.19,1.61c0,12.16-.39,19.63-1.11,22.47l-.15,0c-.23-.92-.5-2-.82-3-2.38-5.46-3.68-8.91-3.85-10.37-.46-1.66-1.81-3.63-4.1-5.89-.73-1.93-1.27-3-1.6-3.09a5.93,5.93,0,0,0-3.71-1.19L66,12.8c-1.49.18-2.62,1.47-3.43,3.87.47,2.36.77,3.89.86,4.65a37.94,37.94,0,0,1,.14,5.24c.31,1.65.52,3.14.68,4.51L64.54,34c0,.28.11,2,.29,5.22l.25,2.1c0,.28.34,2,.91,5.14l.49,4.21A57.94,57.94,0,0,0,69,61.35a21.75,21.75,0,0,0,3.37,8.95c2,1.51,3.79,2.16,5.2,2,3-1,4.48-1.58,4.45-1.86,1.41-.18,2.39-1.45,3-3.82a27.34,27.34,0,0,0-1-4.47c-1.75-5.37-2.68-8.33-2.74-8.86-.14-1.21-.28-2.8-.39-4.71L80.33,47c1.06.4,2.93.46,5.61.13l1.78-.71q3.42-2.64,2.49-10.65l.15,0,.4,3.4a37.94,37.94,0,0,1,.14,5.24l.32,2.75q.56,4.73.79,16.15a13.43,13.43,0,0,0,1.45,4.42,5,5,0,0,0,4.74,2,9.35,9.35,0,0,0,1.66-.37c2.19-.92,3-3.69,2.45-8.35-.15-1.25-.44-2.77-.85-4.65a21.86,21.86,0,0,0,1-6.36l-.09-.81c-.23-2-1.62-6.28-4.15-13L98,35a22,22,0,0,0,.22-3.47,13.48,13.48,0,0,0-.42-2.25A29.54,29.54,0,0,0,97.76,26c-.48-2.49-.78-4-.85-4.66l-.36-3.07a2.68,2.68,0,0,0-1.16-2,32,32,0,0,0-2.17-5.32,5.42,5.42,0,0,0-4-2.3" })
	  );
	};
	
	module.exports = exports["default"];

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Hero = __webpack_require__(248);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Hero).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  justify-content: flex-end;\n'], ['\n  display: flex;\n  justify-content: flex-end;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _emotion = __webpack_require__(22);
	
	var _BFBLogo = __webpack_require__(212);
	
	var _BFBLogo2 = _interopRequireDefault(_BFBLogo);
	
	var _DPLLogo = __webpack_require__(214);
	
	var _DPLLogo2 = _interopRequireDefault(_DPLLogo);
	
	var _breakpoints = __webpack_require__(4);
	
	var _Logo = __webpack_require__(92);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Layout = _styled2.default.section(_templateObject);
	
	var Logos = function Logos() {
	  var _css;
	
	  return _react2.default.createElement(
	    Layout,
	    null,
	    _react2.default.createElement(_BFBLogo2.default, {
	      labelStyles: _Logo.HideLogoLabelOnPhoneStyles,
	      imageStyles: _BFBLogo.BFBLogoSmallOnPhone
	    }),
	    _react2.default.createElement(_DPLLogo2.default, {
	      className: (0, _emotion.css)((_css = {
	        marginLeft: '93px'
	      }, _css[_breakpoints.mediaPhone] = {
	        marginLeft: '52px'
	      }, _css)),
	      labelStyles: (0, _emotion.css)(_Logo.HideLogoLabelOnPhoneStyles, 'text-align: right;'),
	      imageStyles: _DPLLogo.DPLLogoSmallOnPhone
	    })
	  );
	};
	
	exports.default = Logos;
	module.exports = exports['default'];

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  position: relative;\n\n  padding-top: 25px;\n\n  text-align: center;\n\n  ', ' {\n    top: 0;\n    left: 25px;\n  }\n'], ['\n  position: relative;\n\n  padding-top: 25px;\n\n  text-align: center;\n\n  ', ' {\n    top: 0;\n    left: 25px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: relative;\n\n  padding-top: 60px;\n  padding-bottom: 40px;\n'], ['\n  position: relative;\n\n  padding-top: 60px;\n  padding-bottom: 40px;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  display: inline-block;\n\n  z-index: 20;\n\n  ', ' {\n    order: 20;\n    position: relative;\n    top: -80px;\n    margin-bottom: -80px;\n  }\n\n  @media (max-width: 576px) { margin-bottom: -100px; }\n  @media (max-width: 475px) { margin-bottom: -120px; }\n'], ['\n  display: inline-block;\n\n  z-index: 20;\n\n  ', ' {\n    order: 20;\n    position: relative;\n    top: -80px;\n    margin-bottom: -80px;\n  }\n\n  @media (max-width: 576px) { margin-bottom: -100px; }\n  @media (max-width: 475px) { margin-bottom: -120px; }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  display: block;\n  @media (max-width: 979px) {\n    margin-top: 85px;\n  }\n'], ['\n  display: block;\n  @media (max-width: 979px) {\n    margin-top: 85px;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  display: inline-block;\n\n  position: absolute;\n  z-index: 10;\n\n  top: -40px;\n  left: 50px;\n\n  @media (max-width: 979px) {\n    position: relative;\n    top: auto;\n    left: auto;\n  }\n'], ['\n  display: inline-block;\n\n  position: absolute;\n  z-index: 10;\n\n  top: -40px;\n  left: 50px;\n\n  @media (max-width: 979px) {\n    position: relative;\n    top: auto;\n    left: auto;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  margin-top: -130px;\n\n  @media (min-width: 980px) {\n    margin-left: -290px;\n  }\n'], ['\n  margin-top: -130px;\n\n  @media (min-width: 980px) {\n    margin-left: -290px;\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  transform: rotate(-6deg);\n  display: inline-block;\n  width: 340px;\n\n  @media (max-width: 979px) {\n    position: relative;\n    top: -295px;\n    left: -15px;\n    margin-top: -95px;\n  }\n  @media (min-width: 980px) {\n    position: absolute;\n    top: 150px;\n    left: 68%;\n  }\n  @media (min-width: 1100px) {\n    left: 66%;\n  }\n'], ['\n  transform: rotate(-6deg);\n  display: inline-block;\n  width: 340px;\n\n  @media (max-width: 979px) {\n    position: relative;\n    top: -295px;\n    left: -15px;\n    margin-top: -95px;\n  }\n  @media (min-width: 980px) {\n    position: absolute;\n    top: 150px;\n    left: 68%;\n  }\n  @media (min-width: 1100px) {\n    left: 66%;\n  }\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n  ', ';\n  display: inline-block;\n  max-width: 360px;\n  line-height: 1.1;\n  text-transform: uppercase;\n  font-size: 26px;\n  text-align: left;\n'], ['\n  ', ';\n  display: inline-block;\n  max-width: 360px;\n  line-height: 1.1;\n  text-transform: uppercase;\n  font-size: 26px;\n  text-align: left;\n']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n  display: inline-block;\n  font-weight: 400;\n  color: #fff;\n  background-color: #000;\n  padding: 0 6px;\n'], ['\n  display: inline-block;\n  font-weight: 400;\n  color: #fff;\n  background-color: #000;\n  padding: 0 6px;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _Logos = __webpack_require__(251);
	
	var _Logos2 = _interopRequireDefault(_Logos);
	
	var _CTA = __webpack_require__(247);
	
	var _CTA2 = _interopRequireDefault(_CTA);
	
	var _Hero = __webpack_require__(250);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _PageLayout = __webpack_require__(142);
	
	var _PageLayout2 = _interopRequireDefault(_PageLayout);
	
	var _Stacheldraht = __webpack_require__(55);
	
	var _Stacheldraht2 = _interopRequireDefault(_Stacheldraht);
	
	var _breakpoints = __webpack_require__(4);
	
	var _fonts = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Header = _styled2.default.header(_templateObject, _breakpoints.minDesktop);
	
	var Content = _styled2.default.div(_templateObject2);
	
	var HeroStyled = (0, _styled2.default)(_Hero2.default)(_templateObject3, _breakpoints.mediaPhone);
	
	var CTAContainer = _styled2.default.div(_templateObject4);
	
	var CTAStyled = (0, _styled2.default)(_CTA2.default)(_templateObject5);
	
	var StacheldrahtLeftBig = (0, _styled2.default)(_Stacheldraht2.default)(_templateObject6);
	
	var SubTitle = _styled2.default.div(_templateObject7);
	
	var SubTitleHeadline = _styled2.default.h2(_templateObject8, _fonts.HeadlineFont);
	
	var SubTitleHeadlineB = _styled2.default.b(_templateObject9);
	
	var PageHeader = function PageHeader() {
	  return _react2.default.createElement(
	    Header,
	    null,
	    _react2.default.createElement(
	      _PageLayout2.default,
	      null,
	      _react2.default.createElement(_Logos2.default, null),
	      _react2.default.createElement(
	        Content,
	        null,
	        _react2.default.createElement(
	          CTAContainer,
	          null,
	          _react2.default.createElement(CTAStyled, null)
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            SubTitle,
	            null,
	            _react2.default.createElement(
	              SubTitleHeadline,
	              null,
	              'Vier Lerneinheiten zum Thema',
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                SubTitleHeadlineB,
	                null,
	                'nachhaltiger Modekonsum'
	              ),
	              _react2.default.createElement('br', null),
	              'f\xFCr die SekundarStufe'
	            ),
	            _react2.default.createElement(_Stacheldraht2.default, { small: true })
	          )
	        ),
	        _react2.default.createElement(HeroStyled, null),
	        _react2.default.createElement(StacheldrahtLeftBig, null)
	      )
	    )
	  );
	};
	
	exports.default = PageHeader;
	module.exports = exports['default'];

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PageHeader = __webpack_require__(252);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PageHeader).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin-left: auto;\n  margin-right: auto;\n\n  padding: 0 ', 'px;\n\n  ', ' {\n    padding: 0 ', 'px;\n  }\n\n  ', ' {\n    max-width: ', 'px;\n    padding: 0 ', 'px;\n  }\n'], ['\n  margin-left: auto;\n  margin-right: auto;\n\n  padding: 0 ', 'px;\n\n  ', ' {\n    padding: 0 ', 'px;\n  }\n\n  ', ' {\n    max-width: ', 'px;\n    padding: 0 ', 'px;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _breakpoints = __webpack_require__(4);
	
	var _pageLayout = __webpack_require__(143);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Layout = _styled2.default.div(_templateObject, _pageLayout.PHONE_MARGIN, _breakpoints.minTablet, _pageLayout.TABLET_MARGIN, _breakpoints.minDesktop, _pageLayout.DESKTOP_WIDTH + _pageLayout.DESKTOP_MARGIN * 2, _pageLayout.DESKTOP_MARGIN);
	
	var PageLayout = function PageLayout(_ref) {
	  var className = _ref.className,
	      children = _ref.children;
	  return _react2.default.createElement(
	    Layout,
	    { className: className },
	    children
	  );
	};
	
	PageLayout.propTypes = {
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.node.isRequired
	};
	
	PageLayout.defaultProps = {
	  className: undefined
	};
	
	exports.default = PageLayout;
	module.exports = exports['default'];

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin-left: 25px;\n  margin-right: 25px;\n\n  ', ' {\n    margin-left: 40px;\n    margin-right: 40px;\n  }\n\n  @media (min-width: 980px) {\n    padding-top: 50px;\n  }\n\n  ', ' {\n    width: ', 'px;\n    margin-left: auto;\n    margin-right: auto;\n\n    background-color: ', ';\n  }\n'], ['\n  margin-left: 25px;\n  margin-right: 25px;\n\n  ', ' {\n    margin-left: 40px;\n    margin-right: 40px;\n  }\n\n  @media (min-width: 980px) {\n    padding-top: 50px;\n  }\n\n  ', ' {\n    width: ', 'px;\n    margin-left: auto;\n    margin-right: auto;\n\n    background-color: ', ';\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _breakpoints = __webpack_require__(4);
	
	var _colors = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var DESKTOP_WIDTH = 1180;
	
	var Main = _styled2.default.main(_templateObject, _breakpoints.minTablet, _breakpoints.minDesktop, DESKTOP_WIDTH, _colors.SecondaryBackColor);
	
	var PageMainLayout = function PageMainLayout(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    Main,
	    null,
	    children
	  );
	};
	
	PageMainLayout.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	
	exports.default = PageMainLayout;
	module.exports = exports['default'];

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PageMainLayout = __webpack_require__(255);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PageMainLayout).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin-bottom: 60px;\n  padding-top: 10px;\n'], ['\n  margin-bottom: 60px;\n  padding-top: 10px;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  ', ';\n'], ['\n  ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _Stacheldraht = __webpack_require__(55);
	
	var _Stacheldraht2 = _interopRequireDefault(_Stacheldraht);
	
	var _ExternalLinksCollection = __webpack_require__(138);
	
	var _ExternalLinksCollection2 = _interopRequireDefault(_ExternalLinksCollection);
	
	var _breakpoints = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styled2.default.section(_templateObject);
	
	var StacheldrahtStyled = (0, _styled2.default)(_Stacheldraht2.default)(_templateObject2, _breakpoints.showOnlyOnDesktop);
	
	var ProofOfSources = function ProofOfSources(_ref) {
	  var sources = _ref.sources;
	  return _react2.default.createElement(
	    Container,
	    null,
	    _react2.default.createElement(_ExternalLinksCollection2.default, { headline: 'Lehreinheiten und weitere Informationen', sources: sources, showIds: true, collapsable: true }),
	    _react2.default.createElement(StacheldrahtStyled, { small: true })
	  );
	};
	
	ProofOfSources.propTypes = {
	  sources: _ExternalLinksCollection.ExternalLinksShape.isRequired
	};
	
	exports.default = ProofOfSources;
	module.exports = exports['default'];

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ProofOfSources = __webpack_require__(257);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ProofOfSources).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  padding-bottom: 3em;\n  margin-bottom: 30px;\n  ', ' {\n    margin-bottom: 50px;\n  }\n'], ['\n  padding-bottom: 3em;\n  margin-bottom: 30px;\n  ', ' {\n    margin-bottom: 50px;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _ExternalLinksCollection = __webpack_require__(138);
	
	var _ExternalLinksCollection2 = _interopRequireDefault(_ExternalLinksCollection);
	
	var _breakpoints = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styled2.default.section(_templateObject, _breakpoints.minTablet);
	
	var RelatedMaterials = function RelatedMaterials(_ref) {
	  var sources = _ref.sources;
	  return _react2.default.createElement(
	    Container,
	    null,
	    _react2.default.createElement(_ExternalLinksCollection2.default, { sources: sources, collapsable: true })
	  );
	};
	
	RelatedMaterials.propTypes = {
	  sources: _ExternalLinksCollection.ExternalLinksShape.isRequired
	};
	
	exports.default = RelatedMaterials;
	module.exports = exports['default'];

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _RelatedMaterials = __webpack_require__(259);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RelatedMaterials).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _noImportant = __webpack_require__(14);
	
	var _reactImages = __webpack_require__(389);
	
	var _reactImages2 = _interopRequireDefault(_reactImages);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-array-index-key */
	/* eslint-disable arrow-body-style */
	/* eslint-disable arrow-parens */
	/* eslint-disable react/prop-types */
	/* eslint-disable jsx-a11y/alt-text */
	/* eslint-disable no-use-before-define */
	/* eslint-disable react/destructuring-assignment */
	/* eslint-disable react/no-access-state-in-setstate */
	/* eslint-disable react/require-default-props */
	
	// https://github.com/jossmac/react-images/blob/master/examples/src/components/Gallery.js
	
	var Gallery = function (_Component) {
	  _inherits(Gallery, _Component);
	
	  function Gallery() {
	    _classCallCheck(this, Gallery);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this.state = {
	      lightboxIsOpen: false,
	      currentImage: 0
	    };
	
	    _this.closeLightbox = _this.closeLightbox.bind(_this);
	    _this.gotoNext = _this.gotoNext.bind(_this);
	    _this.gotoPrevious = _this.gotoPrevious.bind(_this);
	    _this.gotoImage = _this.gotoImage.bind(_this);
	    _this.handleClickImage = _this.handleClickImage.bind(_this);
	    _this.openLightbox = _this.openLightbox.bind(_this);
	    return _this;
	  }
	
	  Gallery.prototype.openLightbox = function openLightbox(index, event) {
	    event.preventDefault();
	    this.setState({
	      currentImage: index,
	      lightboxIsOpen: true
	    });
	  };
	
	  Gallery.prototype.closeLightbox = function closeLightbox() {
	    this.setState({
	      currentImage: 0,
	      lightboxIsOpen: false
	    });
	  };
	
	  Gallery.prototype.gotoPrevious = function gotoPrevious() {
	    this.setState({
	      currentImage: this.state.currentImage - 1
	    });
	  };
	
	  Gallery.prototype.gotoNext = function gotoNext() {
	    this.setState({
	      currentImage: this.state.currentImage + 1
	    });
	  };
	
	  Gallery.prototype.gotoImage = function gotoImage(index) {
	    this.setState({
	      currentImage: index
	    });
	  };
	
	  Gallery.prototype.handleClickImage = function handleClickImage() {
	    if (this.state.currentImage === this.props.images.length - 1) return;
	
	    this.gotoNext();
	  };
	
	  Gallery.prototype.renderGallery = function renderGallery() {
	    var _this2 = this;
	
	    var images = this.props.images;
	
	
	    if (!images) return;
	
	    var gallery = images.filter(function (i) {
	      return i.useForDemo;
	    }).map(function (obj, i) {
	      return _react2.default.createElement(
	        'a',
	        {
	          href: obj.src,
	          className: (0, _noImportant.css)(classes.thumbnail, classes[obj.orientation]),
	          key: i,
	          onClick: function onClick(e) {
	            return _this2.openLightbox(i, e);
	          }
	        },
	        _react2.default.createElement('img', { src: obj.thumbnail, className: (0, _noImportant.css)(classes.source) }),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _noImportant.css)(classes.thumbnailCaptionContainer) },
	          _react2.default.createElement(
	            'p',
	            { className: (0, _noImportant.css)(classes.thumbnailCaption) },
	            obj.caption
	          )
	        )
	      );
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _noImportant.css)(classes.gallery) },
	      gallery
	    );
	  };
	
	  Gallery.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'section' },
	      this.props.heading && _react2.default.createElement(
	        'h2',
	        null,
	        this.props.heading
	      ),
	      this.props.subheading && _react2.default.createElement(
	        'p',
	        null,
	        this.props.subheading
	      ),
	      this.renderGallery(),
	      _react2.default.createElement(_reactImages2.default, {
	        currentImage: this.state.currentImage,
	        images: this.props.images,
	        isOpen: this.state.lightboxIsOpen,
	        onClickImage: this.handleClickImage,
	        onClickNext: this.gotoNext,
	        onClickPrev: this.gotoPrevious,
	        onClickThumbnail: this.gotoImage,
	        onClose: this.closeLightbox,
	        preventScroll: this.props.preventScroll,
	        showThumbnails: this.props.showThumbnails,
	        spinner: this.props.spinner,
	        spinnerColor: this.props.spinnerColor,
	        spinnerSize: this.props.spinnerSize,
	        theme: this.props.theme
	      })
	    );
	  };
	
	  return Gallery;
	}(_react.Component);
	
	Gallery.displayName = 'Gallery';
	
	Gallery.propTypes = {
	  heading: _propTypes2.default.string,
	  images: _propTypes2.default.array,
	  showThumbnails: _propTypes2.default.bool,
	  subheading: _propTypes2.default.string
	};
	
	var gutter = {
	  small: 10,
	  large: 14
	};
	
	var classes = _noImportant.StyleSheet.create({
	  gallery: {
	    marginRight: -gutter.small,
	    overflow: 'hidden',
	
	    '@media (min-width: 768px)': {
	      marginRight: -gutter.large
	    }
	  },
	
	  // anchor
	  thumbnail: {
	    position: 'relative',
	    boxSizing: 'border-box',
	    display: 'block',
	    float: 'left',
	    lineHeight: 0,
	    paddingRight: gutter.small,
	    paddingBottom: gutter.small,
	    overflow: 'hidden',
	
	    '@media (min-width: 768px)': {
	      paddingRight: gutter.large,
	      paddingBottom: gutter.large
	    }
	  },
	
	  thumbnailCaptionContainer: {
	    display: 'block',
	    position: 'absolute',
	    top: 0,
	    left: 0,
	    right: gutter.small,
	    bottom: gutter.small,
	
	    '@media (min-width: 768px)': {
	      right: gutter.large,
	      bottom: gutter.large
	    },
	
	    opacity: 0,
	
	    ':hover': {
	      opacity: '1'
	    }
	  },
	
	  thumbnailCaption: {
	    display: 'block',
	
	    backgroundColor: 'rgba(184,197,0,1)',
	    color: '#fff',
	
	    position: 'absolute',
	    top: '50%',
	    left: 0,
	    right: 0,
	    bottom: 0,
	
	    margin: 0,
	    padding: '.25em .5em',
	
	    lineHeight: '1.4',
	
	    fontWeight: 'bold',
	    fontSize: '12px',
	
	    '@media (min-width: 480px)': {
	      fontSize: '14px'
	    },
	    '@media (min-width: 600px)': {
	      fontSize: '18px'
	    },
	    '@media (min-width: 700px)': {
	      fontSize: '20px'
	    },
	    '@media (min-width: 768px)': {
	      fontSize: '14px'
	    },
	    '@media (min-width: 830px)': {
	      fontSize: '16px'
	    },
	    '@media (min-width: 900px)': {
	      fontSize: '18px'
	    },
	    '@media (min-width: 1100px)': {
	      fontSize: '20px'
	    }
	  },
	
	  // orientation
	  landscape: {
	    width: '49%',
	    '@media (min-width: 768px)': {
	      width: '33%'
	    }
	  },
	  square: {
	    paddingBottom: 0,
	    width: '40%',
	
	    '@media (min-width: 768px)': {
	      paddingBottom: 0
	    }
	  },
	
	  // actual <img />
	  source: {
	    border: 0,
	    display: 'block',
	    height: 'auto',
	    maxWidth: '100%',
	    width: 'auto'
	  }
	});
	
	exports.default = Gallery;
	module.exports = exports['default'];

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: none;\n  ', ' {\n    display: block;\n    margin-top: -20px;\n    margin-bottom: 20px;\n  }\n'], ['\n  display: none;\n  ', ' {\n    display: block;\n    margin-top: -20px;\n    margin-bottom: 20px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  ', ';\n  font-size: 22px;\n  line-height: 1.2;\n  text-align: center;\n  color: ', ';\n  transform: rotate(-3deg);\n  padding-top: 80px;\n  margin-left: auto;\n  margin-right: auto;\n'], ['\n  ', ';\n  font-size: 22px;\n  line-height: 1.2;\n  text-align: center;\n  color: ', ';\n  transform: rotate(-3deg);\n  padding-top: 80px;\n  margin-left: auto;\n  margin-right: auto;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 1020px;\n  margin-bottom: 90px;\n'], ['\n  position: relative;\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 1020px;\n  margin-bottom: 90px;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  margin-top: 30px;\n  text-align: center;\n  margin-bottom: 30px;\n'], ['\n  margin-top: 30px;\n  text-align: center;\n  margin-bottom: 30px;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  padding: 15px;\n  border-radius: 3px;\n  text-align: center;\n'], ['\n  padding: 15px;\n  border-radius: 3px;\n  text-align: center;\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  text-transform: uppercase;\n  margin-top: 15px;\n  margin-bottom: 18px;\n'], ['\n  text-transform: uppercase;\n  margin-top: 15px;\n  margin-bottom: 18px;\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  top: 0;\n  left: 50%;\n  width: 35px;\n  ', ' {\n    top: -10px;\n    left: 66%;\n    width: 48px;\n  }\n'], ['\n  position: relative;\n  top: 0;\n  left: 50%;\n  width: 35px;\n  ', ' {\n    top: -10px;\n    left: 66%;\n    width: 48px;\n  }\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n  position: relative;\n\n  margin-left: auto;\n  margin-right: auto;\n\n  max-width: 330px;\n  ', ' {\n    max-width: 540px;\n  }\n  ', ' {\n    font-size: 18px;\n  }\n  ', ' {\n    max-width: 400px;\n    left: -20%;\n    top: -130px;\n    margin-bottom: -130px;\n  }\n'], ['\n  position: relative;\n\n  margin-left: auto;\n  margin-right: auto;\n\n  max-width: 330px;\n  ', ' {\n    max-width: 540px;\n  }\n  ', ' {\n    font-size: 18px;\n  }\n  ', ' {\n    max-width: 400px;\n    left: -20%;\n    top: -130px;\n    margin-bottom: -130px;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _colors = __webpack_require__(9);
	
	var _breakpoints = __webpack_require__(4);
	
	var _fonts = __webpack_require__(15);
	
	var _DownloadMaterialButton = __webpack_require__(54);
	
	var _DownloadMaterialButton2 = _interopRequireDefault(_DownloadMaterialButton);
	
	var _H = __webpack_require__(69);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _Stacheldraht = __webpack_require__(55);
	
	var _Stacheldraht2 = _interopRequireDefault(_Stacheldraht);
	
	var _Gallery = __webpack_require__(261);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _Pfeil = __webpack_require__(447);
	
	var _Pfeil2 = _interopRequireDefault(_Pfeil);
	
	var _images = __webpack_require__(380);
	
	var _images2 = _interopRequireDefault(_images);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; } /* eslint-disable object-curly-newline */
	
	
	var StacheldrahtInfoTop = (0, _styled2.default)(_Stacheldraht2.default)(_templateObject, _breakpoints.minDesktop);
	
	var Info = _styled2.default.p(_templateObject2, _fonts.HeadlineFont, _colors.TextColor);
	
	var Section = _styled2.default.div(_templateObject3);
	
	var DownloadAllContainer = _styled2.default.div(_templateObject4);
	
	var DownloadAll = (0, _styled2.default)(_DownloadMaterialButton2.default)(_templateObject5);
	
	var Title = (0, _styled2.default)(_H2.default)(_templateObject6);
	
	var Pfeil = _styled2.default.img(_templateObject7, _breakpoints.mediaPhone);
	
	var InfoContainer = _styled2.default.div(_templateObject8, _breakpoints.onlyTablet, _breakpoints.minTablet, _breakpoints.minDesktop);
	
	var SmartboardGallery = function SmartboardGallery() {
	  return _react2.default.createElement(
	    Section,
	    null,
	    _react2.default.createElement(
	      InfoContainer,
	      null,
	      _react2.default.createElement(StacheldrahtInfoTop, { small: true }),
	      _react2.default.createElement(
	        Info,
	        null,
	        'Hier k\xF6nnen Sie Bilder zum Einsatz im Klassenraum herunterladen'
	      ),
	      _react2.default.createElement(Pfeil, { src: _Pfeil2.default })
	    ),
	    _react2.default.createElement(
	      Title,
	      null,
	      'Smartboard-Galerie'
	    ),
	    _react2.default.createElement(_Gallery2.default, { images: _images2.default.map(function (_ref) {
	        var caption = _ref.caption,
	            src = _ref.src,
	            thumbnail = _ref.thumbnail,
	            srcSet = _ref.srcSet,
	            orientation = _ref.orientation;
	        return {
	          src: src,
	          thumbnail: thumbnail,
	          srcSet: srcSet,
	          caption: caption,
	          orientation: orientation,
	          useForDemo: true
	        };
	      })
	    }),
	    _react2.default.createElement(
	      DownloadAllContainer,
	      null,
	      _react2.default.createElement(DownloadAll, {
	        label: 'Alle herunterladen',
	        href: '/downloads/Modebewusst_Smartboard_Bilder.zip',
	        download: 'Modebewusst_Smartboard_Bilder.zip'
	      })
	    )
	  );
	};
	
	exports.default = SmartboardGallery;
	module.exports = exports['default'];

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SmartboardGallery = __webpack_require__(262);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SmartboardGallery).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  height: ', 'px;\n  max-width: 100%;\n  overflow: hidden;\n'], ['\n  height: ', 'px;\n  max-width: 100%;\n  overflow: hidden;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  width: ', 'px;\n  height: ', 'px;\n  max-width: 100%;\n\n  ', ' {\n    max-width: ', 'px;\n    min-width: 100%;\n  }\n\n  margin-left: auto;\n  margin-right: auto;\n\n  background-position: ', ';\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-image: url(', ');\n'], ['\n  width: ', 'px;\n  height: ', 'px;\n  max-width: 100%;\n\n  ', ' {\n    max-width: ', 'px;\n    min-width: 100%;\n  }\n\n  margin-left: auto;\n  margin-right: auto;\n\n  background-position: ', ';\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-image: url(', ');\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _breakpoints = __webpack_require__(4);
	
	var _GreenLine = __webpack_require__(448);
	
	var _GreenLine2 = _interopRequireDefault(_GreenLine);
	
	var _GreenLineWithIcons = __webpack_require__(449);
	
	var _GreenLineWithIcons2 = _interopRequireDefault(_GreenLineWithIcons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var IMAGE = {
	  default: {
	    width: 349,
	    height: 42,
	    phoneScale: 0.6,
	    url: _GreenLine2.default
	  },
	  withIcons: {
	    width: 349,
	    height: 140,
	    phoneScale: 0.6,
	    url: _GreenLineWithIcons2.default
	  }
	};
	
	var getImage = function getImage(small, prop) {
	  return IMAGE[small ? 'default' : 'withIcons'][prop];
	};
	
	var Container = _styled2.default.div(_templateObject, function (_ref) {
	  var small = _ref.small;
	  return getImage(small, 'height');
	});
	
	var Content = _styled2.default.div(_templateObject2, function (_ref2) {
	  var small = _ref2.small;
	  return getImage(small, 'width');
	}, function (_ref3) {
	  var small = _ref3.small;
	  return getImage(small, 'height');
	}, _breakpoints.mediaPhone, function (_ref4) {
	  var small = _ref4.small;
	  return Math.round(getImage(small, 'width') * getImage(small, 'phoneScale'));
	}, function (_ref5) {
	  var left = _ref5.left;
	  return left ? 'left' : 'center center';
	}, function (_ref6) {
	  var small = _ref6.small;
	  return getImage(small, 'url');
	});
	
	var Stacheldraht = function Stacheldraht(_ref7) {
	  var left = _ref7.left,
	      small = _ref7.small,
	      className = _ref7.className;
	  return _react2.default.createElement(
	    Container,
	    { small: small, className: className },
	    _react2.default.createElement(Content, { small: small, left: left })
	  );
	};
	
	Stacheldraht.propTypes = {
	  left: _propTypes2.default.bool,
	  small: _propTypes2.default.bool,
	  className: _propTypes2.default.string
	};
	
	Stacheldraht.defaultProps = {
	  left: false,
	  small: false,
	  className: undefined
	};
	
	exports.default = Stacheldraht;
	module.exports = exports['default'];

/***/ }),
/* 265 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = [{
	  title: 'Weiterführende Materialen und Tipps',
	  items: [{
	    type: 'component',
	    body: 'MORE_MATERIAL_AND_TIPS'
	  }]
	}];
	module.exports = exports['default'];

/***/ }),
/* 266 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = [{
	  id: 'LE1',
	  title: 'Kleider machen Leute – oder?',
	  download: {
	    label: 'Lerneinheit 1',
	    url: '/downloads/LE1_Kleider-machen-Leute.pdf',
	    file: 'LE1_Kleider-machen-Leute.pdf'
	  },
	  items: [{ type: 'component', body: 'LE1' }, {
	    type: 'pdf',
	    body: 'Die Aussagen als Bilder zum Download',
	    url: ['/smartboard/images/original/LE1_Markenklamotten_Frage1.jpg', '/smartboard/images/original/LE1_Modetrends_Frage2.jpg', '/smartboard/images/original/LE1_Masse_absetzen_Frage3.jpg', '/smartboard/images/original/LE1_Nicht_leisten_Frage4.jpg', '/smartboard/images/original/LE1_Freunde_Frage5.jpg', '/smartboard/images/original/LE1_Secondhand_Frage6.jpg'],
	    indent: 1
	  }, { type: 'component', body: 'LE1_2' }, {
	    type: 'image',
	    body: 'Ein junger Mann in Turnschuhen und legerer Kleidung: Wird er als sportlich, locker etc. beschrieben?',
	    url: '/smartboard/images/original/LE1_TurnschuhMann_Foto.jpg',
	    indent: 1
	  }, {
	    type: 'image',
	    body: 'Eine Frau im Business-Outfit mit Brille: Wird sie als erfolgreich, intelligent, wohlhabend etc. beschrieben?',
	    url: '/smartboard/images/original/LE1_BusinessFrau_Foto.jpg',
	    indent: 1
	  }, { type: 'component', body: 'LE1_3' }, {
	    type: 'pdf',
	    body: 'Lassen Sie die SuS zu Hause mithilfe des Arbeitsblattes einen <b>Kleiderschrank-Check</b> durchführen:',
	    url: '/downloads/LE1_KleiderschrankCheck_AB.pdf',
	    indent: 1
	  }, { type: 'component', body: 'LE1_4', indent: 1 }]
	}, {
	  id: 'LE2',
	  title: 'Vertrauensfragen: Wer redet bei der Kaufentscheidung von Jugendlichen mit?',
	  download: {
	    label: 'Lerneinheit 2',
	    url: '/downloads/LE2_Kaufentscheidung-Influencer.pdf',
	    file: 'LE2_Kaufentscheidung-Influencer.pdf'
	  },
	  items: [{ type: 'component', body: 'LE2' }, {
	    type: 'pdf',
	    body: 'Zeigen Sie anhand des Arbeitsblatts erst alle Optionen, jeder kann erst für sich überlegen, dann folgt eine klasseninterne Umfrage.',
	    url: '/downloads/LE2_Mode-Dschungel_AB.pdf',
	    indent: 1
	  }, { type: 'component', body: 'LE2_2', indent: 1 }, { type: 'component', body: 'LE2_3' }, {
	    type: 'image',
	    body: 'Bildmaterial',
	    url: ['/smartboard/images/original/LE2_Streitfrage_InstagramAuftritte_Frage1.jpg', '/smartboard/images/original/LE2_Streitfrage_Verbandsklage_Frage2.jpg', '/smartboard/images/original/LE2_Streitfrage_RechtfertigungInfluencerin_Frage3.jpg', '/smartboard/images/original/LE2_Streitfrage_UnlautererWettbewerb_Frage4.jpg', '/smartboard/images/original/LE2_Streitfrage_StrittigePosts_Frage5.jpg'],
	    indent: 1
	  }, { type: 'component', body: 'LE2_4' }]
	}, {
	  id: 'LE3',
	  title: 'Fast Fashion',
	  download: {
	    label: 'Lerneinheit 3',
	    url: '/downloads/LE3_Fast-Fashion.pdf',
	    file: 'LE3_Fast-Fashion.pdf'
	  },
	  items: [{ type: 'component', body: 'LE3' }, {
	    type: 'pdf',
	    body: 'Arbeitsblatt',
	    url: '/downloads/L3_Einschaetzungsfragen_AB.pdf',
	    indent: 1
	  }, { type: 'component', body: 'LE3_2', indent: 1 }, {
	    type: 'video',
	    body: 'So ungerecht ist Fast Fashion – Was können wir ändern? Ein Experiment (Tagesschau; 2018)',
	    url: 'https://www.youtube.com/watch?v=3ArXxezDhMY',
	    indent: 1
	  }, {
	    body: 'Tipp: Stoppen Sie den Film bei Minute 3:38 und schauen Sie den Rest des Films, nachdem Sie mit Ihren Schülern die Aufgaben zu den alternativen Handlungsmöglichkeiten (LE 4) durchgeführt haben.',
	    indent: 1
	  }, { type: 'component', body: 'LE3_3' }, {
	    type: 'pdf',
	    body: 'Recherchetipps',
	    url: '/downloads/L3_Fast_Fashion_Recherchetipps.pdf',
	    indent: 1
	  }, { type: 'component', body: 'LE3_4', indent: 1 }, { type: 'component', body: 'LE3_5' }, {
	    type: 'pdf',
	    body: 'Lebenszyklus Fast Fashion-Produkt',
	    url: '/downloads/L3_Lebenszyklus_Fast_Fashion_AB.pdf',
	    indent: 1
	  }, {
	    type: 'pdf',
	    body: '(Arbeitsblatt mit Lösung hier.)',
	    url: '/downloads/L3_Lebenszyklus_Fast_Fashion_Loesungsblatt.pdf',
	    indent: 1
	  }, { type: 'component', body: 'LE3_6', indent: 1 }, { type: 'component', body: 'LE3_7' }]
	}, {
	  id: 'LE4',
	  title: 'Fair Fashion',
	  download: {
	    label: 'Lerneinheit 4',
	    url: '/downloads/LE4_Fair-Fashion.pdf',
	    file: 'LE4_Fair-Fashion.pdf'
	  },
	  items: [{ type: 'component', body: 'LE4' }, {
	    type: 'pdf',
	    body: 'Arbeitsblatt',
	    url: '/downloads/LE4_Kampagnenplanung_AB.pdf',
	    indent: 1
	  }, { type: 'component', body: 'LE4_2', indent: 1 }, {
	    type: 'pdf',
	    body: 'Schlagworte, Recherchetipps und Umsetzung können Sie je nach Leistungsstand Ihrer SuS vorgeben oder zur freien Wahl lassen.',
	    url: '/downloads/LE4_Handlungsalternativen_Recherchetipps.pdf',
	    indent: 1
	  }, { type: 'component', body: 'LE4_2b', indent: 1 }, { type: 'component', body: 'LE4_3' }, {
	    type: 'link',
	    body: 'Fünf Gründe gegen faire Mode – und fünf Argumente, warum sie Schwachsinn sind',
	    url: 'https://www.br.de/puls/themen/leben/warum-ich-keine-faire-mode-trage-100.html',
	    indent: 1
	  }, { type: 'component', body: 'LE4_4' }]
	}];
	module.exports = exports['default'];

/***/ }),
/* 267 */,
/* 268 */,
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin-bottom: 66px;\n\n  margin-top: -70px;\n\n  ', ' {\n    margin-top: 10px;\n  }\n'], ['\n  margin-bottom: 66px;\n\n  margin-top: -70px;\n\n  ', ' {\n    margin-top: 10px;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _AboutMaterialDownload = __webpack_require__(210);
	
	var _AboutMaterialDownload2 = _interopRequireDefault(_AboutMaterialDownload);
	
	var _Impressum = __webpack_require__(224);
	
	var _Impressum2 = _interopRequireDefault(_Impressum);
	
	var _PageHeader = __webpack_require__(253);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _PageMainLayout = __webpack_require__(256);
	
	var _PageMainLayout2 = _interopRequireDefault(_PageMainLayout);
	
	var _ProofOfSources = __webpack_require__(258);
	
	var _ProofOfSources2 = _interopRequireDefault(_ProofOfSources);
	
	var _RelatedMaterials = __webpack_require__(260);
	
	var _RelatedMaterials2 = _interopRequireDefault(_RelatedMaterials);
	
	var _SmartboardGallery = __webpack_require__(263);
	
	var _SmartboardGallery2 = _interopRequireDefault(_SmartboardGallery);
	
	var _Stacheldraht = __webpack_require__(55);
	
	var _Stacheldraht2 = _interopRequireDefault(_Stacheldraht);
	
	var _SOURCES = __webpack_require__(266);
	
	var _SOURCES2 = _interopRequireDefault(_SOURCES);
	
	var _MORE_SOURCES = __webpack_require__(265);
	
	var _MORE_SOURCES2 = _interopRequireDefault(_MORE_SOURCES);
	
	var _breakpoints = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	// import BreakpointDisplay from '../components/BreakpointDisplay';
	
	// import ProjectPartners from '../components/ProjectPartners';
	
	
	var Footer = _styled2.default.footer(_templateObject, _breakpoints.minDesktop);
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_PageHeader2.default, null),
	    _react2.default.createElement(
	      _PageMainLayout2.default,
	      null,
	      _react2.default.createElement(_AboutMaterialDownload2.default, null),
	      _react2.default.createElement(_SmartboardGallery2.default, null),
	      _react2.default.createElement(_ProofOfSources2.default, { sources: _SOURCES2.default }),
	      _react2.default.createElement(_RelatedMaterials2.default, { sources: _MORE_SOURCES2.default })
	    ),
	    _react2.default.createElement(
	      Footer,
	      null,
	      _react2.default.createElement(_Stacheldraht2.default, null),
	      _react2.default.createElement(_Impressum2.default, null)
	    )
	  );
	};
	// <BreakpointDisplay />
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ }),
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var createCache = _interopDefault(__webpack_require__(131));
	var serialize = __webpack_require__(66);
	var utils = __webpack_require__(84);
	
	function insertWithoutScoping(cache, serialized) {
	  if (cache.inserted[serialized.name] === undefined) {
	    return cache.insert('', serialized, cache.sheet, true);
	  }
	}
	
	function merge(registered, css, className) {
	  var registeredStyles = [];
	  var rawClassName = utils.getRegisteredStyles(registered, registeredStyles, className);
	
	  if (registeredStyles.length < 2) {
	    return className;
	  }
	
	  return rawClassName + css(registeredStyles);
	}
	
	var createEmotion = function createEmotion(options) {
	  var cache = createCache(options); // $FlowFixMe
	
	  cache.sheet.speedy = function (value) {
	    if (false) {
	      throw new Error('speedy must be changed before any rules are inserted');
	    }
	
	    this.isSpeedy = value;
	  };
	
	  cache.compat = true;
	
	  var css = function css() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var serialized = serialize.serializeStyles(args, cache.registered, this !== undefined ? this.mergedProps : undefined);
	    utils.insertStyles(cache, serialized, false);
	    return cache.key + "-" + serialized.name;
	  };
	
	  var keyframes = function keyframes() {
	    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    var serialized = serialize.serializeStyles(args, cache.registered);
	    var animation = "animation-" + serialized.name;
	    insertWithoutScoping(cache, {
	      name: serialized.name,
	      styles: "@keyframes " + animation + "{" + serialized.styles + "}"
	    });
	    return animation;
	  };
	
	  var injectGlobal = function injectGlobal() {
	    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    var serialized = serialize.serializeStyles(args, cache.registered);
	    insertWithoutScoping(cache, serialized);
	  };
	
	  var cx = function cx() {
	    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	      args[_key4] = arguments[_key4];
	    }
	
	    return merge(cache.registered, css, classnames(args));
	  };
	
	  return {
	    css: css,
	    cx: cx,
	    injectGlobal: injectGlobal,
	    keyframes: keyframes,
	    hydrate: function hydrate(ids) {
	      ids.forEach(function (key) {
	        cache.inserted[key] = true;
	      });
	    },
	    flush: function flush() {
	      cache.registered = {};
	      cache.inserted = {};
	      cache.sheet.flush();
	    },
	    // $FlowFixMe
	    sheet: cache.sheet,
	    cache: cache,
	    getRegisteredStyles: utils.getRegisteredStyles.bind(null, cache.registered),
	    merge: merge.bind(null, cache.registered, css)
	  };
	};
	
	var classnames = function classnames(args) {
	  var cls = '';
	
	  for (var i = 0; i < args.length; i++) {
	    var arg = args[i];
	    if (arg == null) continue;
	    var toAdd = void 0;
	
	    switch (typeof arg) {
	      case 'boolean':
	        break;
	
	      case 'object':
	        {
	          if (Array.isArray(arg)) {
	            toAdd = classnames(arg);
	          } else {
	            toAdd = '';
	
	            for (var k in arg) {
	              if (arg[k] && k) {
	                toAdd && (toAdd += ' ');
	                toAdd += k;
	              }
	            }
	          }
	
	          break;
	        }
	
	      default:
	        {
	          toAdd = arg;
	        }
	    }
	
	    if (toAdd) {
	      cls && (cls += ' ');
	      cls += toAdd;
	    }
	  }
	
	  return cls;
	};
	
	exports.default = createEmotion;


/***/ }),
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function _interopDefault(ex) {
	  return ex && "object" == typeof ex && "default" in ex ? ex.default : ex;
	}
	Object.defineProperty(exports, "__esModule", { value: !0 });
	var createEmotion = _interopDefault(__webpack_require__(340)),
	  _createEmotion = createEmotion(),
	  flush = _createEmotion.flush,
	  hydrate = _createEmotion.hydrate,
	  cx = _createEmotion.cx,
	  merge = _createEmotion.merge,
	  getRegisteredStyles = _createEmotion.getRegisteredStyles,
	  injectGlobal = _createEmotion.injectGlobal,
	  keyframes = _createEmotion.keyframes,
	  css = _createEmotion.css,
	  sheet = _createEmotion.sheet,
	  cache = _createEmotion.cache;
	(exports.flush = flush),
	  (exports.hydrate = hydrate),
	  (exports.cx = cx),
	  (exports.merge = merge),
	  (exports.getRegisteredStyles = getRegisteredStyles),
	  (exports.injectGlobal = injectGlobal),
	  (exports.keyframes = keyframes),
	  (exports.css = css),
	  (exports.sheet = sheet),
	  (exports.cache = cache);


/***/ }),
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */
/***/ (function(module, exports) {

	module.exports = [{"src":"/smartboard/images/out/LE1_Markenklamotten_Frage1_1024.png","srcSet":["/smartboard/images/out/LE1_Markenklamotten_Frage1_1024.png 1024w","/smartboard/images/out/LE1_Markenklamotten_Frage1_800.png 800w","/smartboard/images/out/LE1_Markenklamotten_Frage1_500.png 500w","/smartboard/images/out/LE1_Markenklamotten_Frage1_320.png 320w"],"thumbnail":"/smartboard/images/thumbnail/LE1_Markenklamotten_Frage1_480x318.png","caption":"LE1 Markenklamotten Frage1","orientation":"landscape"},{"src":"/smartboard/images/out/LE1_Modetrends_Frage2_1024.png","srcSet":["/smartboard/images/out/LE1_Modetrends_Frage2_1024.png 1024w","/smartboard/images/out/LE1_Modetrends_Frage2_800.png 800w","/smartboard/images/out/LE1_Modetrends_Frage2_500.png 500w","/smartboard/images/out/LE1_Modetrends_Frage2_320.png 320w"],"thumbnail":"/smartboard/images/thumbnail/LE1_Modetrends_Frage2_480x318.png","caption":"LE1 Modetrends Frage2","orientation":"landscape"},{"src":"/smartboard/images/out/LE1_Masse_absetzen_Frage3_1024.png","srcSet":["/smartboard/images/out/LE1_Masse_absetzen_Frage3_1024.png 1024w","/smartboard/images/out/LE1_Masse_absetzen_Frage3_800.png 800w","/smartboard/images/out/LE1_Masse_absetzen_Frage3_500.png 500w","/smartboard/images/out/LE1_Masse_absetzen_Frage3_320.png 320w"],"thumbnail":"/smartboard/images/thumbnail/LE1_Masse_absetzen_Frage3_480x318.png","caption":"LE1 Masse absetzen Frage3","orientation":"landscape"},{"src":"/smartboard/images/out/LE1_Nicht_leisten_Frage4_1024.png","srcSet":["/smartboard/images/out/LE1_Nicht_leisten_Frage4_1024.png 1024w","/smartboard/images/out/LE1_Nicht_leisten_Frage4_800.png 800w","/smartboard/images/out/LE1_Nicht_leisten_Frage4_500.png 500w","/smartboard/images/out/LE1_Nicht_leisten_Frage4_320.png 320w"],"thumbnail":"/smartboard/images/thumbnail/LE1_Nicht_leisten_Frage4_480x318.png","caption":"LE1 Nicht leisten Frage4","orientation":"landscape"},{"src":"/smartboard/images/out/LE1_Freunde_Frage5_1024.png","srcSet":["/smartboard/images/out/LE1_Freunde_Frage5_1024.png 1024w","/smartboard/images/out/LE1_Freunde_Frage5_800.png 800w","/smartboard/images/out/LE1_Freunde_Frage5_500.png 500w","/smartboard/images/out/LE1_Freunde_Frage5_320.png 320w"],"thumbnail":"/smartboard/images/thumbnail/LE1_Freunde_Frage5_480x318.png","caption":"LE1 Freunde Frage5","orientation":"landscape"},{"src":"/smartboard/images/out/LE1_Secondhand_Frage6_1024.png","srcSet":["/smartboard/images/out/LE1_Secondhand_Frage6_1024.png 1024w","/smartboard/images/out/LE1_Secondhand_Frage6_800.png 800w","/smartboard/images/out/LE1_Secondhand_Frage6_500.png 500w","/smartboard/images/out/LE1_Secondhand_Frage6_320.png 320w"],"thumbnail":"/smartboard/images/thumbnail/LE1_Secondhand_Frage6_480x318.png","caption":"LE1 Secondhand Frage6","orientation":"landscape"},{"src":"/smartboard/images/out/LE1_TurnschuhMann_Foto_1024.png","srcSet":["/smartboard/images/out/LE1_TurnschuhMann_Foto_1024.png 1024w","/smartboard/images/out/LE1_TurnschuhMann_Foto_800.png 800w","/smartboard/images/out/LE1_TurnschuhMann_Foto_500.png 500w","/smartboard/images/out/LE1_TurnschuhMann_Foto_320.png 320w"],"thumbnail":"/smartboard/images/thumbnail/LE1_TurnschuhMann_Foto_480x318.png","caption":"LE1 Turnschuh Mann","orientation":"landscape"},{"src":"/smartboard/images/out/LE1_BusinessFrau_Foto_1024.png","srcSet":["/smartboard/images/out/LE1_BusinessFrau_Foto_1024.png 1024w","/smartboard/images/out/LE1_BusinessFrau_Foto_800.png 800w","/smartboard/images/out/LE1_BusinessFrau_Foto_500.png 500w","/smartboard/images/out/LE1_BusinessFrau_Foto_320.png 320w"],"thumbnail":"/smartboard/images/thumbnail/LE1_BusinessFrau_Foto_480x318.png","caption":"LE1 Business Frau","orientation":"landscape"},{"src":"/smartboard/images/out/LE2_Streitfrage_InstagramAuftritte_Frage1_1024.png","srcSet":["/smartboard/images/out/LE2_Streitfrage_InstagramAuftritte_Frage1_1024.png 1024w","/smartboard/images/out/LE2_Streitfrage_InstagramAuftritte_Frage1_800.png 800w","/smartboard/images/out/LE2_Streitfrage_InstagramAuftritte_Frage1_500.png 500w","/smartboard/images/out/LE2_Streitfrage_InstagramAuftritte_Frage1_320.png 320w"],"thumbnail":"/smartboard/images/thumbnail/LE2_Streitfrage_InstagramAuftritte_Frage1_480x318.png","caption":"LE2 Streitfrage Instagram Auftritte Frage1","orientation":"landscape"},{"src":"/smartboard/images/out/LE2_Streitfrage_Verbandsklage_Frage2_1024.png","srcSet":["/smartboard/images/out/LE2_Streitfrage_Verbandsklage_Frage2_1024.png 1024w","/smartboard/images/out/LE2_Streitfrage_Verbandsklage_Frage2_800.png 800w","/smartboard/images/out/LE2_Streitfrage_Verbandsklage_Frage2_500.png 500w","/smartboard/images/out/LE2_Streitfrage_Verbandsklage_Frage2_320.png 320w"],"thumbnail":"/smartboard/images/thumbnail/LE2_Streitfrage_Verbandsklage_Frage2_480x318.png","caption":"LE2 Streitfrage Verbandsklage Frage2","orientation":"landscape"},{"src":"/smartboard/images/out/LE2_Streitfrage_RechtfertigungInfluencerin_Frage3_1024.png","srcSet":["/smartboard/images/out/LE2_Streitfrage_RechtfertigungInfluencerin_Frage3_1024.png 1024w","/smartboard/images/out/LE2_Streitfrage_RechtfertigungInfluencerin_Frage3_800.png 800w","/smartboard/images/out/LE2_Streitfrage_RechtfertigungInfluencerin_Frage3_500.png 500w","/smartboard/images/out/LE2_Streitfrage_RechtfertigungInfluencerin_Frage3_320.png 320w"],"thumbnail":"/smartboard/images/thumbnail/LE2_Streitfrage_RechtfertigungInfluencerin_Frage3_480x318.png","caption":"LE2 Streitfrage Rechtfertigung Influencerin Frage3","orientation":"landscape"},{"src":"/smartboard/images/out/LE2_Streitfrage_UnlautererWettbewerb_Frage4_1024.png","srcSet":["/smartboard/images/out/LE2_Streitfrage_UnlautererWettbewerb_Frage4_1024.png 1024w","/smartboard/images/out/LE2_Streitfrage_UnlautererWettbewerb_Frage4_800.png 800w","/smartboard/images/out/LE2_Streitfrage_UnlautererWettbewerb_Frage4_500.png 500w","/smartboard/images/out/LE2_Streitfrage_UnlautererWettbewerb_Frage4_320.png 320w"],"thumbnail":"/smartboard/images/thumbnail/LE2_Streitfrage_UnlautererWettbewerb_Frage4_480x318.png","caption":"LE2 Streitfrage Unlauterer Wettbewerb Frage4","orientation":"landscape"},{"src":"/smartboard/images/out/LE2_Streitfrage_StrittigePosts_Frage5_1024.png","srcSet":["/smartboard/images/out/LE2_Streitfrage_StrittigePosts_Frage5_1024.png 1024w","/smartboard/images/out/LE2_Streitfrage_StrittigePosts_Frage5_800.png 800w","/smartboard/images/out/LE2_Streitfrage_StrittigePosts_Frage5_500.png 500w","/smartboard/images/out/LE2_Streitfrage_StrittigePosts_Frage5_320.png 320w"],"thumbnail":"/smartboard/images/thumbnail/LE2_Streitfrage_StrittigePosts_Frage5_480x318.png","caption":"LE2 Streitfrage Strittige Posts Frage5","orientation":"landscape"}]

/***/ }),
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _aphrodite = __webpack_require__(85);
	
	var _reactScrolllock = __webpack_require__(423);
	
	var _reactScrolllock2 = _interopRequireDefault(_reactScrolllock);
	
	var _theme = __webpack_require__(25);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _Arrow = __webpack_require__(176);
	
	var _Arrow2 = _interopRequireDefault(_Arrow);
	
	var _Container = __webpack_require__(390);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Footer = __webpack_require__(391);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Header = __webpack_require__(392);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _PaginatedThumbnails = __webpack_require__(393);
	
	var _PaginatedThumbnails2 = _interopRequireDefault(_PaginatedThumbnails);
	
	var _Portal = __webpack_require__(395);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Spinner = __webpack_require__(396);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _bindFunctions = __webpack_require__(401);
	
	var _bindFunctions2 = _interopRequireDefault(_bindFunctions);
	
	var _canUseDom = __webpack_require__(402);
	
	var _canUseDom2 = _interopRequireDefault(_canUseDom);
	
	var _deepMerge = __webpack_require__(51);
	
	var _deepMerge2 = _interopRequireDefault(_deepMerge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// consumers sometimes provide incorrect type or casing
	function normalizeSourceSet(data) {
		var sourceSet = data.srcSet || data.srcset;
	
		if (Array.isArray(sourceSet)) {
			return sourceSet.join();
		}
	
		return sourceSet;
	}
	
	var Lightbox = function (_Component) {
		_inherits(Lightbox, _Component);
	
		function Lightbox(props) {
			_classCallCheck(this, Lightbox);
	
			var _this = _possibleConstructorReturn(this, (Lightbox.__proto__ || Object.getPrototypeOf(Lightbox)).call(this, props));
	
			_this.theme = (0, _deepMerge2.default)(_theme2.default, props.theme);
			_this.classes = _aphrodite.StyleSheet.create((0, _deepMerge2.default)(defaultStyles, _this.theme));
			_this.state = { imageLoaded: false };
	
			_bindFunctions2.default.call(_this, ['gotoNext', 'gotoPrev', 'closeBackdrop', 'handleKeyboardInput', 'handleImageLoaded']);
			return _this;
		}
	
		_createClass(Lightbox, [{
			key: 'getChildContext',
			value: function getChildContext() {
				return {
					theme: this.theme
				};
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (this.props.isOpen) {
					if (this.props.enableKeyboardInput) {
						window.addEventListener('keydown', this.handleKeyboardInput);
					}
					if (typeof this.props.currentImage === 'number') {
						this.preloadImage(this.props.currentImage, this.handleImageLoaded);
					}
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (!_canUseDom2.default) return;
	
				// preload images
				if (nextProps.preloadNextImage) {
					var currentIndex = this.props.currentImage;
					var nextIndex = nextProps.currentImage + 1;
					var prevIndex = nextProps.currentImage - 1;
					var preloadIndex = void 0;
	
					if (currentIndex && nextProps.currentImage > currentIndex) {
						preloadIndex = nextIndex;
					} else if (currentIndex && nextProps.currentImage < currentIndex) {
						preloadIndex = prevIndex;
					}
	
					// if we know the user's direction just get one image
					// otherwise, to be safe, we need to grab one in each direction
					if (preloadIndex) {
						this.preloadImage(preloadIndex);
					} else {
						this.preloadImage(prevIndex);
						this.preloadImage(nextIndex);
					}
				}
	
				// preload current image
				if (this.props.currentImage !== nextProps.currentImage || !this.props.isOpen && nextProps.isOpen) {
					var img = this.preloadImageData(nextProps.images[nextProps.currentImage], this.handleImageLoaded);
					if (img) this.setState({ imageLoaded: img.complete });
				}
	
				// add/remove event listeners
				if (!this.props.isOpen && nextProps.isOpen && nextProps.enableKeyboardInput) {
					window.addEventListener('keydown', this.handleKeyboardInput);
				}
				if (!nextProps.isOpen && nextProps.enableKeyboardInput) {
					window.removeEventListener('keydown', this.handleKeyboardInput);
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				if (this.props.enableKeyboardInput) {
					window.removeEventListener('keydown', this.handleKeyboardInput);
				}
			}
	
			// ==============================
			// METHODS
			// ==============================
	
		}, {
			key: 'preloadImage',
			value: function preloadImage(idx, onload) {
				return this.preloadImageData(this.props.images[idx], onload);
			}
		}, {
			key: 'preloadImageData',
			value: function preloadImageData(data, onload) {
				if (!data) return;
				var img = new Image();
				var sourceSet = normalizeSourceSet(data);
	
				// TODO: add error handling for missing images
				img.onerror = onload;
				img.onload = onload;
				img.src = data.src;
	
				if (sourceSet) img.srcset = sourceSet;
	
				return img;
			}
		}, {
			key: 'gotoNext',
			value: function gotoNext(event) {
				var _props = this.props,
				    currentImage = _props.currentImage,
				    images = _props.images;
				var imageLoaded = this.state.imageLoaded;
	
	
				if (!imageLoaded || currentImage === images.length - 1) return;
	
				if (event) {
					event.preventDefault();
					event.stopPropagation();
				}
	
				this.props.onClickNext();
			}
		}, {
			key: 'gotoPrev',
			value: function gotoPrev(event) {
				var currentImage = this.props.currentImage;
				var imageLoaded = this.state.imageLoaded;
	
	
				if (!imageLoaded || currentImage === 0) return;
	
				if (event) {
					event.preventDefault();
					event.stopPropagation();
				}
	
				this.props.onClickPrev();
			}
		}, {
			key: 'closeBackdrop',
			value: function closeBackdrop(event) {
				// make sure event only happens if they click the backdrop
				// and if the caption is widening the figure element let that respond too
				if (event.target.id === 'lightboxBackdrop' || event.target.tagName === 'FIGURE') {
					this.props.onClose();
				}
			}
		}, {
			key: 'handleKeyboardInput',
			value: function handleKeyboardInput(event) {
				if (event.keyCode === 37) {
					// left
					this.gotoPrev(event);
					return true;
				} else if (event.keyCode === 39) {
					// right
					this.gotoNext(event);
					return true;
				} else if (event.keyCode === 27) {
					// esc
					this.props.onClose();
					return true;
				}
				return false;
			}
		}, {
			key: 'handleImageLoaded',
			value: function handleImageLoaded() {
				this.setState({ imageLoaded: true });
			}
	
			// ==============================
			// RENDERERS
			// ==============================
	
		}, {
			key: 'renderArrowPrev',
			value: function renderArrowPrev() {
				if (this.props.currentImage === 0) return null;
	
				return _react2.default.createElement(_Arrow2.default, {
					direction: 'left',
					icon: 'arrowLeft',
					onClick: this.gotoPrev,
					title: this.props.leftArrowTitle,
					type: 'button'
				});
			}
		}, {
			key: 'renderArrowNext',
			value: function renderArrowNext() {
				if (this.props.currentImage === this.props.images.length - 1) return null;
	
				return _react2.default.createElement(_Arrow2.default, {
					direction: 'right',
					icon: 'arrowRight',
					onClick: this.gotoNext,
					title: this.props.rightArrowTitle,
					type: 'button'
				});
			}
		}, {
			key: 'renderDialog',
			value: function renderDialog() {
				var _props2 = this.props,
				    backdropClosesModal = _props2.backdropClosesModal,
				    isOpen = _props2.isOpen,
				    showThumbnails = _props2.showThumbnails,
				    width = _props2.width;
				var imageLoaded = this.state.imageLoaded;
	
	
				if (!isOpen) return _react2.default.createElement('span', { key: 'closed' });
	
				var offsetThumbnails = 0;
				if (showThumbnails) {
					offsetThumbnails = this.theme.thumbnail.size + this.theme.container.gutter.vertical;
				}
	
				return _react2.default.createElement(
					_Container2.default,
					{
						key: 'open',
						onClick: backdropClosesModal && this.closeBackdrop,
						onTouchEnd: backdropClosesModal && this.closeBackdrop
					},
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ className: (0, _aphrodite.css)(this.classes.content), style: { marginBottom: offsetThumbnails, maxWidth: width } },
							imageLoaded && this.renderHeader(),
							this.renderImages(),
							this.renderSpinner(),
							imageLoaded && this.renderFooter()
						),
						imageLoaded && this.renderThumbnails(),
						imageLoaded && this.renderArrowPrev(),
						imageLoaded && this.renderArrowNext(),
						this.props.preventScroll && _react2.default.createElement(_reactScrolllock2.default, null)
					)
				);
			}
		}, {
			key: 'renderImages',
			value: function renderImages() {
				var _props3 = this.props,
				    currentImage = _props3.currentImage,
				    images = _props3.images,
				    onClickImage = _props3.onClickImage,
				    showThumbnails = _props3.showThumbnails;
				var imageLoaded = this.state.imageLoaded;
	
	
				if (!images || !images.length) return null;
	
				var image = images[currentImage];
				var sourceSet = normalizeSourceSet(image);
				var sizes = sourceSet ? '100vw' : null;
	
				var thumbnailsSize = showThumbnails ? this.theme.thumbnail.size : 0;
				var heightOffset = this.theme.header.height + this.theme.footer.height + thumbnailsSize + this.theme.container.gutter.vertical + 'px';
	
				return _react2.default.createElement(
					'figure',
					{ className: (0, _aphrodite.css)(this.classes.figure) },
					_react2.default.createElement('img', {
						className: (0, _aphrodite.css)(this.classes.image, imageLoaded && this.classes.imageLoaded),
						onClick: onClickImage,
						sizes: sizes,
						alt: image.alt,
						src: image.src,
						srcSet: sourceSet,
						style: {
							cursor: onClickImage ? 'pointer' : 'auto',
							maxHeight: 'calc(100vh - ' + heightOffset + ')'
						}
					})
				);
			}
		}, {
			key: 'renderThumbnails',
			value: function renderThumbnails() {
				var _props4 = this.props,
				    images = _props4.images,
				    currentImage = _props4.currentImage,
				    onClickThumbnail = _props4.onClickThumbnail,
				    showThumbnails = _props4.showThumbnails,
				    thumbnailOffset = _props4.thumbnailOffset;
	
	
				if (!showThumbnails) return;
	
				return _react2.default.createElement(_PaginatedThumbnails2.default, {
					currentImage: currentImage,
					images: images,
					offset: thumbnailOffset,
					onClickThumbnail: onClickThumbnail
				});
			}
		}, {
			key: 'renderHeader',
			value: function renderHeader() {
				var _props5 = this.props,
				    closeButtonTitle = _props5.closeButtonTitle,
				    customControls = _props5.customControls,
				    onClose = _props5.onClose,
				    showCloseButton = _props5.showCloseButton;
	
	
				return _react2.default.createElement(_Header2.default, {
					customControls: customControls,
					onClose: onClose,
					showCloseButton: showCloseButton,
					closeButtonTitle: closeButtonTitle
				});
			}
		}, {
			key: 'renderFooter',
			value: function renderFooter() {
				var _props6 = this.props,
				    currentImage = _props6.currentImage,
				    images = _props6.images,
				    imageCountSeparator = _props6.imageCountSeparator,
				    showImageCount = _props6.showImageCount;
	
	
				if (!images || !images.length) return null;
	
				return _react2.default.createElement(_Footer2.default, {
					caption: images[currentImage].caption,
					countCurrent: currentImage + 1,
					countSeparator: imageCountSeparator,
					countTotal: images.length,
					showCount: showImageCount
				});
			}
		}, {
			key: 'renderSpinner',
			value: function renderSpinner() {
				var _props7 = this.props,
				    spinner = _props7.spinner,
				    spinnerColor = _props7.spinnerColor,
				    spinnerSize = _props7.spinnerSize;
				var imageLoaded = this.state.imageLoaded;
	
				var Spinner = spinner;
	
				return _react2.default.createElement(
					'div',
					{ className: (0, _aphrodite.css)(this.classes.spinner, !imageLoaded && this.classes.spinnerActive) },
					_react2.default.createElement(Spinner, {
						color: spinnerColor,
						size: spinnerSize
					})
				);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_Portal2.default,
					null,
					this.renderDialog()
				);
			}
		}]);
	
		return Lightbox;
	}(_react.Component);
	
	Lightbox.propTypes = {
		backdropClosesModal: _propTypes2.default.bool,
		closeButtonTitle: _propTypes2.default.string,
		currentImage: _propTypes2.default.number,
		customControls: _propTypes2.default.arrayOf(_propTypes2.default.node),
		enableKeyboardInput: _propTypes2.default.bool,
		imageCountSeparator: _propTypes2.default.string,
		images: _propTypes2.default.arrayOf(_propTypes2.default.shape({
			src: _propTypes2.default.string.isRequired,
			srcSet: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
			caption: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
			thumbnail: _propTypes2.default.string
		})).isRequired,
		isOpen: _propTypes2.default.bool,
		leftArrowTitle: _propTypes2.default.string,
		onClickImage: _propTypes2.default.func,
		onClickNext: _propTypes2.default.func,
		onClickPrev: _propTypes2.default.func,
		onClose: _propTypes2.default.func.isRequired,
		preloadNextImage: _propTypes2.default.bool,
		preventScroll: _propTypes2.default.bool,
		rightArrowTitle: _propTypes2.default.string,
		showCloseButton: _propTypes2.default.bool,
		showImageCount: _propTypes2.default.bool,
		showThumbnails: _propTypes2.default.bool,
		spinner: _propTypes2.default.func,
		spinnerColor: _propTypes2.default.string,
		spinnerSize: _propTypes2.default.number,
		theme: _propTypes2.default.object,
		thumbnailOffset: _propTypes2.default.number,
		width: _propTypes2.default.number
	};
	Lightbox.defaultProps = {
		closeButtonTitle: 'Close (Esc)',
		currentImage: 0,
		enableKeyboardInput: true,
		imageCountSeparator: ' of ',
		leftArrowTitle: 'Previous (Left arrow key)',
		onClickShowNextImage: true,
		preloadNextImage: true,
		preventScroll: true,
		rightArrowTitle: 'Next (Right arrow key)',
		showCloseButton: true,
		showImageCount: true,
		spinner: _Spinner2.default,
		spinnerColor: 'white',
		spinnerSize: 100,
		theme: {},
		thumbnailOffset: 2,
		width: 1024
	};
	Lightbox.childContextTypes = {
		theme: _propTypes2.default.object.isRequired
	};
	
	var defaultStyles = {
		content: {
			position: 'relative'
		},
		figure: {
			margin: 0 // remove browser default
		},
		image: {
			display: 'block', // removes browser default gutter
			height: 'auto',
			margin: '0 auto', // maintain center on very short screens OR very narrow image
			maxWidth: '100%',
	
			// disable user select
			WebkitTouchCallout: 'none',
			userSelect: 'none',
	
			// opacity animation on image load
			opacity: 0,
			transition: 'opacity 0.3s'
		},
		imageLoaded: {
			opacity: 1
		},
		spinner: {
			position: 'absolute',
			top: '50%',
			left: '50%',
			transform: 'translate(-50%, -50%)',
	
			// opacity animation to make spinner appear with delay
			opacity: 0,
			transition: 'opacity 0.3s',
			pointerEvents: 'none'
		},
		spinnerActive: {
			opacity: 1
		}
	};
	
	exports.default = Lightbox;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _noImportant = __webpack_require__(14);
	
	var _theme = __webpack_require__(25);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _deepMerge = __webpack_require__(51);
	
	var _deepMerge2 = _interopRequireDefault(_deepMerge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function Container(_ref, _ref2) {
		var theme = _ref2.theme;
	
		var props = _objectWithoutProperties(_ref, []);
	
		var classes = _noImportant.StyleSheet.create((0, _deepMerge2.default)(defaultStyles, theme));
	
		return _react2.default.createElement('div', _extends({ id: 'lightboxBackdrop',
			className: (0, _noImportant.css)(classes.container)
		}, props));
	}
	
	Container.contextTypes = {
		theme: _propTypes2.default.object.isRequired
	};
	
	var defaultStyles = {
		container: {
			alignItems: 'center',
			backgroundColor: _theme2.default.container.background,
			boxSizing: 'border-box',
			display: 'flex',
			height: '100%',
			justifyContent: 'center',
			left: 0,
			paddingBottom: _theme2.default.container.gutter.vertical,
			paddingLeft: _theme2.default.container.gutter.horizontal,
			paddingRight: _theme2.default.container.gutter.horizontal,
			paddingTop: _theme2.default.container.gutter.vertical,
			position: 'fixed',
			top: 0,
			width: '100%',
			zIndex: _theme2.default.container.zIndex
		}
	};
	
	exports.default = Container;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _noImportant = __webpack_require__(14);
	
	var _theme = __webpack_require__(25);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _deepMerge = __webpack_require__(51);
	
	var _deepMerge2 = _interopRequireDefault(_deepMerge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function Footer(_ref, _ref2) {
		var theme = _ref2.theme;
	
		var caption = _ref.caption,
		    countCurrent = _ref.countCurrent,
		    countSeparator = _ref.countSeparator,
		    countTotal = _ref.countTotal,
		    showCount = _ref.showCount,
		    props = _objectWithoutProperties(_ref, ['caption', 'countCurrent', 'countSeparator', 'countTotal', 'showCount']);
	
		if (!caption && !showCount) return null;
	
		var classes = _noImportant.StyleSheet.create((0, _deepMerge2.default)(defaultStyles, theme));
	
		var imageCount = showCount ? _react2.default.createElement(
			'div',
			{ className: (0, _noImportant.css)(classes.footerCount) },
			countCurrent,
			countSeparator,
			countTotal
		) : _react2.default.createElement('span', null);
	
		return _react2.default.createElement(
			'div',
			_extends({ className: (0, _noImportant.css)(classes.footer) }, props),
			caption ? _react2.default.createElement(
				'figcaption',
				{ className: (0, _noImportant.css)(classes.footerCaption) },
				caption
			) : _react2.default.createElement('span', null),
			imageCount
		);
	}
	
	Footer.propTypes = {
		caption: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
		countCurrent: _propTypes2.default.number,
		countSeparator: _propTypes2.default.string,
		countTotal: _propTypes2.default.number,
		showCount: _propTypes2.default.bool
	};
	Footer.contextTypes = {
		theme: _propTypes2.default.object.isRequired
	};
	
	var defaultStyles = {
		footer: {
			boxSizing: 'border-box',
			color: _theme2.default.footer.color,
			cursor: 'auto',
			display: 'flex',
			justifyContent: 'space-between',
			left: 0,
			lineHeight: 1.3,
			paddingBottom: _theme2.default.footer.gutter.vertical,
			paddingLeft: _theme2.default.footer.gutter.horizontal,
			paddingRight: _theme2.default.footer.gutter.horizontal,
			paddingTop: _theme2.default.footer.gutter.vertical
		},
		footerCount: {
			color: _theme2.default.footer.count.color,
			fontSize: _theme2.default.footer.count.fontSize,
			paddingLeft: '1em' // add a small gutter for the caption
		},
		footerCaption: {
			flex: '1 1 0'
		}
	};
	
	exports.default = Footer;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _noImportant = __webpack_require__(14);
	
	var _theme = __webpack_require__(25);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _deepMerge = __webpack_require__(51);
	
	var _deepMerge2 = _interopRequireDefault(_deepMerge);
	
	var _Icon = __webpack_require__(177);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function Header(_ref, _ref2) {
		var theme = _ref2.theme;
	
		var customControls = _ref.customControls,
		    onClose = _ref.onClose,
		    showCloseButton = _ref.showCloseButton,
		    closeButtonTitle = _ref.closeButtonTitle,
		    props = _objectWithoutProperties(_ref, ['customControls', 'onClose', 'showCloseButton', 'closeButtonTitle']);
	
		var classes = _noImportant.StyleSheet.create((0, _deepMerge2.default)(defaultStyles, theme));
	
		return _react2.default.createElement(
			'div',
			_extends({ className: (0, _noImportant.css)(classes.header) }, props),
			customControls ? customControls : _react2.default.createElement('span', null),
			!!showCloseButton && _react2.default.createElement(
				'button',
				{
					title: closeButtonTitle,
					className: (0, _noImportant.css)(classes.close),
					onClick: onClose
				},
				_react2.default.createElement(_Icon2.default, { fill: !!theme.close && theme.close.fill || _theme2.default.close.fill, type: 'close' })
			)
		);
	}
	
	Header.propTypes = {
		customControls: _propTypes2.default.array,
		onClose: _propTypes2.default.func.isRequired,
		showCloseButton: _propTypes2.default.bool
	};
	Header.contextTypes = {
		theme: _propTypes2.default.object.isRequired
	};
	
	var defaultStyles = {
		header: {
			display: 'flex',
			justifyContent: 'space-between',
			height: _theme2.default.header.height
		},
		close: {
			background: 'none',
			border: 'none',
			cursor: 'pointer',
			outline: 'none',
			position: 'relative',
			top: 0,
			verticalAlign: 'bottom',
			zIndex: 1,
	
			// increase hit area
			height: 40,
			marginRight: -10,
			padding: 10,
			width: 40
		}
	};
	
	exports.default = Header;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _noImportant = __webpack_require__(14);
	
	var _Thumbnail = __webpack_require__(397);
	
	var _Thumbnail2 = _interopRequireDefault(_Thumbnail);
	
	var _Arrow = __webpack_require__(176);
	
	var _Arrow2 = _interopRequireDefault(_Arrow);
	
	var _theme = __webpack_require__(25);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var classes = _noImportant.StyleSheet.create({
		paginatedThumbnails: {
			bottom: _theme2.default.container.gutter.vertical,
			height: _theme2.default.thumbnail.size,
			padding: '0 50px',
			position: 'absolute',
			textAlign: 'center',
			whiteSpace: 'nowrap',
			left: '50%',
			transform: 'translateX(-50%)'
		}
	});
	
	var arrowStyles = {
		height: _theme2.default.thumbnail.size + _theme2.default.thumbnail.gutter * 2,
		width: 40
	};
	
	var PaginatedThumbnails = function (_Component) {
		_inherits(PaginatedThumbnails, _Component);
	
		function PaginatedThumbnails(props) {
			_classCallCheck(this, PaginatedThumbnails);
	
			var _this = _possibleConstructorReturn(this, (PaginatedThumbnails.__proto__ || Object.getPrototypeOf(PaginatedThumbnails)).call(this, props));
	
			_this.state = {
				hasCustomPage: false
			};
	
			_this.gotoPrev = _this.gotoPrev.bind(_this);
			_this.gotoNext = _this.gotoNext.bind(_this);
			return _this;
		}
	
		_createClass(PaginatedThumbnails, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				// Component should be controlled, flush state when currentImage changes
				if (nextProps.currentImage !== this.props.currentImage) {
					this.setState({
						hasCustomPage: false
					});
				}
			}
	
			// ==============================
			// METHODS
			// ==============================
	
		}, {
			key: 'getFirst',
			value: function getFirst() {
				var _props = this.props,
				    currentImage = _props.currentImage,
				    offset = _props.offset;
	
				if (this.state.hasCustomPage) {
					return this.clampFirst(this.state.first);
				}
				return this.clampFirst(currentImage - offset);
			}
		}, {
			key: 'setFirst',
			value: function setFirst(event, newFirst) {
				var first = this.state.first;
	
	
				if (event) {
					event.preventDefault();
					event.stopPropagation();
				}
	
				if (first === newFirst) return;
	
				this.setState({
					hasCustomPage: true,
					first: newFirst
				});
			}
		}, {
			key: 'gotoPrev',
			value: function gotoPrev(event) {
				this.setFirst(event, this.getFirst() - this.props.offset);
			}
		}, {
			key: 'gotoNext',
			value: function gotoNext(event) {
				this.setFirst(event, this.getFirst() + this.props.offset);
			}
		}, {
			key: 'clampFirst',
			value: function clampFirst(value) {
				var _props2 = this.props,
				    images = _props2.images,
				    offset = _props2.offset;
	
	
				var totalCount = 2 * offset + 1; // show $offset extra thumbnails on each side
	
				if (value < 0) {
					return 0;
				} else if (value + totalCount > images.length) {
					// Too far
					return images.length - totalCount;
				} else {
					return value;
				}
			}
	
			// ==============================
			// RENDERERS
			// ==============================
	
		}, {
			key: 'renderArrowPrev',
			value: function renderArrowPrev() {
				if (this.getFirst() <= 0) return null;
	
				return _react2.default.createElement(_Arrow2.default, {
					direction: 'left',
					size: 'small',
					icon: 'arrowLeft',
					onClick: this.gotoPrev,
					style: arrowStyles,
					title: 'Previous (Left arrow key)',
					type: 'button'
				});
			}
		}, {
			key: 'renderArrowNext',
			value: function renderArrowNext() {
				var _props3 = this.props,
				    offset = _props3.offset,
				    images = _props3.images;
	
				var totalCount = 2 * offset + 1;
				if (this.getFirst() + totalCount >= images.length) return null;
	
				return _react2.default.createElement(_Arrow2.default, {
					direction: 'right',
					size: 'small',
					icon: 'arrowRight',
					onClick: this.gotoNext,
					style: arrowStyles,
					title: 'Next (Right arrow key)',
					type: 'button'
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _props4 = this.props,
				    images = _props4.images,
				    currentImage = _props4.currentImage,
				    onClickThumbnail = _props4.onClickThumbnail,
				    offset = _props4.offset;
	
	
				var totalCount = 2 * offset + 1; // show $offset extra thumbnails on each side
				var thumbnails = [];
				var baseOffset = 0;
				if (images.length <= totalCount) {
					thumbnails = images;
				} else {
					// Try to center current image in list
					baseOffset = this.getFirst();
					thumbnails = images.slice(baseOffset, baseOffset + totalCount);
				}
	
				return _react2.default.createElement(
					'div',
					{ className: (0, _noImportant.css)(classes.paginatedThumbnails) },
					this.renderArrowPrev(),
					thumbnails.map(function (img, idx) {
						return _react2.default.createElement(_Thumbnail2.default, _extends({ key: baseOffset + idx
						}, img, {
							index: baseOffset + idx,
							onClick: onClickThumbnail,
							active: baseOffset + idx === currentImage }));
					}),
					this.renderArrowNext()
				);
			}
		}]);
	
		return PaginatedThumbnails;
	}(_react.Component);
	
	exports.default = PaginatedThumbnails;
	
	
	PaginatedThumbnails.propTypes = {
		currentImage: _propTypes2.default.number,
		images: _propTypes2.default.array,
		offset: _propTypes2.default.number,
		onClickThumbnail: _propTypes2.default.func.isRequired
	};

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Pass the Lightbox context through to the Portal's descendents
	// StackOverflow discussion http://goo.gl/oclrJ9
	
	var PassContext = function (_Component) {
		_inherits(PassContext, _Component);
	
		function PassContext() {
			_classCallCheck(this, PassContext);
	
			return _possibleConstructorReturn(this, (PassContext.__proto__ || Object.getPrototypeOf(PassContext)).apply(this, arguments));
		}
	
		_createClass(PassContext, [{
			key: 'getChildContext',
			value: function getChildContext() {
				return this.props.context;
			}
		}, {
			key: 'render',
			value: function render() {
				return _react.Children.only(this.props.children);
			}
		}]);
	
		return PassContext;
	}(_react.Component);
	
	PassContext.propTypes = {
		context: _propTypes2.default.object.isRequired
	};
	PassContext.childContextTypes = {
		theme: _propTypes2.default.object
	};
	
	exports.default = PassContext;

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTransitionGroup = __webpack_require__(428);
	
	var _reactDom = __webpack_require__(61);
	
	var _PassContext = __webpack_require__(394);
	
	var _PassContext2 = _interopRequireDefault(_PassContext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Portal = function (_Component) {
		_inherits(Portal, _Component);
	
		function Portal() {
			_classCallCheck(this, Portal);
	
			var _this = _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this));
	
			_this.portalElement = null;
			return _this;
		}
	
		_createClass(Portal, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var p = document.createElement('div');
				document.body.appendChild(p);
				this.portalElement = p;
				this.componentDidUpdate();
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				// Animate fade on mount/unmount
				var duration = 200;
				var styles = '\n\t\t\t\t.fade-enter { opacity: 0.01; }\n\t\t\t\t.fade-enter.fade-enter-active { opacity: 1; transition: opacity ' + duration + 'ms; }\n\t\t\t\t.fade-leave { opacity: 1; }\n\t\t\t\t.fade-leave.fade-leave-active { opacity: 0.01; transition: opacity ' + duration + 'ms; }\n\t\t';
	
				(0, _reactDom.render)(_react2.default.createElement(
					_PassContext2.default,
					{ context: this.context },
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'style',
							null,
							styles
						),
						_react2.default.createElement(
							_reactTransitionGroup.TransitionGroup,
							this.props,
							_react2.default.createElement(
								_reactTransitionGroup.CSSTransition,
								{ timeout: { enter: duration, exit: duration }, classNames: 'fade' },
								this.props.children
							)
						)
					)
				), this.portalElement);
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				(0, _reactDom.unmountComponentAtNode)(this.portalElement);
				document.body.removeChild(this.portalElement);
			}
		}, {
			key: 'render',
			value: function render() {
				return null;
			}
		}]);
	
		return Portal;
	}(_react.Component);
	
	exports.default = Portal;
	
	
	Portal.contextTypes = {
		theme: _propTypes2.default.object.isRequired
	};

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _noImportant = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Spinner = function Spinner(props) {
		var classes = _noImportant.StyleSheet.create(styles(props));
	
		return _react2.default.createElement(
			'div',
			{ className: (0, _noImportant.css)(classes.spinner) },
			_react2.default.createElement('div', { className: (0, _noImportant.css)(classes.ripple) })
		);
	};
	
	Spinner.propTypes = {
		color: _propTypes2.default.string,
		size: _propTypes2.default.number
	};
	
	var rippleKeyframes = {
		'0%': {
			top: '50%',
			left: '50%',
			width: 0,
			height: 0,
			opacity: 1
		},
		'100%': {
			top: 0,
			left: 0,
			width: '100%',
			height: '100%',
			opacity: 0
		}
	};
	
	var styles = function styles(_ref) {
		var color = _ref.color,
		    size = _ref.size;
		return {
			spinner: {
				display: 'inline-block',
				position: 'relative',
				width: size,
				height: size
			},
			ripple: {
				position: 'absolute',
				border: '4px solid ' + color,
				opacity: 1,
				borderRadius: '50%',
				animationName: rippleKeyframes,
				animationDuration: '1s',
				animationTimingFunction: 'cubic-bezier(0, 0.2, 0.8, 1)',
				animationIterationCount: 'infinite'
			}
		};
	};
	
	exports.default = Spinner;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _noImportant = __webpack_require__(14);
	
	var _theme = __webpack_require__(25);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _deepMerge = __webpack_require__(51);
	
	var _deepMerge2 = _interopRequireDefault(_deepMerge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Thumbnail(_ref, _ref2) {
		var index = _ref.index,
		    src = _ref.src,
		    thumbnail = _ref.thumbnail,
		    active = _ref.active,
		    _onClick = _ref.onClick;
		var theme = _ref2.theme;
	
		var url = thumbnail ? thumbnail : src;
		var classes = _noImportant.StyleSheet.create((0, _deepMerge2.default)(defaultStyles, theme));
	
		return _react2.default.createElement('div', {
			className: (0, _noImportant.css)(classes.thumbnail, active && classes.thumbnail__active),
			onClick: function onClick(e) {
				e.preventDefault();
				e.stopPropagation();
				_onClick(index);
			},
			style: { backgroundImage: 'url("' + url + '")' }
		});
	}
	
	Thumbnail.propTypes = {
		active: _propTypes2.default.bool,
		index: _propTypes2.default.number,
		onClick: _propTypes2.default.func.isRequired,
		src: _propTypes2.default.string,
		thumbnail: _propTypes2.default.string
	};
	
	Thumbnail.contextTypes = {
		theme: _propTypes2.default.object.isRequired
	};
	
	var defaultStyles = {
		thumbnail: {
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			borderRadius: 2,
			boxShadow: 'inset 0 0 0 1px hsla(0,0%,100%,.2)',
			cursor: 'pointer',
			display: 'inline-block',
			height: _theme2.default.thumbnail.size,
			margin: _theme2.default.thumbnail.gutter,
			overflow: 'hidden',
			width: _theme2.default.thumbnail.size
		},
		thumbnail__active: {
			boxShadow: 'inset 0 0 0 2px ' + _theme2.default.thumbnail.activeBorderColor
		}
	};
	
	exports.default = Thumbnail;

/***/ }),
/* 398 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (fill) {
		return "<svg fill=\"" + fill + "\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"100%\" height=\"100%\" viewBox=\"0 0 512 512\" xml:space=\"preserve\">\n\t\t<path d=\"M213.7,256L213.7,256L213.7,256L380.9,81.9c4.2-4.3,4.1-11.4-0.2-15.8l-29.9-30.6c-4.3-4.4-11.3-4.5-15.5-0.2L131.1,247.9 c-2.2,2.2-3.2,5.2-3,8.1c-0.1,3,0.9,5.9,3,8.1l204.2,212.7c4.2,4.3,11.2,4.2,15.5-0.2l29.9-30.6c4.3-4.4,4.4-11.5,0.2-15.8 L213.7,256z\"/>\n\t</svg>";
	};

/***/ }),
/* 399 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (fill) {
		return "<svg fill=\"" + fill + "\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"100%\" height=\"100%\" viewBox=\"0 0 512 512\" xml:space=\"preserve\">\n\t\t<path d=\"M298.3,256L298.3,256L298.3,256L131.1,81.9c-4.2-4.3-4.1-11.4,0.2-15.8l29.9-30.6c4.3-4.4,11.3-4.5,15.5-0.2l204.2,212.7 c2.2,2.2,3.2,5.2,3,8.1c0.1,3-0.9,5.9-3,8.1L176.7,476.8c-4.2,4.3-11.2,4.2-15.5-0.2L131.3,446c-4.3-4.4-4.4-11.5-0.2-15.8 L298.3,256z\"/>\n\t</svg>";
	};

/***/ }),
/* 400 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (fill) {
		return "<svg fill=\"" + fill + "\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"100%\" height=\"100%\" viewBox=\"0 0 512 512\" style=\"enable-background:new 0 0 512 512;\" xml:space=\"preserve\">\n\t\t<path d=\"M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4 L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1 c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1 c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z\"/>\n\t</svg>";
	};

/***/ }),
/* 401 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = bindFunctions;
	/**
		Bind multiple component methods:
	
		* @param {this} context
		* @param {Array} functions
	
		constructor() {
			...
			bindFunctions.call(this, ['handleClick', 'handleOther']);
		}
	*/
	
	function bindFunctions(functions) {
		var _this = this;
	
		functions.forEach(function (f) {
			return _this[f] = _this[f].bind(_this);
		});
	};

/***/ }),
/* 402 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	// Return true if window + document
	
	exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PropToggle = __webpack_require__(179);
	
	var _PropToggle2 = _interopRequireDefault(_PropToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var LifeCycleProvider = function LifeCycleProvider(_ref) {
	  var isActive = _ref.isActive,
	      props = _objectWithoutProperties(_ref, ['isActive']);
	
	  return isActive ? _react2.default.createElement(_PropToggle2.default, props) : null;
	};
	
	LifeCycleProvider.defaultProps = _PropToggle.defaultProps;
	
	exports.default = LifeCycleProvider;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _LifeCycleProvider = __webpack_require__(403);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LifeCycleProvider).default;
	  }
	});
	
	var _PropToggle = __webpack_require__(179);
	
	Object.defineProperty(exports, 'SimpleToggle', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PropToggle).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(81);
	
	var _reactPropToggle = __webpack_require__(404);
	
	var _utils = __webpack_require__(186);
	
	var _withTouchListeners = __webpack_require__(424);
	
	var _withTouchListeners2 = _interopRequireDefault(_withTouchListeners);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LOCK_COUNT = 0;
	
	var ScrollLock = function (_PureComponent) {
	  _inherits(ScrollLock, _PureComponent);
	
	  function ScrollLock() {
	    _classCallCheck(this, ScrollLock);
	
	    return _possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
	  }
	
	  _createClass(ScrollLock, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      LOCK_COUNT++;
	      if (_exenv.canUseDOM) {
	        this.initialHeight = window.innerHeight;
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      LOCK_COUNT = Math.max(LOCK_COUNT - 1, 0);
	
	      if (_exenv.canUseDOM) {
	        var offset = window.innerHeight - this.initialHeight;
	
	        // adjust scroll if the window has been resized since the lock was engaged
	        if (offset) {
	          window.scrollTo(0, window.pageYOffset + offset);
	        }
	      }
	
	      // reset the initial height in case this scroll lock is used again
	      this.initialHeight = window.innerHeight;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var accountForScrollbars = this.props.accountForScrollbars;
	
	      // avoid overly incrementing padding
	
	      var scrollbarSpacer = accountForScrollbars && LOCK_COUNT < 1 ? { 'padding-right': (0, _utils.getPadding)() + 'px' } : {};
	
	      var height = (0, _utils.getDocumentHeight)() + 'px';
	
	      return _react2.default.createElement(_reactPropToggle.SimpleToggle, {
	        styles: _extends({
	          'box-sizing': 'border-box', // account for possible declaration `width: 100%;` on body
	          overflow: 'hidden',
	          position: 'relative',
	          height: height
	        }, scrollbarSpacer)
	      });
	    }
	  }]);
	
	  return ScrollLock;
	}(_react.PureComponent);
	
	ScrollLock.defaultProps = {
	  accountForScrollbars: true
	};
	exports.default = (0, _withTouchListeners2.default)(ScrollLock);

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ScrollLock = __webpack_require__(422);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ScrollLock).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = withTouchListeners;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(81);
	
	var _utils = __webpack_require__(186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withTouchListeners(WrappedComponent) {
	  return function (_PureComponent) {
	    _inherits(TouchProvider, _PureComponent);
	
	    function TouchProvider() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, TouchProvider);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).call.apply(_ref, [this].concat(args))), _this), _this.listenerOptions = {
	        capture: false,
	        passive: false
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(TouchProvider, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        if (!_exenv.canUseDOM) return;
	
	        var touchScrollTarget = this.props.touchScrollTarget;
	
	        var target = document.body;
	
	        // account for touch devices
	        if (target && (0, _utils.isTouchDevice)()) {
	          // Mobile Safari ignores { overflow: hidden } declaration on the body.
	          target.addEventListener('touchmove', _utils.preventTouchMove, this.listenerOptions);
	
	          // Allow scroll on provided target
	          if (touchScrollTarget) {
	            touchScrollTarget.addEventListener('touchstart', _utils.preventInertiaScroll, this.listenerOptions);
	            touchScrollTarget.addEventListener('touchmove', _utils.allowTouchMove, this.listenerOptions);
	          }
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (!_exenv.canUseDOM) return;
	
	        var touchScrollTarget = this.props.touchScrollTarget;
	
	        var target = document.body;
	
	        // remove touch listeners
	        if (target && (0, _utils.isTouchDevice)()) {
	          target.removeEventListener('touchmove', _utils.preventTouchMove, this.listenerOptions);
	
	          if (touchScrollTarget) {
	            touchScrollTarget.removeEventListener('touchstart', _utils.preventInertiaScroll, this.listenerOptions);
	            touchScrollTarget.removeEventListener('touchmove', _utils.allowTouchMove, this.listenerOptions);
	          }
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      }
	    }]);
	
	    return TouchProvider;
	  }(_react.PureComponent);
	}

/***/ }),
/* 425 */,
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(83));
	
	var _addClass = _interopRequireDefault(__webpack_require__(341));
	
	var _removeClass = _interopRequireDefault(__webpack_require__(343));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _Transition = _interopRequireDefault(__webpack_require__(187));
	
	var _PropTypes = __webpack_require__(189);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var addClass = function addClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass.default)(node, c);
	  });
	};
	
	var removeClass = function removeClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass.default)(node, c);
	  });
	};
	
	var propTypes =  false ? _extends({}, _Transition.default.propTypes, {
	  /**
	   * The animation classNames applied to the component as it enters, exits or has finished the transition.
	   * A single name can be provided and it will be suffixed for each stage: e.g.
	   *
	   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`, `fade-enter-done`,
	   * `fade-exit`, `fade-exit-active`, `fade-exit-done`, `fade-appear`, and `fade-appear-active`.
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  enterDone: 'my-done-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   *  exitDone: 'my-done-exit',
	   * }}
	   * ```
	   *
	   * If you want to set these classes using CSS Modules:
	   *
	   * ```js
	   * import styles from './styles.css';
	   * ```
	   *
	   * you might want to use camelCase in your CSS file, that way could simply spread
	   * them instead of listing them one by one:
	   *
	   * ```js
	   * classNames={{ ...styles }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  enterDone?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   *  exitDone?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** and the `exit-done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: PropTypes.func
	}) : {};;
	/**
	 * A `Transition` component using CSS transitions and animations.
	 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` stages of the transition. The first class is applied and then a
	 * second "active" class in order to activate the css animation. After the animation,
	 * matching `done` class names are applied to persist the animation state.
	 *
	 * When the `in` prop is toggled to `true` the Component will get
	 * the `example-enter` CSS class and the `example-enter-active` CSS class
	 * added in the next tick. This is a convention based on the `classNames` prop.
	 */
	
	var CSSTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	
	    _this.onEnter = function (node, appearing) {
	      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          className = _this$getClassNames.className;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, className);
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node, appearing);
	      }
	    };
	
	    _this.onEntering = function (node, appearing) {
	      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          activeClassName = _this$getClassNames2.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node, appearing);
	      }
	    };
	
	    _this.onEntered = function (node, appearing) {
	      var _this$getClassNames3 = _this.getClassNames('enter'),
	          doneClassName = _this$getClassNames3.doneClassName;
	
	      _this.removeClasses(node, appearing ? 'appear' : 'enter');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(node, appearing);
	      }
	    };
	
	    _this.onExit = function (node) {
	      var _this$getClassNames4 = _this.getClassNames('exit'),
	          className = _this$getClassNames4.className;
	
	      _this.removeClasses(node, 'appear');
	
	      _this.removeClasses(node, 'enter');
	
	      addClass(node, className);
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    };
	
	    _this.onExiting = function (node) {
	      var _this$getClassNames5 = _this.getClassNames('exit'),
	          activeClassName = _this$getClassNames5.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(node);
	      }
	    };
	
	    _this.onExited = function (node) {
	      var _this$getClassNames6 = _this.getClassNames('exit'),
	          doneClassName = _this$getClassNames6.doneClassName;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    };
	
	    _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;
	      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';
	      var doneClassName = typeof classNames !== 'string' ? classNames[type + 'Done'] : className + '-done';
	      return {
	        className: className,
	        activeClassName: activeClassName,
	        doneClassName: doneClassName
	      };
	    };
	
	    return _this;
	  }
	
	  var _proto = CSSTransition.prototype;
	
	  _proto.removeClasses = function removeClasses(node, type) {
	    var _this$getClassNames7 = this.getClassNames(type),
	        className = _this$getClassNames7.className,
	        activeClassName = _this$getClassNames7.activeClassName,
	        doneClassName = _this$getClassNames7.doneClassName;
	
	    className && removeClass(node, className);
	    activeClassName && removeClass(node, activeClassName);
	    doneClassName && removeClass(node, doneClassName);
	  };
	
	  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
	    // This is for to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	    if (className) {
	      /* eslint-disable no-unused-expressions */
	      node && node.scrollTop;
	      /* eslint-enable no-unused-expressions */
	
	      addClass(node, className);
	    }
	  };
	
	  _proto.render = function render() {
	    var props = _extends({}, this.props);
	
	    delete props.classNames;
	    return _react.default.createElement(_Transition.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react.default.Component);
	
	CSSTransition.propTypes =  false ? propTypes : {};
	var _default = CSSTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(83));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = __webpack_require__(61);
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(188));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var propTypes =  false ? {
	  in: _propTypes.default.bool.isRequired,
	  children: function children(props, propName) {
	    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
	    return null;
	  }
	} : {};;
	/**
	 * The `<ReplaceTransition>` component is a specialized `Transition` component
	 * that animates between two children.
	 *
	 * ```jsx
	 * <ReplaceTransition in>
	 *   <Fade><div>I appear first</div></Fade>
	 *   <Fade><div>I replace the above</div></Fade>
	 * </ReplaceTransition>
	 * ```
	 */
	
	var ReplaceTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(ReplaceTransition, _React$Component);
	
	  function ReplaceTransition() {
	    var _this;
	
	    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	      _args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
	
	    _this.handleEnter = function () {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _this.handleLifecycle('onEnter', 0, args);
	    };
	
	    _this.handleEntering = function () {
	      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      return _this.handleLifecycle('onEntering', 0, args);
	    };
	
	    _this.handleEntered = function () {
	      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }
	
	      return _this.handleLifecycle('onEntered', 0, args);
	    };
	
	    _this.handleExit = function () {
	      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	        args[_key5] = arguments[_key5];
	      }
	
	      return _this.handleLifecycle('onExit', 1, args);
	    };
	
	    _this.handleExiting = function () {
	      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	        args[_key6] = arguments[_key6];
	      }
	
	      return _this.handleLifecycle('onExiting', 1, args);
	    };
	
	    _this.handleExited = function () {
	      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	        args[_key7] = arguments[_key7];
	      }
	
	      return _this.handleLifecycle('onExited', 1, args);
	    };
	
	    return _this;
	  }
	
	  var _proto = ReplaceTransition.prototype;
	
	  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
	    var _child$props;
	
	    var children = this.props.children;
	
	    var child = _react.default.Children.toArray(children)[idx];
	
	    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
	    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        inProp = _this$props.in,
	        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);
	
	    var _React$Children$toArr = _react.default.Children.toArray(children),
	        first = _React$Children$toArr[0],
	        second = _React$Children$toArr[1];
	
	    delete props.onEnter;
	    delete props.onEntering;
	    delete props.onEntered;
	    delete props.onExit;
	    delete props.onExiting;
	    delete props.onExited;
	    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
	      key: 'first',
	      onEnter: this.handleEnter,
	      onEntering: this.handleEntering,
	      onEntered: this.handleEntered
	    }) : _react.default.cloneElement(second, {
	      key: 'second',
	      onEnter: this.handleExit,
	      onEntering: this.handleExiting,
	      onEntered: this.handleExited
	    }));
	  };
	
	  return ReplaceTransition;
	}(_react.default.Component);
	
	ReplaceTransition.propTypes =  false ? propTypes : {};
	var _default = ReplaceTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _CSSTransition = _interopRequireDefault(__webpack_require__(426));
	
	var _ReplaceTransition = _interopRequireDefault(__webpack_require__(427));
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(188));
	
	var _Transition = _interopRequireDefault(__webpack_require__(187));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  Transition: _Transition.default,
	  TransitionGroup: _TransitionGroup.default,
	  ReplaceTransition: _ReplaceTransition.default,
	  CSSTransition: _CSSTransition.default
	};

/***/ }),
/* 429 */,
/* 430 */,
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	exports.getInitialChildMapping = getInitialChildMapping;
	exports.getNextChildMapping = getNextChildMapping;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	
	
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  } // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	
	
	  var nextKeysPending = Object.create(null);
	  var pendingKeys = [];
	
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i;
	  var childMapping = {};
	
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	
	    childMapping[nextKey] = getValueForKey(nextKey);
	  } // Finally, add the keys which didn't appear before any key in `next`
	
	
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}
	
	function getProp(child, prop, props) {
	  return props[prop] != null ? props[prop] : child.props[prop];
	}
	
	function getInitialChildMapping(props, onExited) {
	  return getChildMapping(props.children, function (child) {
	    return (0, _react.cloneElement)(child, {
	      onExited: onExited.bind(null, child),
	      in: true,
	      appear: getProp(child, 'appear', props),
	      enter: getProp(child, 'enter', props),
	      exit: getProp(child, 'exit', props)
	    });
	  });
	}
	
	function getNextChildMapping(nextProps, prevChildMapping, onExited) {
	  var nextChildMapping = getChildMapping(nextProps.children);
	  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
	  Object.keys(children).forEach(function (key) {
	    var child = children[key];
	    if (!(0, _react.isValidElement)(child)) return;
	    var hasPrev = key in prevChildMapping;
	    var hasNext = key in nextChildMapping;
	    var prevChild = prevChildMapping[key];
	    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
	
	    if (hasNext && (!hasPrev || isLeaving)) {
	      // console.log('entering', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: true,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    } else if (!hasNext && hasPrev && !isLeaving) {
	      // item is old (exiting)
	      // console.log('leaving', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        in: false
	      });
	    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	      // item hasn't changed transition states
	      // copy over the last transition props;
	      // console.log('unchanged', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: prevChild.props.in,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    }
	  });
	  return children;
	}

/***/ }),
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHZpZXdCb3g9IjAgMCAzMC42MiAzMC42MiI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSwuY2xzLTR7ZmlsbDpub25lO30KICAgICAgLmNscy0ye2NsaXAtcGF0aDp1cmwoI2NsaXAtcGF0aCk7fQogICAgICAuY2xzLTN7ZmlsbDpjdXJyZW50Q29sb3I7fQogICAgICAuY2xzLTR7c3Ryb2tlOiNmZmY7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDoyLjQzcHg7fTwvc3R5bGU+CiAgICA8Y2xpcFBhdGggaWQ9ImNsaXAtcGF0aCI+CiAgICAgIDxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjMwLjYyIiBoZWlnaHQ9IjMwLjYyIi8+CiAgICA8L2NsaXBQYXRoPgogIDwvZGVmcz4KICA8dGl0bGU+RWxlbWVudCA4PC90aXRsZT4KICA8ZyBpZD0iRWJlbmVfMiIgZGF0YS1uYW1lPSJFYmVuZSAyIj4KICAgIDxnIGlkPSJFYmVuZV8xLTIiIGRhdGEtbmFtZT0iRWJlbmUgMSI+CiAgICAgIDxnIGNsYXNzPSJjbHMtMiI+CiAgICAgICAgPHBhdGggY2xhc3M9ImNscy0zIiBkPSJNMTgsMzAuMzlBMTUuMzEsMTUuMzEsMCwxLDAsLjI0LDE4LDE1LjMxLDE1LjMxLDAsMCwwLDE4LDMwLjM5Ii8+CiAgICAgIDwvZz4KICAgICAgPGxpbmUgY2xhc3M9ImNscy00IiB4MT0iNi44MSIgeTE9IjE1LjMxIiB4Mj0iMjMuODIiIHkyPSIxNS4zMSIvPgogICAgICA8bGluZSBjbGFzcz0iY2xzLTQiIHgxPSIxNS4zMSIgeTE9IjIzLjgyIiB4Mj0iMTUuMzEiIHkyPSI2LjgxIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),
/* 438 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/DPLLogo-248x165.6b113574.png";

/***/ }),
/* 440 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSJub25lIiBkPSJNMCAwaDI0djI0SDBWMHoiLz48cGF0aCBkPSJNMTkgMTlINVY1aDdWM0g1Yy0xLjExIDAtMiAuOS0yIDJ2MTRjMCAxLjEuODkgMiAyIDJoMTRjMS4xIDAgMi0uOSAyLTJ2LTdoLTJ2N3pNMTQgM3YyaDMuNTlsLTkuODMgOS44MyAxLjQxIDEuNDFMMTkgNi40MVYxMGgyVjNoLTd6Ii8+PC9zdmc+"

/***/ }),
/* 441 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSJub25lIiBkPSJNMCAwaDI0djI0SDBWMHoiLz48cGF0aCBkPSJNMTkgNXYxNEg1VjVoMTRtMC0ySDVjLTEuMSAwLTIgLjktMiAydjE0YzAgMS4xLjkgMiAyIDJoMTRjMS4xIDAgMi0uOSAyLTJWNWMwLTEuMS0uOS0yLTItMnptLTQuODYgOC44NmwtMyAzLjg3TDkgMTMuMTQgNiAxN2gxMmwtMy44Ni01LjE0eiIvPjwvc3ZnPg=="

/***/ }),
/* 442 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSJub25lIiBkPSJNMCAwaDI0djI0SDBWMHoiLz48cGF0aCBkPSJNMTkgMTlINVY1aDdWM0g1Yy0xLjExIDAtMiAuOS0yIDJ2MTRjMCAxLjEuODkgMiAyIDJoMTRjMS4xIDAgMi0uOSAyLTJ2LTdoLTJ2N3pNMTQgM3YyaDMuNTlsLTkuODMgOS44MyAxLjQxIDEuNDFMMTkgNi40MVYxMGgyVjNoLTd6Ii8+PC9zdmc+"

/***/ }),
/* 443 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSJub25lIiBkPSJNMCAwaDI0djI0SDBWMHoiLz48cGF0aCBkPSJNNCA2LjQ3TDUuNzYgMTBIMjB2OEg0VjYuNDdNMjIgNGgtNGwyIDRoLTNsLTItNGgtMmwyIDRoLTNsLTItNEg4bDIgNEg3TDUgNEg0Yy0xLjEgMC0xLjk5LjktMS45OSAyTDIgMThjMCAxLjEuOSAyIDIgMmgxNmMxLjEgMCAyLS45IDItMlY0eiIvPjwvc3ZnPg=="

/***/ }),
/* 444 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSJub25lIiBkPSJNMCAwaDI0djI0SDBWMHoiLz48cGF0aCBkPSJNMjAgMkg4Yy0xLjEgMC0yIC45LTIgMnYxMmMwIDEuMS45IDIgMiAyaDEyYzEuMSAwIDItLjkgMi0yVjRjMC0xLjEtLjktMi0yLTJ6bTAgMTRIOFY0aDEydjEyek00IDZIMnYxNGMwIDEuMS45IDIgMiAyaDE0di0ySDRWNnptMTIgNlY5YzAtLjU1LS40NS0xLTEtMWgtMnY1aDJjLjU1IDAgMS0uNDUgMS0xem0tMi0zaDF2M2gtMVY5em00IDJoMXYtMWgtMVY5aDFWOGgtMnY1aDF6bS04IDBoMWMuNTUgMCAxLS40NSAxLTFWOWMwLS41NS0uNDUtMS0xLTFIOXY1aDF2LTJ6bTAtMmgxdjFoLTFWOXoiLz48L3N2Zz4="

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Grafik_Download.a1ba5357.svg";

/***/ }),
/* 446 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSJub25lIiBkPSJNMCAwaDI0djI0SDBWMHoiLz48cGF0aCBkPSJNMTQuNTkgOEwxMiAxMC41OSA5LjQxIDggOCA5LjQxIDEwLjU5IDEyIDggMTQuNTkgOS40MSAxNiAxMiAxMy40MSAxNC41OSAxNiAxNiAxNC41OSAxMy40MSAxMiAxNiA5LjQxIDE0LjU5IDh6TTEyIDJDNi40NyAyIDIgNi40NyAyIDEyczQuNDcgMTAgMTAgMTAgMTAtNC40NyAxMC0xMFMxNy41MyAyIDEyIDJ6bTAgMThjLTQuNDEgMC04LTMuNTktOC04czMuNTktOCA4LTggOCAzLjU5IDggOC0zLjU5IDgtOCA4eiIvPjwvc3ZnPg=="

/***/ }),
/* 447 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgMzQuNjIgODIuMiI+PGRlZnM+PHN0eWxlPi5jbHMtMSwuY2xzLTMsLmNscy00e2ZpbGw6bm9uZTt9LmNscy0ye2NsaXAtcGF0aDp1cmwoI2NsaXAtcGF0aCk7fS5jbHMtMywuY2xzLTR7c3Ryb2tlOiMxZDFkMWI7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDoycHg7fS5jbHMtM3tzdHJva2UtZGFzaGFycmF5OjAgNC4wMTt9PC9zdHlsZT48Y2xpcFBhdGggaWQ9ImNsaXAtcGF0aCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTAuNCkiPjxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjM1IiBoZWlnaHQ9IjgyLjEiLz48L2NsaXBQYXRoPjwvZGVmcz48dGl0bGU+RWxlbWVudCAxNTwvdGl0bGU+PGcgaWQ9IkViZW5lXzIiIGRhdGEtbmFtZT0iRWJlbmUgMiI+PGcgaWQ9IkViZW5lXzEtMiIgZGF0YS1uYW1lPSJFYmVuZSAxIj48ZyBjbGFzcz0iY2xzLTIiPjxwYXRoIGNsYXNzPSJjbHMtMyIgZD0iTTMxLjUsNC45YzMsMTQsMTAsNjEuMy0yOC4xLDcyLjQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0wLjQpIi8+PC9nPjxnIGNsYXNzPSJjbHMtMiI+PHBhdGggY2xhc3M9ImNscy00IiBkPSJNMS40LDc3LjloME0zMC42LDFoMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTAuNCkiLz48L2c+PGcgY2xhc3M9ImNscy0yIj48cG9seWxpbmUgY2xhc3M9ImNscy00IiBwb2ludHM9IjcuMSA4MS4yIDEgNzcuOSA0LjggNzIuMSIvPjwvZz48L2c+PC9nPjwvc3ZnPg=="

/***/ }),
/* 448 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/GreenLineWithIcons.a8ca6f9a.svg";

/***/ })
]);


// WEBPACK FOOTER //
// component---src-pages-index-js-7f052faf2e7bfb95416f.js